webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/15XPTva/%3F1721451107778&title=Guide%20to%20the%20Pianist%27s%20Repertoire%2C%20Indiana%20Repertoire%20Guides&summary=Guide%20to%20the%20Pianist%27s%20Repertoire%20continues%20to%20be%20the%20go-to%20source%20for%20piano%20performers%2C%20teachers%2C%20and%20students.%20Newly%20updated%20and%20expanded%20with%20more%20than%20250%20new%20composers%2C%20this%20incomparable%20resource%20expertly%20guides%20readers%20to%20solo%20piano%20literature%20an&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/15XPTva/%3F1721451107778",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Guide%20to%20the%20Pianist%27s%20Repertoire%20continues%20to%20be%20the%20go-to%20source%20for%20piano%20performers%2C%20teachers%2C%20and%20students.%20Newly%20updated%20and%20expanded%20w%0Dhttps://textcafe.co/books/15XPTva/%3F1721451107778&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/15XPTva/%3F1721451107778&posttype=link&caption=Guide%20to%20the%20Pianist%27s%20Repertoire%20continues%20to%20be%20the%20go-to%20source%20for%20piano%20performers%2C%20teachers%2C%20and%20students.%20Newly%20updated%20and%20expanded%20with%20more%20than%20250%20new%20composers%2C%20this%20incomparable%20resource%20expertly%20guides%20readers%20to%20solo%20piano%20literature%20an",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/15XPTva/%3F1721451107778&description=Guide%20to%20the%20Pianist%27s%20Repertoire%20continues%20to%20be%20the%20go-to%20source%20for%20piano%20performers%2C%20teachers%2C%20and%20students.%20Newly%20updated%20and%20expanded%20with%20more%20than%20250%20new%20composers%2C%20this%20incomparable%20resource%20expertly%20guides%20readers%20to%20solo%20piano%20literature%20an&media=https://textcafe.co/books/15XPTva/tc-custom/9780253010230.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9780253010230&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=kQDXAQAAQBAJ&amp;rdid=book-kQDXAQAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9780253010230').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/15XPTva/tc-custom/9780253010230.jpg?1721451107778',
        alt: 'Guide to the Pianist&#x27;s Repertoire, Indiana Repertoire Guides'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "toc", "preface", "guide", "abbreviations", "publish", "address", "part1", "chap1", "chap2", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/15XPTva/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_title__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_copyright__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dedication__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dedication___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_dedication__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_toc__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_toc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_toc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_preface__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_preface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_preface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_guide__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_guide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_guide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_abbreviations__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_abbreviations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_abbreviations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_publish__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_publish___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_publish__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_address__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_address___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_address__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_part1__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_part1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_part1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_chap1__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_chap1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_chap1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_chap2__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_chap2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_chap2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_chap2_01__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_chap2_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_chap2_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_chap3__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_chap3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_chap3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_chap3_01__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_chap3_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_chap3_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_chap4__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_chap4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_chap4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_chap5__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_chap5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_chap5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_chap6__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_chap6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_chap6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_chap7__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_chap7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_chap7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_chap8__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_chap8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_chap8__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_chap9__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_chap9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_chap9__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_chap10__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_chap10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_chap10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_chap11__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_chap11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_chap11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_chap12__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_chap12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_chap12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_chap13__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_chap13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_chap13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_chap14__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_chap14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_chap14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_chap15__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_chap15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_chap15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_chap16__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_chap16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_chap16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_chap17__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_chap17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_chap17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_chap18__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_chap18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_chap18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_chap19__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_chap19___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_chap19__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_chap19_01__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_chap19_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_chap19_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_chap20__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_chap20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_chap20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_chap21__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_chap21___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_chap21__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_chap22__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_chap22___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_chap22__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_chap23__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_chap23___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_chap23__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_chap24__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_chap24___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_chap24__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_chap25__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_chap25___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_chap25__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_chap26__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_chap26___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_chap26__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_part2__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_part2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_part2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_part2_01__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_part2_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_part2_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_bib__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_bib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_bib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_app__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_index__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_abt__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_abt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_abt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_last__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_last__);
/*jshint esversion: 6 */





















































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/toc",
    "name": "toc",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_toc___default.a
  }, {
    "path": "/preface",
    "name": "preface",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_preface___default.a
  }, {
    "path": "/guide",
    "name": "guide",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_guide___default.a
  }, {
    "path": "/abbreviations",
    "name": "abbreviations",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_abbreviations___default.a
  }, {
    "path": "/publish",
    "name": "publish",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_publish___default.a
  }, {
    "path": "/address",
    "name": "address",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_address___default.a
  }, {
    "path": "/part1",
    "name": "part1",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_part1___default.a
  }, {
    "path": "/chap1",
    "name": "chap1",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_chap1___default.a
  }, {
    "path": "/chap2",
    "name": "chap2",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_chap2___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_50__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Maurice Hinson, Wesley Roberts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Maurice Hinson is Senior Professor of Piano at the Southern Baptist Theological Seminary and was founding editor of the Journal of the American Liszt Society. ")]), _c('P', [_vm._v("Wesley Roberts is Professor of Music at Campbellsville University.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15XPTva/tc-custom/9780253010230.jpg?1721451107778",
      "alt": "This image is the cover for the book Guide to the Pianist's Repertoire, Indiana Repertoire Guides"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Guide to the Pianist's Repertoire, Indiana Repertoire Guides\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Guide to the Pianist's Repertoire continues to be the go-to source for piano performers, teachers, and students. Newly updated and expanded with more than 250 new composers, this incomparable resource expertly guides readers to solo piano literature and provides answers to common questions: What did a given composer write? What interesting work have I never heard of? How difficult is it? What are its special musical features? How can I reach the publisher? ")]), _c('p', [_vm._v("New to the fourth edition are enhanced indexes identifying black composers, women composers, and compositions for piano with live or recorded electronics; a thorough listing of anthologies and collections organized by time period and nationality, now including collections from Africa and Slovakia; and expanded entries to account for new material, works, and resources that have become available since the third edition, including websites and electronic resources. The \"newest Hinson\" will be an indispensible guide for many years to come.")]), _c('p'), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "toctitle"
  }, [_c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/guide"
    }
  }, [_vm._v("USING THE GUIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/abbreviations"
    }
  }, [_vm._v("ABBREVIATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/publish"
    }
  }, [_vm._v("AMERICAN AGENTS, DISTRIBUTORS, OR PARENT COMPANIES OF MUSIC PUBLISHERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/address"
    }
  }, [_vm._v("ADDRESSES OF MUSIC PUBLISHERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART I")]), _vm._v(": "), _c('i', [_vm._v("Individual Composers: Their Solo Piano Works in Various Editions and Facsimile Reproductions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART II")]), _vm._v(": "), _c('i', [_vm._v("Anthologies and Collections")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Collections Spanning Historical Periods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baroque")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classical Period")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nineteenth-Century Romanticism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twentieth Century to 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tombeaux, Hommages")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("African")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Australian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Austrian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belgian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brazilian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bulgarian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Canadian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub15"
    }
  }, [_vm._v("Chinese")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub16"
    }
  }, [_vm._v("Czech")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub17"
    }
  }, [_vm._v("Dutch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub18"
    }
  }, [_vm._v("English")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub19"
    }
  }, [_vm._v("English Virginalists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub20"
    }
  }, [_vm._v("Finnish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub21"
    }
  }, [_vm._v("French")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub22"
    }
  }, [_vm._v("French Clavecinists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub23"
    }
  }, [_vm._v("German")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub24"
    }
  }, [_vm._v("German: Bach Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub25"
    }
  }, [_vm._v("Greek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub26"
    }
  }, [_vm._v("Hungarian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub27"
    }
  }, [_vm._v("Irish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub28"
    }
  }, [_vm._v("Israeli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub29"
    }
  }, [_vm._v("Italian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub30"
    }
  }, [_vm._v("Japanese")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub31"
    }
  }, [_vm._v("Latin American")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub32"
    }
  }, [_vm._v("New Zealand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub33"
    }
  }, [_vm._v("Polish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub34"
    }
  }, [_vm._v("Portuguese")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub35"
    }
  }, [_vm._v("Romanian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub36"
    }
  }, [_vm._v("Russian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub37"
    }
  }, [_vm._v("Scandinavian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub38"
    }
  }, [_vm._v("Scottish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub39"
    }
  }, [_vm._v("Slovakian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub40"
    }
  }, [_vm._v("Spanish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub41"
    }
  }, [_vm._v("Swiss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub42"
    }
  }, [_vm._v("Yugoslavian")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX: "), _c('i', [_vm._v("Historical Recital Programs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/app#sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anton Rubinstein, 1885–1886")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/app#sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ferruccio Busoni, 1911")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/app#sub3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ossip Gabrilowitsch, 1915–1916")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEXES:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/index#sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alphabetical List of Composers under Nationality Designations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/index#sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Compositions for Piano and Live or Recorded Electronics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/index#sub3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Compositions for Prepared Piano")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/index#sub4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Index to Anthologies and Collections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/index#sub5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Index to "), _c('i', [_vm._v("Anatomy of a Classic, Virtuoso")]), _vm._v(" Series, and Van Cliburn Competition–Commissioned Works and Publishers")])])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "toctitle"
  }, [_c('i', [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_vm._v("It has been said that the world of music in all its cultural realizations has no end. To this axiom one might add that it is equally true for the vast body of piano literature. The astonishing quantity of music composed for solo piano over the past three centuries must certainly have exceeded the imagination of the first composers for the instrument. Irwin Freundlich in the preface to the first edition of this book noted, “no single musician can successfully encompass the entire piano repertoire. It is, in fact, by far the largest devoted to any instrument, second only in scope to that for voice. Not only is it beyond the capability of the repertoire, but it is also equally difficult to have even a cursory acquaintance with its scope and be able to sift out material for study and performance from the mass of works accumulated over the years without some organized guiding hand to lead the way.” It was for this latter purpose that the "), _c('i', [_vm._v("Guide to the Pianist's Repertoire")]), _vm._v(" came into existence in 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("The original purpose of the "), _c('i', [_vm._v("Guide")]), _vm._v(" has remained unchanged since the first edition: to make available in one practical listing the important piano literature. New material has been added with each edition, while some repertoire has been deleted, either because it is out of print or because the authors have changed their ideas about certain pieces. A certain amount of subjectivity is unavoidable in a work of this nature, and we hope readers will bear this in mind as the book is consulted.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("This fourth edition updates available resources for well-known composers and introduces both older and newer composers of merit. Not only have publishers in the first decade of the twenty-first century been interested in new works, but they have also been reissuing works long out of print. Continuing interest in reference and performing collections of complete works has yielded both familiar and not-so-familiar names in recent years. The Italian rivalry of two complete editions of the music of Clementi is an exceptional case in point. In contrast, lesser known would be the works of the Swedish composer Eduard Tubin, whose piano literature recently became the subject of a complete-edition series.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Works considered for the "), _c('i', [_vm._v("Guide")]), _vm._v(" cover the period from 1700 to the present. A few works predating this period have been included, however, only when they can be effectively realized on the piano. As a rule, transcriptions are excluded, though a few exceptions have been made when, in the authors' opinion, they are highly effective. Information about this fascinating genre may be found in "), _c('i', [_vm._v("The Pianist's Guide to Transcriptions, Arrangements, and Paraphrases")]), _vm._v(" (Indiana University Press, 1990) by Maurice Hinson.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Our understanding of Western music and especially piano literature has quietly been changing since the initial work on this text began a half century ago. Newer editions of historic works, especially urtext, from the Baroque through the nineteenth century have clarified and given greater insights into the works of these two hundred–plus years. Times changed more slowly during these centuries, and the ease with which stylistic tendencies could be traced has been rather straightforward. By contrast, the twentieth century has been an age of pluralism and compression, completely unsettled, with an undertow pulling maverick composers into realms unimagined while counterbalanced by composers dedicated to traditional craftsmanship. The number of "), _c('i', [_vm._v("-isms")]), _vm._v(" during the century proliferated and changed our general perception of music as we watched some come and go.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Twenty-first-century musicians will have the advantage and benefit of years of labor by scholars and performers who have strived to arrive at definitive texts by master composers. At the same time, a word of caution should be noted concerning the increased availability of older editions through the internet, many now freely distributed. As important as older editions have been, and in a few instances will continue to be, these should not become substitutes for scholarly editions. The search for each composer's musical intention requires a careful consideration of all available resources, especially those which have become available in recent years, and which in many instances have changed our approach to the literature itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_c('i', [_vm._v("Acknowledgments:")]), _vm._v(" Many individuals have generously given the authors assistance in the preparation of this and previous editions of the "), _c('i', [_vm._v("Guide.")]), _vm._v(" For the fourth edition, we gratefully acknowledge the assistance of librarians John Burch of Campbellsville University, Martha Powell of the Southern Baptist Theological Seminary, and Karen Little of the University of Louisville, and their staffs. Additional assistance was provided in area studies by Izumi Miyoshi (Japan), Joanna Ximenes (Brazil), María Milagros Boso Galli (Argentina), Kees Weggelaar (The Netherlands), and Denine LeBlanc (Kentucky); in linguistics by Sida Hodoroabă-Roberts; and in typesetting by Anne Gibbs.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Without the generous assistance of numerous publishers, this volume would not be possible. Special appreciation goes to Johannes Mundry of Bärenreiter, Pietro Spada of Boccaccini and Spada, Anne Sobel of Carl Fischer, Scott Wollschleger of European American Music, Marina Furtado of FJH Music, Erin Mathieus of Hal Leonard, Norbert Gertsch, Sigrun Jantzen, and Ulrike Lucht-Lorenz of G. Henle, Stephanie Clement of Friedrich Hofmeister, Mary Kaufman of Oxford University Press, Paul Corneilson of the Packard Humanities Institute, Arnt C. Nitschke of Peermusic Classical, Frank Billack of C. F. Peters, Allison Weissman of G. Schirmer, Kathinka Pasveer of Stockhausen-Stiftung für Musik, Gabriele Bonomo of Suvini Zerboni, Daniel Dorff of Theodore Presser, Katie Wood of United Music Publishers, and Judith Anne Still of William Grant Still Music.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("To those mentioned, and to many more, we owe much gratitude.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("August 2012")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Maurice Hinson")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Louisville, Kentucky")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Wesley Roberts")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Campbellsville, Kentucky")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "toctitle"
  }, [_c('i', [_vm._v("Using the")]), _vm._v(" Guide")]), _vm._v(" "), _c('h3', {
    staticClass: "prefhead"
  }, [_vm._v("ARRANGEMENT OF ENTRIES")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_vm._v("In the “Individual Composers” section, all composers are listed alphabetically. Sometimes biographies and/or stylistic comments follow the composer's name and dates of birth and death. Under each composer's name, individual compositions are listed by opus number, or by title, or by musical form, or by a combination of the three. The entries in the “Anthologies and Collections” section include the editor or compiler, the publisher, the composers, and sometimes the titles represented in the collection.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Descriptions have been limited to general style characteristic, form, particular and unusual qualities, interpretative suggestions, and pianistic problems inherent in the music. Editorial procedures found in a particular edition are mentioned. The term “large span” is used when a span larger than an octave is required in a piece, and that occurs in many works written after 1900. “Octotonic” refers to lines moving in the same direction one or more octaves apart. “Shifting meters” indicates that varied time signatures are used within the space mentioned (a few bars, a movement, the entire work). “Proportional rhythmic relationships,” e.g., "), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/xi_1.jpg"
    }
  }), _vm._v(", indicates five notes are to be played in the time space for four. “Three with two” means three notes in one voice are played with (against) two notes in another voice. “Chance music” (aleatory, aleatoric) is described or mentioned, not analyzed, since it has no definitely ordered sequence of events. “Synthetic scale(s)” are created by the composer whose work is being discussed; the range may be less than one octave. “Stochastic techniques” refers to “a probabilistic compositional method, introduced by Iannis Xenakis, in which the overall contours of sound are specified but the inner details are left to random or chance selection” (DCM, p. 708).")]), _vm._v(" "), _c('h3', {
    staticClass: "prefhead"
  }, [_vm._v("GRADING")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_vm._v("An effort has been made to grade representative works of each composer. Four broad categories are used: Easy, Intermediate (Int.), Moderately Difficult (M-D), and Difficult (D). The following standard works will serve as a guide to the grading:")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('table', {
    staticClass: "body-textb",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Easy:")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Bach, dance movements from the "), _c('i', [_vm._v("Anna Magdalena Notebook")]), _c('br'), _vm._v("Leopold Mozart, "), _c('i', [_vm._v("Notebook for Wolfgang")]), _vm._v(" "), _c('br'), _vm._v("Schumann, easier pieces from "), _c('i', [_vm._v("Album for the Young")]), _vm._v(" "), _c('br'), _vm._v("Bartók, "), _c('i', [_vm._v("Mikrokosmos")]), _vm._v(", Vols. I–II")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Int.:")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Bach, "), _c('i', [_vm._v("Twelve Little Preludes and Fugues")]), _c('br'), _vm._v("Beethoven, "), _c('i', [_vm._v("Ecossaises")]), _vm._v(" "), _c('br'), _vm._v("Mendelssohn, "), _c('i', [_vm._v("Children's Pieces")]), _vm._v(" Op. 72"), _c('br'), _vm._v("Bartók, "), _c('i', [_vm._v("Rumanian Folk Dances")]), _vm._v(" 1–5")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("M-D:")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Bach, "), _c('i', [_vm._v("French Suites, English Suites")]), _c('br'), _vm._v("Mozart, "), _c('i', [_vm._v("Sonatas")]), _vm._v(" "), _c('br'), _vm._v("Brahms, "), _c('i', [_vm._v("Rhapsody")]), _vm._v(" Op. 79/2"), _c('br'), _vm._v("Debussy, "), _c('i', [_vm._v("La Soirée dans Grenade")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("D:")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Bach, "), _c('i', [_vm._v("Partitas")]), _c('br'), _vm._v("Beethoven, "), _c('i', [_vm._v("Sonata")]), _vm._v(" Op. 57"), _c('br'), _vm._v("Chopin, "), _c('i', [_vm._v("Etudes")]), _vm._v(" "), _c('br'), _vm._v("Barber, "), _c('i', [_vm._v("Sonata")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_vm._v("These categories must not be taken too strictly but are only given for general indications of technical and interpretative difficulties.")]), _vm._v(" "), _c('h3', {
    staticClass: "prefhead"
  }, [_vm._v("DETAILS OF ENTRIES")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_vm._v("When known, the date of composition is given after the title of the work. Then, in parentheses, are as many of the following as apply to the particular work: the editor, the publisher, the publisher's edition number, and the copyright date. When more than one edition is available, the editions are generally listed in order of preference, the most desirable first. The number of pages and the performance time are frequently listed, the latter always being a relative figure. The compositions' spellings appear as they do on the music being described, though in a few instances these have been corrected when multiple editions of the same work appear. Specifically related books, dissertations or theses, and periodical articles are listed following individual compositions or at the conclusion of the discussion of a composer's works (a more extended bibliography appears at the end of the book).")]), _vm._v(" "), _c('h3', {
    staticClass: "prefhead"
  }, [_vm._v("SAMPLE ENTRIES AND EXPLANATIONS")]), _vm._v(" "), _c('h3', {
    staticClass: "prefhead1"
  }, [_c('b', [_vm._v("C. P. E. Bach")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('i', [_vm._v("Six Sonatas")]), _vm._v(" 1761 Wq 51 (J. Rose—TP 1973).")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("1761 is the year of composition; Wq 51 stands for Wotquenne (the catalogue of C. P. E. Bach's music) and the number he assigned the pieces. J. Rose is the editor. Theodore Presser is the publisher, and 1973 is the publication date.")]), _vm._v(" "), _c('h3', {
    staticClass: "prefhead1"
  }, [_c('b', [_vm._v("Franz Schubert")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb"
  }, [_c('i', [_vm._v("Four Impromptus")]), _vm._v(" Op. 90 D.899 (Badura-Skoda—VU 50001, includes pencil sketch of No.1; Ferguson—ABRSM; Buonamici—K). M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Op. 90 is the opus number. D.899 stands for Deutsch (the cataloguer of Schubert's music) and the number he has assigned the pieces. There are three separate publications of the collection: Badura-Skoda, Ferguson, and Buonamici are the editors for Vienna Urtext, the Associated Board of the Royal Schools of Music, and Kalmus publications respectively. The Vienna Urtext edition includes a pencil sketch of Impromptu No.1, and 50001 is its edition number. M-D means Moderately Difficult.")]), _vm._v(" "), _c('h3', {
    staticClass: "prefhead1"
  }, [_c('b', [_vm._v("Milton Babbitt")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('i', [_vm._v("Playing for Time")]), _vm._v(" 1977 (in "), _c('i', [_vm._v("Twelve by Eleven")]), _vm._v(", Alfred) 12pp. 22 min. D.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("The date of composition is 1977; the publisher is Alfred. The piece is contained in the collection "), _c('i', [_vm._v("Twelve by Eleven;")]), _vm._v(" it is twelve pages long; it is approximately twenty-two minutes in duration; and it is classified as Difficult. Other pieces in the collection can be checked by looking in the American section of “Anthologies and Collections” under the title "), _c('i', [_vm._v("Twelve by Eleven.")])]), _vm._v(" "), _c('h3', {
    staticClass: "prefhead"
  }, [_vm._v("OTHER ASSISTANCE")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_vm._v("See “Abbreviations” for terms, publishers, books, and periodicals referred to in the text; and the directories “American Agent or Parent Companies of Music Publishers” and “Addresses of Music Publishers” to locate publishers. Three special indexes—“Alphabetical List of Composers under Nationality Designations,” “Compositions for Piano and Live or Recorded Electronics,” and “Compositions for Prepared Piano”—direct the user to entries in the text for music in these categories.")])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "toctitle"
  }, [_c('i', [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "font-size": "85%"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Allemande")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AA")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Authors Agency of the Polish Music Publishers")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ABRSM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Associated Board of the Royal Schools of Music")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ACA")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("American Composers Alliance")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ACF")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("American Composers Forum")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AMC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("American Music Center")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AME")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("American Music Editions")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("AMP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Associated Music Publishers")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anh")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Anhang (appendix)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("APS")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Art Publication Society")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("B")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Bourrée")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("B&UP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Broekmans & Van Poppel")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("BB")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Broude Brothers")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("BBD")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ellie B. Carlson, "), _c('i', [_vm._v("A")]), _vm._v(" "), _c('i', [_vm._v("Bibliographical Dictionary")]), _vm._v(" "), _c('i', [_vm._v("of Twelve-Tone and Serial")]), _vm._v(" "), _c('i', [_vm._v("Composers")]), _vm._v(" (Metuchen, NJ: Scarecrow Press, 1970)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Bk(s)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Book(s)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("BMC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Boston Music Company")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("BME")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Brazilian Music Enterprises")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("BMI")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Broadcast Music, Inc.")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Bo&Bo")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Bote & Bock")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Bo&H")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Boosey & Hawkes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Br")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Bärenreiter")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Br&H")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Breitkopf & Härtel")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("B&S")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Boccaccini & Spada")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Courante")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ca.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("circa")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CAP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Composers' Autograph Publications")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CD")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Compact disc")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CeBeDeM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CeBeDeM Foundations")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CF")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Carl Fischer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CFE")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Composers Facsimile Edition")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CFP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("C. F. Peters")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CHP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Chesky Hudebni Fond")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CK")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Contemporary Keyboard")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CMC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Canadian Music Centre")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CMP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Consolidated Music Publishing")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CPE")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Composer/Performer Edition")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CSMP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Crystal Spring Music Publishers")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("CuMP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Columbia University Music Press")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("D")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Difficult")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("DCM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Dictionary of Contemporary")]), _vm._v(" "), _c('i', [_vm._v("Music")]), _vm._v(", ed. John Vinton (New York E. P. Dutton, 1974)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("DDT")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Denkmäler deutscher Tonkunst")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("DoB")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Doblinger")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("DTB")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Denkmäler der Tonkunst in Bayern")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("DTOe")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Denkmäler der Tonkunst in Österreich")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("DVFM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Deutscher Verlag für Musik")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EAM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Editorial Argentina de Música")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EAMC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("European American Music Corporation")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EBM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("E. B. Marks")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Edizioni Curci")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ECIC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Editorial Cooperativa Intermericana de Compositores")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ECS")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ECS Publishing (parent to E. C. Schirmer Music)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ed.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Edition")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EKJ")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Early Keyboard Journal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ELK")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Elkan & Schildknecht")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EMB")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Editio Musica Budapest")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EMH")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Editions Musikk-Huset")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EmM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Editions musicales du Marais")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EMM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ediciones Mexicanas de Música")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EMT")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Editions Musicales Transatlantiques")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ESC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Max Eschig")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("EV")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Elkan-Vogel")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ff")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fortissimo")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("fl")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Flute")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("flou")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Flourished")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("FSF")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fast–Slow–Fast")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("FVB")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Fitzwilliam Virginial Book")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("G")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Gigue")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Gen")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("General Music Publishing Company")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Gehrmans Musikförlag")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GS")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("G. Schirmer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("GWM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("General Words and Music")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Hin")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Hinrichsen")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("HV")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Heinrichshofens Verlag")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("IEM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Instituto de Extensión Musicale")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("IMC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("International Music Company")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("IMI")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Israel Music Institute")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("IMP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Israeli Music Publications")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Int.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Intermediate difficulty")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ITO")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("In Theory Only")]), _vm._v(" (journal)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("IU")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("William and Gayle Cook Music Library, Indiana University")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("JALS")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Journal of the American Liszt Society")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("JF")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("J. Fischer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("JFC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Japan Federation of Composers")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("JWC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("J. W. Chester")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("K")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Kalmus")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("KC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Keyboard Classics")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("KMB")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Konemann Music Budapest")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("K&S")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Kistner & Siegel")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ku")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Kultura")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("L")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Alessandro Longo")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("LAMR")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Latin American Music Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("LC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Library of Congress, Washington, DC")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("LG")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Lawson Gould")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("l'OL")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("l'Oiseau-Lyre")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("M")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Minuet")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MAB")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Musica Antiqua Bohemica (Artia)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MCA")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MCA Music")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("M-D")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Moderately Difficult")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mer")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mercury Music Corporation")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MFTP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("James Friskin and Irwin Freundlich, "), _c('i', [_vm._v("Music for the")]), _vm._v(" "), _c('i', [_vm._v("Piano")]), _vm._v(" (New York: Rinehart, 1954; reprint New York: Dover, 1973)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MGP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Music Graphics Press")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MJ")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Music Journal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MJQ")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MJQ Music")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ML")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Music and Letters")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Modern Music")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("M&M")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Music and Musicians")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MMB")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MMB Music")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MMP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Master Music Publications")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MMR")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Monthly Musical Record")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MO")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Musical Opinion")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MQ")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Musician Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MR")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Music Review")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MS(S)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("manuscript(s)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MT")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Musical Times")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("mt(s)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("movement(s)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MTNA")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Music Teachers National Association")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MTP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Music Treasure Publications")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("MVH")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Musica Viva Historica (Artia)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Nag")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Nagel's Music-Archive")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NGD")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("New Grove Dictionary of")]), _vm._v(" "), _c('i', [_vm._v("Music and Musicians, 2nd")]), _vm._v(" "), _c('i', [_vm._v("Edition")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NLE")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("New Liszt Edition ("), _c('i', [_vm._v("Liszt")]), _vm._v(" "), _c('i', [_vm._v("Neue Ausgabe sämtlicher")]), _vm._v(" "), _c('i', [_vm._v("Werke")]), _vm._v(")")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NME")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("New Music Edition")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NMO")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Norsk Musikförlag")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NMS")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Nordiska Musikförlaget")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Nov")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Novello")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("NV")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Noetzel Verlag")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("OBV")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Oesterreischer Bundesverlag")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("OD")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Oliver Ditson")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Op.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Opus")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("OUP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Oxford University Press")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("PaF")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Prelude and Fugue")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("PAU")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Pan American Union")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("PF")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Performers' Facsimiles")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("PIC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Peer International Corporation")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("P&K")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Piano and Keyboard")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("PMP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Polish Music Publications")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("PNM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Perspectives of New Music")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("pp")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Pianissimo")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("PQ")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Piano Quarterly")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("PRMA")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Proceedings of the Royal Musical Association")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("PSM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Pennyslvania State Music Series (Pennyslvania State University Press)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("PWM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Polskie Wydawnictwo Muzyczne")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("QT")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Queen's Temple Publications")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("R&E")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ries & Erier")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Rev.")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Revised")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ric")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ricordi")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ric Amer")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ricordi Americana S.A.")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ric BR")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Ricordi Brazil")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("RMP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Russian Music Publishers")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("S")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sarabande")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SA")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sonata-Allegro")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sal")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Salabert")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SB")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Summy-Birchard")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("S&B")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Steiner & Bell")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SBE")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("William S. Newman, "), _c('i', [_vm._v("The Sonata in the Baroque Era")]), _vm._v(" (Chapel Hill: University of North Carolina Press, 1959; rev. ed., 1966; 3rd ed. New York: W. W. Norton, 1972)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SBTS")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Boyce Centennial Library, the Southern Baptist Theological Seminary, Louisville, Kentucky, "), _c('a', {
    attrs: {
      "href": "http://www.library.sbts.edu/music-and-av-library",
      "target": "_blank"
    }
  }, [_vm._v("www.library.sbts.edu/music-and-av-library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SCE")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("William S. Newman, "), _c('i', [_vm._v("The Sonata in the Classical Era")]), _vm._v(" (Chapel Hill: University of North Carolina Press, 1963; 2nd ed., New York: W. W. Norton, 1972)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SDM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Servico de Documentacão Musical da Ordem dos Musicos do Brasil")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SFS")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Slow–Fast–Slow")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SHKY")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Frank E. Kirby, "), _c('i', [_vm._v("Music for Piano: A Short History")]), _vm._v(" (Portland, OR: Amadeus Press, 1995)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SHV")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Státní hudbeni vydavatelstí")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SIMG")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Sammelbände der Internationalen Musikgesellschaft")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SKABO")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Skandinavisk og Borups Musikförlag")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Skandinavisk Musikförlag")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SME")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Special Music Edition")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Shawnee Press")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SSB")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("William S. Newman, "), _c('i', [_vm._v("The Sonata Since Beethoven")]), _vm._v(" (Chapel Hill: University of North Carolina Press, 1969; 2nd ed., New York: W. W. Norton, 1972)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("SZ")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Suvini Zerboni")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ta")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Tambourine")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ti")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Triangle")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("TM")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Jeffrey Kresky, "), _c('i', [_vm._v("Tonal Music")]), _vm._v(" (Bloomington: Indiana University Press, 1977).")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("TP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Theodore Presser")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("TPA")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Antologia de musica antica e moderna per il pianoforte")]), _vm._v(", ed. Gino Tagliapietra, 18 vols. (Milan: Ricordi, 1931–32).")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UE")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Universal Edition")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UK")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Lucille Caudill Little Fine Arts Library, University of Kentucky, Lexington, "), _c('a', {
    attrs: {
      "href": "http://www.uky.edu/FineArts/Music/musicology/resources/library",
      "target": "_blank"
    }
  }, [_vm._v("www.uky.edu/FineArts/Music/musicology/resources/library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UL")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Dwight Anderson Music Library, University of Louisville, Kentucky, "), _c('a', {
    attrs: {
      "href": "http://www.louisville.edu/library/music",
      "target": "_blank"
    }
  }, [_vm._v("www.louisville.edu/library/music")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UME")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Unión Musical Española")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UMEd")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Unión Musical Ediciones")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UMKR")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Unbekannte Meister der Klassik und Romantik (Boonin)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UMP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("United Music Publishers")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("UNC")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("University of North Carolina Press")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("USSR")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Mezhdunarodnaya Kniga (Music Publishers of the USSR)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Var(s).")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Variation(s)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("vc")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("cello")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("vl")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("violin")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("vol(s).")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Volume(s)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("VU")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Vienna Urtext Edition (UE)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("w/")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("with")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("WB")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Warner Brothers")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("WH")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Wilhelm Hansen")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("WIN")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Western International Music")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("YMP")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Yorktown Music Press")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("ZV")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_vm._v("Zenemükiado Vállala")])])])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "toctitle"
  }, [_c('i', [_vm._v("American Agents, Distributors, or Parent Companies of Music Publishers")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[1] Alfred")]), _vm._v(" Publishing Company"), _c('br'), _vm._v("P.O. Box 10003"), _c('br'), _vm._v("Van Nuys, CA 91410"), _c('br'), _vm._v("Tel: (800) 292–6122 or (818) 891–5999"), _c('br'), _vm._v("Fax: (818) 893–5560"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.alfred.com",
      "target": "_blank"
    }
  }, [_vm._v("www.alfred.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[2] Boosey & Hawkes")]), _c('br'), _vm._v("229 W. 28th Street, Floor 11"), _c('br'), _vm._v("New York, NY 10001"), _c('br'), _vm._v("Tel: (212) 358–5300 "), _c('br'), _vm._v("Fax: (212) 358–5305"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.boosey.com",
      "target": "_blank"
    }
  }, [_vm._v("www.boosey.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[3] Brodt Music")]), _vm._v(" Company"), _c('br'), _vm._v("P.O. Box 9345"), _c('br'), _vm._v("Charlotte, NC 28299"), _c('br'), _vm._v("Tel: (704) 332–2177 or (800) 438–4129"), _c('br'), _vm._v("Fax: (704) 335–7215 or"), _c('br'), _vm._v("(800) 446–0812"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.brodtmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.brodtmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[4] Broude Brothers")]), _c('br'), _vm._v("141 White Oaks Road"), _c('br'), _vm._v("P.O. Box 547"), _c('br'), _vm._v("Williamstown, MA 01267–0547"), _c('br'), _vm._v("Tel: (413) 458–8131 or (800) 525–8559"), _c('br'), _vm._v("Fax: (413) 458–5242 "), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.broude.us",
      "target": "_blank"
    }
  }, [_vm._v("www.broude.us")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[5] ECS")]), _vm._v(" Publishing (parent company to E. C. Schirmer Music)"), _c('br'), _vm._v("615 Concord Street"), _c('br'), _vm._v("Framingham, MA 01702"), _c('br'), _vm._v("Tel: (508) 620–7400 or (800) 777–1919"), _c('br'), _vm._v("Fax: (508) 620–7401"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ecspublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ecspublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[6] Elkin Music International")]), _c('br'), _vm._v("94 Merrills Chase"), _c('br'), _vm._v("Asheville, NC 28803"), _c('br'), _vm._v("Tel: (800) 367–3554 or (828) 651–9828"), _c('br'), _vm._v("Fax: (800) 291–5590 (orders) or(800) 651–9655"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.elkinmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.elkinmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[7]")]), _vm._v(" Carl "), _c('b', [_vm._v("Fischer,")]), _vm._v(" Inc."), _c('br'), _vm._v("65 Bleecker Street"), _c('br'), _vm._v("New York, NY 10012"), _c('br'), _vm._v("Tel: (212) 777–0900"), _c('br'), _vm._v("Fax: (212) 477–6996"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.carlfischer.com",
      "target": "_blank"
    }
  }, [_vm._v("www.carlfischer.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[8] Educational Music Service")]), _c('br'), _vm._v("("), _c('i', [_vm._v("superseded")]), _vm._v(" Foreign Music Distributors)"), _c('br'), _vm._v("33 Elkay Drive"), _c('br'), _vm._v("Chester, NY 10918"), _c('br'), _vm._v("Tel: (845) 469–5790"), _c('br'), _vm._v("Fax: (845) 469–5817"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.emsmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.emsmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[9]")]), _vm._v(" Neil A. "), _c('b', [_vm._v("Kjos")]), _vm._v(" Music"), _c('br'), _vm._v("4382 Jutland Drive"), _c('br'), _vm._v("San Diego, CA 92117"), _c('br'), _vm._v("Tel: (858) 270–9800"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.kjos.com",
      "target": "_blank"
    }
  }, [_vm._v("www.kjos.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[10]")]), _vm._v(" Hal "), _c('b', [_vm._v("Leonard")]), _vm._v(" Publishing Corp."), _c('br'), _c('i', [_vm._v("street address:")]), _vm._v(" 7777 West Bluemound Road"), _c('br'), _vm._v("Milwaukee, WI 53213"), _c('br'), _c('i', [_vm._v("mailing address:")]), _vm._v(" P.O. Box 13819"), _c('br'), _vm._v("Milwaukee, WI 53213")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_vm._v("Tel: (414) 774–3630 or (800) 524–4425"), _c('br'), _vm._v("Fax: (414) 774–3259"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.halleonard.com",
      "target": "_blank"
    }
  }, [_vm._v("www.halleonard.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[11] Magnamusic")]), _vm._v(" Distributors"), _c('br'), _vm._v("P.O. Box 338"), _c('br'), _vm._v("Sharon, CT 06069"), _c('br'), _vm._v("Tel: (888) 665–2721 or (860) 364–5431"), _c('br'), _vm._v("Fax: (860) 364–5431"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.magnamusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.magnamusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[12] MMB Music")]), _c('br'), _vm._v("9051 Watson Road, Suite 161"), _c('br'), _vm._v("St. Louis, MO 63126"), _c('br'), _vm._v("Tel: (800) 543–3771 or (314) 531–9635"), _c('br'), _vm._v("Fax: (314) 531–8384"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.mmbmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.mmbmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[13] "), _c('a', {
    attrs: {
      "href": "http://Music44.com",
      "target": "_blank"
    }
  }, [_vm._v("Music44.com")])]), _c('br'), _vm._v("5348 N. Tacoma Avenue"), _c('br'), _vm._v("Indianapolis, IN 46220"), _c('br'), _vm._v("Tel: (866) 419–6497 or (317) 225–5509"), _c('br'), _vm._v("Fax: (317) 222–1327"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.music44.com",
      "target": "_blank"
    }
  }, [_vm._v("www.music44.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[14]")]), _vm._v(" C. F. "), _c('b', [_vm._v("Peters")]), _c('br'), _vm._v("70–30 80th Street"), _c('br'), _vm._v("Glendale, NY 11385"), _c('br'), _vm._v("Tel: (718) 416–7800"), _c('br'), _vm._v("Fax: (718) 416–7805"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edition-peters.com",
      "target": "_blank"
    }
  }, [_vm._v("www.edition-peters.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[15]")]), _vm._v(" Theodore "), _c('b', [_vm._v("Presser")]), _vm._v(" "), _c('br'), _vm._v("588 N. Gulph Road"), _c('br'), _vm._v("King of Prussia, PA 19406"), _c('br'), _vm._v("Tel: (610) 592–1222"), _c('br'), _vm._v("Fax: (610) 592–1229"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.presser.com",
      "target": "_blank"
    }
  }, [_vm._v("www.presser.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[16]")]), _vm._v(" G. "), _c('b', [_vm._v("Schirmer")]), _vm._v(" (part of Music Sales Group)"), _c('br'), _vm._v("180 Madison Avenue, 24th Floor"), _c('br'), _vm._v("New York, NY 10016"), _c('br'), _vm._v("Tel: (212) 254–2100"), _c('br'), _vm._v("Fax: (212) 254–2013"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.schirmer.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schirmer.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[17] Sheet Music Plus")]), _c('br'), _vm._v("1300 64th Street"), _c('br'), _vm._v("Emeryville, CA 94608"), _c('br'), _vm._v("Tel: (800) 743–3868 or (510) 420–7121"), _c('br'), _vm._v("Fax: (510) 420–7190"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.sheetmusicplus.com",
      "target": "_blank"
    }
  }, [_vm._v("www.sheetmusicplus.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_c('b', [_vm._v("[18]")]), _vm._v(" Location or American agent unknown, despite our efforts to find them; many of these publishers are no longer in business.")])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "toctitle"
  }, [_c('i', [_vm._v("Addresses of Music Publishers")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }, [_vm._v("A bracketed number (e.g., "), _c('b', [_vm._v("[1])")]), _vm._v(" following the name of a publisher corresponds to that of its American agent, distributor, or parent company (see preceding listing, “American Agents, Distributors, or Parent Companies of Music Publishers”). "), _c('b', [_vm._v("Bold print")]), _vm._v(" has been added to help the reader find items in the alphabetical sequence. In cases where no information about a publisher was found, the last known address is given. Readers are encouraged to bear in mind that addresses frequently change and that these can often be checked on the worldwide web or through the Music Publishers Association of the United States ("), _c('a', {
    attrs: {
      "href": "http://www.mpa.org",
      "target": "_blank"
    }
  }, [_vm._v("www.mpa.org")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Academia Brasileira de Música")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rua da Lapa"), _c('br'), _vm._v("120/12° andar"), _c('br'), _vm._v("20021-180 Rio de Janeiro, Brazil"), _c('br'), _vm._v("Tel/Fax: (21) 2292-5845"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.abmusica.org.br",
      "target": "_blank"
    }
  }, [_vm._v("www.abmusica.org.br")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Acanthus")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postfach"), _c('br'), _vm._v("4522 Rüttenen SO, Switzerland"), _c('br'), _vm._v("Tel: (41) 32-637-06-30"), _c('br'), _vm._v("Fax: (41) 32-637-06-31"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.acanthus-music.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.acanthus-music.ch")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni Giuseppe "), _c('b', [_vm._v("Accardi")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rotterdam, The Netherlands"), _c('br'), _vm._v("c/o Musica Repartita"), _c('br'), _vm._v("Goedestraat 133"), _c('br'), _vm._v("3572 RS Utrecht"), _c('br'), _vm._v("The Netherlands"), _c('br'), _vm._v("Tel: (31) 30-718465")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Accent")]), _vm._v(" Music "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Adeva")]), _vm._v(" Musik ("), _c('i', [_vm._v("see")]), _vm._v(" Bärenreiter)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Aenear")]), _vm._v(" Publishing Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Toronto, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Africanus")]), _vm._v(" Editions")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3126 Shenandoah Avenue"), _c('br'), _vm._v("St. Louis, MO 63104"), _c('br'), _vm._v("Tel: (314) 773-8769")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ahn & Simrock")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hamburg, Germany"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.theaterverlagmuenchen.de/as_allg.php",
      "target": "_blank"
    }
  }, [_vm._v("www.theaterverlagmuenchen.de/as_allg.php")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Akkord")]), _vm._v(" Music Publishers "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Barackos út 28/a"), _c('br'), _vm._v("1224 Budapest, Hungary"), _c('br'), _vm._v("Fax: (36) 1-207-4767"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.akkordmusic.hu",
      "target": "_blank"
    }
  }, [_vm._v("www.akkordmusic.hu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Alacran")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("695 Wrelton Drive"), _c('br'), _vm._v("San Diego, CA 92109")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Albersen")]), _vm._v(" Muziek")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Valeriusstraat 12"), _c('br'), _vm._v("2517 HR Den Haag"), _c('br'), _vm._v("The Netherlands"), _c('br'), _vm._v("Tel: (31) 70-345-6000"), _c('br'), _vm._v("Fax: (31) 70-345-71-10"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.albersen.nl",
      "target": "_blank"
    }
  }, [_vm._v("www.albersen.nl")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. "), _c('b', [_vm._v("Albert")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" E. B. Marks)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Allans")]), _vm._v(" Music Australia "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("ALMA")]), _vm._v(" (Association for Latin-American")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Music and Art)"), _c('br'), _vm._v("10985 West Broward Blvd."), _c('br'), _vm._v("Plantation, FL 33324"), _c('br'), _vm._v("Tel: (888) 275-2562"), _c('br'), _vm._v("Fax: (954) 915-9144"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.alma-usa.com",
      "target": "_blank"
    }
  }, [_vm._v("www.alma-usa.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Alpeg")]), _vm._v(" Editions "), _c('b', [_vm._v("[14]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Alsbach [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Amadeus [8, 10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hermannstrasse 7"), _c('br'), _vm._v("8400 Winterthur, Switzerland"), _c('br'), _vm._v("Tel: (41) 52-233-28-66"), _c('br'), _vm._v("Fax: (41) 52-233-54-01"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.amadeusmusic.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.amadeusmusic.ch")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("American Composers Alliance:")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Composers Facsimile Edition"), _c('br'), _vm._v("802 W. 190th Street 1st Floor"), _c('br'), _vm._v("New York, NY 10040"), _c('br'), _vm._v("Tel: (212) 925-0458"), _c('br'), _vm._v("Fax: (212) 925-6798"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.composers.com",
      "target": "_blank"
    }
  }, [_vm._v("www.composers.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("American Composers Forum")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("332 Minnesota Street, Suite East 145"), _c('br'), _vm._v("St. Paul, MN 55101-1300"), _c('br'), _vm._v("Tel: (651) 228-1407"), _c('br'), _vm._v("Fax: (651) 291-7978"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.composersforum.org",
      "target": "_blank"
    }
  }, [_vm._v("www.composersforum.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("American Institute of Musicology")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(includes The Corpus of Early Music Keyboard Music)"), _c('br'), _vm._v("c/o Tempo Music Publications"), _c('br'), _vm._v("3773 W. 95th Street"), _c('br'), _vm._v("Leawood, KS 66206"), _c('br'), _vm._v("Tel: (913) 381-5088 or (800) 733-5066"), _c('br'), _vm._v("Fax: (913) 381-5081"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.tempomusic.com/aim",
      "target": "_blank"
    }
  }, [_vm._v("www.tempomusic.com/aim")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("American Music Center")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" New Music USA)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("American Music Editions")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("263 East 7th Street"), _c('br'), _vm._v("New York, NY 10009-6049"), _c('br'), _vm._v("Fax: (212) 420-9393"), _c('br'), _c('i', [_vm._v("Archive:")]), _c('br'), _vm._v("Northwestern University Library"), _c('br'), _vm._v("1970 Campus Drive"), _c('br'), _vm._v("Evanston, Illinois 60208-2300"), _c('br'), _vm._v("Tel: (847) 491-7658"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.library.northwestern.edu/libraries-collections/evanston-campus/music-library/collections/special-collections/american-music",
      "target": "_blank"
    }
  }, [_vm._v("www.library.northwestern.edu/libraries-collections/evanston-campus/music-library/collections/special-collections/american-music")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Gli "), _c('b', [_vm._v("Amici della Musica da Camera")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Bocca di Leone 25"), _c('br'), _vm._v("Rome, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Amphion")]), _vm._v(" Éditions Musicales "), _c('b', [_vm._v("[10]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("AMS")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Brooklyn Navy Yard"), _c('br'), _vm._v("63 Flushing Avenue, Unit #221"), _c('br'), _vm._v("Brooklyn, NY 11205-1073"), _c('br'), _vm._v("Fax: (718) 875-3800"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.amspressinc.com",
      "target": "_blank"
    }
  }, [_vm._v("www.amspressinc.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Amsco")]), _vm._v(" School Publishing "), _c('b', [_vm._v("[13]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("315 Hudson Street"), _c('br'), _vm._v("New York, NY 10013-1085")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 969-8398 or (212) 886-6500")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 886-6515"), _c('br'), _c('a', {
    attrs: {
      "href": "http://amscopub.com",
      "target": "_blank"
    }
  }, [_vm._v("amscopub.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Johann "), _c('b', [_vm._v("André")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Frankfurterstrasse 28")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("63065 Offenbach, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 69-813539")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 69-815339"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musik-andre.de",
      "target": "_blank"
    }
  }, [_vm._v("www.musik-andre.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Andromeda")]), _vm._v(" Editrice "), _c('b', [_vm._v("[10]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("64042 Colledara (Te), Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 861-699014")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 861-699000"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.organisti.it/andromeda.htm",
      "target": "_blank"
    }
  }, [_vm._v("www.organisti.it/andromeda.htm")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Anglican [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("A-R")]), _vm._v(" Editions "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("8551 Research Way, Suite 180"), _c('br'), _vm._v("Middleton, WI 5356")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (608) 836-9000 or (800) 736-0070")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (608) 831-8200"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.areditions.com",
      "target": "_blank"
    }
  }, [_vm._v("www.areditions.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("A-Ram")]), _vm._v(" Edition")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Moscow, Russia")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Arbeitsgemeinschaft der Eigenverleger")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lasserstraße 6")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5020 Salzburg, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (66) 2-78-86-84")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Groupe "), _c('b', [_vm._v("Archambault")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("500 Est, Rue Ste-Catherine Montreal"), _c('br'), _vm._v("Quebec, H2L 2C6 Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (514) 849-6201")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (514) 849-1481")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ariadne")]), _vm._v(" Verlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Geibelgasse 14")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1150 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 1-8953255")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (43) 1-8953244-20"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ariadne-verlag.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ariadne-verlag.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Collecion "), _c('b', [_vm._v("Arion [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Armelin")]), _vm._v(" Musica")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via dei Soncin, 42")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("35122 Padova, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 49-8724-928")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 49-8736-524"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.armelin.it",
      "target": "_blank"
    }
  }, [_vm._v("www.armelin.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Arno Press [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Arno Volk Verlag")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Universal Music Publishing Group)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Arrow")]), _vm._v(" Music Press "), _c('b', [_vm._v("[13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ars Viva")]), _vm._v(" Verlag "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Weihergarten 5")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("55116 Mainz, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 6131-2460")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 6131-246-211")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Arsis")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Empire Publishing Service")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 1344"), _c('br'), _vm._v("Studio City, CA 91614")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (818) 784-8918")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (818) 990-2477"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.arsispress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.arsispress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Art Publication of St. Louis [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Artia [2, 8, 12]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Prague, Czech Republic")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ascherberg, Hopwood & Crew,")]), _vm._v(" Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Music Publishers"), _c('br'), _vm._v("c/o Chappell International Music"), _c('br'), _vm._v("Publ. Group Ltd."), _c('br'), _vm._v("50 New Bond Street"), _c('br'), _vm._v("London W1A 2BR, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edwin "), _c('b', [_vm._v("Ashdown [6, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ashley")]), _vm._v(" Dealers Service "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Hermann "), _c('b', [_vm._v("Assmann")]), _vm._v(" Musikverlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Franz-Werfel-Strasse 3660431"), _c('br'), _vm._v("Frankfurt 50, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49-69) 532431/526231")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Associated Board of the Royal School of Music [14, 15]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("24 Portland Place"), _c('br'), _vm._v("London W1B 1LU"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 20-7636-5400")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 20-7637-0234"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.abrsm.org",
      "target": "_blank"
    }
  }, [_vm._v("www.abrsm.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Associated Music Publishers [10, 13, 16, 17]")]), _vm._v(" (part of Music Sales Group)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("New York, NY")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Astoria")]), _vm._v(" Verlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Weihergarten 5")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("55116 Mainz, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 6131-246-889")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 6131-246-250"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.astoria-verlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.astoria-verlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Augener [5]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Australian Music Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box N690"), _c('br'), _vm._v("Grosvenor Place"), _c('br'), _vm._v("Sydney NSW 1220, Australia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (61) 2-9247-4677")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (61) 2-9241-2873"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.amcoz.com.au/amc",
      "target": "_blank"
    }
  }, [_vm._v("www.amcoz.com.au/amc")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Authors Agency of the Polish Music Publishers")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("ul. Hipteczna 2,"), _c('br'), _vm._v("00-950 Warsaw, Poland")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Autographus Musicus")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Årdalavägen158")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("12432 Bandhagen, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Axelrod [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Musica "), _c('b', [_vm._v("Baltica [14, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Kr. Barona 39-1"), _c('br'), _vm._v("Riga 1011, Latvia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (371) 67-275575")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (371) 67-272755"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musicabaltica.com",
      "target": "_blank"
    }
  }, [_vm._v("www.musicabaltica.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Banks")]), _vm._v(" Music "), _c('b', [_vm._v("[13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("The Granary, Wath Court"), _c('br'), _vm._v("Hovingham, York YO62 4NN"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 1653-628545")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 1653-627214"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.banksmusicpublications.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.banksmusicpublications.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bardic")]), _vm._v(" Edition "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("6 Fairfax Crescent"), _c('br'), _vm._v("Aylesbury, Bucks HP20 2ES"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) (1296) 428609")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("U.S. Tel: (914) 816-1137")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) (1296) 581185"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.bardic-music.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bardic-music.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bärenreiter")]), _vm._v(" Verlag "), _c('b', [_vm._v("[4, 6, 8, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(works of Schoenberg dist. in U.S. by Belmont)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Heinrich-Schütz-Allee 35-37"), _c('br'), _vm._v("34131 Kassel, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 561-3105-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 561-3105-240"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.baerenreiter.com/nc/en/",
      "target": "_blank"
    }
  }, [_vm._v("www.baerenreiter.com/nc/en/")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editio "), _c('b', [_vm._v("Bärenreiter Praha")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("namestri Jiriho z Podebrad 112/19"), _c('br'), _vm._v("130 00 Prague 3, Czech Republic")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (420) 274-001-911")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (420) 222-220-829"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ebp.cz",
      "target": "_blank"
    }
  }, [_vm._v("www.ebp.cz")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Barry [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Buenos Aires, Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bartók Records")]), _vm._v(" and Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 399"), _c('br'), _vm._v("Homosassa, FL 34487")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (352) 382-2015")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (352) 382-0341"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.bartokrecords.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bartokrecords.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("M. P. "), _c('b', [_vm._v("Belaieff [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Mainz, Germany"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.belaieff-music.com",
      "target": "_blank"
    }
  }, [_vm._v("www.belaieff-music.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Belmont")]), _vm._v(" Music Publishers "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1221 Bienveneda Avenue"), _c('br'), _vm._v("Pacific Palisades, CA 90272")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (310) 454-1867")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (310) 573-1925"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.schoenbergmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schoenbergmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Belwin-Mills [1, 6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Berandol")]), _vm._v(" Music Ltd. (Canada) "), _c('b', [_vm._v("[6, 11, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 45059")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("81 Lakeshore Road E."), _c('br'), _vm._v("Mississauga, ON L5G 2X4, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (877) 356-1002 or (905) 278-6338")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (905) 278-9409"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.berandolmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.berandolmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni "), _c('b', [_vm._v("Bèrben [13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Redipuglia 65")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("60122 Ancona, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 71-204428")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 71-57414"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.berben.it",
      "target": "_blank"
    }
  }, [_vm._v("www.berben.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edição "), _c('b', [_vm._v("Bevilacqua [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Biblioteca Central [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Sección de Música"), _c('br'), _vm._v("Barcelona, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Biedermann [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Gerald "), _c('b', [_vm._v("Billaudot,")]), _vm._v(" Editeur/Editions")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Billaudot "), _c('b', [_vm._v("[6, 13, 15, 17]")]), _c('br'), _vm._v("14, Rue de l'Échiquier"), _c('br'), _vm._v("75010 Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-47-70-14-46")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-45-23-22-54"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.billaudot.com",
      "target": "_blank"
    }
  }, [_vm._v("www.billaudot.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Black Cat")]), _vm._v(" Productions")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("10808 124th Street"), _c('br'), _vm._v("Edmonton, AB, T5M 0H4, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 661-3613")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (780) 447-5337")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("BMI Canada,")]), _vm._v(" Ltd. "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Boccaccini e Spada [13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Arezzo 17")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("00040 Pavona di Albano Laziale"), _c('br'), _vm._v("(Rome), Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 6-9310217 or (39) 6-9310561")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 6-9311903"), _c('br'), _vm._v("Email: "), _c('a', {
    attrs: {
      "href": "mailto:bsmusica@tiscalinet.it"
    }
  }, [_vm._v("bsmusica@tiscalinet.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Fred "), _c('b', [_vm._v("Bock [10, 13]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 570567"), _c('br'), _vm._v("Tarzana, CA 91357")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (818) 996-6181")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (818) 996-2043"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.fredbock.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fredbock.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Boelke-Bomart")]), _vm._v(" Music Publications ("), _c('i', [_vm._v("see")]), _vm._v(" Jerona Music Corp.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bolamar")]), _vm._v(" Ediciones Musicales")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Azor, 5 (Molino de la Hoz)"), _c('br'), _vm._v("28232 Las Rozas (Madrid), Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 916303643"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.bolamar.net",
      "target": "_blank"
    }
  }, [_vm._v("www.bolamar.net")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bomart")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Boelke-Bomart)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bongiovanni")]), _vm._v(" Francesco Edizioni Musicali")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Ugo Bassi, 31/F"), _c('br'), _vm._v("40121 Bologna, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 51-22-57-22")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 51-22-61-28")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Joseph "), _c('b', [_vm._v("Boonin")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Jerona Music Corp.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bosse")]), _vm._v(" Edition "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postfach 417")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("84 Regensburg 2, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Boston")]), _vm._v(" Music "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bosworth")]), _vm._v(" & Co. "), _c('b', [_vm._v("[3, 6, 10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bote & Bock [6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bourne")]), _vm._v(" Company "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5 West 37th Street, 6th Floor"), _c('br'), _vm._v("New York, NY 10018")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 391-4300")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 391-4306"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.bournemusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bournemusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bowdoin College")]), _vm._v(" Music Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Bowdoin College"), _c('br'), _vm._v("Brunswick, ME 04011"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.library.bowdoin.edu/arch/archives/bcmpg.shtml",
      "target": "_blank"
    }
  }, [_vm._v("www.library.bowdoin.edu/arch/archives/bcmpg.shtml")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("The "), _c('b', [_vm._v("Boxwood")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("183 Ocean View Blvd."), _c('br'), _vm._v("Pacific Grove, CA 93950")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (408) 375-9110")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bradley")]), _vm._v(" Publications "), _c('b', [_vm._v("[1]")]), _vm._v(" (formerly through CPP/Belwin Music)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Branden")]), _vm._v(" Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Div. of Branden Books")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 812094"), _c('br'), _vm._v("Wellesley, MA 02482"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.brandenbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.brandenbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Bratti [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Brazilian Music")]), _vm._v(" Enterprises "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Breitkopf & Härtel [6, 8, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Walkmühlstraße 52")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("65195 Wiesbaden, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 611-45008-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 611-45008 59-61"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.breitkopf.com",
      "target": "_blank"
    }
  }, [_vm._v("www.breitkopf.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("The "), _c('b', [_vm._v("British Library")]), _vm._v(" Publishing Office")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("96 Euston Road"), _c('br'), _vm._v("London NW1 2DB"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 20-7412-7704"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.publishing.bl.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.publishing.bl.uk")]), _c('br'), _c('b', [_vm._v("distributed in the U.S. & Canada by")]), _c('br'), _vm._v("University of Chicago Press"), _c('br'), _vm._v("1427 E. 60th Street"), _c('br'), _vm._v("Chicago, IL 60637")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (773) 702-7248")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (773) 702-9756"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.press.uchicago.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.press.uchicago.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Broadbent & Dunn [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("66 Nursery Lane"), _c('br'), _vm._v("Dover, Kent, CT16 3EX"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 1304-825604"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.broadbent-dunn.com",
      "target": "_blank"
    }
  }, [_vm._v("www.broadbent-dunn.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Broadcast Music,")]), _vm._v(" Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("10 Music Square East"), _c('br'), _vm._v("Nashville, TN 37203-4399")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (615) 401-2000"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.bmi.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bmi.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Broekmans & Van Poppel [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Van Baerlestraat 92-94"), _c('br'), _vm._v("1071 BB Amsterdam"), _c('br'), _vm._v("The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (31) 20-679-65-75 or 20-659-72-70")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (31) 20-664-67-59"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.broekmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.broekmans.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Dr. J. "), _c('b', [_vm._v("Butz")]), _vm._v(" Musikverlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postfach 30 09 54")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("53189 Bonn, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 228-946-949-24"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.butz-verlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.butz-verlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cambria")]), _vm._v(" Publishing "), _c('b', [_vm._v("[17, 18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cambridge University Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("32 Avenue of the Americas"), _c('br'), _vm._v("New York, NY 10013")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 337-5000 or (845) 353-7500"), _c('br'), _vm._v("(customer service)"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.cambridge.org",
      "target": "_blank"
    }
  }, [_vm._v("www.cambridge.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Canadian Music Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("20 St. Joseph Street"), _c('br'), _vm._v("Toronto, Ontario M4Y 1J9, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (416) 961-6601")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (416) 961-7198"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musiccentre.ca",
      "target": "_blank"
    }
  }, [_vm._v("www.musiccentre.ca")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cantext")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("19 Laval Drive")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Winnipeg R3T 2XB, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (204) 275-1598")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Canyon")]), _vm._v(" Press "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Carisch,")]), _vm._v(" S.P.A. "), _c('b', [_vm._v("[2, 6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Canova 55")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("20020 Lainate, Italy"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.carisch.com",
      "target": "_blank"
    }
  }, [_vm._v("www.carisch.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Carlanita")]), _vm._v(" Music Co. "), _c('b', [_vm._v("[10, 13, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 698, Cathedral Station"), _c('br'), _vm._v("New York, NY 10025")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni "), _c('b', [_vm._v("Carrara")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via A. da Calepio, 4")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("24125 Bergamo, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 35-243618")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 35-270298"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edizionicarrara.it",
      "target": "_blank"
    }
  }, [_vm._v("www.edizionicarrara.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Carus")]), _vm._v("-Verlag "), _c('b', [_vm._v("[6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Sielminger Str. 51")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("70771 LE-Echterdingen, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 711-797-330-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 711-797-330-29"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.carus-verlag.com",
      "target": "_blank"
    }
  }, [_vm._v("www.carus-verlag.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Valentim de "), _c('b', [_vm._v("Carvalho")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Estrada de Paço de Arcos, 26"), _c('br'), _vm._v("2770-129 Paço de Arcos, Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (351) 214-401-000")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (351) 214-401-095"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.valentim.pt",
      "target": "_blank"
    }
  }, [_vm._v("www.valentim.pt")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Casa Amarilla")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Santiago, Chile")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (56) 2-698-3483"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.casamarilla.cl",
      "target": "_blank"
    }
  }, [_vm._v("www.casamarilla.cl")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Casa "), _c('b', [_vm._v("Iriberri [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Buenos Aires, Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Casia")]), _vm._v(" Publishing "), _c('b', [_vm._v("[7]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Catamount")]), _vm._v(" Facsimile Editions ("), _c('i', [_vm._v("see")]), _vm._v(" American Composers Alliance)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Caveat")]), _vm._v(" Music Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o E.C. Kerby Itd."), _c('br'), _vm._v("198 Davenport Road"), _c('br'), _vm._v("Toronto M5R 1J2, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (416) 922-9934")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("CeBeDeM")]), _vm._v(" (Centre Belge de Documentation Musicale)"), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Avenue du port 86c bte 214")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1000 Brussels, Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (32) 2-230-94-30")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (32) 2-230-94-37"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.cebedem.be",
      "target": "_blank"
    }
  }, [_vm._v("www.cebedem.be")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Century")]), _vm._v(" Music Publishing Co. ("), _c('i', [_vm._v("see")]), _vm._v(" Ashley Dealers)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Le "), _c('b', [_vm._v("Chant du Monde [6, 7, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("31-33 Rue Vandrezanne"), _c('br'), _vm._v("75013 Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-53-80-12-30")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-53-80-12-18"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chantdumonde.com",
      "target": "_blank"
    }
  }, [_vm._v("www.chantdumonde.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Chappell")]), _vm._v(" & Co. "), _c('b', [_vm._v("[1, 10, 13]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Warner/Chappel Music)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cherry Lane")]), _vm._v(" Music Co. "), _c('b', [_vm._v("[10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("10 Midland Avenue"), _c('br'), _vm._v("Port Chester, NY 10573")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (914) 935-5200")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (914) 937-0614"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.cherrylane.mseek.net",
      "target": "_blank"
    }
  }, [_vm._v("www.cherrylane.mseek.net")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Chesky Hudebni Fond")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Český rozhlas"), _c('br'), _vm._v("Římská 13")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("120 99 Prague, Czech Republic")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (420) 221-553-361")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (420) 221-553-355"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.hudebnifond.cz",
      "target": "_blank"
    }
  }, [_vm._v("www.hudebnifond.cz")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. W. "), _c('b', [_vm._v("Chester [16]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Chester Music below)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Chester")]), _vm._v(" Music "), _c('b', [_vm._v("[10, 13, 17]")]), _vm._v(" (now part of Music Sales Group)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("14-15 Berners Street"), _c('br'), _vm._v("London W1T 3LJ"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 20-7612-7400")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 20-7612-7545"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chesternovello.com",
      "target": "_blank"
    }
  }, [_vm._v("www.chesternovello.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Chiarato")]), _vm._v(" & Cia. "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("São Paulo, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Editions "), _c('b', [_vm._v("Choudens [16, 17]")]), _vm._v(" (now part of Music Sales Group)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Chromattica [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Chronos")]), _vm._v(" Music (absorbed by Cormorant Press; "), _c('i', [_vm._v("see")]), _vm._v(" Cormorant Press)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("John "), _c('b', [_vm._v("Church")]), _vm._v(" Company "), _c('b', [_vm._v("[18]")]), _vm._v(" (no longer in business)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Andrea "), _c('b', [_vm._v("Coen-Zanibon [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Franco "), _c('b', [_vm._v("Colombo [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Columbia Music Company [13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.comusco.com",
      "target": "_blank"
    }
  }, [_vm._v("www.comusco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Columbia University Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("61 West 62nd Street")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("New York, NY 10023")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.cc.columbia.edu/cu/cup",
      "target": "_blank"
    }
  }, [_vm._v("www.cc.columbia.edu/cu/cup")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 459-0600 or (800) 343-4499")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(Perseus Dist.)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 459-3678 (sales)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.cup.columbia.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.cup.columbia.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Composer/Performer Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("330 University Avenue"), _c('br'), _vm._v("Davis, CA 95616")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Composers Library")]), _vm._v(" Editions "), _c('b', [_vm._v("[7, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Composers")]), _vm._v(" Press ("), _c('i', [_vm._v("see")]), _vm._v(" Seesaw Music Corp.) "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Compozitor")]), _vm._v(" Publishing House")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Bolshaya Morskaya St., 45")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("190000 St. Petersburg, Russia"), _c('br'), _vm._v("Tel/Fax: (7) 812-314-50-54"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.compozitor.spb.ru/eng",
      "target": "_blank"
    }
  }, [_vm._v("www.compozitor.spb.ru/eng")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Concordia")]), _vm._v(" Publishing House "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3558 S. Jefferson St."), _c('br'), _vm._v("St. Louis, MO 63118")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (314) 268-1000 or (800) 325-3040")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (800) 490-9889"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.cph.org",
      "target": "_blank"
    }
  }, [_vm._v("www.cph.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Conners")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("503 Tahoe Street"), _c('br'), _vm._v("Natchitoches, LA 71457-5718")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (318) 357-0924"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.music-usa.org/conners",
      "target": "_blank"
    }
  }, [_vm._v("www.music-usa.org/conners")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Consolidated")]), _vm._v(" Music Publishers (part of Music Sales Corp.)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("257 Park Avenue South, 20th Floor"), _c('br'), _vm._v("New York, NY 10010")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 254-2100")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 254-2013"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.schirmer.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schirmer.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("The "), _c('b', [_vm._v("Consort")]), _vm._v(" Press "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1273 S. Rice Road, #8"), _c('br'), _vm._v("Ojai, CA 93023")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (805) 646-4779"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.consortpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.consortpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Continuo")]), _vm._v(" Music Press "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Copa [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cormorant Press [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cornetto")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hummelgasse 4")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("70378 Stuttgart, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 711-9561396")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 711-9561-397"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.cornetto-music.de",
      "target": "_blank"
    }
  }, [_vm._v("www.cornetto-music.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. B. "), _c('b', [_vm._v("Cramer")]), _vm._v(" & Co., Ltd. "), _c('b', [_vm._v("[2, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Cranz [3, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Creazioni Artistiche Musicali")]), _vm._v(" (C.A.M.)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Cola di Rienzo, 152")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("00192 Rome, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) (6) 6840791")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) (6) 6874046")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Crescendo")]), _vm._v(" Publishing Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (888) 602-8466"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.crescendopublishing.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.crescendopublishing.com/")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Crystal Spring")]), _vm._v(" Music Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("250 Ohua Avenue, 10E"), _c('br'), _vm._v("Honolulu, HI 96815")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (808) 923-6859")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Culver Crest")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 4484"), _c('br'), _vm._v("Culver City, CA 90231-4484"), _c('br'), _vm._v("Tel/Fax: (310) 838-4465"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.culvercrest.com/Culver_Crest_Publications",
      "target": "_blank"
    }
  }, [_vm._v("www.culvercrest.com/Culver_Crest_Publications")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni "), _c('b', [_vm._v("Curci [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Galleria del Corso, 4")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("20122 Milano, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 2-76-03-61")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 2-76-01-45-04"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edizionicurci.it",
      "target": "_blank"
    }
  }, [_vm._v("www.edizionicurci.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Currency Press")]), _vm._v(" Pty Ltd.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('i', [_vm._v("Street address:")]), _vm._v(" 164 James Street"), _c('br'), _vm._v("Redfern NSW 2016, Australia"), _c('br'), _vm._v("M"), _c('i', [_vm._v("ailing address:")]), _vm._v(" P.O. Box 2287"), _c('br'), _vm._v("Strawberry Hills 2012 NSW Australia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (61) (2) 9319-5877")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (61) (2) 9319-3649"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.currency.com.au",
      "target": "_blank"
    }
  }, [_vm._v("www.currency.com.au")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. "), _c('b', [_vm._v("Curwen")]), _vm._v(" & Son (England) "), _c('b', [_vm._v("[6, 10, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Czech State Music [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Da Capo")]), _vm._v(" Press "), _c('b', [_vm._v("[17]")]), _vm._v(" (part of Perseus Books Group)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("44 Farnsworth Street, 3rd Floor"), _c('br'), _vm._v("Boston, MA 02210")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (617) 252-5200 or"), _c('br'), _vm._v("(800) 343-4499 (orders)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (800) 351-5073 (orders)"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.perseusbooksgroup.com/dacapo",
      "target": "_blank"
    }
  }, [_vm._v("www.perseusbooksgroup.com/dacapo")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Dantalian,")]), _vm._v(" Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("11 Pembroke Street"), _c('br'), _vm._v("Newton, MA 02458"), _c('br'), _vm._v("Tel/Fax: (617) 244-7230"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.dantalian.com",
      "target": "_blank"
    }
  }, [_vm._v("www.dantalian.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("De Ring [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni "), _c('b', [_vm._v("de Santis")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Viale Mazzini 6")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("00195 Rome, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Deep Listening")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 1956"), _c('br'), _vm._v("Kingston, NY 12402")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (914) 338-5984"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.deeplistening.org",
      "target": "_blank"
    }
  }, [_vm._v("www.deeplistening.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Georges "), _c('b', [_vm._v("Delrieu [5, 6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("11, Rue de Paris"), _c('br'), _vm._v("06000 Nice, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 4-93-88-61-96"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.georgesdelrieu.com",
      "target": "_blank"
    }
  }, [_vm._v("www.georgesdelrieu.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Derry")]), _vm._v(" Music Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("221 Main Street, Suite 440"), _c('br'), _vm._v("San Francisco, CA 94105")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (415) 537-9640")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Desforges [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Le Havre, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Deutscher Verlag für Musik")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Leipzig, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("DGR")]), _vm._v(" Publishers (name changed to Seda Publications; "), _c('i', [_vm._v("see")]), _vm._v(" Seda Publications)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Oliver "), _c('b', [_vm._v("Ditson")]), _vm._v(" Company "), _c('b', [_vm._v("[15]")]), _vm._v(" (a subsdiary of TP)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.presser.com",
      "target": "_blank"
    }
  }, [_vm._v("www.presser.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Les Éditions "), _c('b', [_vm._v("Doberman-Yppan [6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2220, Chemin du Fleuve"), _c('br'), _vm._v("Saint-Romuald, QC"), _c('br'), _vm._v("G6W 1Y4 Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (418) 834-8384")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (418) 834-3522"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.dobermaneditions.com",
      "target": "_blank"
    }
  }, [_vm._v("www.dobermaneditions.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Ludwig "), _c('b', [_vm._v("Doblinger [6, 8, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Dohr [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Sindorfer Straße 19"), _c('br'), _vm._v("50127 Bergheim, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 2271-70-72-05/06")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 2271-70-72-07"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.dohr.de",
      "target": "_blank"
    }
  }, [_vm._v("www.dohr.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Donemus")]), _vm._v(" Publishing "), _c('b', [_vm._v("[6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Amsterdam, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: 6-4520-5176"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.donemus.nl",
      "target": "_blank"
    }
  }, [_vm._v("www.donemus.nl")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Donna [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Düsseldorf, German")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Dotesio")]), _vm._v(" (Spain) ("), _c('i', [_vm._v("see")]), _vm._v(" Union Musical Española)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Dover")]), _vm._v(" Publications "), _c('b', [_vm._v("[1, 8, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("31 East Second Street")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Mineola, NY 11501-3582")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 223-3130 or (516) 294-7000")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (516) 742-6953"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.doverpublications.com",
      "target": "_blank"
    }
  }, [_vm._v("www.doverpublications.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Dreililien")]), _vm._v(" Verlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Richard Birnbach"), _c('br'), _vm._v("Aubinger Strasse 9")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("82166 Gräfelfing, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49-89) 875450")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("L. K. "), _c('b', [_vm._v("Drew")]), _vm._v(" Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("303 Orton Road"), _c('br'), _vm._v("Yellow Springs, OH 45387")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (937) 767-9383")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Duma")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("557 Barron Avenue"), _c('br'), _vm._v("Woodbridge, NJ 07095")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (732) 636-5406")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (732) 636-5220"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.dumamusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.dumamusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Durand Costallat [13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Durand [2, 6, 8, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.durand-salabert-eschig.com",
      "target": "_blank"
    }
  }, [_vm._v("www.durand-salabert-eschig.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Eastman School of Music")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("26 Gibbs Street"), _c('br'), _vm._v("Rochester, NY 14604")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (585) 274-1000"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.esm.rochester.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.esm.rochester.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ediciones Musicales")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Campanario No. 315"), _c('br'), _vm._v("Havana, Cuba")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Editio Musica Budapest (EMB) [2, 6, 13, 15; 21,")]), _vm._v(" New Liszt Edition only]")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 322")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1370 Budapest, Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (36) 1-2361-104")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (36) 1-2361-101"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.emb.hu",
      "target": "_blank"
    }
  }, [_vm._v("www.emb.hu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Chroma")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 816"), _c('br'), _vm._v("Duncan, BC V9L 3Y2"), _c('br'), _vm._v("Canada")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Gravis")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Grabbeallee 15")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("13156 Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 30-61-69-81-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 30-61-69-81-21"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editiongravis.de",
      "target": "_blank"
    }
  }, [_vm._v("www.editiongravis.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Modern [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Nordstern")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Spitzwegstr. 17")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("70192 Stuttgart, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 711-8179106"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edno.de",
      "target": "_blank"
    }
  }, [_vm._v("www.edno.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Pan [11]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Edition Russe de Musique [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Tympanon")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Karl-Heinz Schickhaus"), _c('br'), _vm._v("Markt 52"), _c('br'), _vm._v("4271 St. Oswald b. Fr., Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 79-45-81-10")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Les Éditions "), _c('b', [_vm._v("Bleu Blanc Rouge")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Hansen House)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Éditions d'Etat pour la Littérature et l'Art [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Bucharest, Rumania")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions de la "), _c('b', [_vm._v("Sirène Musicale [18]")]), _vm._v(" Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Éditions du Centre de Musique Baroque de Versailles")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hôtel des Menus Plaisirs"), _c('br'), _vm._v("22, Avenue de Paris"), _c('br'), _vm._v("78003 Versailles Cedex, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-39-20-78-10")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-39-20-78-01"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.cmbv.fr/Recherche-UMR/Activites-scientifiques/Editions-musicologiques",
      "target": "_blank"
    }
  }, [_vm._v("http://www.cmbv.fr/Recherche-UMR/Activites-scientifiques/Editions-musicologiques")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions Musicales de la "), _c('b', [_vm._v("Schola Cantorum")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("et de la Procure Générale de Musique &"), _c('br'), _vm._v("Labatiaz ("), _c('i', [_vm._v("see")]), _vm._v(" Labatiaz)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions Musicales "), _c('b', [_vm._v("des Marais")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Editions Jobert)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions Musicales "), _c('b', [_vm._v("Transatlantiques [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions Ray "), _c('b', [_vm._v("Ventura [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions "), _c('b', [_vm._v("Rideau Rouge [10]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editions "), _c('b', [_vm._v("Romanos [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3 Michael Koutsofta str.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 56202")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3305 Limassol, Cyprus")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (357) 92-46-024")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (357) 92-41-362")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Editions 75")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("75, Rue de la Roquette"), _c('br'), _vm._v("75011 Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-43-48-90-57")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-43-48-85-74"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editions75.com",
      "target": "_blank"
    }
  }, [_vm._v("www.editions75.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Editorial Argentina")]), _vm._v(" de Música "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Editorial Cooperativa Interamericana de Compositores [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editorial de Música "), _c('b', [_vm._v("Boileau [6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/ Provença, 287")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("08037 Barcelona, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 93-487-74-56 or"), _c('br'), _vm._v("(34) 93-215-53-34")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 93-215-53-34"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.boileau-music.com",
      "target": "_blank"
    }
  }, [_vm._v("www.boileau-music.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editorial de "), _c('b', [_vm._v("Música Española Contemporánea")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Alcalá, 70")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("28009 Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34-91) 5770752")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) (91) 5757645")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editorial "), _c('b', [_vm._v("Politonia [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Buenos Aires, Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editura de Stat "), _c('b', [_vm._v("Pentru")]), _vm._v(" Literatura si Arta")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("("), _c('i', [_vm._v("see")]), _vm._v(" Editura Eminescu)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editura "), _c('b', [_vm._v("Eminescu")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Piata Presei Libere nr.1, corp C, et. 3,"), _c('br'), _vm._v("cam. 360")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Sector 1, Bucurest, Romania"), _c('br'), _vm._v("Tel/Fax: (40) 31-805-8938"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edituraeminescu.ro",
      "target": "_blank"
    }
  }, [_vm._v("www.edituraeminescu.ro")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni "), _c('b', [_vm._v("Curci")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Galleria del Corso, 4")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("20122 Milano, Italy"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edizionicurci.it",
      "target": "_blank"
    }
  }, [_vm._v("www.edizionicurci.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Elkan & Schildknecht")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Emil Carelius AB"), _c('br'), _vm._v("Kungsholmsgatan 15")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("112 27 Stockholm, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (46) 8-6515421")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Elkan-Vogel [15]")]), _vm._v(" (a subsidiary of T. Presser)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.presser.com",
      "target": "_blank"
    }
  }, [_vm._v("www.presser.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("William "), _c('b', [_vm._v("Elkin")]), _vm._v(" Music Services [In U.S., "), _c('i', [_vm._v("see")]), _vm._v(" "), _c('b', [_vm._v("6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Elkin Music International"), _c('br'), _vm._v("Station Road Industrial Estate Salhouse"), _c('br'), _vm._v("Norwich NR13 6NS, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44-1603) 721302")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44-1603) 721801")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Engström & Södring")]), _vm._v(" (Denmark) "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Enoch")]), _vm._v(" & Cie "), _c('b', [_vm._v("[6, 13]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Eres")]), _vm._v(" Edition")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Horst Schubert"), _c('br'), _vm._v("Hauptstraße 35")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("28865 Lilienthal, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 04298-1676")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 04298-5312"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.eres-musik.de",
      "target": "_blank"
    }
  }, [_vm._v("www.eres-musik.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Erviti")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("San Martin, 28 bajo"), _c('br'), _vm._v("20.005 San Sebastian, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 943-30-04-93")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 943-20-03-43")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Max "), _c('b', [_vm._v("Eschig [2, 6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.durand-salabert-eschig.com",
      "target": "_blank"
    }
  }, [_vm._v("www.durand-salabert-eschig.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Euganea")]), _vm._v(" Editoriale Comunicazioni")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Cernaia, 84")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("35142 Padova, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 049657493")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Eulenburg")]), _vm._v(" (Schott Music) "), _c('b', [_vm._v("[6, 8, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("European American")]), _vm._v(" Music Distributors Corp. and European American Retail Music "), _c('b', [_vm._v("[13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Excelsior")]), _vm._v(" Music Publishing "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Faber")]), _vm._v(" Music "), _c('b', [_vm._v("[1, 6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Fairfield,")]), _vm._v(" Ltd. ("), _c('i', [_vm._v("see")]), _vm._v(" Novello)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Manuel de "), _c('b', [_vm._v("Falla")]), _vm._v(" Ediciones "), _c('b', [_vm._v("[6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("S.L. C/ Breton de los Herreros, 55-Bajo F"), _c('br'), _vm._v("28003 Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34-91) 441-77-43")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34-91) 442-60-96"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.manueldefallaediciones.es",
      "target": "_blank"
    }
  }, [_vm._v("www.manueldefallaediciones.es")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Fallen Leaf Press")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" J. W. Pepper)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 10034"), _c('br'), _vm._v("Berkeley, CA 94709"), _c('br'), _vm._v("Tel/Fax: (510) 848-7805"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.fallenleaf.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fallenleaf.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Musik "), _c('b', [_vm._v("Fabrik [6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("18, Rue Marthe Aureau"), _c('br'), _vm._v("77400 Lagny-sur-Marne, France"), _c('br'), _vm._v("Tel/Fax: (33) 1-73-58-50-59"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.classicalmusicnow.com",
      "target": "_blank"
    }
  }, [_vm._v("www.classicalmusicnow.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Fazer [6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("FEMA")]), _vm._v(" Music Publications "), _c('b', [_vm._v("[")]), _vm._v("out of business"), _c('b', [_vm._v("]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Fentone")]), _vm._v(" Music (England) "), _c('b', [_vm._v("[6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Finnish Information Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lauttasaarentie 1")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("00200 Helsinki, Finland")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (358) 9-68101313")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (358) 9-682-0070"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.fimic.fi",
      "target": "_blank"
    }
  }, [_vm._v("www.fimic.fi")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. "), _c('b', [_vm._v("Fisher")]), _vm._v(" & Bro. "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("FJH")]), _vm._v(" Music Company "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2525 Davie Road, Suite 360"), _c('br'), _vm._v("Fort Lauderdale, FL 33317-7424")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 262-8744 or (954) 382-6061")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (954) 382-3073"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.fjhmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fjhmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("FLP")]), _vm._v(" Music Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 60806"), _c('br'), _vm._v("Oklahoma City, OK 73146"), _c('br'), _vm._v("(Does business by mail only.)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("La "), _c('b', [_vm._v("Flûte de Pan")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("59, Rue de Rome (Piano scores)"), _c('br'), _vm._v("75008 Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-42-93-47-82"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.laflutedepan.com",
      "target": "_blank"
    }
  }, [_vm._v("www.laflutedepan.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Foetisch")]), _vm._v(" Frères, S.A. "), _c('b', [_vm._v("[7, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lausanne, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Charles "), _c('b', [_vm._v("Foley,")]), _vm._v(" Inc. "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Fondazione "), _c('b', [_vm._v("Carminignani Rossini [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Pesaro, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Fondazione "), _c('b', [_vm._v("Eugenio Bravi [18]")]), _vm._v(" Milan, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Forberg [14, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("A. "), _c('b', [_vm._v("Forlivesi [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Stelloni 3/A"), _c('br'), _vm._v("40010 Sala Bolognese BO, Italy"), _c('br'), _vm._v("Tel: (39) 51-6814142/98")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 51-6814672"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.forlivesi.it",
      "target": "_blank"
    }
  }, [_vm._v("www.forlivesi.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Arnaldo "), _c('b', [_vm._v("Forni,")]), _vm._v(" Editore")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Gramsci 164"), _c('br'), _vm._v("40010 Sala Bologna, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39-51) 95-41-42 / 95-41-98")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39-51) 95-46-72"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.fornieditore.com",
      "target": "_blank"
    }
  }, [_vm._v("www.fornieditore.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Forsyth Brothers [6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("126 Deansgate"), _c('br'), _vm._v("Manchester M3 2GR"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 161-956-2052")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 161-834-0630"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.forsyths.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.forsyths.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Sam "), _c('b', [_vm._v("Fox")]), _vm._v(" Music Sales "), _c('b', [_vm._v("[15]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Warner/Chappell)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Frangipani")]), _vm._v(" Press "), _c('b', [_vm._v("[1]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Frank")]), _vm._v(" Music Corporation "), _c('b', [_vm._v("[10]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Fredonia")]), _vm._v(" Press Discs")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3947 Fredonia Drive"), _c('br'), _vm._v("Los Angeles, CA 90068"), _c('br'), _vm._v("Tel: (323) 851-3043")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("H. "), _c('b', [_vm._v("Freeman")]), _vm._v(" & Company "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Frog Peak")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Box 1052"), _c('br'), _vm._v("Lebanon, NH 03766"), _c('br'), _vm._v("Tel/Fax: (603) 643-9037"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.frogpeak.org",
      "target": "_blank"
    }
  }, [_vm._v("www.frogpeak.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Fromont [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Theodore "), _c('b', [_vm._v("Front")]), _vm._v(" Music Literature")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("6122 Cohasset Street"), _c('br'), _vm._v("Van Nuys, CA 91406-2989")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (818) 994-1902")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (818) 994-0419"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.tfront.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tfront.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Fujihara")]), _vm._v(" Music Company "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Furore")]), _vm._v(" Verlag "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Naumberger Straße 40")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("34127 Kassel, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 561-500-493-11")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 561-500-493-20"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.furore-verlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.furore-verlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Adolph "), _c('b', [_vm._v("Fürstner [13]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Galaxy")]), _vm._v(" Music Corp. "), _c('b', [_vm._v("[5, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Galliard,")]), _vm._v(" Ltd. (England) "), _c('b', [_vm._v("[5]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Garland")]), _vm._v(" Publishing "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("270 Madison Avenue #4"), _c('br'), _vm._v("New York, NY 10016")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (917) 315-7100")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Carl "), _c('b', [_vm._v("Gehrmans")]), _vm._v(" Musikförlag "), _c('b', [_vm._v("[2, 6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 42026")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("126 12 Stockholm, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (46) 8-6100-600"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.gehrmans.se",
      "target": "_blank"
    }
  }, [_vm._v("www.gehrmans.se")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("General Music Publishing")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Boston Music Company)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("General Words and Music [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Daniel "), _c('b', [_vm._v("Gerard")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5 Plain Avenue"), _c('br'), _vm._v("New Rochelle, NY"), _c('br'), _vm._v("Tel: (914) 235-2525")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Musikverlag Hans "), _c('b', [_vm._v("Gerig [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Girard [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Naples, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Glocken")]), _vm._v(" Verlag "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("12-14 Mortimer Street"), _c('br'), _vm._v("London WIT 3JJ"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Goldberg")]), _vm._v(" Ediçôes Musicais")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rua S. Vicente 360 ap A"), _c('br'), _vm._v("Porto Alegre (Rio Grande do Sul)"), _c('br'), _vm._v("Brazil"), _c('br'), _vm._v("Tel: (51) 3388-87-46")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Greenwood Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("World Library Publications"), _c('br'), _vm._v("2145 Central Parkway"), _c('br'), _vm._v("Cincinnati, OH 45214")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Gregg International")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("White Swan Ho"), _c('br'), _vm._v("Godstone, Surrey RH9 8LW"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44-1883) 744214")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44-1883) 744024")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Henri "), _c('b', [_vm._v("Gregh")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("129, rue Montmartre"), _c('br'), _vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Grupo "), _c('b', [_vm._v("Renovación [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Buenos Aires, Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("GSP Music")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("230 Townsend Street"), _c('br'), _vm._v("San Francisco, CA 94107-1720")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (415) 896-1144"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.gspguitar.com",
      "target": "_blank"
    }
  }, [_vm._v("www.gspguitar.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Gulbenkian Foundation")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Parque de Sta. Gertrudes à Avda. de"), _c('br'), _vm._v("Berna")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lisbon, Portugal"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Wolfgang G. "), _c('b', [_vm._v("Haas")]), _vm._v("-Musikverlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postfach 90 07 48"), _c('br'), _vm._v("Köln, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 2203-98-88-3-50")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 2203-98-88-3-50"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.haas-koeln.de",
      "target": "_blank"
    }
  }, [_vm._v("www.haas-koeln.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("G. K. "), _c('b', [_vm._v("Hall")]), _vm._v(" & Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Simon & Schuster "), _c('b', [_vm._v("[13]")]), _c('br'), _vm._v("200 Old Tappan Road"), _c('br'), _vm._v("Old Tappan, NJ 07675-7095")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 257-5157")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (800) 558-4676"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.simonandschuster.com",
      "target": "_blank"
    }
  }, [_vm._v("www.simonandschuster.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hamelle [13, 15, 17]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Leduc)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hansen House")]), _vm._v(" Music "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1820 West Avenue"), _c('br'), _vm._v("Miami Beach, FL 33139")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (305) 532-5461")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (305) 672-8729"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.hansenhousemusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hansenhousemusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Wilhelm "), _c('b', [_vm._v("Hansen [6, 10, 13, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Bornholmsgade 1A"), _c('br'), _vm._v("1266 Copenhagan K, Denmark"), _c('br'), _vm._v("Tel: (45) 33-11-78-88")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (45) 33-14-81-78"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ewh.dk",
      "target": "_blank"
    }
  }, [_vm._v("www.ewh.dk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hänssler")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" American Institute of Musicology) "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hargail")]), _vm._v(" Music Press "), _c('b', [_vm._v("[11]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Harmonia Uitgave [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Roeltjesweg 23-25"), _c('br'), _vm._v("Hilversum, Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Frederick "), _c('b', [_vm._v("Harris")]), _vm._v(" Music Co. "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(Distributed in the U.S. by FJH Music Company. "), _c('i', [_vm._v("See")]), _vm._v(" FJH.) Suite 882")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("60 Industrial Parkway"), _c('br'), _vm._v("Cheektowaga, NY 14227")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 387-4013")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (416) 408-1542"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.frederickharrismusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.frederickharrismusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Harvard University Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("79 Garden Street"), _c('br'), _vm._v("Cambridge, MA 02138-1499")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 448-2242 or (617) 495-2600")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (617) 495-5898"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.hup.harvard.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.hup.harvard.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Heinrichshofen")]), _vm._v(" Edition "), _c('b', [_vm._v("[16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Liebigstraße 15")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("26389 Wilhelmshaven, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 4421-9267-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 4421-9267-99"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.heinrichshofen.de",
      "target": "_blank"
    }
  }, [_vm._v("www.heinrichshofen.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Helicon")]), _vm._v(" Music ("), _c('i', [_vm._v("see")]), _vm._v(" Schott)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Helios")]), _vm._v(" Music Edition ("), _c('i', [_vm._v("see")]), _vm._v(" Plymouth Music)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("G. "), _c('b', [_vm._v("Henle")]), _vm._v(" USA. Inc. "), _c('b', [_vm._v("[6, 8, 10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Forstenrieder Allee 122")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("81476 Munchen, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 89-759-82-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 89-759-82-40"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.henleusa.com",
      "target": "_blank"
    }
  }, [_vm._v("www.henleusa.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Henmar")]), _vm._v(" Press (USA) "), _c('b', [_vm._v("[14]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions "), _c('b', [_vm._v("Henn")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5-7 Rue de l'Ancien-Port"), _c('br'), _vm._v("1201 Geneva, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (41) 22-738-91-10")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (41) 22-738-91-16")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("HBS "), _c('b', [_vm._v("Hepomuk")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Entfelderstrasse 39")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5000 Aarau, Switzerland"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.hbs-nepomuk.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.hbs-nepomuk.ch")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hermes Beard")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("7121 Viewpoint Road"), _c('br'), _vm._v("Aptos, CA 95003")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Heugel [13, 15, 17]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Leduc)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editions "), _c('b', [_vm._v("Heuwekemeijer [13]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.editionheuwekemeijer.nl",
      "target": "_blank"
    }
  }, [_vm._v("www.editionheuwekemeijer.nl")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hidden Oaks")]), _vm._v(" Music Company")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 47696"), _c('br'), _vm._v("San Antonio, TX 78284-9765")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (210) 590-1689"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.efabregas.com",
      "target": "_blank"
    }
  }, [_vm._v("www.efabregas.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Highgate")]), _vm._v(" Press "), _c('b', [_vm._v("[5]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hildegard")]), _vm._v(" Publishing Company "), _c('b', [_vm._v("[6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 18860"), _c('br'), _vm._v("Mount Airy, PA 19010")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (610) 667-8634")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (215) 359-0654"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.hildegard.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hildegard.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hinrichsen")]), _vm._v(" Edition (England) "), _c('b', [_vm._v("[14, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hinshaw")]), _vm._v(" Music "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(Hinshaw no longer publishes piano literature)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Friedrich "), _c('b', [_vm._v("Hofmeister")]), _vm._v(" (Germany) "), _c('b', [_vm._v("[6, 17,")]), _vm._v(" "), _c('i', [_vm._v("see also:")]), _vm._v(" William Elkin]")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hope")]), _vm._v(" Publishing Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("380 South Main Place"), _c('br'), _vm._v("Carol Stream, IL 60188"), _c('br'), _vm._v("Tel: (800) 323-1049 or (630) 665-3200")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (630) 665-2552"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.hopepublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hopepublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hudební Matice")]), _vm._v(" (Czech Republic) "), _c('b', [_vm._v("[18]")]), _vm._v(" (no longer in business)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hug [6, 11, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Case Postale 6455")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1002 Lausanne, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (41) 21-310-48-10")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (41) 21-310-48-19"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musikhug.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.musikhug.ch")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Hyperion")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("45 Riverside Avenue"), _c('br'), _vm._v("Westport, CT 06880"), _c('br'), _vm._v("*Division of Disney Book Publishing"), _c('br'), _vm._v("114 Fifth Avenue"), _c('br'), _vm._v("New York, NY 10011")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 343-9204 or (212) 633-4400")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 633-4811")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ichthys")]), _vm._v(" Verlag GmbH "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("IMI")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Israel Music Institute)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Imma")]), _vm._v(" Publishing Company")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1600 East Avenue, #1115"), _c('br'), _vm._v("Rochester, NY 14610"), _c('br'), _vm._v("Tel: (585) 413-1651"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.martaandriasova.webs.com",
      "target": "_blank"
    }
  }, [_vm._v("www.martaandriasova.webs.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Impero")]), _vm._v("-Verlag "), _c('b', [_vm._v("[13]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Imprimus")]), _vm._v(" Music ("), _c('i', [_vm._v("see")]), _vm._v(" Sikesdi Press)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Indiana University")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("William and Gayle Cook Music Library")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Simon Music Library & Recital Center")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("200 South Jordan Avenue")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Bloomington, IN 47405")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (812) 855-2970")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (812) 855-3843")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.music.indiana.edu/muslib",
      "target": "_blank"
    }
  }, [_vm._v("www.music.indiana.edu/muslib")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Instituto de Extensión Musicale")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Calle Compañia"), _c('br'), _vm._v("1274 Santiago, Chile")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("International Music Company [10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5 W. 37th Street"), _c('br'), _vm._v("New York, NY 10018")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 391-4200")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 391-4306"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.internationalmusicco.com",
      "target": "_blank"
    }
  }, [_vm._v("www.internationalmusicco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Internationale Gesellschaft für Neue Musik")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(International Society for New Music)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Sektion Österreich")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Ungargasse 11/12")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1030 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 1-23-63-803")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ignm.at",
      "target": "_blank"
    }
  }, [_vm._v("www.ignm.at")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Intitución Fernando el Católico")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Plaza de España, 2")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("50071 Zaragoza, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 976 288 878/79")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 976 288 869")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://ifc.dpz.es",
      "target": "_blank"
    }
  }, [_vm._v("http://ifc.dpz.es")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Intrepid Pixels")]), _vm._v(" Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("820 West End Avenue, Box 9E"), _c('br'), _vm._v("New York, NY 10025"), _c('br'), _vm._v("Tel: (212) 866-3939")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 280-8187")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ione Press,")]), _vm._v(" Inc. "), _c('b', [_vm._v("[5]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("138 Ipswich Street"), _c('br'), _vm._v("Boston, MA 02215")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (617) 236-1935")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (617) 236-0261")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Israel Music Institute")]), _vm._v(" (IMI) "), _c('b', [_vm._v("[13, 15]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("55 Menachem Begin Road"), _c('br'), _vm._v("67138 Tel Aviv, Israel")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (972) 3-624-70-95")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (972) 3-561-28-26"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.imi.org.il",
      "target": "_blank"
    }
  }, [_vm._v("www.imi.org.il")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Israeli Music Publications [13, 15]"), _c('br'), _vm._v("Japan Federation of Composers")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("#101, Mimori-Building"), _c('br'), _vm._v("1-19-4 Hatsudai")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Shibuya-Ku, Tokyo 151-0061 Japan")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (81) 3-6276-1177")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (81) 3-3376-3371"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.jfc.gr.jp",
      "target": "_blank"
    }
  }, [_vm._v("www.jfc.gr.jp")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Japanese Society of Rights of Authors and Composers")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.jasrac.or.jp",
      "target": "_blank"
    }
  }, [_vm._v("www.jasrac.or.jp")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Jaymar")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 2191, Stn. B"), _c('br'), _vm._v("London, Ontario N6A 4E3, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (519) 672-7369")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (519) 672-0016")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Jerona")]), _vm._v(" Music Corp. "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("224 King Street"), _c('br'), _vm._v("Englewood, NJ 07631")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (201) 568-8448")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (201) 569-7023")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Jean "), _c('b', [_vm._v("Jobert")]), _vm._v("/Editions Jobert et Cie "), _c('b', [_vm._v("[6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("27 Boulevard Beaumarchais"), _c('br'), _vm._v("75004 Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-56-68-86-60")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-56-68-90-66"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.jobert.fr",
      "target": "_blank"
    }
  }, [_vm._v("www.jobert.fr")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Joclem")]), _vm._v(" Music Publishing "), _c('b', [_vm._v("[2]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Johnson")]), _vm._v(" Reprint Corp.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("111 Fifth Avenue"), _c('br'), _vm._v("New York, NY 10003")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Joshua")]), _vm._v(" Corp. ("), _c('i', [_vm._v("see")]), _vm._v(" Boston Music Company)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Editions Joubert [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("P. "), _c('b', [_vm._v("Jürgenson [14]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2/46 Bolshaya Sadovaya St."), _c('br'), _vm._v("Moscow 123001, Russia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (7) 495-254-8180")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (7) 495-609-0793"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.jurgenson.pro",
      "target": "_blank"
    }
  }, [_vm._v("www.jurgenson.pro")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("C. F. "), _c('b', [_vm._v("Kahnt [14]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Frankfurt, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Kallisti")]), _vm._v(" Music Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("810 S. Saint Bernard Street"), _c('br'), _vm._v("Philadelphia, PA 19143-3309")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (215) 724-6511 or (800) 260-2881"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.kallistimusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.kallistimusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edwin F. "), _c('b', [_vm._v("Kalmus [6, 8, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 5011"), _c('br'), _vm._v("Boca Raton, FL 33431")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 434-6340")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (561) 241-6347"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.efkalmus.com",
      "target": "_blank"
    }
  }, [_vm._v("www.efkalmus.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Edition Kemel")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Niedernhausen, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Kenyon")]), _vm._v(" Publications "), _c('b', [_vm._v("[10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("E. C. "), _c('b', [_vm._v("Kerby [10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Toronto, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Keturi")]), _vm._v(" Musikverlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postfach 1120"), _c('br'), _vm._v("83251 Rimsting, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 8051-1634")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 8051-63042"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.arends-musikverlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.arends-musikverlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("The "), _c('b', [_vm._v("Keys Press")]), _vm._v(" (available through Theodore Front)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("66 Clotilde Street"), _c('br'), _vm._v("Mount Lawley"), _c('br'), _vm._v("Western Australia 6050, Australia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (61-8) 9271-6547")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (61-8) 9271-6581"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.keyspress.com.au",
      "target": "_blank"
    }
  }, [_vm._v("www.keyspress.com.au")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Robert "), _c('b', [_vm._v("King")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("140 Main Street"), _c('br'), _vm._v("North Easton, MA 02356"), _c('br'), _vm._v("Fax: (508) 238-2571"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.rkingmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.rkingmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Kistner & Siegel [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Kultura [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Kunzelmann")]), _vm._v(" (Switzerland) "), _c('b', [_vm._v("[6, 14, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("La Jolla")]), _vm._v(" Publishing "), _c('b', [_vm._v("[9]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions Musicales "), _c('b', [_vm._v("Labatiaz")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Case postale 112")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1890 St-Maurice, Switzerland"), _c('br'), _vm._v("Tel/Fax: (41) 24-485-24-80"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editions-labatiaz.com",
      "target": "_blank"
    }
  }, [_vm._v("www.editions-labatiaz.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Laurentius")]), _vm._v(" Musikverlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Dr. Wolfram Hader"), _c('br'), _vm._v("Stegerwaldstraße 21"), _c('br'), _vm._v("65929 Frankfurt a.M., Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 69-26-49-47-38")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 69-93-62-34-49"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.laurentius-musikverlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.laurentius-musikverlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lawson Gould")]), _vm._v(" Music Publishers "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lea")]), _vm._v(" Pocket Scores "), _c('b', [_vm._v("[2]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Alphonse "), _c('b', [_vm._v("Leduc [6, 13, 15]")]), _vm._v(" (also available in U.S. through Robert King)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("175, rue Saint-Honoré"), _c('br'), _vm._v("75040 Paris Cedex 01, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-42-96-89-11")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-42-86-02-83"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.alphonseleduc.com",
      "target": "_blank"
    }
  }, [_vm._v("www.alphonseleduc.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lee Roberts [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 341"), _c('br'), _vm._v("Chatham, NY 12037")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (518) 533-4921"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.leerobertsmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.leerobertsmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Leeds Music Corp.")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Universal Music Publishing Group)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Leeds Music Ltd.")]), _vm._v(" (Canada) ("), _c('i', [_vm._v("see")]), _vm._v(" Universal Music Publishing Group)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Robert Owen "), _c('b', [_vm._v("Lehman")]), _vm._v(" Foundation")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o The Morgan Library & Museum"), _c('br'), _vm._v("225 Madison Avenue"), _c('br'), _vm._v("New York, NY 10016")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 685-0008"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.themorgan.org/research/collectionsMusic.asp",
      "target": "_blank"
    }
  }, [_vm._v("http://www.themorgan.org/research/collectionsMusic.asp")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Henry "), _c('b', [_vm._v("Lemoine [6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("27 Boulevard Beaumarchais"), _c('br'), _vm._v("75004 Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-56-68-86-65")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-56-68-90-66"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.henry-lemoine.com",
      "target": "_blank"
    }
  }, [_vm._v("www.henry-lemoine.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Alfred "), _c('b', [_vm._v("Lengnick")]), _vm._v(" ["), _c('i', [_vm._v("see also:")]), _vm._v(" William Elkin] "), _c('b', [_vm._v("[13]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Wayne "), _c('b', [_vm._v("Leopold")]), _vm._v(" Editions")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("8510 Triad Drive"), _c('br'), _vm._v("Colfax, NC 27235")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 765-3196"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.wayneleupold.com",
      "target": "_blank"
    }
  }, [_vm._v("www.wayneleupold.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lerolle [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editorial "), _c('b', [_vm._v("Letras Cubanas")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Calle G, No. 505"), _c('br'), _vm._v("El Vedado"), _c('br'), _vm._v("Habana, Cuba"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ecured.cu/index.php/Editorial_Letras_Cubanas",
      "target": "_blank"
    }
  }, [_vm._v("www.ecured.cu/index.php/Editorial_Letras_Cubanas")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("F. E. C. "), _c('b', [_vm._v("Leuckart [6, 10]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rheingoldstr. 4"), _c('br'), _vm._v("80639 Munich, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 8917-3928")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 8917-6054")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lewis")]), _vm._v(" Music Publishing Co. "), _c('b', [_vm._v("[16]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Library of Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Music Division"), _c('br'), _vm._v("James Madison Memorial Bldg."), _c('br'), _vm._v("101 Independence Avenue, SE"), _c('br'), _vm._v("Washington, DC 20540-4710")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (202) 707-5507"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.loc.gov/rr/perform/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.loc.gov/rr/perform/")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Robert "), _c('b', [_vm._v("Lienau")]), _vm._v(" Musikverlag "), _c('b', [_vm._v("[6, 14, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 69-978286-6")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 69-978286-79"), _c('br'), _vm._v("Frankfurt, Germany"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.lienau-frankfurt.de",
      "target": "_blank"
    }
  }, [_vm._v("www.lienau-frankfurt.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lingua Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 1192"), _c('br'), _vm._v("La Jolla, CA 92038")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Collection "), _c('b', [_vm._v("Litolff [14]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Longman [2]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1560 Broadway"), _c('br'), _vm._v("New York, NY 10036")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Harald "), _c('b', [_vm._v("Lyche")]), _vm._v(" & Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postboks 2171 Str"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/c1.jpg"
    }
  }), _vm._v("ms"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/c1.jpg"
    }
  }), _c('br'), _vm._v("3001 Drammen, Norway"), _c('br'), _vm._v("Tel: (47) 32-24-50-00")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Lyrebird")]), _vm._v(" Press (Editions de l'Oiseau-Lyre)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Faculty of Music"), _c('br'), _vm._v("University of Melbourne"), _c('br'), _vm._v("VIC 3010, Australia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (61) 3-8344-5346"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.lyrebirdpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.lyrebirdpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Vieira "), _c('b', [_vm._v("Machado")]), _vm._v(" Editores")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Maecenas")]), _vm._v(" Music "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5 Bushey Close"), _c('br'), _vm._v("Old Barn Lane"), _c('br'), _vm._v("Kenley, Surrey CR8 5AU"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 20-8660-3914")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 20-8668-5273"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.maecenasmusic.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.maecenasmusic.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Maestro")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Hansen House)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Pierre "), _c('b', [_vm._v("Mardaga")]), _vm._v(" Editeur, S.A.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Avenue Pasteur 6—Bât. H"), _c('br'), _vm._v("1300 Wavre, Belgium"), _c('br'), _vm._v("Tel: (32) 10-686452"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.mardaga.be",
      "target": "_blank"
    }
  }, [_vm._v("www.mardaga.be")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Margun/Gunmar Music [10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("167 Dudley Road"), _c('br'), _vm._v("Newton Center, MA 02159"), _c('br'), _vm._v("Tel: (617) 332-6398")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (617) 969-1079")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edward B. "), _c('b', [_vm._v("Marks [10, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("126 E. 38th Street"), _c('br'), _vm._v("New York, NY 10016"), _c('br'), _vm._v("Tel: (212) 779-7977")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 779-7920"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ebmarks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ebmarks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Masters")]), _vm._v(" Music Publications "), _c('b', [_vm._v("[6, 8, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("6403 W. Rogers Circle")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Boca Raton, FL 33487")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (561) 241-6169 or (800) 434-6340")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (561) 241-6347")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.masters-music.com",
      "target": "_blank"
    }
  }, [_vm._v("www.masters-music.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Materiali Sonori")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Tre Novembre 2")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("52027 San Giovanni Valdarno, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 559120363")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 559120370"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.matson.it",
      "target": "_blank"
    }
  }, [_vm._v("www.matson.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Kevin "), _c('b', [_vm._v("Mayhew [3, 6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Buxhall"), _c('br'), _vm._v("Stowmarket"), _c('br'), _vm._v("Suffolk IP14 3BW"), _c('br'), _vm._v("United Kingdom"), _c('br'), _vm._v("Tel: (44) 845-388-1634")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 1449-737834"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.kevinmayhew.com",
      "target": "_blank"
    }
  }, [_vm._v("www.kevinmayhew.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("MCA")]), _vm._v(" Music Publishing ("), _c('i', [_vm._v("see")]), _vm._v(" Universal Music Publishing Group) "), _c('b', [_vm._v("[13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("McAfee")]), _vm._v(" Music Corp. "), _c('b', [_vm._v("[1]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("McGinnis & Marx [6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("236 West 26th Street, #11S"), _c('br'), _vm._v("New York, NY 10001-6736"), _c('br'), _vm._v("Tel: (212) 675-1630")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 675-1630")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition Tilo "), _c('b', [_vm._v("Medek")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rheinhöhe, Westerwaldweg 22")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("53424 Remagen-Oberwinter, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 2228-8175")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 2228-8176"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.medek.net",
      "target": "_blank"
    }
  }, [_vm._v("www.medek.net")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Melos")]), _vm._v(" Ediciones Musicales "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tte. Gral. Juan D. Perón 1560"), _c('br'), _vm._v("C1037ACD Buenos Aires, Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (54) 11-4371-9841"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.melos.com.ar",
      "target": "_blank"
    }
  }, [_vm._v("www.melos.com.ar")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Mercury")]), _vm._v(" Music Corp. "), _c('b', [_vm._v("[13, 15]")]), _vm._v(" (a subsidiary of TP)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.presser.com",
      "target": "_blank"
    }
  }, [_vm._v("www.presser.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Merion")]), _vm._v(" Music, Inc. "), _c('b', [_vm._v("[15, 17]")]), _vm._v(" (a subsidiary of TP)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.presser.com",
      "target": "_blank"
    }
  }, [_vm._v("www.presser.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Merseburger [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Naumburger Str. 40")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("43127 Kassel, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 561-789809-11")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 561-789809-16"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.merseburger.de",
      "target": "_blank"
    }
  }, [_vm._v("www.merseburger.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Metropolis")]), _vm._v(" Editions "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Ediciones "), _c('b', [_vm._v("Mexicanas")]), _vm._v(" de Música "), _c('b', [_vm._v("[15]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Mills")]), _vm._v(" Music "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Minkoff")]), _vm._v(" Musique et Musicologie / Éditions Minkoff")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("8, rue Eynar"), _c('br'), _vm._v("1211 Geneva 12, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (41-22) 310-46-60")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (41-22) 310-28-57")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Mira")]), _vm._v(" Music Associates")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("199 Mountain Road"), _c('br'), _vm._v("Wilton, CT 06897-1526"), _c('br'), _vm._v("Tel: (302) 762-5186")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Mitteldeutscher")]), _vm._v(" Verlag "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("MJQ")]), _vm._v(" Music "), _c('b', [_vm._v("[10]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Mobart")]), _vm._v(" Music Publications ("), _c('i', [_vm._v("see")]), _vm._v(" Boelke-Bomart)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Uitgeverij "), _c('b', [_vm._v("Moebiprint")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hercules Segherslaan 28"), _c('br'), _vm._v("1701 XB Heerhugowaard"), _c('br'), _vm._v("The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (31) 07-2571-5172")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Hermann "), _c('b', [_vm._v("Moeck")]), _vm._v(" Verlag "), _c('b', [_vm._v("[6, 13, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postfach 3131"), _c('br'), _vm._v("29231 Celle, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 5141-8853-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 5141-8853-42"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.moeck.com",
      "target": "_blank"
    }
  }, [_vm._v("www.moeck.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editio "), _c('b', [_vm._v("Moravia")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hvozdec 55"), _c('br'), _vm._v("664 71 Veverská Bítýška"), _c('br'), _vm._v("Tel/Fax: (420) 549-420-675"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editiomoravia.cz",
      "target": "_blank"
    }
  }, [_vm._v("www.editiomoravia.cz")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Moravian")]), _vm._v(" Music Foundation Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Assoc. University Presses"), _c('br'), _vm._v("440 Forsgate Drive"), _c('br'), _vm._v("Cranbury, NJ 08512"), _c('br'), _vm._v("Tel: (609) 655-4770")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edwin H. "), _c('b', [_vm._v("Morris [10]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("39 West 54th Street"), _c('br'), _vm._v("New York, NY 10019")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Karl Heinrich "), _c('b', [_vm._v("Möseler")]), _vm._v(" Verlag "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Hoffmann-v.-F.-Str. 8")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("38304 Wolfenbüttel, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 5331-95970")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 5331-959720"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.moeseler-verlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.moeseler-verlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Mowbray")]), _vm._v(" Music Publishers "), _c('b', [_vm._v("[13, 15]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Willy "), _c('b', [_vm._v("Müller")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Bärenreiter)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Musikverlag "), _c('b', [_vm._v("Müller & Schade")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Moserstrasse 16")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3014 Bern, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (41) 31-320-26-26")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (41) 31-320-26-27"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.mueller-schade.com",
      "target": "_blank"
    }
  }, [_vm._v("www.mueller-schade.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Ediciones Musicales "), _c('b', [_vm._v("Mundimúsica")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Espejo, 4"), _c('br'), _vm._v("28013 Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 91-548-17-94")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 91-548-17-53"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.mundimusica.es",
      "target": "_blank"
    }
  }, [_vm._v("www.mundimusica.es")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Murdoch & Murdoch")]), _vm._v(" (London) "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Music")]), _vm._v(" Graphics Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3409 Dickens Street"), _c('br'), _vm._v("San Diego, CA 92106"), _c('br'), _vm._v("Tel: (619) 523-1962")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Music Press [7]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Music Sales Limited [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Newmarket Road"), _c('br'), _vm._v("Bury St. Edmund"), _c('br'), _vm._v("Suffolk IP33 3YB, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Music Treasure")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("620 Fort Washington Avenue, #1F"), _c('br'), _vm._v("New York, NY 10040-3930")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Musica Islandica")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Iceland Music Information Centre"), _c('br'), _vm._v("Sidumuli 34")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("108 Reykjavik, Iceland")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (354) 568-3122")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (354) 568-3124"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.mic.is",
      "target": "_blank"
    }
  }, [_vm._v("www.mic.is")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editorial "), _c('b', [_vm._v("Musica Moderna [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editora "), _c('b', [_vm._v("Música Nova")]), _vm._v(" do Brasil")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rua Pres. Carlos de Campos 115"), _c('br'), _vm._v("bl.02/902"), _c('br'), _vm._v("22231-080 Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (55) 21-2553-6222")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (55) 21-2553-9963"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.sites.uol.com.br/marlosnobre",
      "target": "_blank"
    }
  }, [_vm._v("www.sites.uol.com.br/marlosnobre")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Musica Obscura")]), _vm._v(" Editions "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("17 Joey Road")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Merrimack, NH 03054-4549")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (603) 881-7210")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (603) 595-8382")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Musica Rara [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("215 Bailey Avenue"), _c('br'), _vm._v("Rock Hill, SC 29732-1003")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (803) 366-4446")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (803) 212-0016"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musicarara.com",
      "target": "_blank"
    }
  }, [_vm._v("www.musicarara.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editora "), _c('b', [_vm._v("Musical Brasileira")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Musical Scope")]), _vm._v(" Publishers "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Musikk-Huset")]), _vm._v(" Forlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postbox 1499 Vika"), _c('br'), _vm._v("0116 Oslo, Norway"), _c('br'), _vm._v("Tel: (47) 22-82-59-00")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (47) 22-82-59-01"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musikk-huset.no",
      "target": "_blank"
    }
  }, [_vm._v("www.musikk-huset.no")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Musikwissenschaftlichen [14]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Dorotheergasse 10"), _c('br'), _vm._v("1010 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 1-515-03-43")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (43) 1-515-03-51"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.mwv.at",
      "target": "_blank"
    }
  }, [_vm._v("www.mwv.at")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Muzblka")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Moscow, Russia")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editura "), _c('b', [_vm._v("Muzicală")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Calea Victoriei nr. 141, sector 1")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("71102 Bucharest, Romania"), _c('br'), _vm._v("Tel/Fax: (40) 21-312-98-67"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edituramuzicala.ro",
      "target": "_blank"
    }
  }, [_vm._v("www.edituramuzicala.ro")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Nagel's")]), _vm._v(" Musik-Archive ("), _c('i', [_vm._v("see")]), _vm._v(" Bärenreiter)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Arthur "), _c('b', [_vm._v("Napoleão [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Musikedition "), _c('b', [_vm._v("Nepomuk")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" HBS Nepomuk)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("New Music Edition [7, 10]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("New Music USA")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("90 John Street, Suite 312"), _c('br'), _vm._v("New York City, NY 10038")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 645-6949")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (646) 490-0998"), _c('br'), _c('a', {
    attrs: {
      "href": "http://library.newmusicusa.org",
      "target": "_blank"
    }
  }, [_vm._v("library.newmusicusa.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("New Music West")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1437 Crest Drive"), _c('br'), _vm._v("Altadena, CA 91001"), _c('br'), _vm._v("Tel: (626) 794-1684")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("New World Music")]), _vm._v(" Corp. "), _c('b', [_vm._v("[1]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Pierre "), _c('b', [_vm._v("Noël")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Billaudot)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Otto Heinrich "), _c('b', [_vm._v("Noetzel")]), _vm._v(" Verlag "), _c('b', [_vm._v("[14]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Liebigstraße 15")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("26389 Wilhelmshaven, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 4421-9267-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 4421-9267-99"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.heinrichshofen.de",
      "target": "_blank"
    }
  }, [_vm._v("www.heinrichshofen.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Nordiska")]), _vm._v(" Musikförlaget "), _c('b', [_vm._v("[6, 16]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Gehrmans Musikförlag"), _c('br'), _vm._v("Box 42026")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("126 12 Stockholm, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (46) 8-610-06-00")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (46) 8-610-06-27")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Norruth")]), _vm._v(" Music "), _c('b', [_vm._v("[12]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("St. Louis, MO 63103")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Norsk")]), _vm._v(" Musikforläg "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Postboks 1499 Vika"), _c('br'), _vm._v("0116 Oslo, Norway")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (47) 23-00-21-10")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (47) 23-00-20-11"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.norskmusikkforlag.no",
      "target": "_blank"
    }
  }, [_vm._v("www.norskmusikkforlag.no")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Norton")]), _vm._v(" Critical Scores")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("W. W. Norton"), _c('br'), _vm._v("500 Fifth Avenue"), _c('br'), _vm._v("New York, NY 10110"), _c('br'), _vm._v("Tel: (800) 233-4830 or (212) 354-5500")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 869-0856"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.wwnorton.com",
      "target": "_blank"
    }
  }, [_vm._v("www.wwnorton.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Nottingham")]), _vm._v(" Square Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Music Publishing Services"), _c('br'), _vm._v("236 W. 26th Street, Suite 11-S"), _c('br'), _vm._v("New York, NY 10001"), _c('br'), _vm._v("Tel: (212) 243-5233")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 675-1630")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editora "), _c('b', [_vm._v("Novas Metas")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("São Paulo, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Novello [6, 10, 13, 16, 17]")]), _vm._v(" (now part of Music Sales Group)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("14-15 Berners Street"), _c('br'), _vm._v("London W1T 3LJ"), _c('br'), _vm._v("United Kingdom"), _c('br'), _vm._v("Tel: (44) 20-7612-7400")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 20-7612-7545"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chesternovello.com",
      "target": "_blank"
    }
  }, [_vm._v("www.chesternovello.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Oertel")]), _vm._v(" Verlag "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Oesterreichischer Bundesverlag")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Frankgasse 4")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1090 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 1-401-36-36")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (43) 1-401-36-60"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.oebv.at",
      "target": "_blank"
    }
  }, [_vm._v("www.oebv.at")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions de l"), _c('b', [_vm._v("'Oiseau-Lyre [6, 11, 17]")]), _vm._v(" (now taken over by Lyrebird Press)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("OMI")]), _vm._v(" (Old Manuscripts and Incunabula)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 6019 FDR Station"), _c('br'), _vm._v("New York, NY 10150")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 758-1946")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 593-6186"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.omifacsimiles.com",
      "target": "_blank"
    }
  }, [_vm._v("www.omifacsimiles.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ongaku-No-Tomo-Sha [6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ongakunotomo.co.jp",
      "target": "_blank"
    }
  }, [_vm._v("www.ongakunotomo.co.jp")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editions "), _c('b', [_vm._v("Orphée [13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1240 Clubview Blvd. N."), _c('br'), _vm._v("Columbus, OH 43235-1226")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (614) 846-9517")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (614) 846-9794"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editionsorphee.com",
      "target": "_blank"
    }
  }, [_vm._v("www.editionsorphee.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Les Éditions "), _c('b', [_vm._v("Ouvrières")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Alphonse Leduc)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Oxford")]), _vm._v(" University Press "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("198 Madison Avenue"), _c('br'), _vm._v("New York, NY 10016")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 726-6000"), _c('br'), _c('i', [_vm._v("Customer Service")]), _vm._v(" (Orders):"), _c('br'), _vm._v("2001 Evans Road"), _c('br'), _vm._v("Cary, NC 27513")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 411-5445")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (919) 677-1303"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.oup.com/us",
      "target": "_blank"
    }
  }, [_vm._v("www.oup.com/us")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Pan American Union")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Peermusic)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Panton")]), _vm._v(" International ("), _c('i', [_vm._v("see")]), _vm._v(" European American Music Distributors)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Papagena")]), _vm._v(" Press "), _c('b', [_vm._v("[6, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Box 20484, Park West Station"), _c('br'), _vm._v("New York, NY 10025")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 316-2235"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.papagenapress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.papagenapress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Papagrigoriou-Nakas")]), _vm._v(" Music Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(Ch. Nakas—C. Papagrigoriou Co.)"), _c('br'), _vm._v("39 Panepistimiou Street"), _c('br'), _vm._v("105 64 Athens, Greece")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (30) 210-32-21-786")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (30) 210-32-22-742"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.panasmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.panasmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Paragon")]), _vm._v(" Music Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Brentwood-Benson Music"), _c('br'), _vm._v("Publishing"), _c('br'), _vm._v("5409 Maryland Way, Suite 200"), _c('br'), _vm._v("Brentwood, TN 37027")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (615) 371-1320")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (615) 371-1351"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.musicservices.org",
      "target": "_blank"
    }
  }, [_vm._v("www.musicservices.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Parnaso")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rua N.S. Fatima, 231"), _c('br'), _vm._v("Porto, Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("W. "), _c('b', [_vm._v("Paxton [6]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Music Sales Ltd)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("London, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Peer International")]), _vm._v(" has become part of Peermusic Classical (810 Seventh Avenue, New York, NY 10019) "), _c('b', [_vm._v("[6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("250 W. 57th St., Suite 820")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("New York, NY 10107")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 265-3910")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 489-2465"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.peermusicclassical.com",
      "target": "_blank"
    }
  }, [_vm._v("www.peermusicclassical.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Pennsylvania State")]), _vm._v(" Music Series Publication of this series was discontinued in the 1970s; no longer available from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. W. "), _c('b', [_vm._v("Pepper & Son")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2480 Industrial Blvd."), _c('br'), _vm._v("Paoli, PA 19301"), _c('br'), _vm._v("Tel: (800) 345-6296 or (610) 648-0500")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (610) 993-0563"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.jwpepper.com",
      "target": "_blank"
    }
  }, [_vm._v("www.jwpepper.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Permanent Press,")]), _vm._v(" Music of Quality")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("7508 42nd Avenue, NE"), _c('br'), _vm._v("Seattle, WA 98115"), _c('br'), _vm._v("Tel: (206) 525-6596")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Philharmusica Edition [8]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.philharmusica.com",
      "target": "_blank"
    }
  }, [_vm._v("www.philharmusica.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions "), _c('b', [_vm._v("Philippo")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Éditions Combres"), _c('br'), _vm._v("27 Boulevard Beaumarchais"), _c('br'), _vm._v("75004 Paris, France"), _c('br'), _vm._v("Tel: (33) 1-56-68-86-64")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-56-68-90-66"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editions-combre.com",
      "target": "_blank"
    }
  }, [_vm._v("www.editions-combre.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Prhythm [1, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Pioneer")]), _vm._v(" Editions ("), _c('i', [_vm._v("see")]), _vm._v(" American Composers Alliance)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Piwarski")]), _vm._v(" Verlag "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Cracow, Poland")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Plymouth")]), _vm._v(" Music "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("170 NE 33rd Street"), _c('br'), _vm._v("Fort Lauderdale, FL 33334")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (305) 563-1844")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (305) 563-9006")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Polish Music Publications/")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Polskie Wydawnictwo Muzyczne")]), _vm._v(" [PWM] "), _c('b', [_vm._v("[6, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("al. Krasinskiego 11a"), _c('br'), _vm._v("31-111 Krakow, Poland"), _c('br'), _vm._v("Tel/Fax: (48-12) 422-71-71"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.pwm.com.pl",
      "target": "_blank"
    }
  }, [_vm._v("www.pwm.com.pl")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Poon Hill")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.poonhill.com",
      "target": "_blank"
    }
  }, [_vm._v("www.poonhill.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Price Milburn [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Wellington, New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Printed Editions")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 27"), _c('br'), _vm._v("Barrytown, NY 12507")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Pro Organo [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Brühlstraße 42")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("88299 Leutkirch, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 7561-3398")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 7561-72188"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.pro-organo.com",
      "target": "_blank"
    }
  }, [_vm._v("www.pro-organo.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Promethean")]), _vm._v(" Editions "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 10143"), _c('br'), _vm._v("Wellington, New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (64) 4-473-5033")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (64) 4-473-5066"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.promethean-editions.co.nz",
      "target": "_blank"
    }
  }, [_vm._v("www.promethean-editions.co.nz")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("PRO/Scribes")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("734 Wolcott Drive"), _c('br'), _vm._v("Philadelphia, PA 19118")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Providence")]), _vm._v(" Music Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 2362"), _c('br'), _vm._v("East Side Station"), _c('br'), _vm._v("Providence, RI 02906")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Keith "), _c('b', [_vm._v("Prowse")]), _vm._v(" Music Publishing")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("London, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Publicacions de l'Abadia de Montserrat")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Carrer d'Ausiàs Marc, 92-98"), _c('br'), _vm._v("0813 Barcelona, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 93-24-50-303")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 93-24-73-594"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.pamsa.cat/pamsa/inici",
      "target": "_blank"
    }
  }, [_vm._v("www.pamsa.cat/pamsa/inici")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Queen's Temple Publications [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("15 Mallard Drive"), _c('br'), _vm._v("Buckingham")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Buckinghamshire MK18 1GJ United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel/Fax: (44) 1280-813144"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.qtpublications.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.qtpublications.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Radiodifusão Portuguesa")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Av. Duarte Pacheco, no.5-4"), _c('br'), _vm._v("Lisbon, Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("D. "), _c('b', [_vm._v("Rahter [13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Basil "), _c('b', [_vm._v("Ramsey [13]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("604 Rayleigh Road"), _c('br'), _vm._v("Eastwood Leigh-on-Sea"), _c('br'), _vm._v("Essex SS9 5HU"), _c('br'), _vm._v("United Kingdom"), _c('br'), _vm._v("Tel: (44) 1702-524305")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 1702-526142")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Raptus")]), _vm._v(" Edition")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 3698")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Amsterdam, The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Recital Publications [6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 1697"), _c('br'), _vm._v("Huntsville, TX 77342-1697")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel/Fax: (936) 295-6929"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.recitalpublications.com",
      "target": "_blank"
    }
  }, [_vm._v("www.recitalpublications.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Redcliffe")]), _vm._v(" Edition")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("68 Barrowgate Road"), _c('br'), _vm._v("London W4 4HD"), _c('br'), _vm._v("United Kingdom"), _c('br'), _vm._v("Tel: (020) 8995-1223")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Remick")]), _vm._v(" Music Corp. "), _c('b', [_vm._v("[1]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Reuter & Reuter")]), _vm._v(" Forlags")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 55755")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("11483 Stockholm, Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (46) 86-29-53-70")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("G. "), _c('b', [_vm._v("Ricordi")]), _vm._v(" & Co. (International) "), _c('b', [_vm._v("[2, 6, 13, 10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via Benigno Crespi, 19")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("20159 Milan, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 2-80282-811")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 2-80282-882"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ricordi.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ricordi.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ricordi Americana")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" ALMA, Inc., and G. Ricordi & Co.) "), _c('b', [_vm._v("[6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ricordi BA")]), _vm._v(" (Argentina) "), _c('b', [_vm._v("[6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ricordi BR")]), _vm._v(" (Brazil) ("), _c('i', [_vm._v("see")]), _vm._v(" ALMA, Inc.) "), _c('b', [_vm._v("[6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ries & Erler")]), _vm._v(" (Germany) "), _c('b', [_vm._v("[6, 7, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Wandalenalle 8")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("14052 Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 30-825-10-49")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 30-825-97-21"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.rieserler.de",
      "target": "_blank"
    }
  }, [_vm._v("www.rieserler.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Robbins")]), _vm._v(" Music "), _c('b', [_vm._v("[1]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Roberton")]), _vm._v(" Publications "), _c('b', [_vm._v("[13]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Aylesbury, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Winthrop "), _c('b', [_vm._v("Rogers")]), _vm._v(" Edition "), _c('b', [_vm._v("[2]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Romcan")]), _vm._v(" Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("115 Orange Street"), _c('br'), _vm._v("Beaufort, NC 28516"), _c('br'), _vm._v("Tel: (252) 728-2542")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Rongwen")]), _vm._v(" Music "), _c('b', [_vm._v("[2, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("E. "), _c('b', [_vm._v("Rouart, Lerolle & Co.")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Salabert)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Rozsavölgi [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Budapest, Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Russian Music Publishers [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 49 ‘RMP’"), _c('br'), _vm._v("Moscow 105120, Russia")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (7) 495-928-0571")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (7) 495-911-3132"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.rmi.ru",
      "target": "_blank"
    }
  }, [_vm._v("www.rmi.ru")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editions "), _c('b', [_vm._v("Salabert [2, 6, 8, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Paris, France"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.durand-salabert-eschig.com",
      "target": "_blank"
    }
  }, [_vm._v("www.durand-salabert-eschig.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Samfundet:")]), _vm._v(" Society for the Publication of Danish Music "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Gråbrødrestræde 18, 1")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1156 Copenhagen K, Denmark")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (45) 33-13-54-45")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (45) 33-93-30-44"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.samfundet.dk",
      "target": "_blank"
    }
  }, [_vm._v("www.samfundet.dk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("San Andreas")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 60247"), _c('br'), _vm._v("Palo Alto, CA 94306")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (650) 856-9394"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.scoremus.com",
      "target": "_blank"
    }
  }, [_vm._v("www.scoremus.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Sassetti")]), _vm._v(" & Cia.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("R. Nova do Almada, 60"), _c('br'), _vm._v("Lisbon 2, Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("J. S. "), _c('b', [_vm._v("Sato,")]), _vm._v(" Music Editions")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 14854"), _c('br'), _vm._v("Chicago, IL 60614-0854")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (773) 296-0893")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (773) 296-0936"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.satomusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.satomusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Scala Aretina")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Ediciones Musicales"), _c('br'), _vm._v("Apartado de Correos 175")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("25230 Mollerussa, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Richard "), _c('b', [_vm._v("Schauer")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("London, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schaum")]), _vm._v(" Publications, Inc. "), _c('b', [_vm._v("[1, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("10235 North Port Washington Rd."), _c('br'), _vm._v("Mequon, WI 53092")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 786-5023 or (262) 241-5013")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (262) 241-1063"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.schaumpiano.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schaumpiano.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("’Schlesinger'sche")]), _vm._v(" Musikhandlung "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Arthur P. "), _c('b', [_vm._v("Schmidt")]), _vm._v(" Co. "), _c('b', [_vm._v("[1]")]), _vm._v(" (see Summy-Birchard)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schott")]), _vm._v(" Music International "), _c('b', [_vm._v("[6, 8, 10, 11, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("254 W. 31st Street"), _c('br'), _vm._v("New York, NY 10001")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 461-6940")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 810-4564"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.schott-music.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schott-music.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schott")]), _vm._v(" Frères ("), _c('i', [_vm._v("see")]), _vm._v(" Schott Music Internationa) "), _c('b', [_vm._v("[13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schroeder & Gunther [10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schultheiss")]), _vm._v(" Musikverlag, C.L. "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tübingen, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schultz")]), _vm._v(" Music Publications")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("5637 Beacon Street"), _c('br'), _vm._v("Pittsburgh, PA 15217"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.schultzmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.schultzmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Schwann")]), _vm._v(" Musikverlag "), _c('b', [_vm._v("[14]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Scottish Music Centre")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("City Halls, Candleriggs"), _c('br'), _vm._v("Glasgow G1 1NQ"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 141-552-5222")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 141-553-2789"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.scottishmusiccentre.com",
      "target": "_blank"
    }
  }, [_vm._v("www.scottishmusiccentre.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Charles "), _c('b', [_vm._v("Scribner")]), _vm._v("'s Sons")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("c/o Simon & Schuster"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.simonandschuster.com",
      "target": "_blank"
    }
  }, [_vm._v("www.simonandschuster.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Seda Productions")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Seda Publications)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Seda Publications")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("45 Common Street"), _c('br'), _vm._v("Belmont, MA 02478-3022")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (617) 489-1848")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (617) 489-6474")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Seesaw")]), _vm._v(" Music Corp. ("), _c('i', [_vm._v("see")]), _vm._v(" Subito Music) "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Maurice "), _c('b', [_vm._v("Senart")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Salabert)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Servico de Documentacao Musical")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("da Ordem dos Musicos do Brasil"), _c('br'), _vm._v("Av. Almte. Barroso, 72-7 Andar"), _c('br'), _vm._v("Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Shawnee")]), _vm._v(" Press "), _c('b', [_vm._v("[10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 962-8584"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.shawneepress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.shawneepress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Sikesdi Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1102 Bellevue Avenue SE"), _c('br'), _vm._v("Calgary, Alberta T2G 4LI, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (403) 262-1201")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Hans "), _c('b', [_vm._v("Sikorski [6, 8, 10, 13, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Johnsallee 23")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("20148 Hamburg, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 40 41 41 00 0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 40 41 41 00 40")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.sikorski.de",
      "target": "_blank"
    }
  }, [_vm._v("www.sikorski.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("N. "), _c('b', [_vm._v("Simrock [2, 6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Sisra")]), _vm._v(" Publications ("), _c('i', [_vm._v("see")]), _vm._v(" Arsis Press)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Skandinavisk")]), _vm._v(" Musikförlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.nodelageret.dk",
      "target": "_blank"
    }
  }, [_vm._v("www.nodelageret.dk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Skandinavisk")]), _vm._v(" og Borups Musikförlag "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Copenhagan, Denmark")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Smith")]), _vm._v(" Publications/Sonic Art Editions")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("54 Lent Road"), _c('br'), _vm._v("Sharon, VT 05065"), _c('br'), _vm._v("Tel: (802) 765-4714"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.smith-publications.com",
      "target": "_blank"
    }
  }, [_vm._v("www.smith-publications.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Société des Nouvelles Editions Liègeoises")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("("), _c('i', [_vm._v("see")]), _vm._v(" Mardaga)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Société Française de Musicologie [17]")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Minkoff)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Société Liègeoise de Musicologie")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rue Curtius, 11")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("4020 Liège, Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (32) 4-366-58-50"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.slgm.ulg.ac.be",
      "target": "_blank"
    }
  }, [_vm._v("www.slgm.ulg.ac.be")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Fundación Vincente Emilio "), _c('b', [_vm._v("Sojo")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Avenida Santiago de Chile"), _c('br'), _vm._v("No. 17, Los Caebos"), _c('br'), _vm._v("Apartado Postal 70537"), _c('br'), _vm._v("Caracas 1071, Venezuela")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (58) 2-793-57-17 or (58) 2-793-49-48")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (58) 2-793-59-82")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Sonos")]), _vm._v(" Music Resources "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Soundings")]), _vm._v(" Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("948 Canyon Road"), _c('br'), _vm._v("Sante Fe, NM 87501")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("The "), _c('b', [_vm._v("Southern Baptist Theological Seminary")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("James P. Boyce Library"), _c('br'), _vm._v("2825 Lexington Road"), _c('br'), _vm._v("Louisville, KY 40280")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (502) 897-4713"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.library.sbts.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.library.sbts.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Southern")]), _vm._v(" Music Publishing "), _c('b', [_vm._v("[10, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 329"), _c('br'), _vm._v("San Antonio, TX 78292")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (210) 226-8167")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (210) 223-4537"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.southernmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.southernmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Soviet Composers / Sovetskii Kompozitor")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Moscow, Russia")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Leo "), _c('b', [_vm._v("Sowerby")]), _vm._v(" Foundation "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2 Congress Street"), _c('br'), _vm._v("Worcester, MA 01609-2003")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (508) 755-7906")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Special Music Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Maur, Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Stainer & Bell [5, 6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 110, Victoria House"), _c('br'), _vm._v("23 Gruneisen Road"), _c('br'), _vm._v("London N3 1DZ"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 20-8343-3303")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 20-8343-3024"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.stainer.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.stainer.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Thomas C. "), _c('b', [_vm._v("Stangland [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 19263"), _c('br'), _vm._v("Portland, OR 97280-0263")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (503) 244-0634")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (208) 485-4393")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Stat hudbeni vydavateiski")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Supraphon)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Steingräber")]), _vm._v(" Verlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.steingraeber-musikverlag.de",
      "target": "_blank"
    }
  }, [_vm._v("www.steingraeber-musikverlag.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Stockhausen")]), _vm._v(" Verlag "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Stockhausen Foundation for Musik"), _c('br'), _vm._v("51515 Kürten, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 2268-1813"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.stockhausen.org",
      "target": "_blank"
    }
  }, [_vm._v("www.stockhausen.org")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Studio P/R [1]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Subito")]), _vm._v(" Music Publishing "), _c('b', [_vm._v("[2, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("60 Depot Street"), _c('br'), _vm._v("Verona, NJ 07044")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (973) 857-3440")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (973) 857-3442"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.subitomusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.subitomusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Süddeutscher")]), _vm._v(" Musikverlag "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Heidelberg, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Summy-Birchard [2]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("15800 NW 48th Avenue"), _c('br'), _vm._v("Miami, FL 33014"), _c('br'), _vm._v("Tel: (305) 620-1500")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (305) 621-1094")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Supraphon")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Palackého 1 / 740")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("112 99 Prague 1, Czech Republic")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (420) 221-966-600")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (420) 221-966-630"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.supraphon.com",
      "target": "_blank"
    }
  }, [_vm._v("www.supraphon.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Swan")]), _vm._v(" & Co. (England) "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("London, United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Templeton")]), _vm._v(" Publishing Co. ("), _c('i', [_vm._v("see")]), _vm._v(" Shawnee Press)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Tempo")]), _vm._v(" Praha/Bote & Bock "), _c('b', [_vm._v("[15]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Tenuto")]), _vm._v(" Publications "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.tritone-tenuto.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tritone-tenuto.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Tetra")]), _vm._v(" Music Corp. ("), _c('i', [_vm._v("see")]), _vm._v(" Plymouth Music Co.) "), _c('b', [_vm._v("[6]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Thames")]), _vm._v(" Music Publishing "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Gordon V. "), _c('b', [_vm._v("Thompson [1]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("29 Birch Avenue"), _c('br'), _vm._v("M4V 1E2 Toronto, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (416) 227-0566")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (416) 227-0573")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Thorpe")]), _vm._v(" Music Publishing "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.thorpemusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.thorpemusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("P. J. "), _c('b', [_vm._v("Tonger [17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Haid-und-Neu-Straße 18")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("76131 Karlsruhe, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 721-62-68-56-6 or")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(49) 221-93-55-64-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.tonger.de",
      "target": "_blank"
    }
  }, [_vm._v("www.tonger.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Tonos")]), _vm._v(" Musikverlags "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lange Straße 89a"), _c('br'), _vm._v("76530 Baden-Baden, Germany"), _c('br'), _vm._v("Tel: (49) 7221 97370 0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 7221 97370 27"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.tonosmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tonosmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("To-oN Kikau")]), _vm._v(" Co.")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1-15-1 Sugamo"), _c('br'), _vm._v("Toshima-ku"), _c('br'), _vm._v("Tokyo, Japan 170"), _c('br'), _vm._v("Tel: (81-3) 39441581")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (81-3) 39442130")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Ediziun "), _c('b', [_vm._v("Trais Giats")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("7546 Ardez, Switzerland"), _c('br'), _vm._v("Tel/Fax: (41) 81-862-22-34"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.trais-giats.ch",
      "target": "_blank"
    }
  }, [_vm._v("www.trais-giats.ch")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Transcontinental")]), _vm._v(" Music Publications/New Jewish Music Press "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("URJ Books & Music"), _c('br'), _vm._v("633 Third Avenue, 7th Floor"), _c('br'), _vm._v("New York, NY 10017-6778")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (212) 650-4120")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (212) 650-4119"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.transcontinentalmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.transcontinentalmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Tre Media")]), _vm._v(" Musikverlage")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Friederike Zimmermann"), _c('br'), _vm._v("Amalienstrasse 40"), _c('br'), _vm._v("76133 Karlsruhe, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 721-26023")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 721-26044"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.tremediamusicedition.de",
      "target": "_blank"
    }
  }, [_vm._v("www.tremediamusicedition.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Tritó [6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Enamorats, 35-37 baixos"), _c('br'), _vm._v("08013 Barcelona, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 933-426-175")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 933-022-670"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.trito.es",
      "target": "_blank"
    }
  }, [_vm._v("www.trito.es")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editorial "), _c('b', [_vm._v("Tritone [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lima, Peru")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Unión Musical Ediciones [6, 10, 13, 16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(part of Music Sales Group)"), _c('br'), _vm._v("Marqués de la Ensenada, 4"), _c('br'), _vm._v("28004 Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 91-308-4040")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (34) 91-310-4429"), _c('br'), _c('a', {
    attrs: {
      "href": "http://unionmusicalediciones.com",
      "target": "_blank"
    }
  }, [_vm._v("unionmusicalediciones.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Unión Musical Española [16]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Carrera de San Jerónimo, 26"), _c('br'), _vm._v("28014 Madrid, Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (34) 902-112-859"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.unionmusical.es",
      "target": "_blank"
    }
  }, [_vm._v("www.unionmusical.es")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("United")]), _vm._v(" Music Publishers "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3 Abbey Point"), _c('br'), _vm._v("Cartersfield Road"), _c('br'), _vm._v("Waltham Abbey"), _c('br'), _vm._v("Essex EN9 1FE"), _c('br'), _vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (44) 1992-703110")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 1992-767682"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ump.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.ump.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Universal Edition [6, 8, 13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Karlsplatz 6"), _c('br'), _vm._v("1010 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 1-337-23-0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (43) 1-337-23-400"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.universaledition.com",
      "target": "_blank"
    }
  }, [_vm._v("www.universaledition.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Universal Music")]), _vm._v(" Publishing Group")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2100 Colorado Avenue"), _c('br'), _vm._v("Santa Monica, CA 90404"), _c('br'), _vm._v("Tel: (310) 235-4700")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (310) 235-4900"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.umusicpub.com",
      "target": "_blank"
    }
  }, [_vm._v("www.umusicpub.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("University of California Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2120 Berkeley Way"), _c('br'), _vm._v("Berkeley, CA 94704"), _c('br'), _vm._v("Tel: (800) 777-4726 (orders) or")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("(510) 642-4247")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (510) 643-7127"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.ucpress.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.ucpress.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("University of Washington Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 50096"), _c('br'), _vm._v("Seattle, WA 98145")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 537-5487 (orders)"), _c('br'), _vm._v("or (206) 543-4050")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (206) 543-3932"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.washington.edu/uwpress",
      "target": "_blank"
    }
  }, [_vm._v("www.washington.edu/uwpress")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("University of Virginia Press")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 400318"), _c('br'), _vm._v("Charlottesville, VA 22904")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 831-3406")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (877) 288-6400"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.upress.virginia.edu",
      "target": "_blank"
    }
  }, [_vm._v("www.upress.virginia.edu")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("University Society")]), _vm._v(" Publishers")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("145 N. Franklin Turnpike"), _c('br'), _vm._v("Ramsey, NJ 07446")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (201) 327-1982")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Urbanek")]), _vm._v(" ("), _c('i', [_vm._v("see")]), _vm._v(" Artia)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Ut Orpheus")]), _vm._v(" Edizioni "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Piazza di Porta Ravegnana 1")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("40126 Bologna, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 051-226468")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 051-263720"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.utorpheus.com",
      "target": "_blank"
    }
  }, [_vm._v("www.utorpheus.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Valley")]), _vm._v(" Music Press")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Northampton, MA"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.valleymusicpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.valleymusicpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Van Rossum")]), _vm._v(" (Netherlands) "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Vereniging voor Nederlandse")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_c('b', [_vm._v("Muziekgeschiedenis")]), _vm._v(" (Dutch Society for Musicology)"), _c('br'), _vm._v("Postbus 1514"), _c('br'), _vm._v("3500 BM Utrecht"), _c('br'), _vm._v("The Netherlands"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.kvnm.nl",
      "target": "_blank"
    }
  }, [_vm._v("http://www.kvnm.nl")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Verlag für Musikalische Kultur und Wissenschaft")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Wolfenbüttel, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Verlag Neue Musik")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Grabbeallee 15")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("13156 Berlin, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 30 61 69 81 0")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 30 61 69 81 21"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.verlag-neue-musik.de",
      "target": "_blank"
    }
  }, [_vm._v("www.verlag-neue-musik.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Vienna Masterworks")]), _vm._v(" (BMI)")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Margaretenstrasse 125/15"), _c('br'), _vm._v("1050 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Vienna Urtext")]), _vm._v(" Editions "), _c('b', [_vm._v("[13, 15, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Forsthausgasse 9"), _c('br'), _vm._v("1200 Vienna, Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (43) 1-33723-226")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (43) 1-33723-425"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.wiener-urtext.com",
      "target": "_blank"
    }
  }, [_vm._v("www.wiener-urtext.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Musikverlag C. F. "), _c('b', [_vm._v("Vieweg [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Viking")]), _vm._v(" Musikförlag")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Lille Strandvej 3")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2900 Hellerup"), _c('br'), _vm._v("Copenhagen, Denmark")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (45) 31-62-12-10")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Visible")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1037 Park Avenue"), _c('br'), _vm._v("Amherst, OH 44001"), _c('br'), _vm._v("Tel: (440) 984-4037"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.visible-music.com",
      "target": "_blank"
    }
  }, [_vm._v("www.visible-music.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Irmãos "), _c('b', [_vm._v("Vitale")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Rua França Pinto, 42"), _c('br'), _vm._v("São Paulo, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (11) 5081-9499")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (11) 5574-7388"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.vitale.com.br",
      "target": "_blank"
    }
  }, [_vm._v("www.vitale.com.br")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Vivace")]), _vm._v(" Press "), _c('b', [_vm._v("[6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("University of Missouri"), _c('br'), _vm._v("1 University Boulevard"), _c('br'), _vm._v("265 General Services Building")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (314) 516-4990")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (314) 516-4992"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.vivacepress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.vivacepress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Arno "), _c('b', [_vm._v("Volk")]), _vm._v(" Verlag ("), _c('i', [_vm._v("see")]), _vm._v(" Universal Music Publishing Group)")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edition "), _c('b', [_vm._v("Walhall")]), _vm._v(" / Verlag Franz Biersack "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Richard-Wagner Straße 3")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("39106 Magdeburg, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 391-85-78-20")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 391-8-52-00-79"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.edition-walhall.de",
      "target": "_blank"
    }
  }, [_vm._v("www.edition-walhall.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Walton")]), _vm._v(" Music "), _c('b', [_vm._v("[2, 6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1028 Highland Woods Rd."), _c('br'), _vm._v("Chapel Hill, NC 27517")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (919) 929-1330")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (919) 929-2232"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.waltonmusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.waltonmusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Warner Brothers")]), _vm._v(" Publications "), _c('b', [_vm._v("[1, 13]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Warner/Chappell")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("10585 Santa Monica Boulevard"), _c('br'), _vm._v("Los Angeles, CA 90025-4950")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (310) 441-8600")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (310) 441-8780"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.warnerchappell.com",
      "target": "_blank"
    }
  }, [_vm._v("www.warnerchappell.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Waterloo")]), _vm._v(" Music Co. "), _c('b', [_vm._v("[4]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Carlo "), _c('b', [_vm._v("Wehrs")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Ac/de Eulenstein Musica S.A."), _c('br'), _vm._v("Rua Rute Ferreira, 258"), _c('br'), _vm._v("(ZC-22-Ramos)"), _c('br'), _vm._v("20000 Rio de Janeiro, Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Josef "), _c('b', [_vm._v("Weinberger [2, 6, 10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("12-14 Mortimer Street"), _c('br'), _vm._v("London W1T 3JJ, Great Britain"), _c('br'), _vm._v("Tel: (44) 20-7580-2827")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (44) 20-7436-9616"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.josef-weinberger.com",
      "target": "_blank"
    }
  }, [_vm._v("www.josef-weinberger.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Weintraub")]), _vm._v(" Music "), _c('b', [_vm._v("[16, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Westerlund [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Helsinki, Finland")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Western International Music")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("3707 65th Avenue"), _c('br'), _vm._v("Greeley, CO 80634")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (970) 330-6901")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (970) 330-7738"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.wiminc.com",
      "target": "_blank"
    }
  }, [_vm._v("www.wiminc.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Western Music,")]), _vm._v(" Ltd. (Canada) "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Joseph "), _c('b', [_vm._v("Williams")]), _vm._v(" Editions (England) "), _c('b', [_vm._v("[18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Willis")]), _vm._v(" Music Co. "), _c('b', [_vm._v("[10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("7380 Industrial Road")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("P.O. Box 548"), _c('br'), _vm._v("Florence, KY 41042")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (800) 354-9799 or (859) 283-2050")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (859) 283-1784"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.willismusic.com",
      "target": "_blank"
    }
  }, [_vm._v("www.willismusic.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Wimbledon")]), _vm._v(" Music")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Trigram Music Inc./Wimbledon Music "), _c('b', [_vm._v("[17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("1801 Century Park East, Suite 2400"), _c('br'), _vm._v("Los Angeles, CA 90067")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (310) 556-9683")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (310) 277-1278"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.wimbtri.net",
      "target": "_blank"
    }
  }, [_vm._v("www.wimbtri.net")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Witmark & Sons [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Walter "), _c('b', [_vm._v("Wollenweber")]), _vm._v(" Verlag "), _c('b', [_vm._v("[14]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Munich, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Yorktown")]), _vm._v(" Music Press "), _c('b', [_vm._v("[10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("G. "), _c('b', [_vm._v("Zanibon [10, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("c/o "), _c('b', [_vm._v("Armelin")]), _vm._v(" Musica")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Via dei Soncin, 42"), _c('br'), _vm._v("35122 Padova, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 49-8724-928")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 49-8736-524"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.zanibon.it",
      "target": "_blank"
    }
  }, [_vm._v("www.zanibon.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Zen-on")]), _vm._v(" Music Co. "), _c('b', [_vm._v("[6, 10, 11, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("2-13-3 Kami Ochiai"), _c('br'), _vm._v("Shinjuku-ku, Tokyo 161-0034"), _c('br'), _vm._v("Japan"), _c('br'), _vm._v("Tel: (81) 3-3227-6283")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (81) 3-3227-6288"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.zen-on.co.jp",
      "target": "_blank"
    }
  }, [_vm._v("www.zen-on.co.jp")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_c('b', [_vm._v("Zenmükiado")]), _vm._v(" Vallalat ("), _c('i', [_vm._v("see")]), _vm._v(" Editio Musica "), _c('b', [_vm._v("Budapest EMB)")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Éditions du "), _c('b', [_vm._v("Zephyr [18]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Brussels, Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Edizioni Suvini "), _c('b', [_vm._v("Zerboni [2, 6, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Galleria del Corso, 4"), _c('br'), _vm._v("20122 Milano, Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (39) 2-770701")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (39) 2-77070261"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.esz.it",
      "target": "_blank"
    }
  }, [_vm._v("www.esz.it")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Wilhelm "), _c('b', [_vm._v("Zimmermann")]), _vm._v(" Musikverlag "), _c('b', [_vm._v("[6, 14, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (49) 69-978286-6")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (49) 69-978286-79"), _c('br'), _vm._v("Frankfurt, Germany"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.zimmermann-frankfurt.de",
      "target": "_blank"
    }
  }, [_vm._v("www.zimmermann-frankfurt.de")])]), _vm._v(" "), _c('p', {
    staticClass: "body-textb1"
  }, [_vm._v("Editions Aug. "), _c('b', [_vm._v("Zurfluh [6, 13, 17]")])]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("13, Avenue du Lycée Lakanal"), _c('br'), _vm._v("92340 Bourg-la-Reine, France")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Tel: (33) 1-46-60-50-28")]), _vm._v(" "), _c('p', {
    staticClass: "hangb1"
  }, [_vm._v("Fax: (33) 1-46-61-52-30"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.editions-aug-zurfluh.fr",
      "target": "_blank"
    }
  }, [_vm._v("www.editions-aug-zurfluh.fr")])])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "partnumber"
  }, [_c('i', [_c('b', [_vm._v("Part I")])])]), _vm._v(" "), _c('h2', {
    staticClass: "part"
  }, [_vm._v("Individual Composers")]), _vm._v(" "), _c('p', {
    staticClass: "part1"
  }, [_c('i', [_vm._v("Their Solo Piano Works in Various Editions and Facsimile Reproductions")])])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "chaptertitle"
  }, [_vm._v("A")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Marcello Abbado")]), _vm._v(" (1926– ) Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Abbado studied at the Milan Conservatory with Ghedini and has served as principal conductor and music director of the London Symphony Orchestra. He is the brother of conductor Claudio Abbado.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Variations on a Minuet by J. S. Bach")]), _vm._v(" (BWV Anh. 121) 1951 (Zerboni 1953) 15pp. 12½ min. Var. I: two voices, chromatic, contrary motion between the hands. Var. II: Con decisione, rhythmic, chromatic. Var. III: Lento, full arpeggiated chords plus right-hand trills and tremolando, wide keyboard range. Var. IV: Scorrevole, veiled and subdued, melody transferred between the hands. Var. V: Allegro, hammered repeated chords, large span required, chords move over wide range of keyboard. Var. VI: Molto allegro, widely spaced two-note chords skipping over keyboard. Minuetto: Largamente, pointillistic, final eight measures suggest rising line of Bach minuet, build to large climax. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Louis Abbiate")]), _vm._v(" (1866–1933) France")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Trois Pièces")]), _vm._v(" 1918 (Jobert 1980) 13pp. 1. Prélude; 2. Romance; 3. Diabolique. Post-Romantic style, with No.3 showing some Prokofiev influence. Large span required. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.4")]), _vm._v(" Op.48 1925 (Jobert 1981) 31pp. In three movements. Allegretto con moto un poco barcarola: SA, many triadic figures. Cavatina: melodic writing suggests Chopin. Vivace: triadic use in a typically French toccata style. The roots of this work stretch back to Beethoven, with a mixture of the “heroics” of Romantic composers and the less extroverted style of the Impressionists. Conservative but effective writing. Worth investigating. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Johann Joseph Abert")]), _vm._v(" (1832–1915) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Abert was known during his lifetime as a double bassist and conductor, and composed primarily operas, orchestral, and chamber music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Trauermarsch")]), _vm._v(" 1866 (W. Hader—Laurentius 003 2004) 8pp. First edition. Composed at the zenith of Romanticism in music, Abert's short march in ternary form makes much use of octaves and declamatory effects. Preface in German. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Hans Abrahamsen")]), _vm._v(" (1952– ) Denmark")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Abrahamsen teaches at the Royal Danish Academy of Music and composes in an individualist style stemming from the late twentieth century.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("7 Studier")]), _vm._v(" (WH) 17pp. Entitled: Traumlied; Sturm; Arabeske; Ende; Boogie-Woogie; For the Children; Blues. Studies take the character of their titles, generally tonal with altered harmonies. Performers and audiences will especially enjoy Boogie-Woogie with its Presto tempo and changing meters. Score is facsimile of manuscript; sometimes difficult to read, but with suggestive fingerings. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Jean Absil")]), _vm._v(" (1893–1974) Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Many of Absil's earlier works were written in a conventional idiom, but in later years Absil turned to a more personal, austere style. Unconventional rhythmic procedure was the norm in his writing. See anthologies of Belgian composers for other works.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Échecs: Suite")]), _vm._v(" Op.96 1956 (CeBeDeM) 16 min. In six movements. 1. Le Roi; 2. La Reine; 3. Le Fou; 4. La Tour; 5. Les Pions; 6. Les Cavaliers: effective toccata. Much variety and contrast. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Passacaille")]), _vm._v(" Op.101 1959 (CeBeDeM) 10pp. In memoriam Alban Berg. Required piece for the 1960 Queen Elisabeth Competition. Chromatic theme and twenty variations treated in various ways. A few variations are relieved by short episodes. A calm and expressive mood is characteristic of the four middle variations, while a brilliant coda concludes the work. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Six Bulgarian Dances")]), _vm._v(" Op.102 (Lemoine). Dances in ternary or variation form. Bartók influence. Driving rhythms, unusual dissonances over stable tonalities, whimsical. See especially No.6. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatine")]), _vm._v(" Op.125 1966 (Metropolis) 7pp. In three movements. Allegro moderato: fresh harmonies, clever rhythms. Pavane: imitative with mildly dissonant chords. Tarentelle: 6/8, dancelike, fleeting, attractive. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Pastourelle")]), _vm._v(" 1958 (Lemoine) 2pp. Accompanied melody, mildly twentieth-century. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Kathleen Cooper Vadala, "), _c('i', [_vm._v("The Concert Works of Jean Absil for Solo Piano: A Performance Tape and Stylistic Analysis")]), _vm._v(" (DMA document, University of Maryland, College Park, 1986), 132pp.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Motohiko Adachi")]), _vm._v(" (1940– ) Japan")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Per Pianoforte")]), _vm._v(" (Zen-On 412 1978) 27pp. Accordo: Ostinato; Monodia. Complex rhythms, highly organized, clusters, aleatoric, avant-garde. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Daniel A. d'Adamo")]), _vm._v(" (1966– ) France, born Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("D'Adamo studied in Buenos Aires and Lyon, and has already received several prizes for his compositions, including the Prix de Rome. He has lived in France since 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Carta Segreta")]), _vm._v(" 2001 (Billaudot 2002) 24pp. 13 min. In one movement, emancipating from Expressionism with scalar formations, proportional rhythmic relationships, dramatic qualities, sudden dynamic changes, and dense harmonic structures. Challenging. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://danieldadamo.com",
      "target": "_blank"
    }
  }, [_vm._v("http://danieldadamo.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("George Adams")]), _vm._v(" (1904–1959) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" b 1959 (CFP 6232) 14 min. A three-movement (FSF) work written by a versatile hand. Tonal, dramatic, full sonorities. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("John Adams")]), _vm._v(" (1947– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("One of the most successful composers of the late twentieth century, Adams writes in an elegant minimalist style influenced by the popular vernacular and by European mainstream art.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("China Gates")]), _vm._v(" 1977 (AMP 7859–21983; in "), _c('i', [_vm._v("American Contemporary Masters")]), _vm._v(", GS 1995). Evolving patterns that should be soft and resonant throughout, never exceeding "), _c('i', [_vm._v("mf.")]), _vm._v(" Both hands should be equalized so no line is ever louder than another. Pedals should be held throughout each passage until the next gate (change of mode) occurs; minimalistic music. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Phrygian Gates")]), _vm._v(" 1977–78 (AMP 7860–2 1983) 61pp. Gradually evolving patterns; special attention should be given to equalizing the volume of both hands so that no single pattern ever dominates another. Minimalistic music. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("American Berserk")]), _vm._v(" 2001 (Hendon 2007) 15pp. 6 min. Inspired by Philip Roth's novel "), _c('i', [_vm._v("American Pastoral")]), _vm._v(" (1997); Adams notes that the work “hints at the darker, manic edge of American life. Influences of American jazz and bop playing mixed with impressions of Conlon Nancarrow's disjunct rhythmic world dominate the writing of this short, manic, bipolar scherzo” ("), _c('a', {
    attrs: {
      "href": "http://www.earbox.com/w-americanberserk",
      "target": "_blank"
    }
  }, [_vm._v("www.earbox.com/w-americanberserk")]), _vm._v("; July 12, 2010). An action-packed, intense, bitonal work requiring a sense of freedom within precise rhythms, mixed meters, and constant drive. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Kyle Fyr, "), _c('i', [_vm._v("Proportion, Temporality, and Performance Issues in Piano Works of John Adams")]), _vm._v(" (PhD diss., Indiana University, 2011), 252pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "href": "http://earbox.com",
      "target": "_blank"
    }
  }, [_vm._v("http://earbox.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Thomas Adès")]), _vm._v(" (1971– ) England")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Adès has received considerable recognition for his works and became the recipient of the prestigious Ernst von Siemens Prize and the Grawemeyer Award before the age of thirty.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Still Sorrowing")]), _vm._v(" Op.7 1992 (Faber 1992) 6pp. 9 min. For prepared piano; assistant needed. Score is copy of manuscript, written on three to four staves. Shows influence of Webern but moves on to proportional rhythmic relations, denser harmonic relationships, and complete use of the keyboard. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Darknesse Visible: After John Dowland")]), _vm._v(" 1992 (Faber 1998) 5pp. 7 min. “This piece is an explosion of John Dowland's lute song ‘In Darknesse Let Mee Dwell’ (1610). No notes have been added; indeed, some have been removed. Patterns latent in the original have been isolated and regrouped, with the aim of illuminating the song from within, as if during the course of a performance” (title-page comment by composer). Individual lines are printed in colors to show voicing and timbres. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Traced Overhead")]), _vm._v(" Op.15 1995–96 (Faber 1997) 24pp. 12 min. In three movements: Sursum; Aetheria; Chori. Inspired by the Latin terms suggesting “upward” in the opening movement, “ascent” in the second, and “layer upon layer” in the third. Highly detailed damper-pedaling markings indicate degrees of use by quarters. Expressionist in concept with complicated rhythmic procedures. Must be able to reach a ninth. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Samuel Adler")]), _vm._v(" (1928– ) USA, born Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Adler's works display enormous rhythmic vitality. He taught at the Eastman School of Music from 1966 until 1995 and is the composer of over 400 published works.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Capriccio")]), _vm._v(" 1954 (in "), _c('i', [_vm._v("New Music for the Piano")]), _vm._v(", LG). Flexible meters and tonal centers, cross-relations, polymodality. Makes a fine one-minute encore. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Triptych for Dancing")]), _vm._v(" 1958 (AMC). Changing meters, colorful, three-sectioned, polytonal. Large span required. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata Brève")]), _vm._v(" 1963 (OUP 1967) 22pp. 11 min. In three movements. Allegro grazioso: Adagio con delicatezza; Allegro di bravura. Contrapuntal, freely tonal. Large span required; needs mature pianism. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Gradus: Forty Studies")]), _vm._v(" 1971 (OUP). Books I and II. Twenty studies in each volume that explore contemporary techniques. Volume II is more difficult than I. Notes explain each study. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Canto VIII")]), _vm._v(" 1973 (CF) 5 min. String effects inside piano, harmonics. Quiet introduction is exploded by torrents of octaves, clusters, stopped notes—all make this a fun avant-garde concert etude. D."), _c('br'), _c('i', [_vm._v("See:")]), _vm._v(" David Burge, “Five New Pieces,” CK 3 (December 1977): 66.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Gradus III")]), _vm._v(" 1979 (OUP 1981). Twenty pieces illustrating twentieth-century techniques including clusters, string strumming, harmonics, twelve-tone pieces. Excellent etudes. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina")]), _vm._v(" 1979 (GS E-3468) 20pp. In three movements. Fast and brilliant: a broad-gestured introduction leads to section “even a bit faster”; varied textures, including tremolo clusters; broad-gestured coda. Slow and very gently moving: melodic, section “like a chant, very freely moving 8ths,” octotonic faster section, slow-moving coda. Very fast (perpetual motion): perform as fast as possible, “make certain the 8th-notes are not all equal,” carefully pedaled, brilliant, all over keyboard, coda “Fast, but heavily.” D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Sense of Touch")]), _vm._v(" 1981 (TP 1983) 11pp. 12 min. Eight short pieces that introduce the young pianist to twentieth-century idioms. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Song Expands My Spirit")]), _vm._v(" (TP 1983) 7pp. 4 min. Slow lyric introduction leads to main part of piece, which is energetic and introduces two new tunes. Enthusiastic ending. Short, colorful, brilliant. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Road to Terpsichore")]), _vm._v(" 1988 (GS 3774) 24pp. 12½ min. A suite of dances. 1. Fast and Wild. 2. Free, quite relaxed, but stately. 3. Like a waltz. 4. Like a Tango, with verve, and very rhythmic. 5. Like a Tarantella, fast and furious. Strong rhythms, fairly thin textures, contrasting, mildly twentieth-century. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Piano Preludes")]), _vm._v(" 1999–2000 (CF PL 125 2006) 15pp. Rushing Waters; Dream Sequence; Paradelle. Written for virtuosi pianists who are friends of the composer. “These are ‘occasional’ pieces which are character studies, not so much studies of the pianist for whom they were written, but studies that explore moods and paint pictures through the medium of the piano, in the spirit of the Preludes for Piano by Claude Debussy” (from program notes). M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Four Composer Portraits")]), _vm._v(" 2001–2 (TP 2006) 16pp. 8 min. Birthday cards for solo piano: I. Milton [Babbitt]; II. Ned [Rorem]; III. Gunther [Schuller]; David [Diamond]. Themes derived from an extended musical alphabet. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Festschrift")]), _vm._v(" (TP 2007) 11pp. To celebrate W. John Williams's teaching career at the University of South Carolina. In one continuous movement, commencing Slowly and lyrically, and quickly moving into a Fast tempo, mostly in two voices. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Bradford Gowen, “Samuel Adler's Piano Music,” AMT 25 (January 1976): 6–8.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Mei-Yuk Tang, "), _c('i', [_vm._v("Pedagogical Works for Piano by Samuel Adler")]), _vm._v(" (PhD diss., Texas Tech University, 2003), 268pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "href": "http://www.samueladler.com",
      "target": "_blank"
    }
  }, [_vm._v("www.samueladler.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Denes Agay")]), _vm._v(" (1911–2007) USA, born Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Agay's style was conservatively modern, freely tonal, and full of harmonic surprises. He knew how to write for the instrument; not one gesture seems contrived or dictated by formula.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Concertino Barocco")]), _vm._v(" (GS 1975) 15pp. Based on themes of Handel. Three contrasting movements, delightful. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("15 Little Pieces on Five-Note Patterns")]), _vm._v(" (BMC 1973). Great variety of five-finger positions. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Four Dance Impressions")]), _vm._v(" (TP 1977) 6½ min. Night Music; Vibrations; Ballad without Words; Hommage à Joplin. Chromatic, strong rhythms, mildly twentieth-century, sophisticated. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Joy of the Music of Denes Agay")]), _vm._v(" (Yorktown 1980) 64pp. Twenty-four pieces from early published works to new compositions that illustrate Agay's attractive style and the great variety of his creative approaches, including distillations of popular idioms dating from the 1940s. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Mosaics")]), _vm._v(" 1968 (MCA) 21pp. 12½ min. Six Piano Pieces on Hebrew Folk Themes, consisting of five short pieces followed by a set of eleven variations over an eight-bar melody that progresses to a brilliant but not too demanding climax. Beautifully laid out for the piano. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Petit Trianon Suite")]), _vm._v(" (GS). Ten tuneful short pieces in classic dance forms. M; S; Contredanse; Musette; etc. Easy.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Serenata Burlesca")]), _vm._v(" 1968 (Bo&H) 7pp. 2½ min. Cross-rhythms, chromatic lines, brilliant closing. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina Hungarica")]), _vm._v(" (MCA 1967) 19pp. 9½ min. In three movements: Scena; Serenata; Rondo. Changing meters, quartal harmony, cadenza passages, well put together, attractive. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Two Improvisations on Hungarian Folk Songs")]), _vm._v(" (TP 1973) 7pp. 4 min. The Peacock. Gipsy Tune: modal, more fetching of the two, attractive. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("4 Popular Diversions")]), _vm._v(" (TP 1984) 12pp. Little Prelude in Waltz Time. Baroque Bounce. Echoes of the Blues. Ragtime Doll. Clever, contrasting, colorful. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Klaus Ager")]), _vm._v(" (1936– ) Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sounds in the Evening Haze")]), _vm._v(" Op.38 1983 (Arbeitsgemeinschaft der Eigenverleger 87101 1987) 12pp. In one movement with two broad sections. Clusters, counting time by seconds, proportional rhythmic relationships, and complete use of the keyboard characterize this largely complicated work. Requires large span. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Maria Teresa d'Agnesi Pinottini")]), _vm._v(" (1720–1795) Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Agnesi was best known as an opera composer in European courts.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Two Pieces for Solo Piano or Harpsichord")]), _vm._v(" (Harbach—Vivace) 12pp. Contains a Sonata in G and Allegro ou Presto: hand crossings and arpeggios, Scarlatti-like. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Drei Sonaten")]), _vm._v(" (F. Zimmermann—Tonger 2962–1 1999) 32pp. Three Sonatas cast in FSF form in G, F, G. Attractive Style Galant works requiring finger dexterity and clarity. Sportive in figuration and passagework. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Roy Agnew")]), _vm._v(" (1891–1944) Australia")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Agnew was the most outstanding of early twentieth-century Australian composers. His music was written in a unique style strongly influenced by Romantic-Impressionistic tendencies.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Works, Vol. I")]), _vm._v(" (Keys Press 1997) 21pp. Australian Forest Pictures: six colorful character pieces. Youthful Fancies: four pedagogical pieces, attractive. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Six Sonatas for Piano")]), _vm._v(" (L. Sitsky—Keys Press 1997) 127pp. Introduction by R. Crews. Symphonic Poème; Fantasie Sonata; Sonata (1929); Sonata Poem; Sonata Ballade; Sonata Legend (Capricornia).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Rita Crews, "), _c('i', [_vm._v("An Analytical Study of the Piano Works of Roy Agnew, Margaret Sutherland and Dulcie Holland, including Biographical Material")]), _vm._v(" (diss., University of New England, Armidale, 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Guido Agosti")]), _vm._v(" (1901–1989) Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Agosti wrote in a mildly contemporary style strongly influenced by Ravel. He was an outstanding pianist and teacher. Zubin Mehta and Carlo Maria Giulini studied with Agosti.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Cinque Bagatelle")]), _vm._v(" Op.5 1941 (SZ). 10pp. Scorrevole. Lento. Presto. Marcia Funebre per Bobolino. Allegro vivace. Grateful tonal writing, Impressionistic, varied moods. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Prelude and Toccata")]), _vm._v(" Op.7 1942 (SZ). Slow, expressive Prelude e, "), _c('i', [_vm._v("pp")]), _vm._v(" closing leads to short, brilliant Toccata E, somewhat in Ravel's style. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Johan Agrell")]), _vm._v(" (1701–1765) Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.2/1, "), _c('i', [_vm._v("Sonata")]), _vm._v(" D Op.2/5 (Autographus Musicus 1976) 20pp. Facsimile of a 1748 edition. Op.2/1: Largo; Allegro; Larghetto; Presto; Aria Andante; Menuetto I, II. Traditional eighteenth-century style, melodic, written in various clefs. Op.2/5: Adagio; Presto assai; Allegro; Aria; Tempo di Menuetto. Both works show strong Germanic influence. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Ernani Aguiar")]), _vm._v(" (1950– ) Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A composer, choral conductor, and musicologist, Aguiar teaches at the Federal University of Rio de Janeiro.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Passos Gramanianos")]), _vm._v(" 1975–2003 (Academia Brasileira de Música 2010) 13pp. 8 min. Ten untitled short pieces, all in two voices except No.7. Syncopated rhythms tend to dominate in these strongly tonal settings. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina No.3")]), _vm._v(" 1975–2003 (Academia Brasileira de Música 2010) 12pp. 8½ min. In three movements: Allegro moderato; Andante tranquilo; quasi “Pastorale.” Thin textures with snappy rhythms and motivic development. The middle movement is a fugato. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina No.4")]), _vm._v(" 2003 (Academia Brasileira de Música 2010) 8pp. 7½ min. In three movements: Allegro; Andante commodo; Allegro commodo. Appealing designs primarily in two voices with a sense of spontaneity. The final movement uses canon and various other techniques of imitation. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Miguel del Aguila")]), _vm._v(" (1957– ) USA, born Uruguay")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Aguila moved to the U.S. in 1978 and received a BA degree from the San Francisco Conservatory. He spent the next ten years in Vienna, studying at the Hochschule für Musik and Konservatorium, and composing, then returned to the U.S.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Conga")]), _vm._v(" 1993 (PIC 1995) 17pp. Began as the last movement of an Organ Fantasy. Changing meters, minimalistic, glissandos, motoric rhythms. Repeat the final figuration many times. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.migueldelaguila.com",
      "target": "_blank"
    }
  }, [_vm._v("www.migueldelaguila.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Julián Aguirre")]), _vm._v(" (1868–1924) Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Aguirre taught at the Buenos Aires Conservatory for a number of years. Some of his piano works are based on Argentine idioms, while others show Spanish and French influences.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Aires Criollos")]), _vm._v(" (Ric 1953) 7pp. Three short contrasting pieces using traditional Latin American tunes, rhythms, and harmonies. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("2 Books of Argentine National Airs")]), _vm._v(" (Ric). "), _c('i', [_vm._v("Book I:")]), _vm._v(" Op.17, 5 Tristes. "), _c('i', [_vm._v("Book II:")]), _vm._v(" Op.36, 5 Cançiones. No.5 has text and melody. Unusual rhythms and haunting melodies. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Huella")]), _vm._v(" Op.49 (Ric) 4pp. Tricky but effective rhythms. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Gato")]), _vm._v(" (Ric). Very rhythmic Argentine dance. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Kalevi Aho")]), _vm._v(" (1949– ) Finland")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" 1980 (Fazer) 15 min. First movement: kaleidoscopic, highly chromatic lines spin out eruptively and forcefully. Second movement: a nine-page perpetual-motion idea; climax of rising and falling passages is breathtaking. Finale: more than twice as long as the first two movements together; begins languidly with brief configurations reminiscent of the Barber Piano Sonata; eventually tremolo activity builds to a climax before the sonata ends reflectively with gentler, more melancholy trilling. There is much anxiety here—true angst at times. Inspired by late Scriabin style, with large leaps, cluster glissandos, hand crossings. Moves constantly over entire range of keyboard; intense, feverish writing. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Hugh Aitken")]), _vm._v(" (1924– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Fantasy")]), _vm._v(" (OUP 1969) 20pp. 15 min. Complex, with contrasting expressive qualities. Large-scale work in two movements demanding virtuosity and mature musicianship. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Connected Pieces")]), _vm._v(" (OUP 1968) 4pp. Thirds. Melody: uses ostinato figures. Fifths: displays attractive contrasting writing. Changing meters, chromatic studies. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Jehan Alain")]), _vm._v(" (1911–1940) France")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alain's style was characterized by rhythmic and metric flexibility and colorful, with highly individualized writing and emphases upon rhythm and melody. His music contains great variety, ranging in difficulty from the two-line "), _c('i', [_vm._v("Choral")]), _vm._v(" in "), _c('i', [_vm._v("Mythologies Japonaises")]), _vm._v(" to the "), _c('i', [_vm._v("Etude on a Four-Note Theme")]), _vm._v(" and the driving rhythms of "), _c('i', [_vm._v("Taras Boulba.")]), _vm._v(" The easiest works are: "), _c('i', [_vm._v("Suites faciles I-II, Nocturne, Romance Etude de Sonorité.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Works for Piano")]), _vm._v(" (Leduc). In 3 volumes.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I:")]), _vm._v(" Chorale; Étude de sonorité; Un cercle d'argent souple; Heureusement la bonne fée; Mythologies japonaises; Romance; Nocturne; Suite facile I; Suite facile II.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II:")]), _vm._v(" Thème varié; Ecce ancilla Domini; Étude; Togo; Lumière qui tombe d'un vasistas; Histoire d'un homme; Prélude; Il pleura toute la journée.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. III:")]), _vm._v(" Étude sur un thème de 4 notes; Petite rapsodie; Dans le rêve laissé par…; Taras Boulba.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Dix Pièces")]), _vm._v(" 1929–1931 (Leduc 1989) 19pp. Ten short pieces of imaginative qualities using a variety of early twentieth-century compositional techniques. 1. Histoire, sur des tapis. 2. Mélodie Sandwich. 3. 26 Septembre 1931. 4. Comme quoi des projets. 5. Nocturne. 6. En dévissant mes chaussettes. 7. Pour le déchiffrage. 8. Chanson triste. 9. Choral à 7 voix. 10. Canons. Nos.9–10 are for piano, four hands. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Deux Courtes Pièces")]), _vm._v(" 1930 (Leduc 2002) 4pp. 4 min. 1. Lettre à mon amie Lola Bluhm: brief introduction leads to a “tempo di marcia,” chordal in construction with two cadenza-like flourishes. 2. Un Spécimen d'harmonies consonants: 5-measure spoof on consonant writing with 7th chords and meandering melody at soft dynamics. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Quarante Variations")]), _vm._v(" 1930 (Leduc 1989) 19pp. 15 min. Forty variations on a four-measure theme. Picturesque, eloquent, and sometimes humorous. Preface by Marie-Claire Alain. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Seize Pièces")]), _vm._v(" (Leduc 1992) 19pp. Sixteen programmatic pieces ranging from two measures to five pages in length. The Sonata and Andante are the most developed in the uneven technical demands of these pieces. Easy to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Prélude et Fugue")]), _vm._v(" 1935 (Leduc 2000) 6pp. 5½ min. An impatient Prelude with changing meters and textual materials yields to a thirteen-measure subject for a pseudo 4-voiced fugue which completes the work. Preface by M.-C. Alain in French, German, and English. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.jehanalain.com",
      "target": "_blank"
    }
  }, [_vm._v("www.jehanalain.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Isaac Albéniz")]), _vm._v(" (1860–1909) Spain")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Albéniz, a prolific composer for the piano, was one of Spain's finest pianists. His works are a composite of Lisztian pianistic techniques and the idioms and rhythms of Spanish popular music. He wrote about 250 pieces for his instrument, mostly in small forms.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Alhambra Suite No.1: La Vega")]), _vm._v(" 1897 (UME; M. R. Laufer—Henle 823; K; ESC). This fairly lengthy movement is set in Granada. Colorful native rhythms and melodies. The suite contains only this movement. It was left unfinished. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Milton Ruben Laufer, "), _c('i', [_vm._v("Isaac Albéniz and “La Vega”: A Publication History and New Edition")]), _vm._v(" (DMA document, Rice University, 2003), 106pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Azulejos")]), _vm._v(" (“Mosaics” or “Tiles”) 1909 (UME). 1. Prelude: this work was finished by Granados. This is the only piece in this intended set of short pieces. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite Espagnole")]), _vm._v(" Op.47 1886 (U. Scheideler—Henle 783; UE 3348; IMC; Schott 5068; K; Ongaku-No-Tomo-Sha). Pieces date from various years in the 1880s and 1890s. This suite, with the exception of No.8, Cuba, is an affectionate representation of Spanish towns and regions. 1. Granada: Serenata: opening suggests guitar strumming with repeated rolled chords over a left-hand lyrical syncopated melody. This melody is shifted to the right hand and moves over some unusual harmonic modulations before ending with the opening material. 2. Cataluña: Curranda: a musical portrait of Albéniz's birthplace; majestic 6/8 rhythm supports a chromatic harmony and tender melodies. 3. Sevilla: Sevillanas: passionate piece with incisive rhythm suggesting the clicking of castanets as a background accompaniment; full of flamenco excitement. 4. Cadiz: Canción: in the style of a saeta, a song sung to a statue of the Virgin Mary held aloft in procession. A gentle lullaby supported by Spanish dance rhythms. 5. Asturias: Leyenda: strong guitar influence, hands work closely together, large skips, octotonic writing in midsection, "), _c('i', [_vm._v("ppp")]), _vm._v(" closing. 6. Aragón: Fantasy: Introduction moves through three keys. The midsection, Copla (a designation of stanzas of early Spanish and Italian song forms), provides some of Albéniz's most languid writing; "), _c('i', [_vm._v("fff")]), _vm._v(" closing. 7. Castillas: Seguidillas: Full of melodious joy and intriguing rhythms, octatonic (same as "), _c('i', [_vm._v("Cantos de España")]), _vm._v(" Op.232/5 Seguidillas). 8. Cuba: Capricho: suggests travel impressions from Albéniz's days as a touring virtuoso pianist; a slow and dreamy rumba. The suite contains some of Albéniz's most colorful writing. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Gavotte")]), _vm._v(" from "), _c('i', [_vm._v("Suite Ancienne III")]), _vm._v(" 1886 (UME). A minuet with a bagpipe tune. Melodious; played over a drone pedal D. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Cantos de España / Songs of Spain")]), _vm._v(" Op.232 ca.1896 (U. Scheideler—Henle 782; UME; K 9218; Onagaku-No-Toma-Sha). Prelude: this is the same piece as Asturias in "), _c('i', [_vm._v("Suite Española")]), _vm._v(" Op.47/5. Imitates the guitar's flowing right-hand tremolo technique. Midsection suggests improvisation, while the outer sections are full of the dramatic tension found in flamenco dance. Orientale: uses subtle chromatic elements in imitation of Eastern influences found in Spanish music. Sous le palmier (Under the Palms): a suave and pleasant tango. Córdoba: This haunting nocturne is a colorful picture of that famous Andalusian city. Sharp chords, as if plucked from the strings of a guitar, preface an oriental-type melody, which suggests the Moorish background of the city. Albéniz wrote at the beginning of this piece: “In the silence of night, interrupted by whispering breezes full of jasmine scent, the guzlas [a one-string instrument] intone as they accompany serenades, sending flowing melodies through the air, tones as sweet as the sound of swaying palms high overhead.” Spanish dance rhythms, colorful imagination. Seguidillas: a brilliant stylish dance, one of Spain's oldest dance forms for couples, mentioned by Cervantes around 1600. Full of melodious joy and fascinating rhythms. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Torre Bermeja: Serenata")]), _vm._v(" Op.92/12 (UME; K9218; Ongaku-No-Toma-Sha; Sal; Ashley; IMC). Strong guitar influence, passionate and exciting mood. The opening uses the two hands in close proximity to produce a striking rhythmic effect. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Cadiz-Gaditana")]), _vm._v(" 1886–1890? (Ashley; K). Strong influence of Spanish folk music, a picture of the spirited citizens of Cadiz. Strong guitar-like strumming in opening chords, left-hand rhythmic melody; somewhat similar to "), _c('i', [_vm._v("Rumores de la celeta, malagueña.")]), _vm._v(" M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Mallorca: Barcarola")]), _vm._v(" Op.202 ca.1891 (UME; Sal; K). Celebrates the sun-drenched island where Chopin composed his Préludes. A lively middle part contrasts with the outer, more introspective sections. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Spanish Dances")]), _vm._v(" (K 3003) 33pp. All six dances use tango rhythm, making a somewhat monotonous impression. No titles on any of the dances. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Pavana-Capricho")]), _vm._v(" Op.12 1883 or earlier (UME 6273) 4pp. ABA, some two-against-three writing, more like a capriccio than a pavana. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Seis Pequeños valses / 6 Little Waltzes")]), _vm._v(" Op.25 before 1884 (UME; Ashley). Chopin influence, different mood and texture for each waltz, Channing. No.6, A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", may have been modeled after Chopin's Waltz in A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", Op.64/3. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Serenata Española")]), _vm._v(" Op.181 ca.1890 (UME; Sal; K; Ashley). This is the same piece as "), _c('i', [_vm._v("Suite Española")]), _vm._v(" Op.47/4, “Cadiz.”")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Zambra granadina: Danse orientale")]), _vm._v(" ca.1890 (UME; K; Ashley). Many triplets followed by duplets, cross relations. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Deseo")]), _vm._v(" Op.40 ca.1883–86. Estudio de concerte (K9480). Bold octaves, large chords, six pages of triplets, like a perpetual-motion study. Long, ambitious. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("España")]), _vm._v(" Op.165 1890 (Six Album Leaves) (UME; N. Müllemann—Henle 857; CFP; Schott; IMC; Ongaku-No-Tomo-Sha; Dover). In six movements: Prélude; Tango (Godowsky—CF); Malagueña (Alfred); Serenata; Capricho catalan; Zortzico. The Tango is a protype of all tango music with its fascinating flamenco-like melody and insistent rhythm, genuinely Spanish in all aspects. The Godowsky arrangement is brilliant and complex. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Douglas Riva, “Albéniz's Malagueña,” KC 10/4 (July–August 1990): 42–43. A master lesson on Op.165/3.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fiesta de Aldea")]), _vm._v(" Op. posth. (UME 1973) 18pp. Apparently the first part of an unfinished composition intended for orchestra. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Iberia")]), _vm._v(" 1906–9 (UME: K; Sal; IMC; N. Gertsch—Henle 647, 648, 649; Dover; EBM Nos.1–9; G. González—Editorial de Música Española Contemporánea with Española de Ediciones Musicales Schott; T. Schumacher—Zen-On). In 4 vols. Evocation; El Puerto; Fête-Dieu à Seville; Rondeña; Almeria; Triana; El Albaicin; El Polo; Lavapies; Malaga; Jerez; Eritaña. This pianistic marvel is Albéniz's masterpiece. The pieces are evocative of Spanish scenes and landscapes, and they blend Liszt with newer and more suggestive elements of the best French music of Albéniz's times. Enormous technical demands. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Lisa Michele Lewis, "), _c('i', [_vm._v("Twelve Nouvelle Impressions: Historical and Cultural Factors Relating to the Performance of Isaac Albéniz's “Iberia” Suite")]), _vm._v(" (DMA diss., University of Washington, 1998), 141pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Myungsook Wang, "), _c('i', [_vm._v("Isaac Albéniz's “Iberia” and the Influence of Franz Liszt")]), _vm._v(" (DMA document, City University of New York, 2004), 108pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Improvisations")]), _vm._v(" 1903 (M. R. Laufer—Henle 953 2010) 10pp. Composed in the seaside town of Tiana apparently as pure improvisations. Albéniz recorded these three short pieces (his only extant recording) on the new Edison phonograph. Score includes a CD recording of Albéniz playing them. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Mallorca: Barcarola")]), _vm._v(" Op.202 ca.1891 (UME; J. Behr—Henle 830; Sal; IMC; K). Albéniz played this piece in London during the spring of 1891. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Navarra")]), _vm._v(" Op. posth. (EBM; IMC; Sal; UME). A poignant tonal evocation of the Spanish province below the Pyrenees. There are no direct motives of authentic popular themes in this work; rather, it uses a special style of singing that is the essence of the region. The jota itself does not appear; instead Albéniz introduces its rhythm by means of a sublime stylization, full of spirit and energy, which freely transcribes the character, if not the music, of Navarra. Because of the complexity and immense wealth, it is difficult to follow the lyric melodic lines at all times. The last 26 bars were completed by Déodat de Sévérac. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Piezas Características")]), _vm._v(" Op.92 ca.1888 (UME). Gavotte; Minuetto à Sylvia; Barcarolle; Prière; Conchita: Polka; Pilar: Waltz; Zambra; Pavana; Polonesa; Majurka; Staccato: Caprice; Torre Bermeja: Serenade. Published separately. Nos.3 and 12 (UME; K; Ashley) published separately. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Recuerdos de Viaje")]), _vm._v(" Op.71 ca.1886 (Travel Impressions) (IMC; UME). En el mar (On the sea): melodic detail is tossed between the hands. Leyenda: languid. Alborada (Dawn): uses repeated large chords over arpeggio figures and a melody in the bass. En la Alhambra (In the Alhambra): insistent rhythm. Puerto de (Port of) Tierra (refers to Cadiz, a seventeenth-century fortress): a lively bolero. Rumores de la Caleta (Murmurs from the small courtyard): a sensual and emotional courting dance from Malaga (malaguena). The Lento midsection is improvisational; available separately (BMC). En la Playa (On the beach): requires a cantabile style.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Sonatas")]), _vm._v(" No.3 Op.68 A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v("; No.4 Op.72 A; No.5 Op.82 G"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (UME) separately. For a thorough discussion of these three works see Newman, SSB, 652–54.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("COLLECTIONS")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Collected Works")]), _vm._v(" (K 09478–79).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I")]), _vm._v(" (60pp.). Navarra. Op. post. Mallorca (Barcarola) Op.202: languid and flowing. Sérénade Espagnole Op.181. Triana from Iberia. Zambra Granadina: an oriental dance. Serenata Arabe. Asturies: short. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Vol. II (62pp.). Barcarolle Catalane Op.23. Sérénade Espagnole Op.181: this piece is the same as Suite Española, Op.47/4. Cadiz-Gaditana: very similar to Rumoreres de la caleta: Malagueña Op.71. Troisième Suite Ancienne: Minuetto, Gavotta. Rapsodia Cubana Op.66 (the same opus number used for 6 Mazurkas de salón). Estudio Impromptu Op.56. Torre Bermeja Op.92/12, from Piezas Características. This edition omits some repeat signs, as well as a whole section at the end. Print not always clear. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Albéniz Album")]), _vm._v(" (A. Héra and J. Sármai—EMB Z. 13826 1993) 47 pp. From España, Op.165: Tango, Serenata, Capricho Catalan. From Cantos de España, Op.232: Danza Espagnola—Bajo la palma. From Recuerdos de Viaje (Travel Impressions) Op.71: Malagueña—Rumores de la caleta, Puerto di Tierra (bolero), En la Alhambra. Mallorca, Op.202. Serenata Arabe. Zambra Granadina: Danza Oriental. A fine introduction to Albéniz's music with some of his finest piano works. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Albéniz Méconnu")]), _vm._v(" (A. Ruiz-Pipó—ESC 1999) in 3 vols. Contains introductory notes in French and Spanish.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I")]), _vm._v(" (43pp): "), _c('i', [_vm._v("Siete Estudios en los tonos naturals mayores")]), _vm._v(" (7 Etudes in natural major keys) Op.65 1886, 23 min.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II")]), _vm._v(" (36pp): "), _c('i', [_vm._v("l'Automne")]), _vm._v(" ("), _c('i', [_vm._v("valse")]), _vm._v(") 1890, 13 min.; "), _c('i', [_vm._v("Les Saisons")]), _vm._v(" 1892, 9½ min.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. III")]), _vm._v(" (43pp): Prelude and Asturias from "), _c('i', [_vm._v("España")]), _vm._v(" ("), _c('i', [_vm._v("recuerdos")]), _vm._v(") Op.165 1890; "), _c('i', [_vm._v("Rêves")]), _vm._v(" Op.201 1891, 11 min.; "), _c('i', [_vm._v("Champagne")]), _vm._v(" ("), _c('i', [_vm._v("Carte-blanche")]), _vm._v(") 1888, 6 min.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Isaac Albéniz Piano Album")]), _vm._v(" (D. Riva—GS No. 1985). Selections from a Piano Sonata, Cantos de España, Suite Española, Recuerdos de Viaje, and others. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("A Book of Waltzes")]), _vm._v(" (K). Four waltzes from Op.25 to Op.170. L'Automne. Champagne. Cotillon. Six Little Waltzes. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Selected Works for Piano Solo")]), _vm._v(" (Ashley 1979) 195pp. Compiled by B. G. Thompson. Contents: Mallorca-Barcarola Op.202. Navarra. Sérénade Espagnole Op.181. Triana. Zambra Granadina: Danse orientale. Arabe (Serenata arabe). Espagne: Souvenirs (No.2 Asturies). Barcarolle Catalane Op.23. Sérénade Espagnola Op.181 (almost the same piece as on pp. 23–28). Cadiz-Gaditana: very similar to Rumores de la Caleta: Malagueña Op.71. Minuetto: No.1 from [Troisième] Suite Ancienne. Gavotta: No.2 from [Troisième] Suite ancienne: written to serve as a sight-reading test for the position of assistant professor at the Escuela Nacional de Música, November 1886. Rapsodia Cubana Op.66. Estudio Impromptu Op.56. Torre Bermeja Op.92/12 (revised by J. Montés). l'Automne Waltz Op.170/1–3: a three-section waltz with each section in a different key. Champagne Waltz: also called Cotillon Carte blanche and Vals de salón. Cotillian Waltz: very similar to Champagne Waltz. Six Little Waltzes Op.25. Songs of Spain Op.232: Prelude, Orientale, Sous le Palmier, Córdoba, Seguidillas. First works written while Albéniz was living in Paris. Reprint of early editions; mistakes not corrected. Int. to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Album of 8 Pieces")]), _vm._v(" (BMC). Cadiz; Cuba; Tango; Seguidilla; Curranda; Leyenda; Mazurka; Zortzico. Leyenda available separately (BMC).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Album of Isaac Albéniz Masterpieces")]), _vm._v(" (EBM). Suite Espagnole: Cadiz. Iberia: Evocation, El Puerto, Fête-Dieu à Seville, Triana. Sevilla. Tango. Seguidillas Op.232/5.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Il mio primo Albéniz / My First Albéniz")]), _vm._v(" (Rattalino—Ric 2738). Pavana Op.83: like a rondo. Waltz A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.25/6. Curtsey. Waltz E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.25/2. Preludio Op.165/1. Capriccio catalano Op.165/5.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("10 Pieces")]), _vm._v(" (Leduc). Aragonaise; l'Automne; Berceuse; Chant d'armour; l'Été; Hiver; Menuet; Le Printemps; Scherzino; Tango en la mineur. Nos.3, 5, 7, 8, 9, 10 available separately.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Pola Baytelman, "), _c('i', [_vm._v("Isaac Albéniz: Chronological List and Thematic Catalog of His Piano Works")]), _vm._v(" (Warren, MI: Harmonie Park Press, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sydney Grew, “The Music for Pianoforte of Albéniz,” "), _c('i', [_vm._v("Chesterian")]), _vm._v(" 6 (November 1924): 43–48.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Anthony Olson, “Isaac Albéniz: The Man, the Myth and the Music,” "), _c('i', [_vm._v("Piano Journal")]), _vm._v(" 29/90 (2010): 18–26.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Mateo Albéniz")]), _vm._v(" (1706?–1831) Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" D (Alfred; Editiorial Musica Moderna) 3pp. Presto, attractive, suggestion of Zapateado dance, fanfare effects. Fine program opener or encore. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Sebastián Albero")]), _vm._v(" (1722–1756) Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Treinta Sonatas")]), _vm._v(" (S. Kastner—UME 1978) 115pp. Edited from a manuscript in the Biblioteca nazionale Marciana, Venice. Some charming as well as surprising works in this collection, somewhat in style of Soler. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Eugen d'Albert")]), _vm._v(" (1864–1932) Germany, born Scotland")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("D'Albert, an outstanding pianist, left a few early works, eminently pianistic and well grounded in a late nineteenth-century idiom. He is better known for his operas and editions of keyboard works by Bach and Beethoven.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite")]), _vm._v(" d Op.1 1883 (Bo&Bo). Baroque influence plus nineteenth-century harmony. A, C, S, Gavotte and Musette, and G, A, Gavotte, and Musette (GS). The Musette shimmers over a long D pedal point, and the G is fugal and full of rhythmic vitality.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" f"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(" Op.10 1892 (Bo&Bo) 31pp. Brahms influence in all three movements. Cyclic construction. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("4 Klavierstücke")]), _vm._v(" Op.16 (CFP Nos.3 and 4). Waltz A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v("; Scherzo f"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v("; Intermezzo B; Ballade b. At least the vivacious Scherzo deserves an occasional hearing; available separately (Musica Obscura). M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("5 Bagatelles")]), _vm._v(" Op.29 (Bo&Bo). Ballade; Humoresque; Nocturne; Intermezzo; Scherzo. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Domenico Alberti")]), _vm._v(" (ca.1710–ca.1740) Italy")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Although Alberti probably did not invent the “Alberti bass,” he used it with such prominence that his name has become linked with this technique. He wrote about 36 sonatas.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" G Op.1 No.8 (W. S. Newman—UNC). "), _c('i', [_vm._v("Thirteen Keyboard Sonatas of the 18th and 19th Centuries.")]), _vm._v(" From a set of eight sonatas published by Walsh in London. Thin textures, Alberti bass, elaborate ornamentation. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Toccata")]), _vm._v(" G (Boghen—Ric). "), _c('i', [_vm._v("Toccatas by Old Italian Masters.")]), _vm._v(" M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (Zecchi, Fazzari—Carisch 1971) 10pp. Preface in Italian. Flowing lines, charming. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Johann Georg Albrechtsberger")]), _vm._v(" (1736–1809) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Six Fugues")]), _vm._v(" Op.7 (I. Sulyok—EMB & Litolff 1974) 32pp. For keyboard instrument. Informative preface in English and German deals with sources and editorial procedure. These pieces are good examples of contrapuntal skill using attractive subjects. Printed score contains a few errors. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("William Albright")]), _vm._v(" (1944–1998) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Albright, an outstanding performer, presented many organ and piano recitals of contemporary music in the United States and Europe. Popular music and jazz, along with his work in the theater and film, have influenced his music. He taught for many years at the University of Michigan.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Dream Rags")]), _vm._v(" 1979 (CFP 1995) 25pp. 18½ min. Sleepwalker's Shuffle: lazy, full chords, large span required; trio leads to a “Chicken Scratch” Harlem style. The Nightmare Fantasy Rag—A Night on Rag Mountain: based loosely on Mussorgsky's "), _c('i', [_vm._v("Night on Bald Mountain")]), _vm._v(", a kind of Lisztian “Mephisto Waltz rag”; wild, fantastic, involved, cadenza, coda (cruel rock tempo—a rag to end all rags!); longest and most difficult of the three pieces. Morning Reveries—A Slow Drag: highly chromatic, suggests morning recovery from the night of tortured dreams. Intriguing rhythms, colorful harmonies, out-Joplins Joplin! The set is a veritable goulash of excursions and interruptions. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Jennifer Louise Gray Trent, "), _c('i', [_vm._v("The Style Characteristics and Performance Problems of William Albright's “The Dream Rags”")]), _vm._v(" (DMA document, University of Houston, 2000), 94pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Five Chromatic Dances")]), _vm._v(" 1976 (CFP 66797) 38pp. 28 min. Procession and Rounds; Masquerade; Fantasy-Mazurka; Hoedown; The Farewell. Albright refers to but does not quote from chromatic styles from the past, using passages from Bach, Chopin, Debussy, and Ellington. Relies strongly on long sections of a homogeneous nature; rhythmic ostinatos; sonorous; easily recognizable formal structures use frequent recapitulation of earlier material. Evokes the grand Romantic spirit of Chopin and Liszt. One of the finest American piano works from the 1970s. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" David Burge, “William Albright,” CK 3 (March 1977): 52.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("———, “Contemporary Piano: Albright's Five Chromatic Dances,” CK 7 (March 1981): 56–57.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Randall Steve Sulton, "), _c('i', [_vm._v("Aspects of the New Romanticism in William Albright's ‘Five Chromatic Dances’")]), _vm._v(" (DMA document, University of Texas, Austin, 1992), 122pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Grand Sonata in Rag")]), _vm._v(" 1974 (Jobert) 21pp. In three movements: Scott Joplin's Victory; Ragtime Turtledove; Behemoth Two-Step. Technically and musically demanding (especially the second movement). Each movement can be played alone. A blend of sonata form with rag characteristics. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Pianoagogo")]), _vm._v(" (Jobert 1965) 8pp. 8 min. Suggestions for performance, spatial notation, dynamic range "), _c('i', [_vm._v("ppppp–fff")]), _vm._v(". Jazz element gradually becomes more important throughout. Pianistic for both hand and instrument. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sweet Sixteenths")]), _vm._v(" (in "), _c('i', [_vm._v("Ragtime Current")]), _vm._v(", EBM 1977). Interesting irregular left-hand part. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Novelty Rags")]), _vm._v(" 1973 (Jobert) 17pp. Written with William Bolcom. Sleight of Hand, or Legerdemain Rag; Burnt Fingers; Brass Knuckles. Clever, tricky, delightful fun for pianist and audience. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sphaera")]), _vm._v(" 1985 for piano and computer-generated four-channel tape (CFP) 40pp. Tape is available from the publisher. The notation of the tape part is incomplete and serves only as an assistance for coordination of the live piano part. Some piano preparation (mutes, etc.) is necessary. Plucked strings, scrape along strings with stick end, extended, several sections. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Machine Age")]), _vm._v(" 1988 (CFP) 20pp. 12 min. A set of short piano pieces inspired by contemporary images. The Ever-Blinking Eye; Player-Piano on Broadway; The Computer's Revenge (Scherzo); Blues for Cristofori (Lullabye Pian'e Forte); Robot Drummers (From Hell); Prayer (after the poetry of Christopher Smart as presented in the oratorio "), _c('i', [_vm._v("Song to David")]), _vm._v("). Some unmetered notation, “let piano lid fall closed, piano strings should resonate,” some avant-garde techniques, improvisation required. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Original Rags")]), _vm._v(" (CFP 1985) 23pp. 11 min. On the Lamb: moderate Rag Tempo, with enthusiasm and poise. Queen of Sheba: slow drag (with stomp = foot tapping), shy and relaxed. Onion Skin: lively rag tempo, infectious chromaticism. Striking examples of the contemporary rag. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Robert Livingston Aldridge")]), _vm._v(" (1954– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Though not a prolific composer, Aldridge holds a composition doctorate from Yale and has received several fellowships and awards for his music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Waltzes")]), _vm._v(" 2010 (CFP 68347 2011) 16pp. Commissioned by the California Music Teachers Association. Marked: Con moto; Gently lilting; Very animated and rhythmic. The composer observed that “waltzes often seem old-fashioned, but that is part of the fascination for me. In these three waltzes, I wanted to embrace that old-fashioned quality while trying to find something new in the form” (composer's note). Suitable for gifted high school students. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.robertaldridge.com",
      "target": "_blank"
    }
  }, [_vm._v("www.robertaldridge.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Raffaele d'Alessandro")]), _vm._v(" (1911–1959) Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("3ème Sonatine")]), _vm._v(" Op.39 (Henn) 8pp. 7 min. In three movements. Allegro marcato: dry chords punctuated by chromatic interchange between hands. Lento: chorale-like. Allegretto molto grazioso: an “ironic” minuet. Presto: a rondo with contemporary Alberti bass, catchy melody, rhythmic, neoclassic, extremely attractive. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Four Visions")]), _vm._v(" Op.49 (Gerig 1973) 8pp. Four short contrasting pieces. No.3 “Somnambulique” has wide-chord spacing. Large span required. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fantaisie")]), _vm._v(" Op.59 (Bo&Bo 1950) 17pp. 12–13 min. Improvisation: introduction, recitative-like. Marcato: driving rhythmic punctuation. Lirico (Lent). Con brio Toccata: brilliant figuration with exciting close. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Haim Alexander")]), _vm._v(" (1915–2012) Israel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Israeli Dances")]), _vm._v(" (IMP). Suite of short pieces inspired by Israeli folk material. Could be played as a group or individually. Climactic ending. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Improvisation on a Persian Song")]), _vm._v(" 1974 (IMI 6006) 6pp. 2 min. Lyrical; repeated rhythmic figuration. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Patterns")]), _vm._v(" (IMI 325) 11pp. 6 min. Required piece for the first Arthur Rubinstein International Piano Competition, held in Israel in 1974. Exhibits the requisite variations of texture and opportunities for virtuoso display. Strong rhythmic figurations throughout; wide span required. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Soundfigures")]), _vm._v(" (IMI 1968). Twelve cyclic pieces in variation form. A twelve-tone row and a cantus firmus form the basis of the work. Profuse use of the melodic interval of a minor second. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Josef Alexander")]), _vm._v(" (1910–1992) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alexander studied at Harvard University and the New England Conservatory. He taught for thirty-five years at Brooklyn College.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Bagatelles")]), _vm._v(" (Gen 1967). These thin-textured “trifles” demand a well-developed technique. Wide variety of moods with a liberal sprinkling of dissonances. All pieces are tonal. Seconds are exploited in No.1. Most are no longer than two pages. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Games Children Play")]), _vm._v(" (Gen). Ten short pieces with titles such as Leap Frog; Hide-and-Go-Seek; Follow the Leader. Contemporary sonorities, clever. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Of Chinese New Year")]), _vm._v(" (Gen 1980) 16pp. Twelve pieces for solo piano or piano and Chinese toy cymbals or wood blocks. Musical illustrations of the various animals associated with Chinese celebration. Colorful contemporary settings. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Anatoly Alexandrow")]), _vm._v(" (1888–1982) Russia")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Scriabin influenced Alexandrow's early works, but native folk song took on more importance in later compositions.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.5")]), _vm._v(" g Op.22 (UE 1922). First movement: Scriabin influence. Second movement: set of ten variations and a fugue. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.6")]), _vm._v(" Op.26 (USSR 1925). Lyric, serene opening leads to an Adagio; closes with a rhythmic Foxtrot. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Eight Pieces on USSR Folksongs")]), _vm._v(" Op.46 (USSR 1938). Simple settings of Armenian, Kirghiz, Russian, and Tchouvach folk tunes. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.8")]), _vm._v(" B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.50 (USSR 1946). Employs tunes from Op.46 in transparent writing. A buoyant Allegretto giocoso opening, a serious Andante cantabile, and an exuberant finale make this a well-balanced work. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.9")]), _vm._v(" Op.61 (USSR 1946). Allegro moderato; Andante; Allegro. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Six Pieces of Medium Difficulty")]), _vm._v(" (USSR). Short character pieces in varied moods.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Alexander A. Aliabev")]), _vm._v(" (1787–1851) Russia")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Selections from His Piano Works")]), _vm._v(" (USSR). Consists mainly of short pieces in a post-Mozart style with some indebtedness to John Field. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Heitor Alimonda")]), _vm._v(" (1922–2002) Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Alimonda has taught at the School of Music in the University of Rio de Janerio.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("O Estudo do Piano")]), _vm._v(" (Ric Brazil 1976) 10 vols. A piano course covering the main ingredients for developing a solid pianistic background. Easy to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Movimento Perpétuo")]), _vm._v(" (Ric BR 1966) 2pp. Ostinato treatment recalls Ibert's "), _c('i', [_vm._v("The Little White Donkey.")]), _vm._v(" M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Estudo No.I")]), _vm._v(" (Ric BR 1956) 3pp. Romantic, tuneful. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Estudo No.II")]), _vm._v(" (Wehrs 1958) 1 min.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Estudo No.III")]), _vm._v(" (Gerig 1957) 3pp. Moving thirds in right hand, then left hand; melody in opposite hand; contrary-motion thirds in next-to-last bar. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Modinha")]), _vm._v(" (Wehrs 1958) 2pp. Improvisational in spirit in ternary form with light texture. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina No.2")]), _vm._v(" (SDM 1960–61) 11pp. 8 min. Three movements. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Roman Alis")]), _vm._v(" (1931– ) Spain")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alis has taught in the conservatories of Seville and Madrid. He has written music for films and television.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Poemas de la Baja Andalucía")]), _vm._v(" Op.18 1958 (Editorial de Música Española Contemporánea 1991) 20pp. 10 min. Nubes. Canción. Niños. Siesta. Fiesta. Colorful contrasting pieces using a broadened tonality, some use of harmonic fourths, well crafted. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Charles Henri Valentin Alkan")]), _vm._v(" (1813–1888) France")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This contemporary of Chopin, Liszt, Anton Rubinstein, and César Franck produced some of the most powerful piano music of the nineteenth century. Busoni placed him among “the greatest of the post-Beethoven piano composers.” Many of his works deserve to be rescued from oblivion. Alkan gave the same opus numbers to different compositions; he also republished some works under different opus numbers. Therefore, it is nearly impossible to provide a complete and accurate list of his works.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Variations")]), _vm._v(" Op.1 E (F. M. Delaborde, I. Philipp—Billaudot) 21pp. Composed on a theme by Steibelt. Allegro, expressive theme in 6/8 with a lilting rhythm, interrupted midway by a dramatic scalar run. Six variations in contrasting characters follow, sometimes gentle and sometimes virtuosic, testing the pianist's skill in a Lisztian manner. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Allegro Barbaro")]), _vm._v(" (IMP 127) 7pp. An octave study, all on white keys, composed sixty years before Bartók's piece of the same title. Plenty of vigor; storm and stress. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Concerto da Camera I")]), _vm._v(" Op.10/1 a (Musica Obscura). Adagio available separately from same publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Trois Études de Bravoure (Scherzi")]), _vm._v(") Op.16 (E.M. Delaborde, I. Philipp—Billaudot) 25pp. Reproduction of the newer corrected edition from around the turn into the twentieth century. I. Mouvement de valse: in a/C, contrasted by a Trio in A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" and Stretto in C at "), _c('i', [_vm._v("fff")]), _vm._v(" to "), _c('i', [_vm._v("ffff.")]), _vm._v(" II (quasi Minuetto): Moderato in c with octaves, thirds, and 6/3 chords in scales, contrasted by dotted eighth–sixteenth note Trio in F. III. Prestissimo: Con impeto in b with internal trio in B offset by a formal Trio marked Prestissimamente, "), _c('i', [_vm._v("pp")]), _vm._v(" et staccatissimo. Virtuosic, bravura effects abound in these etudes, bound to be audience pleasers in spite of occasional staidness. Wide span required in II. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Pieces")]), _vm._v(" [Opp.23–25] (MMP) 25pp. "), _c('i', [_vm._v("Saltarelle")]), _vm._v(", Op.23: Prestissimo in 6/8 at mostly soft levels until virtuosic finish. "), _c('i', [_vm._v("Gigue et Air de Ballet")]), _vm._v(", Op.24: Presto in 12/8 with two-voice fugal introduction for the Gigue and Modéré in 2/2 with full chords and octaves for the Air de Ballet. "), _c('i', [_vm._v("Alleluia")]), _vm._v(", Op.25: an exuberantly restrained proclamation in full chords at "), _c('i', [_vm._v("ff")]), _vm._v(" to "), _c('i', [_vm._v("fff.")]), _vm._v(" M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Alleluia")]), _vm._v(" Op.25 (Billaudot; Musica Obscura; MMP, in "), _c('i', [_vm._v("Three Pieces")]), _vm._v(") 5pp. Slow, sustained, full repeated chords. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Perpetuum Mobile")]), _vm._v(" Op.30 (F.M. Delaborde, I. Philipp—Billaudot).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("25 Préludes")]), _vm._v(" Op.31 1848 (F. M. Delaborde, I. Philipp—Billaudot) 61pp. In all major and minor keys plus 1, the final Prelude a Prayer. Many preludes have programmatic titles. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" Op.33 “Les Quatre Ages” (Billaudot; Joubert). “Twenty Years”—Very fast, Firmly. “Thirty Years”—Quasi-Faust—Quite fast, Satanically. “Forty Years”—A happy household—Slowly. “Fifty Years”—Prometheus chained—Extremely slow. This “grand” work begins with the scherzo “Twenty Years,” which turns out to be a kind of introduction to a huge, virtuosic Romantic sonata. As the work unfolds, the effect is one of gradual deceleration (getting old!). Combines flash with musical substance; continually appealing musical inventiveness. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Études in Major Keys")]), _vm._v(" Op.35 (Joubert; Billaudot; MMP) 32 min. Some of Alkan's finest works.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("30 Chants")]), _vm._v(" (Billaudot; MMP). In five Suites, each with six pieces using mostly programmatic titles. All five Suites finish with a Barcarolle. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Suite No.1")]), _vm._v(" Op.38/1. 1. Assez vivement. 2. Sérénade. 3. Chœur. 4. l'Offrande. 5. Agitatissimo. 6. Barcarolle.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Suite No.2")]), _vm._v(" Op.38/2. 1. Hymne. 2. Allegretto. 3. Chant de Guerre. 4. Procession-Nocturne. 5. Andantino. 6. Barcarolle en Chœur.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Suite No.3")]), _vm._v(" Op.65. 1. Vivante. 2. Esprits follets. 3. Canon. 4. Tempo giusto. 5. Horace et Lydie. 6. Barcarolle.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Suite No.4")]), _vm._v(" Op.67. 1. Neige et lave. 2. Chanson de la bonne vieille. 3. Bravement. 4. Doucement. 5. Appassionato. 6. Barcarolle.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Suite No.5")]), _vm._v(" Op.70. 1. Duettino. 2. Andantinetto. 3. Allegro vivace. 4. La Voix de l'Instrument. 5. Scherzo-Coro. 6. Barcarolle.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Études in Minor Keys")]), _vm._v(" Op.39 (Billaudot) in two suites, six pieces in each. 1. Comme le vent: 27 min. 2. Rythme molossique. 3. Scherzo diabolico. 4. Allegro moderato. 5. Marche funèbre. 6. Menuet. 7. Finale. 8. Concerto: Allegro assai. 9. Concerto: Adagio. 10. Allegro alla Barbaresca. 11. Ouverture, la. Le festin d'Esope. Nos.4–7 make up the "), _c('i', [_vm._v("Symphony for Piano Solo.")]), _vm._v(" No.12 is a cross between a bolero and a polonaise, an eclectic sprawling piece full of imagination, craft, and virtuosity. This set contains some of Alkan's most interesting compositions; No.12 is one of his finest achievements and shows Alkan at the height of his powers.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Réconciliation, petite caprice en forme de Zorcico")]), _vm._v(" Op.42 (Billaudot) 10pp. Contains some sonorous effects. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Capriccio alla solidatesca")]), _vm._v(" Op.50/1 (Billaudot). Left-hand clusters, fantastic writing.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Une Fusée")]), _vm._v(" Op.55 (Billaudot). Introduction and Impromptu.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatine")]), _vm._v(" a Op.61 (Billaudot). Classic in its purity of form; what a piano sonata by Berlioz might have sounded like. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Esquisses: 48 Motifs")]), _vm._v(" Op.63 (Billaudot). Four suites, twelve pieces in each, published in 4 books, a few separately. Programmatic titles for these 1–3pp. pieces. Nos.42 and 48 (Musica Obscura).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Les Mois")]), _vm._v(" Op.74 (Billaudot). Twelve pieces in four suites published in four books.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Katharine Boyes, "), _c('i', [_vm._v("The Months of the Year Portrayed in Piano Works by Fanny Hensel, Charles-Valentin Alkan, Peter Tchaikovsky, and Judith Lang Zaimont")]), _vm._v(" (diss., University of Cincinnati, 1998), 465pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("3 Grandes Études")]), _vm._v(" Op.76 (Billaudot). Fantaisie A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(": left hand only. Introduction, Variation, Finale: right hand only. Mouvement semblable et perpetuel: for both hands. Published separately. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Perpetuum Mobile")]), _vm._v(" (Billaudot). Preparatory to Op.76.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Deux Fugues")]), _vm._v(" (Musica Obscura). Jean qui pleure; Jean qui rit.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Le Festin d'Ésope and Other Works for Solo Piano")]), _vm._v(" (M.-A. Hamelin—Dover 1998) 223pp. Contains: Symphonie, Op.39/4–7, Concerto, Op.39/8–10, Le Festin d'Ésope, Op.39/12.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Oeuvres choises")]), _vm._v(" (F. M. Delaborde, I. Philipp—Billaudot 1970). Super flumina Babylonis, Op.52; Paraphrase du psaume 137, Op.52.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Alkan in Miniature")]), _vm._v(" (R. Smith, J. White—Billaudot 1979) 31pp. Fourteen shorter and easier pieces representing the variety of Alkan's style. See especially The Pursuit; Laus Deo (Praise to God); Song of the Mad Woman (eerie); La Vision (exquisite lyricism); Esquisses. Text in French and English. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Piano Music of Alkan")]), _vm._v(" (R. Lewenthal—GS 1964) 147pp. Contains a brief biography of Alkan, a preface “On Recreating a Style,” “General Remarks on Alkan's Style as It Affects the Interpreter,” “Alkan's Treatment of the Piano,” “Athletic Form,” and extensive performance suggestions. Includes "), _c('i', [_vm._v("Le Festin d'Ésope")]), _vm._v(" Op.39/12 (the last étude in a 275-page set of studies published in 1857); "), _c('i', [_vm._v("Symphonie")]), _vm._v(" Op.39 (comprising Nos.4, 5, 6, 7 of the "), _c('i', [_vm._v("Études")]), _vm._v(" Op.39); "), _c('i', [_vm._v("Fa")]), _vm._v(" Op.38/2; "), _c('i', [_vm._v("Barcarolle")]), _vm._v(" Op.65/6; "), _c('i', [_vm._v("Le Tambour bat aux champs")]), _vm._v(" Op.50/2; "), _c('i', [_vm._v("Étude")]), _vm._v(" Op.35/8; "), _c('i', [_vm._v("Quasi-Faust")]), _vm._v(" Op.33 (second movement of the “Grande Sonate”); and "), _c('i', [_vm._v("Esquisses")]), _vm._v(" Op.63 (eleven pieces from this set of forty-eight short pieces through all the major and minor keys). The "), _c('i', [_vm._v("Esquisses")]), _vm._v(" are La Vision No.1, Le Staccatissimo No.2, Le Legatissimo No.3, Les Soupirs No.11, Barcarolette No.12, Scherzettino No.37, Héraclite et Démocrite No.39, Les Enharmoniques No.41, Les Diablotins No.45, Le Premier Billet Doux No.46, and Scherzetto No.47. Virtuoso techniques required for this orchestral approach to the piano. D.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("SEPARATE PIECES")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Desire")]), _vm._v(" (Musica Obscura) 3pp. A miniature set of variations with some interesting modulations. Requires good melodic projection. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Les Omnibus: Variations")]), _vm._v(" Op.2. See below, “Collections,” "), _c('i', [_vm._v("Piano Music and the Virtuosos, 1810–1860.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Wind")]), _vm._v(" (GS). Sweeping figurations. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("13 Selected Works")]), _vm._v(" (G. Beck—Heugel). Notes in French, German, and English. Does not duplicate any of the pieces in the Lewenthal album.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bourée d'Avergne; Etude")]), _vm._v(" Op.29 (Schott). Strong rhythms, full chords. M-D.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("BRIEF BIBLIOGRAPHY")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Henry H. Bellamann, “The Piano Works of C. V. Alkan,” MQ 10 (April 1924): 251–62.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Joseph Bloch, “Charles-Valentin Alkan,” thesis, Harvard University (Indianapolis: privately printed for the author, 1941).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Raymond Lewenthal, “The Berlioz of the Piano,” MA 84/2 (February 1964): 44.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Bryce Morrison, “Alkan the Mysterious,” M&M 22 (June 1974): 30–32. Mainly discusses "), _c('i', [_vm._v("Sonata")]), _vm._v(" Op.33.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Humphrey Searle, “A Plea for Alkan,” ML 18/3 (1937): 276–79.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Larry Sitsky, “Summary Notes for a Study on Alkan,” "), _c('i', [_vm._v("Studies in Music")]), _vm._v(" 8 (1974): 53–91. Twenty sections, each of which could well be the subject of a separate essay. Musical examples, including the following complete pieces: "), _c('i', [_vm._v("Gigue et Air de Ballet")]), _vm._v(" Op.21/1; "), _c('i', [_vm._v("Trois Airs à cinq temps et un à sept temps")]), _vm._v(" Op.32/2; "), _c('i', [_vm._v("Cinquième Recueil de chants")]), _vm._v(" Op.70; "), _c('i', [_vm._v("Ancienne Mélodie de la Synagogue.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("J. H. White, “Alkan the Neglected Genius,” "), _c('i', [_vm._v("Piano Journal")]), _vm._v(" 7 (February 1982): 15–17.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Douglass Allanbrook")]), _vm._v(" (1921–2003) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Allanbrook studied composition with Walter Piston and Nadia Boulanger.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("40 Changes")]), _vm._v(" (Bo&H 1971) 22 min. Large-scale set of variations, exploits the piano's possibilities. The composer states: “Its form could be thought of as a jeweled sphere with many facets which wheels before the ear and the mind—its intensity increases until the end where it reveals itself as a song.” Mature pianism required. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Preludes for All Seasons")]), _vm._v(" 1974 (Bo&H) 25pp. One short prelude for each month of the year. Advanced compositional and pianistic techniques are used. Linear writing interspersed with vertical sonorities. For the artist student. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Terence Allbright")]), _vm._v(" (1946– ) England")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Sonata I")]), _vm._v(" 1974 (B. Ramsey 1978) 20pp. 12 min. Facsimile reproduction. Divided into two main sections. Requires solid technique. Mildly twentieth-century. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("P. Humberto Allende")]), _vm._v(" (1885–1959) Chile")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("An Impressionistic nationalism pervades the work of Allende. Unusual metric structure also appeals to him.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Études")]), _vm._v(" (Sal). French influence, melodic in emphasis. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Miniatures Grecques")]), _vm._v(" (Sal). All on white keys except No.5.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("2 Préludes")]), _vm._v(" (Sal). Subtle, expressive. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Tempo di Minuetto")]), _vm._v(" (Sal). Short, chromatic, lyric. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Tonadas")]), _vm._v(" (Sal 1918–22). Based on popular Chilean tunes. Short pieces that go through a circle of major and minor keys. Each piece begins in a minor key, then goes to the parallel major in a faster tempo. Some of the finest piano music inspired by folk music of the region. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Hans Günther Allers")]), _vm._v(" (1935– ) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Eleven Bagatelles")]), _vm._v(" (Br&H EB8100 1980) 12pp. Preface in German and English. Pieces become progressively more difficult. They begin well, but inspiration dries up toward the end of the collection. Many directions, footnotes in German only. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Claude Marion Almand")]), _vm._v(" (1916–1957) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Almand received a PhD from the Eastman School of Music in 1940 and taught at George Peabody College, Southern Baptist Theological Seminary, University of Louisville, and Stetson University.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("2nd Piano Sonata")]), _vm._v(" (UL) 19pp. in manuscript copy. In one movement marked Adagio non tanto—Allegro risoluto. Broad musical ideas and scope in a strongly tonal, expressive environment. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("5th Piano Sonata")]), _vm._v(" 1956 (UL) 33pp. in manuscript. In three movements: Spiritual; Dance; Passacaglia. Scalar passagework and coloristic, especially in Passacaglia, where sudden chordal shifts sometimes occur in step motion rather than through conventional harmonic principles. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Yardena Alotin")]), _vm._v(" (1930–1994) Israel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Alotin taught at the Israel Conservatory in Tel Aviv.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Preludes")]), _vm._v(" (IMI 1978) 12pp. 7 min. 1. E, virtuosic, bitonal counterpoint. 2. Quiet, pastorale-like tune, loose rondo form. 3. Playful and lively. Contains pedaling, essential fingering, and metronome indications. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Carlos Roqué Alsina")]), _vm._v(" (1941– ) France, born Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alsina teaches piano at the Conservatoire National Supérieur de Musique in Lyon and has performed in Latin America, Europe, Canada, and the United States in solo and orchestral settings.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite")]), _vm._v(" 1988 (SZ 9792 2006) 4 large sheets. In four movements, three with metronomic tempo markings at slow speeds and the other (No.3) without indication. Avant-garde with Webern's economy, Berio's splashes of sound, and Ligeti's rhythmic complexities, yet with the composer's distinct voice. Uses some late twentieth-century notational procedures, described in the preface in Italian and French. Highly expressive with nearly every note bearing individual attention. Special pedal effects, clusters, glissandi, embellishments, and indeterminancy are present. No.3 is deeply personal with trills throughout in a thin texture at dynamics ranging from "), _c('i', [_vm._v("mp")]), _vm._v(" to "), _c('i', [_vm._v("pppp")]), _vm._v(", interrupted by a sudden "), _c('i', [_vm._v("ff")]), _vm._v(" which quickly retreats. No.4 is the most difficult and has an optional prerecorded tape part. A challenge for pianists and audiences alike, but well worth the effort. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Delamar Alvarenga")]), _vm._v(" (1952– ) Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alvarenga studied with Oliver Toni and has lived in São Paulo.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Ah, vous dirai-je, Maman")]), _vm._v(" 1970 (Universidade de São Paulo 1972, Escola de Communicacões e Artes, São Paulo, Brazil) 7pp. Aleatoric, improvisational, new notation. Directions are given for three different realizations. Avant-garde.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Estudo a duas vozes")]), _vm._v(" 1969 (Ric) 2pp. This work attempts to integrate daily sounds into the context of a musical structure in two voices. Improvisational, graphic notation. On the thirtieth repetition, the pianist must decide how to bring about the climax by using anything except the glissando. Avant-garde.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("William Alwyn")]), _vm._v(" (1905–1985) England")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Alwyn was best known as a writer of music for over fifty films. He composed in an unashamed Romantic style full of instrumental color.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata alla Toccata")]), _vm._v(" (Lengnick 1951) 21pp. In four movements. Maestoso: C, basically diatonic, much rhythmic drive. Andante con moto e semplice: F, much use of thirds in melody and accompaniment. Molto vivace: triplet figuration prominent; requires good octave technique; concludes with an effective Presto furioso. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fantasy-Waltzes")]), _vm._v(" (Lengnick 1956) 48pp. Eleven pieces inspired by Schubert and Ravel, cast in a mild twentieth-century harmonic idiom. Some charming, delectable writing, always gratifying for pianist and audience. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Movements")]), _vm._v(" (JWC). Allegro appassionato; Evocation; The Devil's Reel. Pianistic writing of moderate difficulty.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Twelve Preludes")]), _vm._v(" (Lengnick 1959) 33pp. The "), _c('i', [_vm._v("Twelve Preludes")]), _vm._v(", Alwyn said, “were written when I was experimenting with short note groups each with a strong tonal center; a different group of notes is used for each Prelude” (from a Chandos compact disc). Each is written in a specific key, i.e., No.1 in E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", No.2 in A, No.6 in G and F"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", etc., but with no key signature. Each piece is a complete entity and “fits the hand” beautifully. An impressive set that shows there is still plenty to be said in the key of C. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("André Amellér")]), _vm._v(" (1912–1990) France")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatine en Sol")]), _vm._v(" Op.54 1950 (Combre 1999) 17pp. Cast in three movements: Allegro e sciolto; Languido; Vivace. Suitable for advanced high school student, though inner voices may pose problems. Languido in 7/8 meter with colorful harmonic movement. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Montréal")]), _vm._v(" Op.185 1970 (Leduc 1973) 3pp. 3 min. Short prelude opens with an expressive recitative. Octotonic writing interspersed with mild twentieth-century chords, modal. Impressionistic portrayal of Montreal, bell sonorities. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.ameller.org",
      "target": "_blank"
    }
  }, [_vm._v("www.ameller.org")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("René Amengual")]), _vm._v(" (1911–1954) Chile")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Amengual's piano works show the stylistic influences of the modern French school.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina")]), _vm._v(" 1938 (ECIC 1945) 14pp. Three movements, the second of which contains effective melodic writing. Does not display any overt Latin American rhythmic characteristics. Shows a startling resemblance to the Ravel "), _c('i', [_vm._v("Sonatine.")]), _vm._v(" M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Emanuel Amiran-Pougatchov")]), _vm._v(" (1909–1993) Poland")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("Lahat")]), _vm._v(" (Ecstasy) (IMI 1974) 20pp. A toccata for the adventurous pianist. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Martin Amlin")]), _vm._v(" (1953– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("An accomplished pianist, Amlin teaches composition and theory at Boston University.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Sonata No.7")]), _vm._v(" 1998–99 (TP 410–41332 2000) 27pp. 13 min. Fantasia: marked Very freely; based on three twelve-tone rows. Lament: marked Mysterious—eccentric, commences and ends very softly, uses intense rhythmic figures, and whole-tone tetrachords. Scherzo and Fugue: marked Very energetic, angular, and driven, recalls one twelve-tone row from the Fantasia amidst its exuberant pace, uses proportional rhythmic relationships, and a three-voiced fugue on a strident subject. A demanding work for performers and audiences alike. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Richard A. Hendricks, "), _c('i', [_vm._v("A Brief Analysis of Martin Amlin's Keyboard Works: A Personal Case Study in Informing Performance")]), _vm._v(" (DMA paper, University of North Carolina, Greensboro, 2009).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "href": "http://www.martinamlin.com",
      "target": "_blank"
    }
  }, [_vm._v("www.martinamlin.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("David Amram")]), _vm._v(" (1930– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Amram is equally at home with classical music and jazz.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" 1965 (CFP 6685) 18 min. In three movements. Overture: rhythmic with quiet ending. Lullaby: song-like, requires span of ninth. Theme and Variations: variety of moods, brilliant climax, quiet close. Requires first-class pianism. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" David Amram, "), _c('i', [_vm._v("Vibrations: The Adventures and Musical Times of David Amram")]), _vm._v(" (New York: Macmillan, 1968).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Gilbert Amy")]), _vm._v(" (1936– ) France")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Amy studied with Messiaen and Milhaud, but Messiaen influenced him more. The two seemingly opposed principles of serial and aleatoric techniques exist side by side in his piano works.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Cahiers d'Epigrammes")]), _vm._v(" (Heugel 1966). Contains Formant A, Formant B, Formant B, second part. Directions given. Serial and aleatoric. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Epigramme")]), _vm._v(" (Heugel 1962). Issued in an envelope with one large score printed on both sides. Performance directions listed on outside cover. Serial and aleatoric. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Obliques I")]), _vm._v(" (Amphion A.561 1995) 22pp. In one continuous movement with multiple sections. Added-note harmonies and shifting rhythmic patterns create an oblique reflection. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Obliques No.3")]), _vm._v(" 1989 (Amphion 1994) 10pp. Requires piano with sostenuto pedal. Proportional rhythmic relationships, pointillistic, contrasted sonorities and touches, pedal indicated, frequent tempo changes, highly organized. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonate")]), _vm._v(" (Heugel 1961). Within its aleatoric limits this is extraordinarily fashioned music. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" André Hodeir, "), _c('i', [_vm._v("Since Debussy: A View of Contemporary Music")]), _vm._v(" (New York: Grove, 1961).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("H. Riley, “Aleatoric Procedures in Contemporary Piano Music,” MT 107 (April 1966): 311–12.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("K. Stone, “The Piano and the Avant-Garde,” PQ 52 (Summer 1965): 14–28.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Karl Andersen")]), _vm._v(" (1903–1970) Norway")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Anderson was one of Norway's leading cellists. His style is thoroughly contemporary and logically thought out and developed.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Columbine and the Annoyed Harlequin")]), _vm._v(" (Lyche). Serial technique handled in a highly personal manner. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Allen Anderson")]), _vm._v(" (1951– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Anderson received a doctorate from Brandeis University and presently teaches at the University of North Carolina, Chapel Hill.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Solfeggietti")]), _vm._v(" 1988 (CFP 67664 1997) 13pp. 15 min. three movements: Caprice; Chaconne; Scherzo. A virtuosic work with graceful lyricism emerging out of strong dissonances and a mixture of polyphonic and homophonic writing. Chaconne has 4 variations. Score is easy-to-read photocopy of manuscript. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Thomas Jefferson Anderson")]), _vm._v(" (1928– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Watermelon")]), _vm._v(" 1971 (Bo&Bo) 9 pp. 7 min. Based on a street huckster's song heard in Washington, D.C. Tune included in index. Variations on the tune use many contemporary techniques: pointillism, harmonics, contrary black-and white-key glissandos, careful pedal indications, dynamic extremes. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Volkmar Andreae")]), _vm._v(" (1879–1962) Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sechs Klavierstücke")]), _vm._v(" Op.20 (Hug 1911). Praeludium: Bacchantischer Tanz; Frage; Catalonisches Ständchen: Adagio; Unruhige Nacht. Post-Brahms writing, well-conceived pianistic sonorities. Available separately. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Arshak Andriasov")]), _vm._v(" (1980– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Born into a musical family where his father was a well-known Armenian composer and his mother a musicologist, Andriasov has achieved fame as pianist and composer, writing in an eclectic idiom.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("First Sonata")]), _vm._v(" Op.4 2001 (Imma 2003) 31pp. 5 min. In one movement with repetitive rhythms, seventh chords, lyricism, strong dynamic contrasts, and muscular writing. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Second Sonata")]), _vm._v(" Op.5 2003 (Imma 2003) 25pp. 12 min. In three movements: "), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music1.jpg"
    }
  }), _vm._v(" = 200; "), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music1.jpg"
    }
  }), _vm._v(" = 50; "), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music1.jpg"
    }
  }), _vm._v(" = 92. Harp-like slow movement emphases rolled chords with added notes for coloristic purposes. Driving rhythms in outer movements require stamina and pacing. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.arshakandriasov.com",
      "target": "_blank"
    }
  }, [_vm._v("www.arshakandriasov.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Hendrik Andriessen")]), _vm._v(" (1892–1981) The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The elder Andriessen's style incorporated influences of both Debussy and popular music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonate")]), _vm._v(" 1934 (Van Rossum 1934) 10 min. Oriented toward Hindemith, polytonal. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Pavane")]), _vm._v(" 1937 (B&VP) 3pp. Poco maestoso and molto espressivo setting with ascending melodic lines and chromatic interior. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Jurriaan Andriessen")]), _vm._v(" (1925–1996) The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Andriessen studied with his father, Hendrik. Later, in Paris, he studied film music and was influenced by Messiaen. Nonetheless, he wrote in a neoclassic style, oriented toward Stravinsky.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Roger's Sonatine")]), _vm._v(" (B&VP 1237). Outside movements are lively, while the middle is a sensitive sarabande. Refreshing. Contains no stretch larger than a seventh. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Serenade")]), _vm._v(" (B&VP 1982) 8pp. An expressive essay at Moderato with thin textures and rolled chords, which turns to a lively Allegro giocoso with mixed meters and triadic chord formations. Finishes sweetly at Andante. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("De Tuin van Eros / The Garden of Eros")]), _vm._v(" (Wagenaar) 16pp. In five movements: Danse; Romance; Nocturne; Sicilienne; Scherzo. Colorful with each movement illuminating Andriessen's style. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Portret van Hedwig")]), _vm._v(" (Moebiprint 1998) 82pp. Fifty-four short studies on a compendium of technical problems. Preface and description of pieces in Dutch. Easy to D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Louis Andriessen")]), _vm._v(" (1939– ) The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Andriessen studied with his father, Hendrik, and later with Kees van Baaren. He also studied with Berio in Milan and Berlin in the early 1960s. Cage and Stockhausen have likewise influenced Andriessen, who won the 2011 Grawemeyer Award in composition.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Registers")]), _vm._v(" (Donemus 1963) 7 min. Written in spatial or time notation, i.e., the duration is fixed by the space on the paper. Andriessen says this piece “is more an indication for action than a composition.” Avant-garde, fascinating sonorities. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Jean-Henri d'Anglebert")]), _vm._v(" (1635–1691) France")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Among the galaxy of composers who made the reign of the Sun King one of the high points in the history of music, D'Anglebert is one of the most important.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Pièces de Clavecin")]), _vm._v(" (Roesgen-Champion—Société Française de Musicologie 1934). Urtext edition containing nearly all the keyboard works. Newly transcribed with preface and notes by D. Restout.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Pièces de Clavecin")]), _vm._v(" (BB 1965). Facsimile of the 1689 Paris edition. Contains a preface and a detailed table of ornaments. Harpsichord Suites in G, g, d, and D; five fugues and a short contrapuntal Kyrie for the organ; Principles of Accompaniment; six pages of theoretical treatise, chords, intervals, etc. The harpsichord suites usually contain a prelude, A, C, S, and G. Other compositions, including transcriptions of works by Lully, follow. The final piece is D'Anglebert's tribute to his teacher, Chambonnières.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Pièces de Clavecin")]), _vm._v(" (K. Gilbert—Heugel 1975). This easy-to-read edition offers all of the 1689 collection plus thirty-five more pieces, thirteen of which were previously unpublished. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Beverly Scheibert, "), _c('i', [_vm._v("Jean-Henri D'Anglebert and the Seventeenth-Century Clavecin School")]), _vm._v(" (Bloomington: Indiana University Press, 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Istvan Anhalt")]), _vm._v(" (1919–2012) Canada, born Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("Fantasia")]), _vm._v(" (Berandol). Eloquent serial writing. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("George Antheil")]), _vm._v(" (1900–1959) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Antheil shocked audiences in the 1920s with his “machine music.” His style changed remarkably after the early experimental days, and he finally seemed at home in the area of neo-Romantic and Impressionist surroundings. A sense of humor often permeates his writing.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Pastels")]), _vm._v(" (Weintraub). 15 varied short pieces, mildly dissonant. First-rate teaching pieces. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.2")]), _vm._v(" “The Airplane” 1922 (NME 1931). In two movements, the first very fast, the second slower. No dynamic markings except at the beginning and close of the first movement. Rhythms are aggressive and motoristic but also sometimes reminiscent of ragtime. Strident harmonies, clusters, deliberately noisy. Sharply contrasting ideas juxtaposed but not developed; repeats material either wholly or in fragments. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.3")]), _vm._v(" 1947 (AMC). In three movements. Allegro marcato (Heroic): chordal; dramatic; syncopated; bitonal; large gestures; static tonal planes and overused sequential devices antithetical to the style of the rest of the movement; coda based on opening material. Adagio molto expressivo (Romantic): accompanied melody in tripartite form; nocturne-like; some bitonality; sensitive pedaling required. Presto (Diabolic): full chords at fast tempo; C major pounded out in last 18 bars. Changing meters, large skips, sardonic, ironic, humorous. Not a totally integrated work. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.4")]), _vm._v(" 1948 (Weintraub). In three movements. Allegro giocoso—Ironico: frames the rhythmic and aesthetic elements of Antheil's mechanistic music of the 1920s within the formal construct of traditional forms. Andante: neo-Romantic, lyric, expressive. Allegro (Presto): a brilliant toccata activated by a continual frenzied pulse and by pounding chords. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite")]), _vm._v(" (GS). Three short pieces that provide an introduction to the contemporary idiom. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("2 Toccatas")]), _vm._v(" 1951 (GS). Published separately. No.2 B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" has constant eighth-note motion and alternating chords and octaves. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("La Femme 100 Têtes: 45 Preludes")]), _vm._v(" 1933 (Antheil Press 1985; GS, print on demand). These 44 preludes and the concluding Percussion Dance were inspired by Max Ernst's collage of etchings by the same name. The preludes explore many facets of Antheil's style, from percussive machinations to triadic lyricism. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" David L. Albee, "), _c('i', [_vm._v("George Antheil's ‘La Femme 100 Têtes’: A Study of the Piano Preludes")]), _vm._v(" (DMA diss., University of Texas–Austin, 1977), 140pp.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Theodore Antoniou")]), _vm._v(" (1935– ) Greece")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Antoniou taught at Boston University. His music combines conventional and avant-garde techniques. He explores abstract relationships, such as the movements of sounds, the several ways of playing an instrument, problems of space, sound, movement, and event.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Acquarelle")]), _vm._v(" (Edition Modern 1967) 14pp. in a package, 15 min. Ten separate pieces. Adagio espressivo; Vivo e secco; Largo mysterioso; Allegro ritmico; Andante espressivo; Allegro brioso; Andantino calmo; Presto scherzino; Largo amoroso; Allegro barbaro. Colorful and appealing pieces written in a freely tonal idiom with use of some serial technique. Mild twentieth-century sonorities. Entire suite or a selection of the pieces would add strong interest to any program. One suggested grouping consists of Nos.2, 3, 8, 10. Requires above-average pianistic ability. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sil-ben")]), _vm._v(" (Syllables) (in "), _c('i', [_vm._v("Contemporary Greek Piano Music")]), _vm._v(", Gerig 1965) 4pp. Six short pieces, each based on certain properties of letters or syllables in speech. Constructed on a twelve-tone row that also uses parameters of serial organization. Parachesis: a sound group recurs frequently, like the recurring syllable creating this rhetoric figure in speech; dynamic extremes; hands crossed. Anagram: the position of notes is interchanged in quick passages with different quantities that always end on a stressed note; short groups of fast chromatic notes stop on a long melody note. Derivatives: a sound group or note induces others to sound as in language; addition of prefixes or suffixes leads to new words; pointillistic. Epenthesis: middle register is altered in timbre by placing a book on the strings, giving a harpsichord-like sound; a motive has been transposed, transformed, and varied. Aphairesis: the Greek word means both subtraction and abstraction; glissando on string; plucked strings. Conclusion: a theme in a different style appears amid motives from the preceding movement; finally it is assimilated. Experimental. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Dennis Aplvor")]), _vm._v(" (1916–2004) Ireland")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Seven Pieces")]), _vm._v(" Op.30 1960 (Sikesdi Press 1996) 13pp. Serial, pointillistic, contrasting. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Animalcules")]), _vm._v(" Op.35 1993 (Sikesdi Press 1996) 12pp. Twelve short pieces. Serial, pointillistic, contrasting. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Rafael Aponte-Ledée")]), _vm._v(" (1938– ) Puerto Rico")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Aponte-Ledée taught composition at the University of Puerto Rico.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Tema y seis differencias")]), _vm._v(" (PIC 1963) 6pp. 3 min. Serial, six short contrasting and effective variations, frequent meter changes, contemporary treatment. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Hans Eric Apostel")]), _vm._v(" (1901–1972) Austria")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Early works by Apostel were highly chromatic and thick-textured. After he studied with Schönberg and Berg, more linear writing and thinner textures appeared in his compositions. For a while he was interested in combining traditional principles with serial technique, but after the mid-1950s he showed more interest in exploiting the possibilities of twelve-tone writing.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina Ritmica")]), _vm._v(" Op.5 (Dob 1934). Three movements. Changing meters plus thick textures. Slow movement is most effective. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Klavierstücke")]), _vm._v(" Op.8 (Dob). Thick chromatic textures. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Kubiniana")]), _vm._v(" Op.13 (UE). Ten short pieces after drawings of Alfred Kubin. Variety of moods, serial. Some use of harmonics. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite ‘Concise’")]), _vm._v(" Op.24 1956 (UE) 15pp. 11 min. l'Arrivée; La Promenade; La Maison; Les Salutations; Problème Dodécaphonique; Le Vin et les poissons; Le Départ. Descriptive serial writing inspired by Switzerland. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Vier Kleine Klavierstücke")]), _vm._v(" Op.31A (Dob 1962) 4 pp. 6½ min. Bound with "), _c('i', [_vm._v("Fantasie")]), _vm._v(" Op.31B. Promenade; Walzer; Fantasie; Marsch. Imitation, some chromaticism. Serial. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fantasie")]), _vm._v(" Op.31B (Dob 1962) 4 min. Bound with "), _c('i', [_vm._v("Vier Kleine Klavierstücke.")]), _vm._v(" More involved than Op.31A but employs the same techniques. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Edward Applebaum")]), _vm._v(" (1938– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Applebaum taught at the University of California, Santa Barbara.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" (WH 1965) 16pp. 12 min. Reproduction of the manuscript is not very legible, and there are a number of errors in the score. Serial, contemporary idioms. Mirrors: a mixture of contrasting sounds, i.e., dissonant chords, fast passagework, moderate tempo. Gestures: pedal effects, more colorful sonorities including a tremolo passage to be played “à la Errol Garner.” D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Preludes")]), _vm._v(" (MMB 1984) 7pp. I:1980 3½ min. Serial influence, slow, contrast of strict rhythmic sections with rubato sections. II: 1982 2½ min. Serial influence, frequent dynamic changes, looks more interesting than it sounds. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Arioso")]), _vm._v(" 1989 (Norruth/MMB 1988) 7pp. Score is copy of manuscript. Pianist must be able to feel the music for the opening rubato's effectiveness. Some controlled indeterminacy. Added-note harmonies. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Stan Applebaum")]), _vm._v(" (1929– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sound World")]), _vm._v(" (Schroeder & Gunther 1974) 23pp. A collection of new keyboard experiences. Thirty-one short pieces that will open new worlds of sonorities for the intermediate pianist. Each new technique explained in detail. May be played separately or grouped in sets to form a miniature suite. Ideas developed include: major seconds, bitonality, perfect fourths contrasted with augmented fourths, clusters, twelve-tone piece. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Frenzy-Toccata")]), _vm._v(" (Broude 1977) 4pp. In 6/8 with frequent hand alternations, bitonal, chromatic, thin textures, Vivace agilimente directions. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Summercloud")]), _vm._v(" (Broude 1980) 2pp. Lyric, freely with expression over ostinato-like left-hand eighth notes, Mildly twentieth-century. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Tito Aprea")]), _vm._v(" (1904–1989) Italy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("15 Dances")]), _vm._v(" (Ric 1973) 39 pp. Titles include Pastoral Dance; Rustic Dance; Dance of the Ant; Dance of the Elephant; Dance of the Flea; Dance of the Chicks; Pierrot's Dance; Ponchinello's Dance. Colorful illustrations ranging from folk to circus dances. Imaginative and some original writing. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Pedro de Araújo")]), _vm._v(" (f1.1662–1705) Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Five Pieces for Keyboard Instruments")]), _vm._v(" (Kastner—Valentim de Carvalho). Preface in Portuguese. Excellent editing. In the style of tientos and toccatas; reveal both fantasy and fluency. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Violet Archer")]), _vm._v(" (1913–2000) Canada")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Archer wrote in a combination of neoclassic and serial techniques. She was a master of complex dissonant counterpoint and has often been inspired by simple folk materials.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Habitant Sketches")]), _vm._v(" 1942 (TP) 5 min. Three Scenes: Jig; Church Scene; Christmas in Quebec. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" 1945, rev.1957 (CMC) 16 min. A large-scale three-movement work demanding mature pianism. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina No.2")]), _vm._v(" 1946 (Bo&H) 9 min. Three movements in neoclassic style. Final movement, Fughetta, is difficult but attractive. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Eleven Short Pieces")]), _vm._v(" 1960 (PIC) 10 min. Pedagogic material much above average. Fertile ideas; varied moods and techniques. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Miniatures")]), _vm._v(" 1963 (Waterloo) 4 min. Dreaming; Dark Mood; Determination. Mildly twentieth-century. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Theme and Variations")]), _vm._v(" 1963 (Waterloo) 5pp. 3 min. Flowing theme, six contrasting short variations. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Four Little Studies")]), _vm._v(" 1964 (Waterloo) 2pp. Each piece concentrates on one contemporary technique. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina No.3")]), _vm._v(" 1973 (Waterloo) 7 min. First movement: two-part counterpoint. Second movement: quiet, tuneful, a waltz. Third movement: a cheery jig. Uses only white keys; more difficult to play than it sounds. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Six Preludes")]), _vm._v(" 1976 (Waterloo) 20 min. Variety of moods and idioms. Tonal; tend toward lean textures. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Four Bagatelles")]), _vm._v(" 1977 (Waterloo 1979) 15pp. Forceful: needs strength and firmness without being harsh. Capricious: needs lightness and control, legato accompanied by staccato, rhythmic changes. Introspective: expressive cantabile playing. Festive: brilliant and light, midsection needs smooth legato. Effective. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.2")]), _vm._v(" 1979 (Berandol 1982) 16pp. In three movements: Andante moderato, amabile capriccioso; Largo a piacere, meditando e con rubato; Andante ma energico. Dramatic ideas, well organized, demanding for performer, easier on listener. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Rosalyn Wai-Yan Soo, "), _c('i', [_vm._v("Selected Intermediate to Early-Advanced Works for Piano Solo by Violet Balestreri Archer: An Analysis for Teaching and Performance")]), _vm._v(" (DMA document, University of Oklahoma, 1997), 297pp. Presents a teaching and performance analysis of the Three Scenes (Habitant Sketches) (1942), Sonatina No.2 (1946), Theme and Variations on ‘La-Haut sur ces Montagnes’ (1952), and 4 Bagatelles (1977).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Angela Sue Willoughby, "), _c('i', [_vm._v("The Solo Piano Music of Violet Archer: A Study of Selected Didactic Works")]), _vm._v(" (DMA document, Louisiana State University and Agricultural and Mechanical College, 1998), 101pp. This study focuses on Here and Now (1996), Four Bagatelles (1977), and Sonatina No.3 (1979).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("José Ardévol")]), _vm._v(" (1911–1981) Cuba, born Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Seis Piezas")]), _vm._v(" (Southern 1949). Preludio; Danzon; Invencion; Habanera; Son; Rumba. Short, folk-like melodies, tricky rhythms. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.3")]), _vm._v(" (ECIC 1944). In three movements. Moderato: three basic contrasting textures alternate. Invenciones en Rondo: lengthy allegretto, two- and three-part linear treatment, deceptive rhythms. Differencias sobre la cantiga ‘Entre Ave et Eva’ del Rey Sabio: theme and nine variations, theme da capo, homophonic and linear treatment of modal tune, quiet. Neoclassic, in the style of Scarlatti-Falla. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina")]), _vm._v(" (NME 1934). Two short dissonant movements. Larghetto: linear and lyric. Allegro: in two and three voices. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Anton Arensky")]), _vm._v(" (1861–1906) Russia")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Excellent material in salon style.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Morceaux")]), _vm._v(" Op.5/5 Basso ostinato D (Musica Obscura). 5/4, six pleasing variations. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("3 Esquisses")]), _vm._v(" Op.24 (K 9905) 27pp. 1. F: Allegro, flowing figuration surrounds embedded melody, cadenza, fleeting figures. 2. A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(": Vivace, outer sections use broken chordal intervals (fourths, fifths, sixths, etc.): Meno mosso midsection is more melodic. 3. f: Presto, syncopated melody over active left hand, conclusion is similar to No.1. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("24 Morceaux Caractéristiques")]), _vm._v(" Op.36 (K 9904) 128pp. Varied moods and figuration; Nos.12, 16, and 21 are especially fine. No.13 Etude F"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(" only (Osterle—GS). M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Preludes")]), _vm._v(" Op.63 (CFP F114, 115) in two vols. Nos.4 and 10 are of special interest. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Etudes")]), _vm._v(" Op.74 (C. Sorel—EBM). Excellent preface. Each piece is in a different key. Varied styles; fine recital material; excellent for developing flexible wrist motion, nimble fingers, and tonal control. Carefully edited with commentary. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Selections")]), _vm._v(" (L. Prosypalova—USSR 1976) 61pp. Contains studies and other piano pieces. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Two Pieces")]), _vm._v(" (GS 139). In the Field, Op.36/24; Prelude in d, Op.63/10.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("By the Sea")]), _vm._v(" (Musica Obscura) 6pp. Melody mostly in left hand; triplet figuration suggests lapping waves. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Barcarolle")]), _vm._v(" (Musica Obscura) 4 pp. Left-hand melody printed in large notes. Undulating right-hand accompaniment. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Gavotte Pastorale")]), _vm._v(" (Musica Obscura) 3pp. Sprightly, a few awkward spots. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Selected Works")]), _vm._v(" (V. Samarin—Jurgenson 2005) 72pp. Contains "), _c('i', [_vm._v("Scherzo")]), _vm._v(", Op.8; "), _c('i', [_vm._v("Three Sketches")]), _vm._v(", Op.24; [6] "), _c('i', [_vm._v("Essays in Forgotten Rhythms")]), _vm._v(", Op.28, each based upon editions published during Arensky's life. This edition of the "), _c('i', [_vm._v("Essays")]), _vm._v(" takes into account changes made in the autograph score at the time of proofreading for its publication. Substantial works filled with pathos, even for their youthful appearance. Comments in Russian and English. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Isabel Aretz")]), _vm._v(" (1909–2005) Venezuela, born Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Aretz was director of the Inter-American Institute of Ethnomusicology and Folklore of the National Institute of Culture and Fine Arts in Venezuela.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" (PAU 1965) 27pp. In three movements. Moderato agitato: textures are thin and widely spread. Andante—Ostinato—Scherzando: midsection scherzando breaks monotony of Andante—Ostinato. Toccata—Allegro: major seventh exploited in propulsive movement. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Rodolfo Arízaga")]), _vm._v(" (1926–1985) Argentina")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Arizaga studied with Luis Gianneo, Messiaen, and Nadia Boulanger. He was a well-known music critic for the newspaper "), _c('i', [_vm._v("El Clarin.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Preludio y Arietta")]), _vm._v(" (EAM 1946). Neoclassic. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Toccata")]), _vm._v(" Op.5 (PIC 1947) 4 pp. In Prokofieff toccata style, chromatic, driving rhythm, tonal, exciting. Program closer. Large span required. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Serranillas del Jaque")]), _vm._v(" Op.17 1956 (EAM 1956) 8 min. Spanish Impressionism. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Cecilia Arizti")]), _vm._v(" (1856–1930) Cuba")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Siete Obras")]), _vm._v(" (Biblioteca Nacional José Martí, Havana 1962; UK) 48pp. Contains seven early works showing the influence of Chopin in their sweeping breath, harmonic development, and titles. Includes: Barcarola, Op.6; Vals Lento, Op.8; Scherzo, Op.10; Impromptu, Op.12; Nocturno, Op.13; Reverie, Op.16; Scherzo, Op.17. Favors thin textures. Introduction in Spanish by Lid Juárez. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Paul Arma")]), _vm._v(" (1905–1987) France, born Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Arma studied with Bartók. In 1945 he organized the Folklore de la Résistance at the Radiodiffusion Française in Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("A la decouverte du passé")]), _vm._v(" (Lemoine 1947). Fourteen easy pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Cinq Esquisses")]), _vm._v(" (EMT 1969) 4pp. 7 min. Parlando; Rubato; Con allegrezza; Lento rubato, con dolore; Con fretta. Contrasting, colorful, based on popular Hungarian melodies. Makes a fine set performed together. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Le Tour du Monde en 20 Minutes")]), _vm._v(" (Galazy). Varied styles, clever. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata da Ballo")]), _vm._v(" (EMT 1940) 11 min. Based on popular French themes from Bourgogne, Savoie, Auvergne, and Bretagne. First movement: the longest; has rhythmic drive, attractive melodic construction. Second movement: orchestral coloring. Third movement: builds to a tremendous climax. An appealing, unusual work. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Trois Epitaphes")]), _vm._v(" (EMT 1945) 9pp. 15 min. Pour Romain Roland: improvisatory, quietly moving harmonic sevenths with a chordal accompaniment, unbarred. Pour ceux qui ne sont jamais revenus: mes amis torturés, massacrés: written on four and five staffs; octotonic; chordal punctuation; builds to large climax, then subsides; "), _c('i', [_vm._v("ppp")]), _vm._v(" closing. Pour Béla Bartók, qui fut mon maître et mon ami: slow-moving chords, long-held sonorities; requires large span. Individual style. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Two Sonatinas")]), _vm._v(" 1937 (Lemoine 1980) 8pp. Sonatine I, 7 min. Sonatine II, 4 min. Lean textures, strong rhythms. Preface in French. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Thomas Arne")]), _vm._v(" (1710–1778) England")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Arne was no mere imitator of the Handelian style, but nevertheless, Italianate ornamental melody is characteristic of his Sonatas or Lessons. These suite-like compositions, dating from about 1756, were the first works entitled Sonatas to be published in England. They contain lively dance movements, vigorous toccatas, and simple airs.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("A Keyboard Allegro")]), _vm._v(" (C. Hogwood—OUP 1974). A graceful and melodically deft alternative for a Bach Two-Part Invention. Was originally the third movement of Concerto in C. Editor has added an improvised cadenza on the diminished seventh just before the close, which a good student could and should expand. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Eight Keyboard Sonatas")]), _vm._v(" (C. Hogwood—Faber 1983; K; S&B). F; e; G; d; B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v("; g; a; G. Arne's unique melodic gifts have long ensured popularity for these pieces, his only published works for solo keyboard. No.4 has a fine fugue. No.8 is a set of variations on a minuet of Rameau. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Concerto No.2")]), _vm._v(" G (R. Langley—Musica Rara). May be played with or without orchestra. Two outer movements with orchestra flank three short solo movements. Scarlatti-like writing with outer movements requiring the most facility. Contains historical and performance notes. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" A. E. F. Dickinson, “Arne and the Keyboard Sonata,” MMR 85 (May 1955): 88–95.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("M. Henderson, “Old English Keyboard Music (Byrd to Arne),” PRMA 64 (1937–38).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Arthur Steiger, “Thomas Arne and His Keyboard Sonatas,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 16 (May 1977). Brief remarks on the eight sonatas by Arne.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Richard Arnell")]), _vm._v(" (1917–2009) England")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Arnell writes in an eclectic style and has composed in almost all forms. “I simply believe that it is mere prejudice and unclear thinking which rejects a work of art that has attached to it the stigma of ‘programme music.’ Music is a complicated amalgam of meanings, an expression of man himself, and cannot be abstracted from him without becoming ‘un-music’ or sheer noise. Theorists and academicians who try to tear them apart would doom us to sterility and death” (composer in BHI brochure).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Siciliana and Furiante")]), _vm._v(" Op.8 (Music Press 1947). Siciliana (2pp.): smoothly flowing style. Furiante (Poco presto) (8pp.): imitative, thin textures, some ostinato-like writing, hand crossings, mildly twentieth-century. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Impromptu")]), _vm._v(" Op.66 (PIC 1960). 4pp. Essentially diatonic, modern writing. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Carl [Karl] Arnold")]), _vm._v(" (1794–1873) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fantasie")]), _vm._v(" Op.20 AWV 37 (H. W. Schwab—Florian Noetzel 7095 1993). In one movement at mostly fast tempos. Early Romanticism in style with declamatory statements and refined expression. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Malcolm Arnold")]), _vm._v(" (1921–2006) England")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Arnold was one of the most distinctive voices in mid- to late twentieth-century English music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Buccaneer")]), _vm._v(" (Lengnick). Healthy rhythmic drive. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" 1942 (Roberton 1992) 13pp. 9–10 min. Published in manuscript form. The two outer movements are strongly rhythmic interspersed with lyrical sections, much dynamic contrast. The middle movement (Andante) is calm and tranquil and leads immediately to the finale. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Variations on a Ukrainian Folk-Song")]), _vm._v(" (Lengnick 1944). Diatonic idiom. Expressive theme harmonized in a mildly dissonant style. Ten variations cover the gamut of contrast; Var. 10 serves as a coda to the complete work. Has much audience appeal and could add excitement to a program. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Children's Suite: Six Little Studies")]), _vm._v(" Op.16 (Lengnick 1948). Prelude: study in fourths and fifths. Carol: study in legato thirds for left hand. Shepherd's Lament: study in triplets and accidentals. Trumpet Tune: study in trills and rhythmic playing. Blue tune: study in rhythms and color. Folk-Song: study in touch and phrasing. Short, attractive, clever. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Fantasies")]), _vm._v(" Op.129 1987 (Queen's Temple QT44 2001) 4pp. Lento e mesto: in two imitative voices. Vivace in 9/8 meter. Andante con molto in two voices with sustained values. Fantasy-like only in imagination. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Early Piano Music")]), _vm._v(" (QT 59 2003). Contains seven works composed between the ages of fifteen and twenty-four: Allegro, Day Dreams, Prelude, Serenade, Three Piano Pieces (1937), Three Piano Pieces (1943), Two Piano Pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Music, Vol. 2")]), _vm._v(" (QT 73 2004) 12pp. Contains four previously unpublished short pieces: The Dream City (1938), Flamenco (ca.1953), Theme for Players (1962), Constance's Sad Dance (ca.1975). Postscript by Paul Harris. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Zach M. Arnold")]), _vm._v(" (1921– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Arnold was a professional scientist in marine protozoology and micropaleontology who turned more decidedly toward composition following early retirement.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Impressions")]), _vm._v(" (C. Anderson—Boxwood 1997) 308pp. Spiralbound collection of eleven works: Berkeley Sketches; Réflexion; Point du Jour; Waltz Suite; Lyric Suite; Miniatures; Pieces; Romantic Sketches; Album Maritime; Concert Dances; Songs Without Words. Curiosity pieces in strongly tonal settings with character or picturesque settings. Pieces can wear thin but are not long. Many consist of multiple short sections in contrasting moods. Most pieces have been published separately. Poems and collages are presented suggestive of the music or the background of each work.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Juan Crisostomo Arriaga")]), _vm._v(" (1806–1826) Spain")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Precocious Spanish violinist and composer who left some astonishing works: three string quartets, a symphony, an overture, and many unpublished works.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Tres Estudios de Carácter")]), _vm._v(" (Dotesio). Allegro; Moderato; Risoluto. Classic style infused with some chromatic usage. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Claude Arrieu")]), _vm._v(" (1903–1990) France")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Arrieu studied piano with Marguerite Long and composition with Jean Roger-Ducasse and Noël Gallon.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("La Boite à malice")]), _vm._v(" (Lemoine 1931). Eight pieces. Impressionistic. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Toccata pour Clavecin (ou Piano")]), _vm._v(") (Leduc 1963) 7 min. Registration leads to Allegro. A midsection Commenciando Lento (quasi Cadenza) provides contrast before a return to faster tempi. Allegro sections have numerous ritards. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Petit Récit. La Poupée Cassée")]), _vm._v(" (Billaudot 1976) 2pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Escapade et Cerf-Volant")]), _vm._v(" (Billaudot 1976) 4pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Promenade Mélancolique et Questionnaire")]), _vm._v(" (Billaudot 1976) 4pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Prélude Pastoral. l'Enfant Sage")]), _vm._v(" (Billaudot 1976) 2pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("The above Billaudot publications are easy teaching pieces written in a traditional style.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Lectures")]), _vm._v(" 1977 (Billaudot) 8pp. Four contrasting pieces in a mild twentieth-century attractive idiom. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Haruo Asakaua")]), _vm._v(" (1942– ) Japan")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano-Sonaro")]), _vm._v(" (Eterna) 1975 (Japan Federation of Composers) 11pp. Sonaro is synonymous with “sonata.” Hexachord: Allegro. Pentachord: Andante. Heptachord (Phrygian mode): Allegro (toccatina). Freely tonal. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("John H. Ashton")]), _vm._v(" (1938– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Theme and Five Variations")]), _vm._v(" (Seesaw) 19pp. Var.I: March, pp and staccato. Var.II: Andante, freely. Var.III: Very fast. Var.IV: Chorale Prelude. Var.V: Finale, brightly. Solid neoclassical writing. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Daniel Asia")]), _vm._v(" (1953– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Asia teaches at the University of Arizona. He is co–music director of the New York–based contemporary ensemble Musical Elements.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Set I")]), _vm._v(" 1975 (Merion 1997) 23pp. 22 min. Features a dreamlike second movement and a strong rhythmic fourth movement of fast linear contrary motion between hands. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Why Jacob (?")]), _vm._v(") 1983 (Merion 1995) 10 min. An elegy written as a memorial for a childhood friend killed in the 1973 Arab–Israeli War. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Scherzo Sonata")]), _vm._v(" 1987 (Merion 1995) 35 min. Seven contrasting movements, a powerful sense of expression, worth investigating. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Variations")]), _vm._v(" 1998–99 (Merion Music 2003) 10pp. 12 min. Cast in four movements, “the outer movements are linked by character and material, the latter being a simple variation on the first…. The second movement is both ethereal and ruminative…[and] the third movement is whimsical and playful” (from preface). Attractive writing, with decisive character. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("No Time")]), _vm._v(" 2004 (TP) 4 min.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.danielasia.net",
      "target": "_blank"
    }
  }, [_vm._v("www.danielasia.net")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Thomas Attwood")]), _vm._v(" (1763–1838) England")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Attwood studied in Vienna with Mozart, who said of him, “He partakes more of my style than any scholar I ever had: and I predict that he will prove a sound musician.”")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Four Sonatinas / Easy Progressive Lessons")]), _vm._v(" (L. House—CF PL119 2006; R. Jones— ABRSC 1983). G; C; F; D. Delightful, musically and technically. CF includes Introduction and performance suggestions, including the positioning of hands. Would make an excellent substitute for the Clementi Op.36 sonatinas. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina I")]), _vm._v(" G (Alfred 8050) 5pp. Attractive. Editing in gray print. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Lucien-Marie Aube")]), _vm._v(" (1889–1953) France")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonate Provençale")]), _vm._v(" (Durand 1952) 31pp. In four movements. Le Matin: sweeping arpeggiation and chordally supported melodies. Scherzo Provençal: well-crafted rhythms with humoresque qualities. Coucher de soleil: in triple meter for gentle waltz in a depiction of sunset. Soir de la Saint-Jean: toccata-like with repeated notes and chords and a sailor's song. Neoclassic with straightforward rhythm and charming appeal. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Louis Aubert")]), _vm._v(" (1877–1968) France")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Esquisse sur le nom de Fauré")]), _vm._v(" 1922 (Durand; in "), _c('i', [_vm._v("Hommage à Gabriel Fauré, La Revue Musicale")]), _vm._v(" 23 [October 1922]) 3pp. Chromatic and harmonic writing suggestive of Fauré's style. Gentle tribute to his teacher. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Tony Aubin")]), _vm._v(" (1907–1981) France")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Aubin wrote in a lively neoclassic style.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Prélude, Récitatif et Final")]), _vm._v(" (Heugel 1931). In Franckian tradition. Utilizes full resources of the keyboard. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" b (Heugel 1930). A large three-movement (FSF) work of Romantic character. Effective pianistic writing. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Le Sommeil d' Iskender")]), _vm._v(" 1936 (in "), _c('i', [_vm._v("Le Tombeau de Paul Dukas, La Revue Musicale")]), _vm._v(" 161 [May–June 1936]). 6pp. “The Sleep of Iskender” refers to a character in the ballet "), _c('i', [_vm._v("La Peri")]), _vm._v(" by Dukas. Material in measures 31–32 quotes from "), _c('i', [_vm._v("La Peri.")]), _vm._v(" Written on three staves; large hand span. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Marianna d'Auenbrugg")]), _vm._v(" (1759–1782) Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata per Il Clavicembalo o Forte Piano")]), _vm._v(" (Hildegard). First published in 1781 with an ode by her teacher Antonio Salieri. Three movements, classical style. Haydn dedicated some of his best sonatas to the d'Auenbrugg sisters. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (in "), _c('i', [_vm._v("At the Piano with Women Composers")]), _vm._v(", Hinson—Alfred 428). Rondo: Allegro. The finale of the Sonata discussed above. Numerous dynamic changes show this movement was intended for the fortepiano. Editorial policy explained. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Rafal Augustyn")]), _vm._v(" (1951– ) Poland")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Mono Sonata")]), _vm._v(" (PWM 8213 1979) 23pp. Notes in Polish, German, and English. An ambitious, percussive work; a toccata. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Yoon-il Auh")]), _vm._v(" (1961– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Auh is a violinist and has composed works for many different instruments. He is also active in the field of computer technology and has written a book on the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Eastern Suite")]), _vm._v(" Op.8 1993 (Intrepid Pixels Publishing Co.) 22pp. Dawn. One Day, One Room, One Window. The Winter Bridge. Summer Breeze. Freely tonal, contrasted figuration, mildly twentieth century. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Micro Carnival")]), _vm._v(" Op.10 1993 (Intrepid Pixels Publishing Co.) 16pp. Prelude. Marching Ants. A Fire Bug. Sleepy Flea. A Spanish Lady Bug (tango rhythm). Old Spider. Colorful, clever, contrasting moods, some figures repeated “as many times as possible.” Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Liberty Suite")]), _vm._v(" Op.11 1995 (Intrepid Pixels) 14pp. La Vague: rubato, long-held sonorities. The Heart of Cloister: fantasia, strongly contrasted sonorities, glissando. Autumn Leaf: contrasted styles and sections, freely tonal. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Josephine Aurenhammer")]), _vm._v(" (1758–1820) Austria")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Aurenhammer studied with Mozart, who often played piano duets with her. She was an outstanding improviser.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Six Variations on a Hungarian Theme")]), _vm._v(" (Furore 118). An excellent well-crafted work in Viennese classical style. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Georges Auric")]), _vm._v(" (1899–1983) France")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Auric was the youngest member of the group known as “Les Six.” He was influenced early in his career by Satie and wrote in a style that would produce “auditory pleasure without demanding a disproportionate effort from the listener.”")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Adieu, New York")]), _vm._v(" (Editions de la Sirène 1919; MMP). Exciting foxtrot with a ragtime bass. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("3 Impromptus")]), _vm._v(" (ESC 1940). Exploits clear ideas. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("3 Pastorales")]), _vm._v(" (Sal 1920). No.2 is serene, No.3 spirited. All are short. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Petite Suite")]), _vm._v(" (Heugel 1927). Prélude; Danse; Villanelle et Entrée; Sarabande; Voltes. Two- and three-part writing in varied moods. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("La Seine, au Matin")]), _vm._v(" 1937 (Sal 1975). Available separately. Light and spirited. All French words are translated into English. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Rondeau")]), _vm._v(" from the ballet "), _c('i', [_vm._v("l'Eventail de Jeanne")]), _vm._v(" 1927 (Heugel). Very rhythmic with a waltz for the midsection. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" F 1930–31 (Sal). A large four-movement virtuoso work, neoclassic, full of gestures intended to be dramatic. Subject matter is characterless, has little distinction. Thickly dissonant handling of sound texture, insufficient contrast in development. Mature pianism required. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatine")]), _vm._v(" G 1922 (Sal). In three movements. Allegro: rhythmic vitality. Andante: flowing. Presto: brisk. Clear, thin textures. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Larry Austin")]), _vm._v(" (1930– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Austin taught at universities in California, Florida, and Texas for nearly four decades. His primary compositional interest has been in live electronics and computer music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Variations")]), _vm._v(" 1960 (MJQ) 10 min. Jazz influence. There is no theme for the variations in the traditional sense, but rather a set of notes and intervals serving as highly generative raw material. The term “variations” refers more to the process of composition rather than of classical form. Seven numbered sections differentiated by texture and movement. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Set in Open Style")]), _vm._v(" 1964 (CPE 1964) 10 min. Directions discuss space-time, i.e., durations of single notes and/or groups of notes are determined by the visual space between. Blank spaces are silent. Durational gradations are obtained by use of the tie. Pointillistic, expressionistic. Avant-garde. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Accidents")]), _vm._v(" 1967 (Deep Listening Publications 1968). A theater piece for electronically-prepared piano. The pianist raises the hands over the head, performs hand gestures as suggested in the score, and brings them down quickly to the keyboard, only to stop at the last moment and press the keys silently. When pitches sound, they become “accidents,” which a technician adjusts electronically to create the music. No two performances are ever the same. Visually entertaining.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Accidents Two")]), _vm._v(" 1992 (see website below for availability). Sound projects for piano with computer music. “‘Accidents Two’ continues, extends, and subsumes the original compositional and real-time performance approach first evolved in ‘Accidents’…In open form, the piece begins, continues, and ends at any point in time, its continuity of musical events and their ordering randomly programmed by the performer or a computer” (from program notes on website below, May 23, 2012).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://cemi.music.unt.edu/larry_austin",
      "target": "_blank"
    }
  }, [_vm._v("http://cemi.music.unt.edu/larry_austin")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Menahem Avidom")]), _vm._v(" (1908–1995) Israel, born Poland")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Hommage à Schoenberg")]), _vm._v(" 1974 (IMI 307) 6pp. 4½ min. Serial; based on a hexachord derived from Schoenberg's name; displays strong musical integrity. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Once Upon a Time")]), _vm._v(" 1977 (IMI 6195) 8pp. 8 min. Five mildly twentieth-century pieces; requires subtlety. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Passacaglia D–A–E–B")]), _vm._v(" 1973 (IMI 466) 7pp. 7 min. Six contrasting variations. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Jorge Gonzalez Avila")]), _vm._v(" (1925– ) Mexico")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("24 Invenciones")]), _vm._v(" (EMM 1964) 15pp. 2 vols. I:1–9; II:10–24. Atonal; individual ideas for each invention are well developed. Displays a fine craft. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Emil Axman")]), _vm._v(" (1887–1949) Czech Republic")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Axman was a prolific composer and wrote in all forms except opera. His Romantic style is based on folk song.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata Appassionata")]), _vm._v(" (Hudební Matice 1922). 36pp. Warm, Romantic, virtuoso writing. The first of three piano sonatas, all written in the early 1920s. D.")])])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "chaptertitle"
  }, [_vm._v("B")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Kees van Baaren")]), _vm._v(" (1906–1970) The Netherlands")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Van Baaren studied with Pijper at the Amsterdam Conversatory.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina in memoriam Willem Pijper")]), _vm._v(" 1948 (B&VP 1523 1950). No.5 in the set "), _c('i', [_vm._v("Hommage à Willem Pijper")]), _vm._v(". Allegretto; Lento non troppo; Vivo e leggier. Serial style with mixed meters. Intense and uncompromising. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Arno Babadjanian")]), _vm._v(" (1921–1983) Armenia")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Poem")]), _vm._v(" 1966 (USSR). Composed for the 1966 Tchaikowsky Piano Competition. A splashy, technically-oriented showpiece. Style fits somewhere between Anton Rubinstein and Aram Khachaturian. Proficient and inventive. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Milton Babbitt")]), _vm._v(" (1916–2011) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Babbitt's pioneering work in the development of twelve-tone compositional techniques and electronic music in the United States has already entered the realm of legend. Allan Kozinn called Babbitt “a composer who gloried in complexity,” an apt description ("), _c('i', [_vm._v("New York Times")]), _vm._v(", January 30, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Compositions")]), _vm._v(" 1947–48 (Bomart) 19pp. 7 min. Contains the earliest piece considered to be totally serial in all elements. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" H. Wiley Hitchcock, "), _c('i', [_vm._v("Music in the United States")]), _vm._v(" (New York: Prentice-Hall, 1969), pp.232–35 for an analysis of this set.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Semi-Simple Variations")]), _vm._v(" 1956 (TP). Although this piece seems to be a theme followed by five variations in twelve-tone technique, it is actually six variations on a twelve-tone set. Explanatory notes. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Elaine Barkin, “A Simple Approach to Milton Babbitt's "), _c('i', [_vm._v("Semi-Simple Variations,”")]), _vm._v(" MR 28/4 (November 1967): 316–22.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Christopher Wintle, “Milton Babbitt's "), _c('i', [_vm._v("Semi-Simple Variations,”")]), _vm._v(" PNM 14–15 (1976): 111–54.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Partitions")]), _vm._v(" 1963 (LG). See album "), _c('i', [_vm._v("New Music for the Piano")]), _vm._v(". Serial, pointillistic, subtle use of sostenuto pedal, complex rhythms. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Post-Partitions")]), _vm._v(" 1966 (CFP 1973) 29pp. 4 min. To be performed immediately after "), _c('i', [_vm._v("Partitions")]), _vm._v(" or independently. Pitch, rhythm, and dynamics are serial, the latter ranging from "), _c('i', [_vm._v("ppppp")]), _vm._v(" to "), _c('i', [_vm._v("fffff")]), _vm._v(". Atonal, complex. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Tableaux")]), _vm._v(" 1973 (CFP 66560) 30pp. 9½ min. Pointillistic, complex rhythms, constant dynamic changes, proportional rhythmic notation. Virtuoso technique required. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Dora A. Hanninen, "), _c('i', [_vm._v("A General Theory for Context-Sensitive Music Analysis: Applications to Four Works for Piano by Contemporary American Composers")]), _vm._v(" (PhD diss., University of Rochester, 1996), 760pp. Includes analysis of "), _c('i', [_vm._v("Tableaux")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Reflections")]), _vm._v(" 1975 (CFP) for piano and tape. 9½ min. Based on a scale of twelve dynamic values ranging from "), _c('i', [_vm._v("ppppp")]), _vm._v(" to "), _c('i', [_vm._v("fffff")]), _vm._v(" plus "), _c('i', [_vm._v("mf")]), _vm._v(" and "), _c('i', [_vm._v("mp")]), _vm._v(". Three separate sections; in the first two the piano and tape exchange places, while in the third the basic musical and sonorous materials are superimposed on each other. The title refers to the structure and content of the work, which is composed of reflections and interchanges between the piano and the loudspeakers, as well as to the organization of twelve-tone material. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See: Contemporary Music Newsletter")]), _vm._v(", May–June 1975, for a thorough analysis of this complex and highly sensitive piece.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Playing for Time")]), _vm._v(" 1977 (in "), _c('i', [_vm._v("Twelve by Eleven")]), _vm._v(", Alfred). 12pp. 22 min. Employs characteristically unfamiliar rhythmic notation in a simple context (3/4 meter). The underlying “set” finally evolves and appears explicitly in (among other places) the final four measures. Highly organized musical syntax, pointillistic. Falls into place remarkably fast when read through even a few times. Contains some unique pianistic sonorities. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("My Compliments to Roger (on yet another birthyear)")]), _vm._v(" 1978 (Smith/Sonic Art 1991) 9pp. In 3/4 meter with each measure stretching across the page. Complicated rhythms, as might be expected.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" James M. Keller, “Conversation with Robert Taub,” PQ 159 (Fall 1992): 29–32, 34. Touches on Babbitt's piano works.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Jerome George Kuderna, "), _c('i', [_vm._v("Analysis and Performance of Selected Piano Works of Milton Babbitt (1916–– )")]), _vm._v(" (PhD diss., New York University, 1982), 179pp.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Stanley Babin")]), _vm._v(" (1932–2010) Israel, born Latvia")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Babin received his musical training in Israel and at the Curtis Institute of Music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Dance around the World")]), _vm._v(" (MCA 1969). Twenty countries represented by characteristic dances. Mood of each nation cleverly captured. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Piano Pieces")]), _vm._v(" (MCA 1968). Musette: ostinato in 7/8 meter. Fugue: modal subject, Hindemithian treatment. Presto: dramatic closing, Prokofieff-inspired. A mildly modern triptych. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Two Sonatinas")]), _vm._v(" (MCA). No.1 (1965). Comodo; Lento; Allegro molto. Requires span of ninth. Int. No.2 (published separately). Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Victor Babin")]), _vm._v(" (1908–1972) USA, born Russia")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Babin studied with Artur Schnabel and performed as a duo with his wife, Vitya Vronsky. He was director of the Cleveland Institute of Music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Variations on a Theme of Beethoven")]), _vm._v(" (Augener 1960). Five variations, closing with a fugue and a coda. Contains some brilliant idiomatic writing. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Vytautas Bacevičius")]), _vm._v(" (1905–1970) Poland, born Lithuania")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Poems")]), _vm._v(" (Mer), all published separately: Poem contemplation Op.5. Poem mystique Op.6. Poem astral Op.7. Poem No.4 Op.10. Short single movements in rhapsodic style. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.2")]), _vm._v(" Op.37 (Mer 1960). Three movements, with introduction to first movement. Traditional harmonic and tonal treatment, chromatic embellishment. Thick textures, thematic material well defined, Szymanowski influence. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.3")]), _vm._v(" Op.52 (Mer 1960) 23pp. Three movements (FSF). Chromatic, dramatic, tonal writing. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sixième mot")]), _vm._v(" Op.72 (UE). In four parts, no bar lines. More tightly unified than the early works. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Trois pensées musicales")]), _vm._v(" Op.75 (Mer). Serious atonal works requiring sensitive pedaling. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Grażyna Bacewicz")]), _vm._v(" (1909–1969) Poland")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bacewicz was Poland's outstanding woman composer in her generation. Her music reflects the conflicts and shattering changes which took place during her lifetime.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Trois Pièces Charactéristiques")]), _vm._v(" 1932 (B. Stryszewska—PWM) 10pp. 6 min. Allegretto; Moderato; Vivace. An early set of pieces Bacewicz seems to have dismissed, they show her imaginative thought and lyric persuasion already in place by the age of twenty-three. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suita Dziecieca / Children's Suite")]), _vm._v(" 1934 (PWM 1998) 14pp. Preludium; Marsz; Walc; Kolysanka; Burleska; Menuet; Gawat; Scherzino. Clever, sparkling, charming, mildly early twentieth-ccentury. No key signatures, chromatic. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Scherzo")]), _vm._v(" 1934 (B. Stryszewska—PWM 1999) 12pp. A lively Vivace with generally two-voiced writing. Effective alternative to other well-known scherzos. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Grotesques")]), _vm._v(" 1935 (B. Stryszewska—PWM 1999) 15pp. Molto allegro; Allegro ma non troppo; Vivo. Hemiola rhythms in the opening, syncopation in the second, and a driving rhythm in the third makes these Grotesques effective in their deviation from normal. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Concert Krakowiak")]), _vm._v(" 1949 (B. Stryszewska—PWM 2002) 20pp. Composed for the centennial of Chopin's death. Bacewicz's “harmonies have a characteristic roughness and pungency, arising from various combinations of intervals of seconds, fourths, and fifths. The lively musical narrative, both light and mercurial, is evolved, in this case, from motifs of popular krakowiak melodies, which the composer subjects to all kinds of motivic, harmonic, and rhythmic transformations—sometimes deceptive or even grotesque (the change of major/minor modes), as if poking fun at the listener. It is a ‘concert’ bravura in the full sense of the word” (from preface by Elżbieta Widlak).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Petit Triptyque")]), _vm._v(" (PWM 1966) 7pp. Three short complementary pieces using strong contemporary compositional techniques. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Rondino")]), _vm._v(" 1953 (PWM 1993) 19pp. Tuneful with varied harmonizations, chordal, large leaps, ends with a glissando and rhythmic effect. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.2")]), _vm._v(" (PWM 1955). 21pp. 14 min. In three movements: Maestoso; Largo; Toccata. Many chromatics, much rhythmic interest. Sonorous Largo, virtuoso writing in the Toccata. This work is a good example of mid-twentieth-century Polish piano writing by a moderately conservative composer. Her finest work for piano. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina")]), _vm._v(" 1955 (M. Szmyd-Dormus—PWM 1977) 16pp. 8 min. Allegro non troppo; Melody; Oberek. Engaging outer movements with buoyant rhythmic figures contrasted by a calm, simple Melody constructed on a short three-note motive. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Ten Studies")]), _vm._v(" (PWM 1958) 42pp. Covers pianistic problems such as leaps, extreme keyboard range, legato sixths, polyrhythms. Powerful writing. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" William Andrew Hudson, "), _c('i', [_vm._v("Stylistic Evolution through Chromaticism in the Piano Compositions of Grażyna Bacewicz")]), _vm._v(" (DMA paper, University of Texas, Austin, 1998), 102pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Charlotte R. Mills, "), _c('i', [_vm._v("Grazyna Bacewicz: A Stylistic Analysis and Evaluation of Selected Keyboard Works")]), _vm._v(" (PhD diss., University of Northern Colorado, 1986), 139 pp.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Carl Philipp Emanuel Bach")]), _vm._v(" (1714–1788) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The keyboard contribution of J. S. Bach's most talented son contains over 400 works, including some 143 sonatas, approximately 50 concerti, and many separate pieces. A comprehensive listing of his works is to be found in MGG, I, cols. 930–35.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Indispensable to studying this composer is his "), _c('i', [_vm._v("Essay on the True Manner of Playing Keyboard Instruments")]), _vm._v(", available in a fine English translation by William J. Mitchell (New York: W. W. Norton, 1949). Numbers preceded by W. refer to Alfred Wotquenne's "), _c('i', [_vm._v("Thematisches Verzeichnis der Werke von C. P. E. Bach")]), _vm._v(" (Br&H 1905). Numbers preceded by H. refer to Eugene Helm's "), _c('i', [_vm._v("Thematic Catalogue of the Works of Carl Philipp Emanuel Bach")]), _vm._v(" (New Haven, Conn.: Yale University Press, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Carl Philipp Emanuel Bach: The Complete Works")]), _vm._v(" (Packard Humanities Institute 2005– ). This complete edition is a joint project in progress among the Packard Humanities Institute, the Bach-Archiv Leipzig, the Sächsische Akademie der Wissenschaften zu Leipzig, and Harvard University, with Christopher Hogwood, chair of the editorial board, and Darrell M. Berg, general editor. This edition supersedes the "), _c('i', [_vm._v("Carl Philipp Emanuel Bach Edition")]), _vm._v(" (OUP) listed below, which was never completed. The newer endeavor by the Packard Humanities Institute is arranged into eight series, with Series I devoted to solo keyboard works. Packard hopes to complete the entire collection by 2014 in time for the 300th anniversary of Bach's birth. Extensive critical notes, facsimiles of manuscripts are included. Urtext edition of impeccable quality at affordable prices. Volumes are clothbound.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/1: ‘Prussian’ and ‘Württemberg’ Sonatas")]), _vm._v(" (in progress). Wq 48/1–6, Wq 49/1–6.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/2: Sonatas with Varied Reprises")]), _vm._v(" (in progress). Wq 50/1–6, Wq 51/1–6, Wq 52/1–6, Wq 65/35–36.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/3: ‘Probestücke,’ ‘Leichte’ and ‘Damen’ Sonatas")]), _vm._v(" (D. Schulenberg, ed., 2006). Wq 53/1–6, Wq 54/1–6, Wq 63/1–12.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/4.1: ‘Kenner und Liebhaber’ Collection I")]), _vm._v(" (C. Hogwood, ed., 2009). Sonatas and Rondos: Wq 55/1–6, Wq 56/1–6, Wq 57/1–6, Wq/H "), _c('i', [_vm._v("deest")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/4.2: ‘Kenner und Liebhaber’ Collection II")]), _vm._v(" (C. Hogwood, ed., 2009). Sonatas, Rondos, and Fantasias: Wq58/1–7, Wq 59/1–6, Wq 61/1–6.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/5.1: Miscellaneous Sonatas from Prints I")]), _vm._v(" (D. M. Berg, ed., 2007). Wq 62/1–11, 13–14.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/5.2: Miscellaneous Sonatas from Prints II")]), _vm._v(" (D. M. Berg, ed., 2007). Wq 60, Wq 62/15–24, 32, Wq 112/7.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/6.1: Sonatas from Manuscript Sources I")]), _vm._v(" (in progress). Wq 64/1–6, Wq 65/1–3, 5.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/6.2: Sonatas from Manuscript Sources II")]), _vm._v(" (in progress). Wq 65/6–14.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/6.3: Sonatas from Manuscript Sources III")]), _vm._v(" (in progress). Wq 65/15–18, 20–25, Wq 69.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/6.4: Sonatas from Manuscript Sources IV")]), _vm._v(" (in progress). Wq 65/26–31, 33–34, 37–39.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/6.5: Sonatas from Manuscript Sources")]), _vm._v(" V (in progress). Wq 65/19, 40–50.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/7: Variations")]), _vm._v(" (in progress). H.351 (versions 1 & 2), Wq 79, Wq 118/1–10.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("1/8.1: Miscellaneous Keyboard Works I")]), _vm._v(" (P. Woolny, ed., 2006). H.348, Wq 12/1–19, Wq 66, Wq 67, Wq 113/1–11, Wq 114/1–11, Wq 117/11–14.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("1/8.2: Miscellaneous Keyboard Works II")]), _vm._v(" (P. Woolny, ed., 2005). H.255–58, 340, 370, Wq 62/12, Wq 65/4, Wq 111, Wq 115/1–4, Wq 116/1–8, 18–28, Wq 117/1–4, 17–40, Wq 199/16, Wq/H deest (several short works), BWV Anh. 122–25.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/10.1: Arrangements of Orchestral Works I")]), _vm._v(" (D. A. Lee, ed., 2007). Concertos H.242, Wq 43/1–6.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/10.2: Arrangements of Orchestral Works II")]), _vm._v(" (J. Kregor, ed., 2008). Symphonies Wq 122/1–3, 5, 13, Wq 174 (arr.), Wq 176 (arr.), Wq 179.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.cpebach.org",
      "target": "_blank"
    }
  }, [_vm._v("www.cpebach.org")]), _vm._v(" for further information on this edition.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Complete Edition")]), _vm._v(" (OUP 1989–95). Begun as a complete edition with the support of the National Endowment of the Humanities, only four of the intended ninety-nine volumes were published before the project was abandoned. Superseded by "), _c('i', [_vm._v("Carl Philipp Emanuel Bach: The Complete Works")]), _vm._v(" (Packard Humanities Institute) listed above. Uses catalog numbers developed by Helm. Includes prefaces and critical commentaries.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/18: Keyboard Sonatas, 1744–1747")]), _vm._v(" (D. Schulenberg, ed., 1995) 142pp. Contains seven Sonatas (H. 40, 43, 46–49, 51 [Wq 65/6, 15–20]).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I/24: Eight Keyboard Sonatas, 1763–1766")]), _vm._v(" (C. Widgery, ed., 1989) 127pp. Contains eight Sonatas: H.176–78, 189, 192, 211–13.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("II/15: Keyboard Concerto No. 38")]), _vm._v(" in C, H.488; "), _c('i', [_vm._v("Keyboard Concerto No. 39")]), _vm._v(" in F, H.454 (E. N. Kulukundis and P. G. Wiley II, eds., 1989) 112 pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("II/23: Concertos and Sonatinas")]), _vm._v(" (1992) 74pp. Contains Sonatinas No.4 (H. 451) and 5 (H. 452) for keyboard and orchestra.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("SONATAS")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Clavier Sonaten und freien Fantasien, nebst einigen Rondos für Fortepiano für Kenner und Liebhaber")]), _vm._v(" (Connoisseurs and Amateurs) 1779–87 (C. Krebs— Br&H). Urtext. Sonatas Wq 55/1 (C) and Wq 55/3 (A) deserve special mention. These large-scale works are eminently suitable for recitals. The fantasies contain some of Bach's most original writing. Of special interest are the Fantasia E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" from Vol.VI and the Fantasia C from Vol.V. The other genre is the rondo, found everywhere except Vol.I. The Rondos b and G are also in "), _c('i', [_vm._v("Klavierwerke")]), _vm._v(" (H. Schenker—UE), Vol.II, while those in B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" and c, from Vols.IV and V, are contained in Georgii, "), _c('i', [_vm._v("Keyboard Music of the Baroque and Rococo III")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I:")]), _vm._v(" Wq 55/1–6.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II:")]), _vm._v(" Wq 56/1–6.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. III:")]), _vm._v(" Wq 57/1–6.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. IV:")]), _vm._v(" Wq 58/1–7.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. V:")]), _vm._v(" Wq 59/1–6.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. VI:")]), _vm._v(" Wq 61/1–6.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatas, Fantasias and Rondos")]), _vm._v(" (K) in 2 vols. Reprints of Br&H noted above. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I: 6 Sonaten für Kenner und Liebhaber")]), _vm._v(" (1779), Wq 55; "), _c('i', [_vm._v("Sonaten nebst einigen Rondos für Kenner und Liebhaber")]), _vm._v(" (1780–81), Wq 56–57.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II: Sonaten und Freye Fantasien nebst einigen Rondos für Kenner und Liebhaber")]), _vm._v(" (1783, 1785, 1787), Wq 58–59, 61.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Klaviersonaten / Piano Sonatas")]), _vm._v(" (D.M. Berg—Henle 1986). Three volumes containing thirty-four Sonatas. Urtext ed., derived from autograph manuscripts and printed editions. Fingering added by K. Börner. Preface in German, English, and French.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I")]), _vm._v(" (Henle 376): Wq 49/6, Wq 52/1, 4, Wq 54/4, Wq 62/6–7, Wq 65/7, 12 (1st ed.), 13, 17, 22–23, Wq 69 (H.23, 32.5, 36, 37, 40, 41, 47, 50, 53, 56, 57).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II")]), _vm._v(" (Henle 377): Wq 52/6, Wq 62/10, 16, 18–19, 21–22, Wq 65/28–32 (H.59, 78, 83, 106, 116, 118, 119, 121, 131, 132, 133 [135]).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. III")]), _vm._v(" (Henle 378): Wq 51/1, Wq 62/24, Wq 65/35–37, 40–42, 44, 47–48 (H.150, 156, 157, 174, 177, 178, 189, 211, 240, 248, 280.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Le Trésor des Pianistes")]), _vm._v(" (J. Farrenc, L. Farrenc—Leduc 1861–72; reprint Da Capo 1977). Sixty-five Sonatas and four Rondos are included in "), _c('i', [_vm._v("Vols. XII–XIII")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Great Piano Sonatas")]), _vm._v(" (Dover 1985). Two volumes, reprinted from "), _c('i', [_vm._v("Le Trésor des Pianistes")]), _vm._v(", ed. by A. and C. Farrenc, 1861–74.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Series I: 1731–1751")]), _vm._v(" (189pp.). Twenty-six Sonatas, including the Prussian and Wurttemberg Sonatas.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Series II: 1752–1784")]), _vm._v(" (183pp.). Twenty-five Sonatas, including selections from Sonatas für Kenner und Liebhaber.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Keyboard Works of C. P. E. Bach")]), _vm._v(" (H. Ferguson—ABRSM) 4 vols.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I: Short and Easy Keyboard Pieces")]), _vm._v(" (19), including Six New Sonatines (Wq. 63/7–12) from Bach's "), _c('i', [_vm._v("Essay")]), _vm._v(". Valuable introduction. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II: Miscellaneous Keyboard Pieces")]), _vm._v(". Eleven pieces including the Fantasia Allegretto in d (Wq 114/7) with a suggested realization by the editor. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. III: Five Keyboard Sonatas")]), _vm._v(". Wq 49/2 A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v("; 55/3 b; 55/5 F; 57/6 f; 60 c. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. IV: Six Keyboard Sonatas from the Essay")]), _vm._v(". Excellent edition; ornaments are realized in footnotes, essential fingering is given, and sources are identified. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Prussian Sonatas")]), _vm._v(" 1742, Wq 48 (Br; Steglich—Nag; K, in 2 vols). Six sonatas (each has three movements) dedicated to Frederick the Great. No.1 F: contains an Andante f, parts of which are modeled after operatic recitative; numerous dynamic indications. No.2 B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(": has a slow movement, Adagio g, with a cadenza near the end. No.6 A: the most adventurous and prophetic of the set; silence as well as sound produce much of the dramatic effect of the first movement, and one can discern a direct continuity between its development section and those of Haydn, Beethoven, and Brahms; the expressive, fantasy-like Adagio movement in f"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(" is followed by a Scarlattian finale. These Sonatas are among the musical high points between J. S. Bach and Haydn and firmly established Bach as a major composer. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Myron Schwager, “C. P. E. Bach's Prussian Sonatas,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 26//9 (November 1987): 14–18. Contains "), _c('i', [_vm._v("Sonata No.1")]), _vm._v(" on pp.18–21.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Württemberg Sonatas")]), _vm._v(" 1744, Wq 49 (R. Steglich—Nag) 2 vols. (K). Six sonatas dedicated to the Duke of Württemberg. Baroque to early classic sonatas in the three-movement Italian ideal form of the time: two quick movements enclose a slow middle movement. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sechs Sonaten mit veränderten Reprisen")]), _vm._v(" Wq 50 (E. Darbellay—Amadeus 1760, 1976) 72pp. Preface and critical note in German and English. Six sonatas with varied reprises in an exemplary edition including comprehensive critical material. The aphorism “Play from the soul, not like a trained bird” sums up the aesthetic approach of C. P. E., an approach that defines the style known as Empfindsamkeit. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" M. S. Cole, “Rondos, Proper and Improper,” M&L 51 (October 1970): 388–99.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Six Sonatas")]), _vm._v(" 1761 Wq 51 (J. Rose—TP 1973). No.8 in Series of Early Music, University of California, Santa Barbara. These works appeared here for the first time in a modern edition. They generally reflect the more conservative harmonic language favored by King Frederick. Table of ornaments and editorial notes are included. Interesting examples of works written between the Baroque and Classic periods. See especially No.6, g. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Sonate all’ Uso delle Donne / Sechs Cembalosonaten für Damen")]), _vm._v(" (W. Opp— Merseburger 2119 1997) 39pp. Wq.54/1–6 (H.204, 205, 184, 206, 185, 207). M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("4 Leichte Sonaten")]), _vm._v(" (O. Vrieslander—Nag). H.56, 143, 21, and 42 in G, a, g, and D. These sonatas were not published during Bach's life. They show more buoyancy in style than many of the other sonatas. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatas and Pieces")]), _vm._v(" (K. Herrmann—CFP) 52pp. Four sonatas, Variations on ‘La Folia,’ Rondo E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", and short pieces. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Works")]), _vm._v(" (K. Herrmann—CFP 4188). Sonatas and pieces: Wq 50/5; 51/3; 52/3; 61/1; 65/48; 116/16, 17, 21. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Sonatas")]), _vm._v(" (L. Hoffmann-Erbrecht—Br&H 5875; Doflein—Schott, 2 vols. 2353/4) written to go with "), _c('i', [_vm._v("The Essay on the True Art of Playing the Keyboard")]), _vm._v(". M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Sonatas")]), _vm._v(" (K. Janelzky—Musica Rara 1958). H. 629–34.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Sonatas")]), _vm._v(" (P. Friedheim—State University of N.Y., through Galaxy). Wq 65/9, 16, 23; 62/19; 52/2; 53/4. Well edited. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("3 Leichte Klaviersonaten")]), _vm._v(" (Zürcher—Schott 4707). Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" c, Wq 60 1766 (F. Nagel—Eulenburg 717 1978) 6pp. Bach stated that this work is “easy and practical without any Adagio [middle movement],” adding that such slow movements were “no longer in fashion.” This work could have easily been included in his "), _c('i', [_vm._v("Kenner und Liebhaber")]), _vm._v(" collections. It is graceful and pleasing in spite of being written in the “tragic” key of c minor. The use of dynamics shows that the work was definitely intended for a large German clavichord or a fortepiano. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" G, Wq 62 (H. Albrecht—K&S) Organum, Series 5 No.2. A delightful FSF arrangement of movements. The last movement, a short Allegro, sparkles. M-D.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("MISCELLANEOUS PIECES")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("Keyboard Pieces with Varied Reprises")]), _vm._v(" (O. Jonas—UE). Twenty-two easy pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Klavierwerke")]), _vm._v(" (H. Schenker—UE) 2 vols. Nine sonatas, four single movements, and a rondo. A superb, interesting edition.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("46 Anfangsstücke")]), _vm._v(" W.259, H.868 (M. Schütte—HV 2370 1996) 56pp. Collected by Carl Friedrich Rellstab, 1788–90. Forty-six pieces for beginners, of one page in length in mostly binary form. Preface and notes in German. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("24 Kleine Stücke")]), _vm._v(" (O. Vrieslander—Nag). Menuets, Fantasias, Polaccas, four Solfeggi, Arioso con Variazione (Wq 118/4, 1747), and other pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Kurze und Leichte Clavierstücke")]), _vm._v(" (O. Vrieslander—UE; O Jonas—VU UE 13311 1962). Twenty-two small pieces. The word “easy” ("), _c('i', [_vm._v("leichte")]), _vm._v(") is used rather loosely. These pieces are C. P. E. Bach's “Inventions.” Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Leichte Spielstücke")]), _vm._v(" (Hug 1971) 12pp. Menuett D; Allegretto C; Aria B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v("; Rondo b; Arioso con Variazioni A; Polonaise a. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("4 Fantasias")]), _vm._v(" (Gát—EMB) No.18 Thesaurus Musicus. Contains H.277, 278, 284, 291. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Seven Pieces")]), _vm._v(" (E. Caland, F. P. Goebels—Heinrichshofen 1975) 48pp. Contains pieces from various collections: Sonatas Wq 51/4, 5; Rondos Wq 53/3, Wq 58/1, 3; and two short pieces, ‘La Stahl’ and ‘Les Languers tendres,’ Wq 117/24. Editorial notes in German; editorial additions are confusing. A few interpretations of ornaments are questionable. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Solfeggio")]), _vm._v(" H.220 (Alfred; Willis). Famous study in broken chords and diatonic figuration. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Miscellaneous Pieces: Abschied von meinem Silbermannschen Claviere")]), _vm._v(" (1781). Poignant rondo, liberally laced with rubato, unusual harmonic treatment and florid melodies. See "), _c('i', [_vm._v("The Character Piece")]), _vm._v(" (Anthology of Music Series) and "), _c('i', [_vm._v("The Bach Family")]), _vm._v(" (UE). M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Musikalisches Mancherlei")]), _vm._v(" (Musical Diversities) (Kranz—NV). Six pieces. Int. to M-D. See the collection "), _c('i', [_vm._v("Sons of Bach")]), _vm._v(" for other separate pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("18 Probestücke")]), _vm._v(" Wq 63 (E. Döflein—Schott). Example pieces for Bach's "), _c('i', [_vm._v("Essay")]), _vm._v(", organized into six sonatas, each sonata in three movements. Allegro siciliano e scherzando, a short, graceful piece in f"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v("; and Allegro di molto f, fast, étude-like, with contrasting lyric sections, are choice selections. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Second Bach")]), _vm._v(" (O. Jonas—SB). Unusual choice and variety of material. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Variationen auf die ‘Folie d'Espagne’")]), _vm._v(" (Herrmann—CFP). Unusual modulations and changes of key; brilliant and expressive keyboard treatment. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fantasia")]), _vm._v(" C (J. Friskin—JF 8831). Sectional; lively and humorous; anticipates boisterous pranks of Haydn and Beethoven. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("23 Pièces Caractéristiques")]), _vm._v(" (C. Hogwood—OUP 1989) 51pp. Some of Bach's most stylistically varied pieces. La Borchward: Polonaise H. 79. La Pott: Menuet H. 80. La Gleim: Rondeau H. 89. La Bergius H. 90. La Prinzette H. 91. l'Auguste: Polonaise H. 122. l'Herrmann H.92. La Buchholtz H.93. La Stahl H. 94. La Boehmer H. 81. l'Aly Rupalich (La Bach) H. 95. La Complaisante H. 109. La Xénophon—La Sybille H. 123. Les Langueurs tendres H. 110. l'Irresoluë H. 111. La Journalière H. 112. La Capricieuse H. 113. La Philippine H. 96. La Gabriel H. 97. La Louise H. 114. La Gause H. 82. l'Ernestine H. 124. La Caroline H. 98. Editorial notes include discussion of person, song, or idea that inspired the piece. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Variationen ‘Ich schlief da traumte mir’")]), _vm._v(" (“I slept, then I dreamed”) H. 69, Wq 118:1 (Schott Ed 7335; in "), _c('i', [_vm._v("Masters of the Theme and Variations")]), _vm._v(", Hinson—Alfred 2209). Published with set of variations on the same tune by J. P. Kirnberger, six pp., as No.9 of "), _c('i', [_vm._v("Journal für das Pianoforte")]), _vm._v(". Bach's set includes twenty-four variations, Kirnberger's ten. Int. to M-D.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("BIBLIOGRAPHY")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Philip Barford, "), _c('i', [_vm._v("The Keyboard Music of C. P. E. Bach")]), _vm._v(" (London: Barrie and Rockliff, 1965).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("———, “C. P. E. Bach, A Master of the Clavichord,” MO 76 (July 1953): 601–3.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Darrell M. Berg, "), _c('i', [_vm._v("The Keyboard Sonatas of C. P. E. Bach: An Expression of the Mannerist Principle")]), _vm._v(" (PhD diss., State University of New York, Buffalo, 1975), 401pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Paz Corazon G. Canave, "), _c('i', [_vm._v("A Re-evaluation of the Role Played by C. P. E. Bach in the Development of the Clavier Sonata")]), _vm._v(" (Washington, D.C.: Catholic University Press, 1956).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Il-Soo Chay, "), _c('i', [_vm._v("A Stylistic and Interpretive Analysis of Selected Keyboard Works of C. P. E. Bach")]), _vm._v(" (EdD diss., Columbia University Teachers College, 1989), 248pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Kathleen Dale, “C. P. E. Bach and the Keyboard,” MMR 76 (October 1946): 187–92.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Emily R. Daymond, “C. P. E. Bach,” PRMA 33 (1907).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("E. G. Elden, "), _c('i', [_vm._v("Carl Philipp Emanuel Bach's Concept of the Free Fantasia")]), _vm._v(" (thesis, Eastman School of Music, 1980).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Pamela Ruth Fox, "), _c('i', [_vm._v("Melodic Nonconstancy in the Keyboard Sonatas of C. P. E. Bach")]), _vm._v(" (PhD diss., University of Cincinnati, 1983), 292pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("William A. Koehler, "), _c('i', [_vm._v("The Late Independent Keyboard Rondos of Carl Philipp Emanuel Bach")]), _vm._v(" (diss., University of Texas–Austin, 1986), 102 pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Frank E. Lorince, A Study of Musical Texture in Relation to Sonata-Form as Evidenced in Selected Keyboard Sonatas from C. P. E. Bach through Beethoven (diss., University of Rochester, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("William J. Mitchell, “C. P. E. Bach's ‘Essay’: An Introduction,” MQ 33 (1947): 460–80.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Dragan Plamenac, “New Light on the Last Years of C. P. E. Bach,” MQ 35 (1949): 565–87.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Eduard Reeser, "), _c('i', [_vm._v("The Sons of Bach")]), _vm._v(" (Stockholm: Continental Book Co., 1949).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Walter Schenkman, “Three Collections of Keyboard Works by C. P. E. Bach,” Part I, "), _c('i', [_vm._v("Bach")]), _vm._v(" 8 (October 1977): 23–33; Part II, "), _c('i', [_vm._v("Bach")]), _vm._v(" 9 (January 1978): 2–14. Deals with three representative collections of keyboard works: the "), _c('i', [_vm._v("Prussian")]), _vm._v(" and "), _c('i', [_vm._v("Württemberg")]), _vm._v(" Sonatas and the "), _c('i', [_vm._v("Sechs Sammlungen für Kenner und Liebhaber")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Patricia Ann Thompson, “A Study of the Chromatic Fantasy in D Minor (J. S. Bach) and the Free Fantasia in C Minor by C. P. E. Bach” (thesis, University of Washington, 1958).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Jean M. Walkinshaw, "), _c('i', [_vm._v("Improvisatory Aspects of the Keyboard Music of C. P. E. Bach (1714–1788)")]), _vm._v(", (thesis, University of Washington, 1972).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Jan Bach")]), _vm._v(" (1937– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Bagatelles")]), _vm._v(" 1963 (AMP 1979) 21pp. Emilia (for unprepared piano): “twittery.” Lauretta: reflective, recitatives. Pamfilo: restless. All are thorny mazes to cut through. Unusual sonorities, Expressionist in style. Helpful suggestions to the performer, e.g.: “Use all or none depending on tightness in R. H.” D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Johann Christian Bach")]), _vm._v(" (1735–1782) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The youngest and most successful son of J. S. Bach is one of the most important representatives of Italianate lyricism in the early development of the piano sonata. A student of Padre Martini during his stay in Italy, J. C. Bach soon became a major musical influence in London after his arrival in that world capital. Thin textures, Alberti basses, sequences, passagework, and smooth “singing melodies” are found in abundance in his works, which are of moderate difficulty. In 1768, Christian Bach was the first musician to perform in solo on the pianoforte; and with his friend Carl Friedrich Abel, he gave concerts in London for seventeen years. J. C. Bach greatly influenced Mozart, whose admiration for him is well known. He composed twenty-four solo keyboard sonatas, but only about half of them are readily available in modern editions.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Collected Works of Johann Christian Bach, 1735–1782: Keyboard Music")]), _vm._v(" (S. Roe—Garland 1989) 263pp. Vol. 42 in the complete edition. Contains thirty-five works from eighteenth-century manuscript and printed sources: 6 Minuets; 2 Polonaises; Aria; 6 Sonatas, Op.5; 6 Symphonies (Overtures), Op.3, adapted for harpsichord; 6 Sonatas, Sieber Op.12/Welcker Op.17; 2 Duets, Op.15; 2 Duets, Op.18. Difficulties in authenticity abound in some cases since there are no surviving autographed manuscripts. Introduction, editorial procedures, bibliography, and photocopies of manuscripts and first editions accompany.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Keyboard Sonatas")]), _vm._v(" (C. Hogwood—OUP). A facsimile of the original eighteenth-century editions with an excellent introduction by the editor. The "), _c('i', [_vm._v("Style Galant")]), _vm._v(" at its best. Both sets sound fine on the piano or harpsichord but even better on the fortepiano. Excellent preparation for Mozart sonatas. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Set I")]), _vm._v(" Op.5 (1768). Six sonatas.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Set II")]), _vm._v(" Op.17 (1779). Six sonatas.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Klaviersonaten")]), _vm._v(" (Heinemann—Henle 332–33 1981) with fingering by H.-M. Theopold. The two sets make an important contribution to the advancement of classical instrumental forms, the principal movements revealing distinct features typical of the classical form. This edition is based on the first edition. Contains a preface and remarks on each sonata. Urtext and performing edition.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I")]), _vm._v(" Op.5 (53pp.). Sonatas B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v("; D; G; E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v("; E; c.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II")]), _vm._v(" Op.17 (65pp.). Sonatas G; c; E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v("; G; A; B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Le Trésor des Pianistes")]), _vm._v(" (J. Farrenc, L. Farrenc—Leduc 1861–72; reprint Da Capo 1977). Volume XVIII contains contains Op.5/3–6, and Op.17/2, 3, and 6 (as Op.12).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("10 Sonatas")]), _vm._v(" (L. Landschoff—CFP) 2 vols. Excellent introductory remarks.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I:")]), _vm._v(" Op.5/2, 5; Op.17/2, 4, 5.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II:")]), _vm._v(" Op.5/3, 4, 6; Op.17/3, 6.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" G Op.5/3 (F. Goebels—Schott).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" c Op.17/2 (W. Georgii—Arno Volk Verlag). In "), _c('i', [_vm._v("Keyboard Music of the Baroque and Rococo, Vol. III")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonate")]), _vm._v(" E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.17/3 (S. Staral—Heinrichshofen 2422 1998) 24pp. Allegro assai; Andante; Allegro. Facsimile of the manuscript for the Andante included. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.17/6 (W. Newman—Mer). In "), _c('i', [_vm._v("Sons of Bach")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Leichte Spielstücke")]), _vm._v(" (Hug 1971). Menuett F; Andantino F; Marsch C; Allegretto a; Menuett and Trio D; Theme and Variations G. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("14 Pieces")]), _vm._v(" (M. Hinson—Alfred 10153) 32pp. By J. C. Bach and Francesco P. Ricci. These pieces are part of a method that appeared in 1786 by both composers, written for a conservatory in Naples. All have thin textures, sequences, passagework, and smooth, singing melodies. This style greatly influenced W. A. Mozart. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Maurice Hinson, “Johann Christian Bach and Francesco Pasquale Ricci Forte-Piano or Harpsichord Method,” "), _c('i', [_vm._v("Piano Journal")]), _vm._v(" 3/8 (June 1982): 13–15.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Richard Maunder, “J. C. Bach and the Early Piano in London,” "), _c('i', [_vm._v("Journal of the Royal Musical Association")]), _vm._v(" 116 (1991): 201–10. Suggests the Op.5 sonatas and Op.7 concertos were written for the fortepiano.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Beth Mekota, "), _c('i', [_vm._v("The Solo and Ensemble Keyboard Works of Johann Christian Bach")]), _vm._v(" (PhD diss., University of Michigan, 1969), 317pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Stephen W. Roe, "), _c('i', [_vm._v("Keyboard Music of J. C. Bach: Source Problems and Stylistic Development in the Solo Ensemble Music")]), _vm._v(" (New York: Garland, 1989), 490 pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Melchijah Spragins Jr. "), _c('i', [_vm._v("The London Keyboard Sonatas of J. C. Bach: Galant Musical Aesthetics, Elite Culture, and Analogies to the Mid-Century British Novel")]), _vm._v(" (PhD diss., University of Chicago, 2010), 571pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Charles S. Terry, "), _c('i', [_vm._v("John Christian Bach")]), _vm._v(" (London: Oxford University Press, 1929).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Johann Christoph Bach")]), _vm._v(" (1642–1703) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This Bach, a cousin of Johann Sebastian's father, was well known in his own day as a composer and organist, C. P. E. Bach considered him a “great and expressive” composer, and J. S. Bach is known to have performed a number of his vocal works in Leipzig.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Keyboard Works")]), _vm._v(" (P. Dirksen—Br&H 8730 2002) 36pp. Includes the four principal works for keyboard: Prelude and Fugue in E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v("; Aria Eberliniana variata; Aria variata; Sarabanda variata. “As a whole, the four works bear eloquent testimony to the art of keyboard composition in Middle Germany in the late 17th Century…they also document the strong influence exerted in this domain by Johann Pachelbel” (from preface). Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Aria")]), _vm._v(" a with 15 Variations (G. Birkner—Amadeus 1973) 12pp. Charming. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sarabande mit 12 Variationen")]), _vm._v(" (H. Riemann—Steingräber). Overedited. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Prelude and Fugue")]), _vm._v(" E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (Steingräber). Bischoff formerly attributed this work to J. S. Bach (S.Anh.177). Effective. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Johann Christoph Friedrich Bach")]), _vm._v(" (1732–1795) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Known as the “Bückeburg Bach” (since he was active at the Bückeburg court from 1759 to 1795), this ninth son of J. S. Bach wrote about forty solo sonatas, though only two-thirds survive, as do a few sets of variations and about eighty smaller works for the keyboard. His style combines German and Italian elements with a compositional technique characteristic of both Baroque and Classic styles.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sechs Klaviersonaten")]), _vm._v(" BR A 16–22 (U. Leisinger—Carus 34.901 2005) 64pp. First publication, Stuttgarter Bach-Ausgaben Urtext, from the autograph at the Forschungs- und Landesbibliothek Gotha. In D, A, F, B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", G, E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(". These Sonatas were written during Friedrich's last creative period and show strong influence of the Italian "), _c('i', [_vm._v("Style Galant")]), _vm._v(". They were “intended for the musical amateur, who enjoys making music at a high artistic level, but without any intention of becoming a professional musician; they are similar musically and technically to the set of "), _c('i', [_vm._v("Sechs leichte Sonaten")]), _vm._v(" published in 1785” (from foreword). Three movements each, with rondos as the final movement in all except F. Foreword in German, English, and French. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Drei Klaviersonaten")]), _vm._v(" BR A 26, 27, 31 (U. Leisinger—Carus 34.902 2005) 40pp. First publication, Stuttgarten Bach-Ausgaben Urtext, from autographs at the Forschungs- und Landesbibliothek Gotha and Stadbibliothek Hannover. In F, E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", D. Three movements each. Noteworthy, with inspired creativity. Foreword in German, English, and French. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sechs leichte Sonaten")]), _vm._v(" (H. Ruf and H. Bemmann—Schott). Originally published in 1785. All in three movements. Simple and attractive. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Variations on ‘Ah, vous dirai-je Maman’")]), _vm._v(" (in "), _c('i', [_vm._v("The Sons of Bach")]), _vm._v(", Alfred 418; F. Goebels—Schott 6916). Theme and fourteen short, delightful variations. Easier than the famous Mozart set. Int. to M-D. Schott includes a set of variations on the same tune by an anonymous composer (1795). Charming and clever. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Leichte Spielstücke")]), _vm._v(" (Hug 1971). Arioso F; Menuett and Trio D; Andantino G; Allegretto c; Polonaise D; Andante F. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Musikalische Nebenstunden")]), _vm._v(" (Musical Leisure Hours) (A. Kreutz—Schott; T. Roberts—ABRSM). Schott includes fifteen varied short pieces: Marche; Menuet; Polonaise; etc. Int. ABRSM (40 pp.) contains twenty-six short pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Le Trésor des Pianistes")]), _vm._v(" (J. Farrenc, L. Farrenc—Leduc 1861–72; reprint Da Capo 1977). Volume XV contains Sonatas in F, C, G, and F and various pieces. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Karl Geiringer, "), _c('i', [_vm._v("The Bach Family")]), _vm._v(" (New York: Oxford University Press, 1954).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Ulrich Leisinger, “Johann Christoph Friedrich Bach as a Keyboard Composer,” "), _c('i', [_vm._v("EKJ")]), _vm._v(" 13 (1995): 7–38.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Eduard Reeser, "), _c('i', [_vm._v("The Sons of Bach")]), _vm._v(", translated by W. A. G. Doyle-Davidson (Stockholm: The Continental Book Co., 1949).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Johann Sebastian Bach")]), _vm._v(" (1685–1750) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The pianist must have a thorough knowledge of the keyboard works of this great master. Henle, Vienna Urtext, and Alfred have produced some remarkable urtext editions for practical use. Peters publishes many fine editions of the individual works as does the three preceding. It is best to request specific editors or individual volume numbers of Peters, for many works are available from this publisher in more than one edition. The Hans Bischoff edition (published by Kalmus) still has many positive features. If tempo, dynamic, and articulation marks are disregarded, this edition is remarkable considering the date of its publication (1891). The original "), _c('i', [_vm._v("Bach-Gesellschaft")]), _vm._v(" edition is available in Lea Pocket Scores and in regular size. See Vols. 3, 13, 14, 36, and 45 for the keyboard works. The "), _c('i', [_vm._v("Neue Ausgabe sämtliche Werke")]), _vm._v(" (Br) serves as the primary scholarly reference collection. S. numbers below refer to Wolfgang Schmieder's "), _c('i', [_vm._v("Thematisch-systematisches Verzeichnis der musikalischen Werke von Johann Sebastian Bach")]), _vm._v(" (Leipzig: Br&H, 1950).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Helpful to the pianist is "), _c('i', [_vm._v("Interpreting Bach at the Keyboard")]), _vm._v(" by Paul Badura-Skoda (New York: Oxford University Press, 1993), and the preface to Rosalyn Tureck's "), _c('i', [_vm._v("An Introduction to the Performance of Bach")]), _vm._v(" (New York: Oxford University Press, 1962). Consult the bibliography for other specific references to the performance of Bach on the piano.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("INVENTIONS")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fifteen Two-Part and Fifteen Three-Part Inventions")]), _vm._v(", S.772–801 1723. The Alfred—Palmer edition is a fine scholarly and performing edition. Differences in the autograph copies of 1720 and 1725 are noted. A table of tempo indications by Bischoff and by Czerny as well as tempi of recordings by Glenn Gould, Martin Galling, Ralph Kirkpatrick, Wanda Landowska, George Malcolm and Rosalyn Tureck are listed. Vol. V/3 of the New Bach Edition, edited by G. von Dadelsen (Br 1972), includes appendices with six sinfonias in the ornamented form in which they survive in two manuscripts belonging to Bach's pupils. The Landshoff—CFP urtext has a fine Preface. CFP also publishes a facsimile of the 1723 autograph with a foreword by Ralph Kirkpatrick. See also the fine edition of Steglich and Theopold—Henle (64) as well as Leisinger and Jonas—VU (UT 50253 2007), the latter with its extensive preface, notes on interpretation, and critical notes, and embellished versions of one Invention and six Sinfonias. Ratz, Fussl, Jonas—VU 50042, edited and annotated from autographs and manuscript copies, contains a charming rhythmic variant of Invention I, and extensive critical notes and preface. Yale University Press publishes a facsimile (reproduced from the holograph) of the "), _c('i', [_vm._v("Notebook for Wilhelm Friedemann Bach")]), _vm._v(" with a preface by Ralph Kirkpatrick. It contains the first version of the two- and three-part inventions. Other noteworthy editions are KMB; Bischoff—K; E. Fischer— WH; Röntgen—UE; Kreutz—Schott; J. Friskin—JF; Friedman—WH; L. Hernardi—EMB; R. Jones—ABRSM; Snell—Kjos; E. Simon—Dover, which contains a facsimile of the autograph along with a reprint of the Bach-Gesellschaft edition; and Zurfluh (AZ 1556 2000), which consists of a facsimile of a manuscript copied by H. G. M. Darnköhler, ca.1755, recently found in the library of the regional National Conservatory of Toulouse.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Two-Part Inventions")]), _vm._v(", S.772–786 (Steglich, Theopold—Henle 169; U. Leisinger, O. Jonas—VU UT 50254; G. Anson—Willis, has performance suggestions and ornamentation; Banowetz—GWM 1974, contains an extensive discussion of ornamentation, fingering, rhythmic conventions, tempi; editorial suggestions in red print, excellent preface, helpful performance suggestions; Landshoff—CFP; Pestalozza—Ric 1973; Solymos—EMB 1972; Jones—ABRSM; R. Heath—FJH H1001).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Two-Part Inventions")]), _vm._v(" C, E, F (S.772, 777, 779) (Ratz, Füssl, Jonas—VU). Urtext edition plus facsimile of the autographs.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sinfonien / Three-Part Inventions")]), _vm._v(", S.787–801 (Steglich, Theopold—Henle 360). Urtext edition.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Courtney S. Adams, “Organization in the Two-Part Inventions of Johann Sebastian Bach, Part[s] I [and] II,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 13/2 (April 1982): 6–16, and 13/3 (July 1982): 12–19.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Diane Carliner, "), _c('i', [_vm._v("The Bach Sinfonias: History and Performance")]), _vm._v(" (Baltimore: Musicolor Publications, 1968). In color. Different color for each voice; historical and performance commentary.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("E. Fred Flindell, “Apropos Bach's Inventions, Part[s] I[–]III,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 14/4 (October 1983): 3–14; 15/1 (January 1984): 3–16; and 15/2 (April 1984): 3–17.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Karl Heinz Füssl, “Bach's Secret Composition Course,” PQ 93 (Spring 1976): 18–19. A discussion of the Inventions and Sinfonias as Bach's only manual on composition.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Walter William Hawthorne, "), _c('i', [_vm._v("J. S. Bach's Inventions and Sinfonias: An Analysis")]), _vm._v(" (PhD diss., University of Cincinnati, 1980), 197pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Julius Herford, “Notizbuch für Studenten—Bach's Models of ‘Good Inventiones’ [Parts I–III, How to Develop the Same Well],” "), _c('i', [_vm._v("Bach")]), _vm._v(" 2/4 (October 1971): 10–14; 3/1 (January 1972): 27–30; 3/2 (April 1972): 28–30; and 4/1 (January 1973): 16–20.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Theodore O. Johnson, "), _c('i', [_vm._v("An Analytical Survey of the Fifteen Sinfonias (Three-Part Inventions) by J. S. Bach")]), _vm._v(" (Lanham, MD: University Press of America, ca.1986).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Jeffrey Kahane, “Bach's Three-Part Invention in E Minor,” "), _c('i', [_vm._v("Keyboard Classics")]), _vm._v(" 6/6 (November/December 1986): 36–37. Contains music on pp.18–19. A masterclass on this piece.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Robert L. Reynolds, "), _c('i', [_vm._v("The Bach Sinfonias: A Guide to Analysis and Performance Planning")]), _vm._v(" (DMA diss., University of Kentucky, 1993), 234pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("John Satterfield, “Dissonance and Emotional Content in the Bach Two-Part Inventions,” MR 17 (November 1956): 273–81 and 19 (August 1958): 173–79.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Ruth Slenczynska, “J. S. Bach's Two-Part Invention No.12: An Analysis for Performers,” "), _c('i', [_vm._v("Keyboard")]), _vm._v(" 10/9 (September 1984): 44–45. Includes score and analysis on pp.48–50.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("TM, Analysis of Invention in d, pp.56–67.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("SUITES")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bach composed nearly forty suites for various solo instruments. The best known for keyboard are the “French” Suites, “English” Suites, and Partitas. Although Bach did not give the French and English titles to these collections, they have become intrinsically associated with them.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("French Suites")]), _vm._v(", S.812–817 (Steglich, Theopold—Henle 71, based on the autographs and copies in the Notebook for Anna Magdalena of 1725; Durr—Br; Müller, Kahn—VU 50048; Keller—CFP; KMB; Bischoff—K; Petri—Br&H; E. Fischer—WH; Mugellini—Ric; EMB 1975). The form A, C, S, optional dances, and G is followed throughout this set.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite No.1")]), _vm._v(" d, S.812. Allemande: three voices, requires fine voicing. Courante: French type, light and fast, contains complicated fingering problems. Sarabande: four voices, harmonic. Minuets I and II; three voices, pseudo-contrapuntal, expressive. Gigue: unusual slow-moving type; requires precise treatment of dotted notes; sixteenths and thirty-seconds must be carefully handled. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite No.2")]), _vm._v(" c, S.813. Allemande: duet, plucked bass. Corrente: Italian type. Sarabande: expressive. Air: attractive. Minuet: two voices, flowing. Gigue: two voices. Technically the easiest of the set. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Howard Stephens, “Bach's French Suite No. 2 in C Minor,” "), _c('i', [_vm._v("Music Teacher")]), _vm._v(" 60/4 (April 1981): 16.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite No.3")]), _vm._v(" b, S.814. Allemande: highly organized. Courante: French type, some fingering problems. Sarabande: interesting counterpoint, must be carefully balanced. Minuet and Trio: tuneful. Anglaise: attractive. Gigue: challenging. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite No.4")]), _vm._v(" E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.815. Allemande: flowing, easiest Allemande of the set. Courante: three voices, graceful. Sarabande: easier than one in S.814. Gavotte: attractive; observe the authentic slurs. Minuet: flowing. Gigue: trills require careful attention. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite No.5")]), _vm._v(" G, S.816 (VU 51011 Müller, Kahn). Urtext edition plus facsimile of autograph. Allemande: melodious and expressive with phrasing a problem. Courante: fast and brilliant. Sarabande: Romantic; take plenty of time. Gavotte: a test of rhythmic control. Bourrée: tricky, begins on upbeat. Loure: flowing bass; needs delicate accentuation. Gigue: brilliant; bubbles with gaiety, a three-voice fugue with technical and rhythmic problems. The best of the French Suites. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite No.6")]), _vm._v(" E, S.817. Allemande: contrapuntal. Courante: requires firm rhythmic control. Sarabande: rich and full chords. Gavotte: needs careful accentuation. Polonaise: nice rhythms. Menuet: charming. Bourrée: needs a snappy tempo. Gigue: trill passages require steady control. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Renate McLaughlin, “J. S. Bach's English and French Suites with an emphasis on the Courante,” "), _c('i', [_vm._v("The Diapason")]), _vm._v(" 1218 (May 2011): 24–25.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Lory Wallfisch, “The Gigues of the Six ‘French Suites’ by J. S. Bach: A Performer's and Teacher's View,” "), _c('i', [_vm._v("Piano Journal")]), _vm._v(" 7 (February 1982): 11, 13–14.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("English Suites")]), _vm._v(", S.806–811 ca.1715 (Steglich, Theopold—Henle 100 complete, and in 2 vols. 102, 103, based on copies by Bach's pupils; Dürr—Br 5165; Dehnhard—VU 50060; Bischoff— K; Kreutz—CFP, in 2 vols. 4580A and B; Tamás—EMB; E. Fischer—WH; Petri—Br&H; Mugellini—Ric). These suites begin with a Prelude and are generally on a larger and more imposing scale than the French Suites.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite No.1")]), _vm._v(" A, S.806. Prelude: flowing; three-voiced; improvisatory character; ABA form, as are all the Preludes. Allemande: complex part writing. Courante I: French type. Courante II: two variations (doubles). Sarabande: beautiful and expressive. Bourrée I: appealing. Bourrée II: more appealing! Gigue: vivacious but slower than some of its five companions. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite No.2")]), _vm._v(" a, S.807. Prelude: lively, mainly two-voiced, could be used as a solo. Allemande: stately, moderate tempo. Courante: simple textures, rhythmic ambiguity. Sarabande: ornaments are written out in a second version. Bourrées I and II: lighter in mood than other movements. Gigue: has a da capo. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite No.3")]), _vm._v(" g, S.808. Prelude: has the ritornello form of an Italian concerto, still within the ABA design. Allemande: similar in tempo and character to Nos.2, 3, and 5. Courante: care needed with the ornamentation. Sarabande: Bach provides both mildly and floridly ornamented versions. Gavottes I and II: No.II is a musette (bagpipe imitation), play "), _c('i', [_vm._v("pp")]), _vm._v(" on repeat. Gigue: a two-voice fugue with theme inverted for second half. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite No.4")]), _vm._v(" F, S.809. Prelude: opens like a two-part invention, gathers force with various devices. Allemande: rolling triplets; figurative elements treated sequentially and contrapuntally. Courante: elaborate and refined. Sarabande: highly expressive. Minuets I and II: contrasting. Gigue: imitative counterpoint in two or three voices. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite No.5")]), _vm._v(" e, S.810. Prelude: lively, energetic, fugal. Allemande: short motives treated in various ways. Courante: oscillation between pattern of two beats each divided in three and three beats divided by two. Sarabande: more melodic than some of the other sarabandes. Passepieds I and II: in the form of a rondeau with three episodes. Gigue: a fugue. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite No.6")]), _vm._v(" d, S.811. Prelude: fugal passages alternate with episodes. Allemande: short running figures pass through various voices. Courante: French type. Sarabande and Double: dignified and expressive. Gavottes I and II: provide mood contrast to surrounding movements. Gigue: stunning and more exacting technically than the other gigues. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Rosaline Cameron, “Bach's Six English Suites,” MJ 32 (July 1974): 6–7.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Alfred Dürr, “The Historical Background and Composition of Johann Sebastian Bach's Clavier Suites, Parts I and II,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 16/1 (January 1985): 53–68.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Serge de Gastyne, “Bach's English Suites: A New Approach,” PQ 116 (Winter 1981–82): 45–47.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("J. Fuller-Maitland, "), _c('i', [_vm._v("The Keyboard Suites of J. S. Bach")]), _vm._v(" (London: Oxford University Press, 1925).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Cory Hall, “Of Bach and Courante Tempos,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 41/6 (July/August 2002): 23–25.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Natalie Jenne, “On the Performance of Keyboard Allemandes,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 10/2 (April 1979): 13–30.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("James W. McConkie, "), _c('i', [_vm._v("The Keyboard Suites of Bach: A Consideration of the Horizontal and Vertical Elements Found Therein")]), _vm._v(" (diss., Columbia University, 1950).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Renate McLaughlin, “J. S. Bach's English and French Suites with an emphasis on the Courante,” "), _c('i', [_vm._v("The Diapason")]), _vm._v(" 1218 (May 2011): 24–25.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Peter Watchorn, "), _c('i', [_vm._v("A Performer's Guide to the English Suites of J. S. Bach, BWV 806–11")]), _vm._v(" (DMA document, Boston University, 1995), 170pp.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("CLAVIER-ÜBUNG")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The "), _c('i', [_vm._v("Clavier-Übung")]), _vm._v(" was one of the few works of Bach that was published during his lifetime. Its complete title (in translation) was "), _c('i', [_vm._v("Keyboard Practice Consisting of Preludes, Allemandes, Courantes, Sarabandes, Gigues, Minuets, and Other Galanteries, Composed for Music Lovers, to Refresh Their Spirits")]), _vm._v(". It was published in four parts by Bach between 1731 and 1742.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Part I: 6 Partitas")]), _vm._v(", S.825–830 1726–1731 (K. Engler, E. Pitch-Axenfeld—VU 50192 2004 [previously published in 2 vols.]; Steglich—Henle 28 complete and in 2 vols. 30, 31, based on the original edition of 1731; Jones—Br5165; Emery— ABRSM; Soldan—CFP in 2 vols. 4463A&B; Bischoff—K, includes French Overture; E. Fischer—WH; Petri—Br&H; EMB). Published as Bach's Op.1, these grand suites have greater diversity than the French and English suites. The introductory movements vary in each partita: Praeludium, Sinfonia, Fantasia, Overture, Praeambulum, and Toccata, and could easily have stood as independent pieces. The dance movements become freer, as in Partita No.5, where Bach uses “Tempo di Minuetto,” and in No.6, “Tempo di Gavotta.” The standard suite form is changed in the Second Partita, in which Bach substitutes a Capriccio for the usual Gigue.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Partita No.1")]), _vm._v(" B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.825 (Palmer—Alfred). Praeludium: flowing arabesques in right hand over steadily moving eighth and quarter notes in left hand; fourth and fifth voices added to fill harmony at end. Allemande: arpeggiated chords; two measures before the double bar warns against a too-fast tempo. Corrente: Italian type, two voices, vivacious. Sarabande: elaborate melody requires a steady left-hand pulse to maintain motion. Minuets I and II: guard against too fast a tempo. Gigue: stunning; three voices that look like two; hand crossings suggest Scarlatti; Italian influence. Discreet pedaling advised. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Frank Morana, “The Lost Dedication Copy of "), _c('i', [_vm._v("Partita 1:")]), _vm._v(" Bach as Poet?,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 22/2 (Fall/Winter 1991): 13–23.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Dennis Todd, “Bach's Partita No. 1 in B-Flat Major,” "), _c('i', [_vm._v("Music Teacher")]), _vm._v(" 60/2 (February 1981): 13.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Partita No.2")]), _vm._v(" c, S.826. Sinfonia: majestic chordal opening leads to an Andante requiring careful phrasing and concludes with a two-voice fugue. Allemande: two voices, constructed on sequence of descending imitations. Courante: elaborate. Sarabande: different in texture from No.1 but has similar harmonic and rhythmic structure. Rondeau: base tempo on triplets in bars 86–87, delightful. Capriccio: brilliant; requires unflagging tempo; presents technical problems greater than any other movement in the Partitas. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Partita No.3")]), _vm._v(" a, S.827. Fantasia: simple textures. Allemande: florid and elaborate. Corrante: Italian type, light and simple. Sarabande: austere, no character of a sarabande. Burlesca: slight but original. Scherzo: light. Gigue: three voices, fugal, inverted second subject, serious and weighty. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Partita No.4")]), _vm._v(" D, S.828. Overture: imposing Grave orchestral opening and spirited contrapuntal Allegro. Allemande: one of Bach's most moving movements; requires a sustained cantabile line. Courante: French type, rhythmic and fast. Aria: two voices, simple, unhurried. Sarabande: Baroque arabesques in right hand over a steadily paced left hand. Minuet: short, simple. Gigue: brilliant, technically exacting; contrapuntal D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Partita No.5")]), _vm._v(" G, S.829. Praembulum: bright and lively rondo, requires well-controlled fingers. Allemande: weighty and complex. Corrente: technically one of the easiest. Sarabande: unusual rhythm, ornament interpretation not easy. Tempo di Minuetto: delicate, cross-rhythms. Passepied: trio has some difficult ornaments. Gigue: trills pose real problems; digital and interpretative complications. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Partita No.6")]), _vm._v(" e, S.830. Toccata: a solid fugue framed in a decorative improvisatory opening and closing. Allemande: extremely rich. Corrente: abounds in rhythmic surprises. Air: light, delicate tune, full of bold keyboard devices. Sarabande: transcendentally rich ornamentation, most complex of all the sarabandes. Tempo di Gavotta: elegant and witty. Gigue: conceals beneath its mockery and banter recondite and masterly fugal writing. A fitting climax to the form as used by Bach. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bach's first biographer, Forkel, expressed his appreciation for these suites as follows: “This work made in its time a great noise in the musical world. Such excellent compositions for the clavier had never been seen and heard before. Anyone who had learnt to perform well some pieces out of them could make his fortune in the world thereby; and even in our times, a young artist might gain acknowledgment by doing so, they are so brilliant, well-sounding, expressive, and always new” (Hans David and Arthur Mendel, "), _c('i', [_vm._v("The Bach Reader")]), _vm._v(" [New York: Norton, 1945], pp.337–38).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Walter Emery, “Bach's Keyboard Partitas: A Set of Composer's Corrections?” MT 93 (November 1952): 495–99.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Eric Michael Hicks, "), _c('i', [_vm._v("A Historical Perspective on Unity in the Keyboard Partitas of Johann Sebastian Bach")]), _vm._v(" (DMA diss., University of Texas, Austin, 1993), 317pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Charles Joseph, “Performing Bach on the Piano,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 14 (November 1975): 20, 36–39. Compares the tempi of Partita No.3 in three editions and in three different recordings.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Arthur A. Lambert, "), _c('i', [_vm._v("The Keyboard Partitas of J. S. Bach, A Study of Background, Text, and Interpretation")]), _vm._v(" (diss., State University of Iowa, 1961).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Karyl Louwenaar-Lueck, “The Sequence of Sarabande and Air in Bach's Keyboard Partitas,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 23/1 (Spring/Summer 1992): 38–50.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Joseph Ponte, "), _c('i', [_vm._v("Problems in the Performance of J. S. Bach's")]), _vm._v(" Clavierübung, "), _c('i', [_vm._v("Part I")]), _vm._v(" (thesis, Harvard University, 1952).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Andrew James Talle, "), _c('i', [_vm._v("J. S. Bach's Keyboard Partitas and Their Early Audience")]), _vm._v(" (PhD diss., Harvard University, 2003), 307pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Fernando Valenti, "), _c('i', [_vm._v("A Performer's Guide to the Keyboard Partitas of J. S. Bach")]), _vm._v(" (New Haven, CT: Yale University Press, 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Part II: Overture nach französischer Art")]), _vm._v(" b, S.831 1733 and "), _c('i', [_vm._v("Concerto nach italienischem Gusto")]), _vm._v(" F, S.971 1735 (Emery—Br 5161; Steglich, Theopold—Henle 129, also includes "), _c('i', [_vm._v("4 Duets, Goldberg Variations;")]), _vm._v(" Bischoff—K; U. Leisinger—VU 50186; Hans T.David—Schott; Soldan—CFP, early version in c, S.831a; Petri—Br&H).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Overture in the French Manner")]), _vm._v(", S.831, commences with a majestic introduction, gigue-like midsection, and a return to the opening idea, exemplying the French overture style; C; Gavottes I and II; Passepieds I and II; S; B I and II; G; and an Echo (which makes clever use of the two manuals of the harpsichord, but is also very effective on the piano; it is published separately by CFP). Paired dances take on greater importance than in any of the other suites.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Frederick Neumann, “The Question of Rhythm in the Two Versions of Bach's French Overture, S.831,” in "), _c('i', [_vm._v("Studies in Renaissance and Baroque Music in Honor of Arthur Mendel")]), _vm._v(" (Kassel: Bärenreiter, 1974), pp.183–94.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Italian Concerto")]), _vm._v(", S.971 (Tureck—GS [see below]; Engler—VU; Palmer—Alfred; Bischoff—K; Steglich, Theopold—Henle 160, based on first edition and manuscript copies of Bach's pupils; W. Emery—Br; U. Bartels—CFP 11240; E. Fischer—WH; Kruetz—Schott; Petri—Br&H and Soldan—CFP, published with the French Overture; Röntgen—UE; Schungeler—Heinrichshofen, published with Chromatic Fantasia and Fugue). Allegro; Andante; Presto. Although this work was designed for a two-manual harpsichord, Bach provided a few dynamics marks. It is written in the style of the Italian concerto grosso, with “forte” and “piano” representing the alternation of large and small concertino groups. The Petri edition is almost a transcription for harpsichord, for it tries to reproduce pitches that instrument produces with 16', 8', and 4' stops. R. Tureck (GS 1983; 18pp. plus 26pp. of critical notes and facsimile edition) edited and discussed the music text, original sources, embellishment symbols, notation style, part writing, Bach on the piano, and other topics. A superb critical and performing edition. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Wha Kyung Choi, "), _c('i', [_vm._v("The Italian Concerto of J. S. Bach and Its Interpretation")]), _vm._v(" (Master's thesis, Southern Illinois University, 1965).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Federico Garcia, “The Nature of Bach's "), _c('i', [_vm._v("Italian Concerto")]), _vm._v(", BWV 971,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 36/1 (2005): 1–24.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Benjamin Ivry, “Bach's Italian Concerto, BWV 971,” "), _c('i', [_vm._v("International Piano")]), _vm._v(" 40 (July/August 2005): 50–55. Discusses the work and historical recordings.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Part III: Four Duets")]), _vm._v(", S.802–805 1739 (M. Tessmer—Br; Steglich, Theopold—Henle 161, published separately and also with the rest of the "), _c('i', [_vm._v("Clavier-Übung")]), _vm._v(" [Henle 129]; Bischoff—K; Soldan—CFP; Petri—Br&H). In e, F, G, and a.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("These pieces are not for two players! Bach intended one part for the right hand and one part for the left hand. Other works in "), _c('i', [_vm._v("Part III")]), _vm._v(" are intended for the organ, and perhaps these Duets were also, but they sound well on the piano. Even though they are short and similar in character to the "), _c('i', [_vm._v("Two-Part Inventions")]), _vm._v(", they are mature Bach and their construction is much more elaborate. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Part IV: The Goldberg Variations")]), _vm._v(", S.988 1742 (R. Kirkpatrick—GS, excellent scholarly edition with information on many performance problems; Soldan— CFP; C. Wolff—Br; C. Wolff & H. Dreyfus—VU; Gilbert—Sal; Busoni and Petri—Br&H; Bischoff—K; Steglich, Theopold—Henle 159, also published with other pieces from the "), _c('i', [_vm._v("Clavier-Übung")]), _vm._v(" [129]). This towering set of thirty-two variations, based on a majestic sarabande, was written for a harpsichord with two keyboards but may be performed on the piano. Wanda Landowska called this work, along with "), _c('i', [_vm._v("The Art of Fugue")]), _vm._v(" and "), _c('i', [_vm._v("The Musical Offering")]), _vm._v(", “a dazzling secular temple erected in honor of absolute music.” It is Bach's most highly organized set of variations.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Elinore Barber, “Bach Tercentenary Facsimile Project: "), _c('i', [_vm._v("Clavierübung")]), _vm._v(", Book IV [The ‘Goldberg’ Variations], Nürnberg: Balthasar Schmid [ca. 1742],” "), _c('i', [_vm._v("Bach")]), _vm._v(" 11/1 (January 1980): 2–40. Includes facsimile of Bach's manuscript.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Robert C. Ehle, “Comments on the Goldberg Variations,” AMT 19 (November–December 1969): 20–22.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Cory Hall, “Bach's Goldberg Variations Demystified,” AMT 54/5 (April/May 2005): 35–39, 98.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Munsook Cho Kim, "), _c('i', [_vm._v("Extemporization of J. S. Bach's Goldberg Variations BWV 988: The Varying of Reprise with Improvised Embellishments")]), _vm._v(" (DMA diss., Boston University, 1996), 323pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Walter Schenkman, “Tatlow's Bach and Bach's Signatures in the "), _c('i', [_vm._v("Goldberg Variations,” Bach")]), _vm._v(" 34/2 (2003): 63–106.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("———, “The Goldberg Mystery,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 44/1 (January 2005): 12–19.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("———, “The Establishment of Tempo in Bach's "), _c('i', [_vm._v("Goldberg Variations,” Bach")]), _vm._v(" 6/3 (July 1975): 3–10.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Wadham Sutton, “J. S. Bach: The Goldberg Variations,” "), _c('i', [_vm._v("Music Teacher")]), _vm._v(" 54 (August 1975): 11.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Rosalyn Tureck, “The Goldberg Variations: Pianistic Prisms,” MJ 21 (March 1963): 28, 89.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("OTHER WORKS")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("14 Canons")]), _vm._v(", S.1087 (C. Wolff—Br 5153). From Vol.V/2 of the New Bach Edition. Based on a fragment of the main subject of the Goldberg Variations. Published for the first time. Contains a facsimile of the original manuscript and reproduces the canons in their original notation; also offers suggestions by the editor for their solution and performance. (Sal 1976, with realizations by O. Alain.)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Well-Tempered Clavier, Books 1–II")]), _vm._v(", S.846–893 1722, 1744. "), _c('i', [_vm._v("The Well-Tempered Clavier")]), _vm._v(" is perhaps the most published keyboard work of the Baroque period. It stands as a monument to Bach's achievements in contrapuntal writing through its Fugues as well as a compendium of styles and forms through its Preludes. Hans von Bülow would call it the Old Testament of Music (and Beethoven's thirty-two Sonatas the New Testament). That Bach was inspired by the newly created well-tempered tuning system to compose these volumes was to create one of the greatest achievements in keyboard literature. Bach himself must have been aware of the significance, for he entitled the first volume (in translation): "), _c('i', [_vm._v("The Well-Tempered Clavier or Preludes and Fugues through all the tones and semitones, both as regards the ‘tertia major’ or ‘Ut Re Mi,’ and as concerns the ‘tertia minor’ or ‘Re Mi Fa.’ For the Use and Profit of the Musical Youth Desirous of Learning, drawn up and written by Johann Sebastian Bach, Capellmeister to His Serene Highness the Prince of Anhalt-Cöthen, etc. and Director of His Chamber Music. Anno 1722")]), _vm._v(" (H. David and A. Mendel, "), _c('i', [_vm._v("The Bach Reader")]), _vm._v(" [New York: Norton, 1945], p.85). This title indicates the instructional emphasis Bach placed on the work, even though the musical world has chosen to place it among the loftiest of his creations. Among the many fine editions of these collections is the one by Willard A. Palmer (Alfred 1994 [2nd ed.]). Based on Bach's original autograph and every other important source known to exist, it includes the original as well as the final form of the preludes and fugues. Contains lengthy foreword. A superb edition with the editor's suggestions in lighter print. Other fine editions include: E.-G. Heinemann, Y. Tomita, A. Schiff—Henle 14, 16 (2007), with its scholarly preface, notes on execution, and editorial comments in German, English, and French; Kroll— CFP; Tovey & R. Jones—ABRSM, contains an excellent introduction and separate notes for each Prelude and Fugue; Busoni—Br&H, 8 vols., with interesting phrasing; K printed one ed. with Fugues in open score; GS and K have Busoni edition of Vol.I; W. Dehnhard—VU 1977, fingering by D. Kraus; Mugellini—Br&H, judicious fingering; Bischoff—K; Hughes—GS; A. Kreutz & H. Keller—CFP; Röntgen—UE; Dover, reprint of Bach-Gesellschaft edition; Amsco, 2 vols., 8-page introduction and fingering by G. Gould, who presents a viable argument for performing both volumes on the piano; text is the one edited by F. Krolland and published by CFP over a hundred years ago; Br&H, facsimile of Vol.I; O. Morgan—Ashdown, 2 vols. An altogether alternative edition is edited by A. Brennink (Chroma 1995), which prints pitches in exact proportions using the Ailler-Brennink Chromatic Notation system. Of special interest is the edition by Bartók (EMB 4475, 4476) in which the volumes are arranged in progressive order (Arabic numbers in the columns below standing alone refer to Preludes and Fugues in Book I of the original edition; those followed by the indication “II” refer to Book II):")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "40%"
    }
  })]), _c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Volume I")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Volume II")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("15/II")]), _vm._v(" "), _c('td', [_vm._v("15")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("12/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("21")]), _vm._v(" "), _c('td', [_vm._v("1/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("10")]), _vm._v(" "), _c('td', [_vm._v("24/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("20/II")]), _vm._v(" "), _c('td', [_vm._v("10/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("11")]), _vm._v(" "), _c('td', [_vm._v("16")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("5/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("9")]), _vm._v(" "), _c('td', [_vm._v("18/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("13")]), _vm._v(" "), _c('td', [_vm._v("24")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("21/II")]), _vm._v(" "), _c('td', [_vm._v("9/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("6/II")]), _vm._v(" "), _c('td', [_vm._v("4/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("19/II")]), _vm._v(" "), _c('td', [_vm._v("23")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("11/II")]), _vm._v(" "), _c('td', [_vm._v("3/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("19")]), _vm._v(" "), _c('td', [_vm._v("12")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("14")]), _vm._v(" "), _c('td', [_vm._v("3")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("18")]), _vm._v(" "), _c('td', [_vm._v("8/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("2/II")]), _vm._v(" "), _c('td', [_vm._v("22")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("17/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_vm._v("4")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("14/II")]), _vm._v(" "), _c('td', [_vm._v("8")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("7/II")]), _vm._v(" "), _c('td', [_vm._v("20")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("22/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("17")]), _vm._v(" "), _c('td', [_vm._v("16/II")])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("13/II")]), _vm._v(" "), _c('td', [_vm._v("23/II")])])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Study edition (small scores) include: Henle Vols. 1 (9256) and 2 (9258); Thomson—Allans with facsimile of autograph, 2 vols.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Selected Preludes and Fugues from Book I")]), _vm._v(" (J. Banowetz—General Words & Music 321 1980) 61pp. Includes Preludes and Fugues 1, 2, 5, 6, 21, 22. Based on seven known manuscripts and copies of the work. Critical notes. Excellent edition.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("Well-Tempered Clavier, Vol. I")]), _vm._v(" 1722 Cöthen")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("1. C, S.846 (E.-G. Heinemann, A. Schiff—Henle 642; Dehnhard, Kraus— VU 51003, urtext edition plus facsimile of the autograph). Prelude: modulating chords in broken figures require delicacy and evenness. Fugue: rich in strettos but contains no episodes and needs careful tonal distinction between voices played by same hand.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Andrew White, “The Prelude and Fugue in C Major from Bach's "), _c('i', [_vm._v("Well-Tempered Clavier")]), _vm._v(" [Book I]: Notes on the Compositional Process,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 23/2 (Fall/Winter 1992): 47–60.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("2. c, S.847. Prelude: persistent animated broken-chord figuration to five bars before the end, three tempo changes. Fugue: four episodes use fragments of the subject; requires rhythmic vitality.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Julius Herford, “The C-Major and C-Minor Preludes of "), _c('i', [_vm._v("The Well-Tempered Clavier")]), _vm._v(", Book I,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 4/2 (April 1973): 17–21.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("———, “Notizbuch für Studenten—J.S. Bach's "), _c('i', [_vm._v("Fugue in C Minor")]), _vm._v(" from "), _c('i', [_vm._v("The Well-Tempered Clavier")]), _vm._v(", Book I,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 4/3 (July 1973): 36–40.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Béla Siki, “Prelude and Fugue in C Minor,” in "), _c('i', [_vm._v("Piano Repertoire: A Guide to Interpretation and Performance")]), _vm._v(" (New York City: Schirmer, 1981), pp.3–7.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("3. C"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", S.848. Prelude: dazzling; even finger technique essential. Fugue: graceful and dancelike; requires firm rhythmic control and finger independence in double-note passages.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("4. c"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", S.849. Prelude: duet between outer voices requires legato and cantabile phrasing. Fugue: five-voice triple fugue, three distinct subjects developed separately and together; climax in third section is more internal than external.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("5. D, S.850 (Schott). Prelude: charming; should be played leisurely, with even finger technique. Fugue: grand “Handelian style,” with dignity but not too stiff or affected.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Mark Ellis, “Motif and Structure in Bach's Fifth Prelude,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 37/1 (2006): 1–25.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Béla Siki, “Prelude and Fugue in D Major,” in "), _c('i', [_vm._v("Piano Repertoire: A Guide to Interpretation and Performance")]), _vm._v(" (New York City: Schirmer, 1981), pp.8–13.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("6. d, S.851 (Schott). Prelude: harmonic subtleties lurk in inner voices; even finger technique required. Fugue: three voices, requires careful tonal discrimination between voices.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Béla Siki, “Prelude and Fugue in D Minor,” in "), _c('i', [_vm._v("Piano Repertoire: A Guide to Interpretation and Performance")]), _vm._v(" (New York City: Schirmer, 1981), pp.14–19.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("7. E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.852. Prelude: pastoral mood in flowing sixteenth notes interrupted once by a fugato; steady tempo but not dragging. Fugue: requires good phrasing and staccato plus rhythmic vitality and steady, even fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("8. e"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.853. Prelude: grand; break (roll) chords solemnly; sarabande rhythm; cantabile plus steady rhythmic flow. Fugue: slow and eloquent; grasp design and point to climax.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("9. E, S.854. Prelude: a three-part invention that needs legato cantabile phrasing. Fugue: high-spirited and busy; needs even fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("10. e, S.855. Prelude: flowing; duet-like; chordal punctuation; even finger control necessary, especially in second half. Fugue: easiest of the fugues, with energy but not too hurried; even fingers needed.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Béla Siki, “Prelude and Fugue in E Minor,” in "), _c('i', [_vm._v("Piano Repertoire: A Guide to Interpretation and Performance")]), _vm._v(" (New York City: Schirmer, 1981), pp.20–26.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("11. F, S.856. Prelude: dashing study in finger playing that needs smooth legato. Fugue: has rhythm and grace of a passepied; point up phrasing of imitative entries.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("12. f, S.857. Prelude: legato; organistic; steady and reposeful tempo. Fugue: unique chromatic subject; point up contrast between thematic parts and episodes.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("13. F"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", S.858. Prelude: gigue-like, transparent two-voice texture, flowing, cantabile legato. Fugue: soft and gently flowing, requires careful voice leading.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("14. f"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", S.859. Prelude: suppressed emotional content; serious; requires even fingers. Fugue: expressive; countersubject as important as subject; legato cantabile.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("15. G, S.860. Prelude: broken chords; exuberant; needs strong finger technique. Fugue: multipart subject; requires uninterrupted tempo and sharp articulation.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("16. g, S.861 (Schott). Prelude: three-voiced arioso; begin trills slowly, then increase their speed and slacken toward the end. Fugue: quietly moving tempo; do not let the subject fall apart at the rest; differentiate between voices. Nos.15 and 16 make an excellent group.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Béla Siki, “Prelude and Fugue in G Minor,” in "), _c('i', [_vm._v("Piano Repertoire: A Guide to Interpretation and Performance")]), _vm._v(" (New York City: Schirmer, 1981), pp.27–31.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("17. A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.862. Prelude: festive and ceremonial; sarabande-like; requires much rhythmic vitality. Fugue: warm and noble; organistic; phrasing and careful legato essential.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("18. g"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", S.863. Prelude: a three-part invention strictly worked out; cantabile; quietly moving tempo. Fugue: one of the freest, subject is legato except for repeated eighth notes, which should be slightly separated; expressive and graceful.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("19. A, S.864. Prelude: three-part invention that stresses contrapuntal intersest; develops three themes in triple counterpoint; reflective tempo; be careful of voice leading. Fugue: dance rhythm; strange subject; delicate; accurate tonal balance vital.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("20. a, S.865. Prelude: bold; elastically resilient subject; requires much rhythmic vitality; superior to the fugue. Fugue: four voices almost throughout, monotonous rhythm; separate large sections from one another; do not emphasize all subject entries.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("21. B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.866. Prelude: brilliant; a fast and lightly tossed-off small toccata that requires steady finger technique. Fugue: a capricious dance that needs much rhythmic vitality and finger independence in the double-note figuration.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Carl Schacter, “Bach's Fugue in B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Major, "), _c('i', [_vm._v("Well-Tempered Clavier, Book I")]), _vm._v(", No.XXI,” "), _c('i', [_vm._v("The Music Forum")]), _vm._v(" 3 (1973): 239–67. A thorough analysis oriented toward a Schenkerian approach.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Béla Siki, “Prelude and Fugue in B-Flat Major,” in "), _c('i', [_vm._v("Piano Repertoire: A Guide to Interpretation and Performance")]), _vm._v(" (New York City: Schirmer, 1981), pp.32–36.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("22. b"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.867. Prelude: dark, poignant, expressive phrasing in flowing rhythms. Fugue: songlike; full and warm choral sonorities; legato cantabile; be careful of voice leading.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("23. B, S.868. Prelude: three-part invention; quietly flowing tempo; phrasing and careful finger control essential. Fugue: all voices should be quiet and songlike; legato and careful balance of voices required.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("24. b, S.869. Prelude: two-voice canon plus scale accompaniment; Bach's direction “andante” means a quiet, steady tempo, with quarter note ca.69. Fugue: longest in the WTC; bold subject, “largo” indicates solemnity and breadth; bring out tonal contrast in episodes not based on main subject.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("The Well-Tempered Clavier, Vol. II")]), _vm._v(" 1744 Leipzig")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("1. C, S.870. Prelude: has much charm and fluency; legato; requires dignity and breadth. Fugue: masculine humor; should be played exactly twice as fast as the prelude to unify the two; requires even finger technique.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Michael Linton, “The Dual Chiastic Design of the C Major Prelude, BWV 870 ("), _c('i', [_vm._v("The Well-Tempered Clavier, Vol. II")]), _vm._v("),” "), _c('i', [_vm._v("Bach")]), _vm._v(" 27/1 (Spring–Summer 1996): 31–56.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("2. c, S.871 (Schott). Prelude: a dancelike two-part invention, not too fast, but with a quiet, thoughtful delicacy; finger independence and careful phrasing required. Fugue: severe and reflective; tonal balance in voice leading important.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("3. C"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", S.872. Prelude: unusual meter change from 4/4 to 3/8; crescendo in bars 23–24 leads to the forte of the fughetta in bar 25, which needs rhythmic vitality. Fugue: many short-breathed cadences; grows in intensity toward closing; requires careful building of climax to the quarter-note augmentation.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("4. c"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", S.873. Prelude: five sections, problematic ornaments, needs an expressive legato. Fugue: double fugue; virtuosic; controlled, even finger technique required.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("5. D, S.874. Prelude: brilliant; a complete SA movement; strong fingers and articulation needed. Fugue: contains many harmonic delights; needs distinction between two voices in same hand, expressive and restrained.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("6. d, S.875. Prelude: passagework and broken harmonies; lively; strongly articulated; full of tense energy. Fugue: dazzling, chromatic, elastically resilient, controlled energy.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("7. E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.876. Prelude: five sections; lyrical; fluent transitions; gently flowing with expressive legato and phrasing. Fugue: like a choral fugue with careful attention to voice leading and planning of climax.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("8. d"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", S.877. Prelude: a two-part invention of sixteen plus twenty bars, both parts repeated; legato and rhythmic flow are the problems. Fugue: melancholy mood; voice leading, arrival of climax, and legato cantabile present the most difficulty.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("9. E, S.878. Prelude: pastoral serenity, quietly flowing, expressive phrasing and legato. Fugue: noble and stately; Palestrina-like; clear voice leading and grasp of design required.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("10. e, S.879. Prelude: corrente-like; two-part and two voices; needs inner liveliness and humor. Fugue: virtuosic, requires a powerfully controlled rhythmic vitality and drive.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("11. F, S.880. Prelude: four sections; restful and peaceful; sustained notes must have a clear, singing quality. Fugue: fleeting and light; needs firm rhythmic control and even fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("12. f, S.881. Prelude: simplest and technically the easiest prelude, expressive legato phrasing. Fugue: capricious, needs even fingers and rhythmic vitality.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("13. F"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", S.882. Prelude: festive; like a French overture; needs verve, fire, and strong rhythms. Fugue: bold trill opening; gavotte-like episodes; delicacy and rhythmic vitality important.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("14. f"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", S.883. Prelude: a noble arioso that requires smooth legato and eloquent phrasing. Fugue: triple fugue with three contrasting subjects; player must understand design clearly and plan tone in relation to climax.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("15. G, S.884. Prelude: keep it graceful and not too hasty; finger technique and rhythmic drive essential. Fugue: delicately moving, light staccato, two-voice countersubjects must come through clearly.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("16. g, S.885. Prelude: grandioso, full sonorities, steady rhythmic flow. Fugue: cumulative rhetoric; needs careful planning of the climax and strong rhythmic vitality.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("17. A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.886. Prelude: full of grandeur and dignity, builds to an impressive closing. Fugue: in two halves; second half intensifies; legato; distinguish the tonal voice leading.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("18. g"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", S.887. Prelude: close to SA design; animated; a certain elegance underlies the expressive legato phrasing. Fugue: gliding subject; requires a fluent, nimble tempo; legato; economy of tone.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("19. A, S.888. Prelude: a pastorale-like three-part invention, needs a quiet legato delicacy. Fugue: same tempo as the prelude, constantly intertwining motives, rhythmic vitality.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("20. a, S.889. Prelude: chromatic; two-part invention; reflective legato and phrasing required. Fugue: bold; grand; heavy and powerful; strong rhythmic drive essential.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("21. B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.890. Prelude: fast; cheerful; graceful; flowing; smooth legato plus careful phrasing needed. Fugue: lightly animated, has grace and humor; requires tonal balance in playing two voices in same hand.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("22. b"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.891. Prelude: contrapuntal art plus intellectual discipline in prelude and fugue; expressive legato; careful voice leading important. Fugue: many contrapuntal devices; grasp of design needed; should not be too slow.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("23. B, S.892. Prelude: four sections; toccata-like; requires fiery, richly colored performance with even finger technique. Fugue: quietly flowing, singing, steady rhythmic flow toward cadences.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Herbert Anton Kellner, “Considering the Tempering Tonality B-Major in Part II of the "), _c('i', [_vm._v("Well-Tempered Clavier,” Bach")]), _vm._v(" 30/1 (Spring–Summer 1999): 10–25.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("24. b, S.893. Prelude: a two-voice dance; motivic elaboration resembles an invention; rhythmic drive; legato. Fugue: playful; like a passepied; controlled rhythmic vitality but with comfortable grace.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Eric L. Altschuler, "), _c('i', [_vm._v("Bachanalia: The Essential Listener's Guide to Bach's Well-Tempered Clavier")]), _vm._v(" (Waltham, MA: Little, Brown & Co., 1994).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("James A. Brokaw, II, “Recent Research on the Sources and Genesis of Bach's "), _c('i', [_vm._v("Well-Tempered Clavier,” Bach")]), _vm._v(" 16/3 (July 1985): 17–35.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Siglund Bruhn, "), _c('i', [_vm._v("J. S. Bach's Well-Tempered Clavier, In-Depth Analysis and Interpretation")]), _vm._v(", 4 vols. (Hong Kong: Mainer International Ltd., 1993). The finest and most comprehensive analysis seen by this writer.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Matthew Charles Dirst, "), _c('i', [_vm._v("Bach's ‘Well-Tempered Clavier’ in Music Thought and Practice, 1750–1850")]), _vm._v(" (PhD diss., Stanford University, 1996), 176pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("J. Fuller-Maitland, "), _c('i', [_vm._v("The ‘48’: Bach's Wohltemperiertes Clavier")]), _vm._v(", 2 vols. (London: Oxford University Press, 1925).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Laurette Goldberg, "), _c('i', [_vm._v("The Well Tempered Clavier of J. S. Bach, A Handbook for Keyboard Teachers and Performers")]), _vm._v(", 2 vols. (Berkeley, CA: Music Sources, 1996).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Cecil Gray, "), _c('i', [_vm._v("The Forty-Eight Preludes and Fugues of J. S. Bach")]), _vm._v(" (London: Oxford University Press, 1938; Reprint New York: Da Capo Press, 1979).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Edwin Hughes, “‘Forty-Eight’ from the Player's Standpoint,” MQ 11 (July 1925): 444–53.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Frederick Iliffe. "), _c('i', [_vm._v("Analysis of Bach's Forty-Eight Preludes and Fugues")]), _vm._v(" (London: Novello, 1897).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Hermann Keller, "), _c('i', [_vm._v("The Well-Tempered Clavier by Johann Sebastian Bach")]), _vm._v(" (New York: W. W. Norton, 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Edna Kilgore, “Time Signatures of "), _c('i', [_vm._v("The Well-Tempered Clavier:")]), _vm._v(" Their Place in Notational History,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 4/2 (April 1973): 3–16.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Ralph Kirkpatrick, "), _c('i', [_vm._v("Interpreting Bach's Well-Tempered Clavier")]), _vm._v(" (New Haven, CT: Yale University Press, 1984).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Joseph Matthews, "), _c('i', [_vm._v("Busoni's Contribution to Piano Pedagogy")]), _vm._v(" (DM diss., Indiana University, 1977), 120pp. See especially the chapter on Busoni's edition of Bach's "), _c('i', [_vm._v("The Well-Tempered Clavier.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Paul Pisk, “A New Look at the ‘Great 48,’” "), _c('i', [_vm._v("Bach")]), _vm._v(" 8 (April 1977): 23–25.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Fritz Rothschild, "), _c('i', [_vm._v("A Handbook of the Performance of the Forty-Eight Preludes and Fugues of Bach According to the Rules of the Old Tradition")]), _vm._v(", 2 vols. (London: Adam and Charles Black, 1955).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Yo Tomita, “Psalm and the "), _c('i', [_vm._v("Well-Tempered Clavier II:")]), _vm._v(" Revisiting the Old Question of Bach's Source of Inspiration,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 32/1 (2001): 17–43.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("———, “The Sources of J.S. Bach's "), _c('i', [_vm._v("Well-Tempered Clavier II")]), _vm._v(" in Vienna 1777–1801,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 29/2 (Fall–Winter 1998): 8–79.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Konrad Wolff, “Fugue Subjects without Leading Tone in the WTC,” PQ 100 (Winter 1977–78): 11–12, 14.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Preludes, Fughettas")]), _vm._v(" (A. Dürr—Br 5200 1995) 52pp. Composed in conjunction with the WTC II. Extracted from the "), _c('i', [_vm._v("Neue Bach-Ausgabe, Series 5, Vol.6.2.")]), _vm._v(" Includes S.870a, 870b, 871/2, 872a/1–2, 872/2, 875a, 875/1–2, 876/2, 884/1, 899–902.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Seven Toccatas")]), _vm._v(", S. 910–916 (P. Wollny—Br, urtext; Steglich, Theopold—Henle 126; Keller—CFP, urtext; C. Eisert, R. Hill—VU 2000; Bischoff—K; Busoni, Petri—Br&H; Hughes—GS). In f"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", c, D, d, e, g, G. These toccatas are the apex of this musical convention. They are multisectional works of a free and rhapsodic character employing diverse moods, rhythms, and textures. All contain at least one slow movement and one fugue. Tremolos and long trills abound. The fugues are more improvisatory than those in "), _c('i', [_vm._v("The Well-Tempered Clavier")]), _vm._v(". The Toccatas in f"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", c, and G are later than the others, completed ca.1717–19. The others were completed no later than 1710. All seven make fine opening recital pieces. Br edition is from the "), _c('i', [_vm._v("Neue Ausgabe sämtlicher Werke")]), _vm._v(". VU includes early versions of S.912 and 913 and an ornamented version of S.916. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Available separately: D (S.912) (Kreutz—Schott), d(S.913) (Donath—Mitteldeutscher Verlag).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" J. Fuller-Maitland, “The Toccatas of Bach,” SIMG 14 (1912–13): 578–82. Published separately, London, 1913.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Sidney Grew, “The Clavier Toccatas of J. S. Bach,” MT 60 (1919): 17–20.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Igor Kipnis, “Ornaments in Bach's Toccata in G (S.916),” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 23/8 (October 1984): 20–25. Includes score.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Little Notebook for Anna Magdalena Bach")]), _vm._v(" (G. v. Dadelsen—Br 5242 2005, "), _c('i', [_vm._v("Neue Ausgabe sämtlicher Werke")]), _vm._v("). Contains the 1725 edition. The older Br edition (5008 1957, Series V, Vol.4) contains both the 1722 and 1725 editions. From the 1722 edition: Suite d (S.812) A, C, S, M I and II, G; Suite c (S.813) A, C, S, Air, G; Suite b (S.814) A, C, S, Gavotte, G; Suite E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (S.815) A, C, S, Gavotte, Air, G; Suite G (S.816) A, C, S, Gavotte, B, Loure, G; Fantasia for Organ (S.573); Air c (S.991); Chorale “Jesu, meine Zuversicht” (S.728); Menuet c from Suite (S.813); Menuet and Trio b from Suite (S.814); Menuet G (S.814). From the 1725 edition: Partita a (S.827) Prelude, A, C, S, M, G; Partita e (S.830) Prelude, A, C, S, Tempo di Gavotta, G; Suite I pour le Clavessin d (S.812) A, C, S, M I & II, G; Suite II pour le Clavessin c (S.813) A, C, S; smaller works by Bach and other composers such as Couperin, C. P. E. Bach, Stoelzel (?) and Boehm. Some of the small dance movements (so popular with many piano teachers) are not by Bach. Bach himself started this collection with the two large partitas (Partita a S.827, Partita e S.830) as a form of dedication. The "), _c('i', [_vm._v("Klavierbüchlein")]), _vm._v(", with its patchwork of grave and gay, spontaneity and profound art, opens a door for us to the Bachs’ daily life. Other editions: Heinemann, Theopold, Petrenz—Henle 349; N. Taneda—VU UT 50150 2001; A. Schering—K, based on the 1725 edition; Keller—CFP; Imre—EMB; O. Mortensen—WH.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Michaele Benedict, “A Visit with Anna Magdalena Bach,” AMT 43/4 (February/March 1994): 22–25.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Glen Carruthers, Ornaments from Bach's Anna Magdalena Notebook,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 37/1 (January 1998): 9.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COLLECTIONS WITH SELECTED PIECES")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Selections from Anna Magdalena Note Book")]), _vm._v(" (Palmer—Alfred). Twenty-two pieces in scholarly edition. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Bach I")]), _vm._v(" (Anson—Willis). Eighteen pieces from the "), _c('i', [_vm._v("Anna Magdalena Bach Note Book")]), _vm._v(". Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Twenty Easy Pieces")]), _vm._v(" (Ludwig—Schott).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Twenty Easy Pieces from Anna Magdalena Bach's Notebook")]), _vm._v(" (E. Sauer—CFP 3829). Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Twenty Easy Pieces")]), _vm._v(" (E. Sauer—Augener).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Easiest Piano Pieces—Notebook for Anna Magdalena Bach")]), _vm._v(" (CFP 5008). Thirteen pieces. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Selections")]), _vm._v(" (Snell—Kjos).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Twelve Selected Pieces")]), _vm._v(" (Philipp—IMC).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Anna Magdalena Bach Notebook")]), _vm._v(" (Langrish—ABRSM) 32pp. Twenty pieces. S. Anh.113–132. Highly edited. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Little Notebook for Wilhelm Friedemann Bach")]), _vm._v(" 1720 (W. Plath—Br, "), _c('i', [_vm._v("Neue Ausgabe sämtlicher Werke")]), _vm._v("). A scholarly edition that includes Bach's only table of ornaments and sixty-two pieces. This notebook contains first versions of eleven preludes from "), _c('i', [_vm._v("The Well-Tempered Clavier")]), _vm._v(", fifteen "), _c('i', [_vm._v("Two-Part Inventions")]), _vm._v(" (Praeambulums), fourteen "), _c('i', [_vm._v("Three-Part Inventions")]), _vm._v(" (Fantasias), and miscellaneous pieces by Bach, W. F. Bach, Richter, Telemann, and J. G. Stoelzel. The miscellaneous pieces are Applicatio C (S.944); Prelude C (S.924a); “Wir nur den lieben Gott” (S.691); Prelude d (S.926); “Jesu meine Freude” (S.753); Allemandes g (S.836 and 837); Prelude F (S.927); Prelude g (S.928); Minuet G (S.841); Minuet g (S.842); Minuet G (S.843); earlier versions (with different S. numbers) of two preludes from "), _c('i', [_vm._v("The Well-Tempered Clavier:")]), _vm._v(" Prelude No.1 C (S.846a), and Prelude No.5 e (S.855a); Prelude C (S.924); Prelude D (S.925); Prelude e (S.932); Prelude a (S.931); Fugue C (S.953); Suite by Telemann (S.824); Partita by Stoelzel with minuet trio by Bach (S.824). Other editions: K; R. Kirkpatrick—Yale University Press, 1959, facsimile of the holograph with commentary; H. Trede—Schott, sixteen selections; Palmer— Alfred 603, twenty-two selections.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Trevor Fischer, “The Little Clavier Book for W. F. Bach,” MT 101 (February 1960): 87–88.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Matthew Hill, “Delightful, Easy Piano Pieces in Bach's "), _c('i', [_vm._v("Clavier-Büchlein,” Clavier")]), _vm._v(" 43/4 (April 2004): 14–19.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("John Horton, “A Famous Primer: J. S. Bach's "), _c('i', [_vm._v("Little Keyboard Book for Wilhelm Friedemann,” Music Teacher")]), _vm._v(" 60/3 (March 1981): 21.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Sandra Soderlund, “Bach's "), _c('i', [_vm._v("Little Keyboard Book")]), _vm._v(", Music Lessons for Bach's Sons,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 40/4 (March 2001): 20–24.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("SEPARATE PIECES")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite")]), _vm._v(" a, S.818 (CFP 214 and 9007: A, C, S Simple, S Double, G. S.818a; Busoni, Mugellini—Br&H: Prelude, a different version of the C, a different S, M, the same A and G as S.818). In the style of the French Suites. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite")]), _vm._v(" E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.819 (CFP 214 and 9007; Busoni, Petri—Br&H). Two separate Allemandes, C, S, B, and M with Trio in e"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(". M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Two Suites")]), _vm._v(", S.818, 819, 818a, 819a (Durr—Br 5166). Includes second versions. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Ouverture")]), _vm._v(" F (Suite), S.820 (CFP 9007) (Busoni, Petri—Br&H). An untitled opening movement in the style of a French Overture, Entrée, M (Trio), B, G. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite")]), _vm._v(" B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.821 (Busoni, Petri—Br&H). Praeludium, A, C, S, Echo. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite")]), _vm._v(" g, S.822 (CFP 1959). Overture, Aria, Gavotte en Rondeau, M I and II (Trio), G. An early work. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite")]), _vm._v(" f, S.823 (CFP 9007; Busoni, Petri—Br&H; Tureck—OUP, in Vol.III of "), _c('i', [_vm._v("An Introduction to the Performance of Bach")]), _vm._v("). P, S, G. Lute influence. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite")]), _vm._v(" A, S.824 (Busoni, Petri—Br&H; Tureck—OUP, in Vol.III of "), _c('i', [_vm._v("An Introduction to the Performance of Bach")]), _vm._v("). A, C, G. This suite is contained in the "), _c('i', [_vm._v("Notebook for W. F. Bach")]), _vm._v(". Difficulty of French Suites.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Prelude and Fugue")]), _vm._v(" a, S.894 (CFP 9009; Br&H). This large work, later transformed into the opening and closing movement of the "), _c('i', [_vm._v("Triple Concerto")]), _vm._v(" in a (S.1044), requires the utmost finger dexterity. The Prelude is in the style of a huge fantasy while the fugue is gigue-like. Impressive. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Chromatic Fantasia and Fugue")]), _vm._v(" d, S.903 1720–23 (Dadelsen, Rönnau, Theopold— Henle 163; Schenker, rev. Jonas—UE; Keller—CFP; Busoni—Br&H; Bischoff—K; Kreutz—Schott; E. Fischer—WH; Röntgen—UE; Huber—UE; Schenker—Longman, 128pp. critical edition with commentary translated and edited by H. Siegel; U. Leisinger, M. Behringer—VU; Schungeler— Heinrichshofen, published with the Italian Concerto). Expansive harmonic language; highly sectionalized and free in construction. The three-voice fugue is a magnificent example of dramatic cumulative effect stretched over a lengthy period. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Heinrich Schenker, "), _c('i', [_vm._v("J. S. Bach's Chromatic Fantasy and Fugue")]), _vm._v(". Critical edition with commentary. Translated and edited by Hedi Siegel (New York and London: Longman, 1984), 101 pp. The commentary includes, among other topics, a discussion of non-legato, dynamics, and fingering. An appendix lists works of Heinrich Schenker.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Konrad Wolff, “Bach's Chromatic Fantasy S.903: An Attempt at an Analysis with Commentary and Realizations,” PQ 115 (Fall 1981): 41–45.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fantasia and Fugue")]), _vm._v(" a, S.904 (CFP 208; Br&H). The Fantasia is written in organ style, while the double Fugue is one of Bach's most majestic compositions. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fantasia")]), _vm._v(" c, S.906 (Br 1976; CFP 9009; Br&H; Henle; Schott; JF; K). Brilliant, short, Scarlatti-like. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fugue")]), _vm._v(" a, S.944 (CFP 9009; Br&H; Durand). Opening arpeggiated introduction leads to one of Bach's longest fugues (198 bars) in “perpetual-motion” style. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Two Fugues on Themes by Albinoni")]), _vm._v(" A, S.950; b, S.951 (Bischoff—K; Kreutz— Schott; Friskin—JF). M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" D, S.963 (CFP; Br&H). Two untitled movements (125 and 41 bars respectively). Adagio introduction to a fugue “all’ Imitatio Gallina Cucca,” imitating a hen and a cuckoo. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" d, S.964 (CFP; Br&H). A transcription of a solo violin sonata a S.1003. Adagio; Fuga; Andante; Allegro. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Kenwyn G. Boldt, "), _c('i', [_vm._v("The Solo Clavier Sonatas Attributed to J. S. Bach")]), _vm._v(" (DM paper, Indiana University, 1967).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Fugues on Themes by Reinken")]), _vm._v(" a, S.965; C, S.966; B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", S.954 (Keller—Br). The first two themes are from Reinken's "), _c('i', [_vm._v("Hortus Musicus")]), _vm._v(". M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" C, S.966 (in "), _c('i', [_vm._v("Various Works, Vol.I")]), _vm._v(", K). Präludium; Fuga; Adagio-Presto; Allemande; Courante; Sarabande; Gigue. Bach's transcription of a quartet by J. S. Reinken. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Adagio")]), _vm._v(" G, S.968 (CFP 9091). A beautiful transcription by Bach of the first movement of the "), _c('i', [_vm._v("Sonata")]), _vm._v(" C for unaccompanied violin S.1005. Very effective on the keyboard. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Aria with Variations in the Italian Manner")]), _vm._v(", S.989 1709 (Tureck—OUP, in Vol. III of "), _c('i', [_vm._v("An Introduction to the Performance of Bach;")]), _vm._v(" CFP 9043; Br&H; Bischoff—K; Amadeus-Paüler; Frotscher—Mitteldeutscher Verlag). Aria with ten contrasting variations. M-D. This early set and the Goldberg Variations are Bach's only two separate sets of keyboard variations.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Capriccio, On the Departure of a Beloved Brother")]), _vm._v(", S.992 1704 (Bischoff—K; Dadelsen—Henle; Busoni—Br&H; Friskin—JF; Goldberger—GS; CFP). An early work. Bach's only example of programmatic keyboard music, composed for Johann Jacob Bach on his departure to Sweden to become oboist in the National Guard of Swedish King Charles XII. In six sections with programmatic titles. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Partita")]), _vm._v(" c, S.997 1737–41 (CFP 9007; Busoni, Petri—Br&H; H. Ferguson—Schott). Preludio, Fuga, S, G, Double. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Musikalisches Opfer / Musical Offering")]), _vm._v(", S.1079 1747 (C. Wolff—Br 1983) 19pp. "), _c('i', [_vm._v("Book I:")]), _vm._v(" Ricercari für cembalo. Magnificent contrapuntal writing. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Die Kunst der Fuge")]), _vm._v(" / "), _c('i', [_vm._v("The Art of the Fugue")]), _vm._v(", S.1080 ca.1745–50 (Moroney—Henle 423; C. Wolff—CFP; K. Hofmann—Br 5207). A series of fugues on the same theme. Nearly all are in four voices. Contrapunctus I–XIV; Canons in Hypodiapason, alla Decima, alla Duodecima, in Hypodiatessaron; Contrapunctus XIII in der Fassung für zwei Cembali.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite")]), _vm._v(" F, S.Anhang 80 (J. Werner—Ascherberg). A, C, S, G. Dates from around 1701. Easier than any of the French or English Suites. The autograph is at Stanford University. M-D.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("COLLECTIONS FOR ADVANCING PERFORMERS")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suiten, Sonaten, Capriccios, Variationen")]), _vm._v(" (G. v. Dadelsen, H.-M. Theopold—Henle 262). Urtext edition. Suite a (S.818a): Prelude, A, C, S, M, G. Suite a (S.818): A, C, S simple and S double, G. These two suites are similar in many ways. Suite E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (S.819): A (another version of this A, S.819a), C, S, B, M I & II. Ouverture F (S.820): Entrée, M, B, G. Suite f (S.823): Prélude, S en Rondeau, G. Suite A (S.832): A, Air pour les Trompettes, S, B, G. Präludium et Partita del Tuono Terzo (S.833): Präludium, A, C, S and Double, Air. 2 Menuettes from French Suites c (S.813a); E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (S.815a). 3 Menuettes from the "), _c('i', [_vm._v("Notebook for Wilhelm Friedemann Bach:")]), _vm._v(" I G (S.841); II g (S.842); III G (S.843). Sonata D (S.963). Sonata a (S.967). Sonata after Reinken a (S.965). Sonata after Reinken C (S.966). Sonata d (S.964, transcribed from a violin sonata). Adagio G (S.968, transcribed from a violin sonata C). Capriccio on the Departure of His Beloved Brother (S.992). Capriccio in Honor of Johann Christoph Bachii Ohrdruf E (S.993). Aria Variata a (S.989). Preface in English, French, and German; critical notes and commentary in German. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fantasien, Präludien und Fugen")]), _vm._v(" (G.v. Dadelsen, Rönnau, Theopold—Henle 219). Urtext edition. Fantasies: Chromatic Fantasy and Fugue (S.903, 903a); Fantasy and Fugue a (S.904), a (S.944), c (S.906); Fantasy g (S.917), c (S.918), c (S.919), a (S.922). Preludes and Fugues: a (S.894), F (S.901); Prelude G (S.902/1); Prelude and Fugue on a Theme by Albinoni (S.923, 951); Fugue on a Theme by Albinoni (S.951a). Fugues: C (S.946), a (S.947), d (S.948), A (S.949); Fugue on a Theme by Albinoni (S.950); Fugue after Reinken (S.954); Fugue after Erselius (S.955).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Italienisches Konzert, Französische Ouverture, Vier Duette, Goldberg-Variationen")]), _vm._v(" (Steglich, Theopold—Henle 129). Urtext edition of the Italian Concerto, French Overture, Four Duets, and Goldberg Variations.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Italian Concerto, Chromatic Fantasia and Fugue and Other Works for Keyboard")]), _vm._v(" (Dover 1987) 104pp. Includes Italian Concerto, Chromatic Fantasia and Fugue, Overture in the French Manner; smaller Preludes and Fugues/ Fughettas, (S.894, 901, 902), Fantasias and Fugues (S.904, 906), Fantasias (S.917–919), Prelude (S.922), Fugues (S.946–948, 950).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Keyboard Music")]), _vm._v(" (Dover 1970) 312pp. A reprint of the "), _c('i', [_vm._v("Bach Gesellschaft")]), _vm._v(" edition, 1853 and 1863: 6 English Suites; 6 French Suites; 6 Partitas; Goldberg Variations; 15 Two-Part Inventions; 15 Three-Part Sinfonias. Clean edition. Int. to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Miscellaneous Keyboard Works: Toccatas, Fugues and Other Pieces")]), _vm._v(" (Dover 1991) 303 pp. From "), _c('i', [_vm._v("Bach-Gesellschaft")]), _vm._v(" (Br & H) 1890, 1894, 1897. 7 Toccatas. PaF (S. 895). Fugue (from S. 996). Fugue (S. 897). PaF (S.899, 900). Fantasias and Fugues (S.905, 907, 908). Concerto and Fugue (S.909). Fantasias (S.920, Anh. 86, S. 921). Prelude (S. 923). 7 Little Preludes (S.924–930). 6 Little Preludes (S.933–938). 5 Preludes (S.939–943). Fugues (S.944, 949, 951, 952, 953, 954, 955, 956, 957, 958, 959, 961). Prelude, Fugue and Allegro (S.998). Suites (S.818, 819). Overture (S.820). Suites (S.821, 823). Partie (S.832). Partitas (S.832, 897, 1006a). Sonatas (S.963, 964, 965, 966). Adagio (S.968). 3 Minuets (S.841–843). Aria variata alla maniera italiana (S. 989). Capriccio on the Departure of His Beloved Brother (S.992). Capriccio (S.993).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Christoph Öhm-Kühnle, “Heinrich Nikolaus Gerber's Rediscovered Manuscript of Johann Sebastian Bach's Suite in E Minor (BWV 996): A Copy of Bach's Hitherto Unknown Revised Version,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 38/1 (2007): 45–66.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("14 Chorale Preludes")]), _vm._v(" (Zorn—Concordia). From the chorale preludes Bach wrote for the manuals alone. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Klavier und Lautenwerke")]), _vm._v(" (H. Eichberg, T. Kohlhase—Br 5044GA). Series V Vol.10 of the "), _c('i', [_vm._v("Neue Ausgabe sämtliche Werke")]), _vm._v(". Contains the following keyboard works: Ouverture F (Suite; S.820); Suite g (S.822); Suite f (S.823); Partie A (S.832); Praeludium e Partita del Tuono Terzo F (S.833); Sonata D (S.963); Aria Variata alla maniera Italiana a (S.989); Capriccio on the Departure of His Beloved Brother B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (S.992); Capriccio in Honorem Joh. Christoph. Bachii E (S.992). M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Miscellaneous Works for Piano")]), _vm._v(" (U. Wolf, H. Eichberg, T. Kohlhase—Br 5232–34 1976, 1999). Urtext edition from "), _c('i', [_vm._v("Neue Ausgabe sämtliche Werke")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I:")]), _vm._v(" 6 Little Preludes (S.933–938); Fantasias, Preludes, Fugues, (S.894–896, 903, 903a, 917, 918, 921, 922).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II:")]), _vm._v(" Fantasias, Fugues, Prelude, Sonata (S.904, 906, 923/951, 951a, 944, 946, 948–950, 952, 959, 961, 967).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. III:")]), _vm._v(" Capriccios (S.992, 993); Aria (S.989); Sonata (S.963); Ouverture (S.820, 822); Suites (S.823, 832); Prelude and Partita (S.833); Prelude, Fugue, and Allegro (S.998).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bach Album")]), _vm._v(" (I. Mariassy—EMB 1973, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I")]), _vm._v(" (58pp): Aria variata (S.989); Capriccio B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (S.992); Duetto a (S.805); Fuga a (S.958); Gigue f (S.845); Menuet I G (S.841); Menuet II g (S.842); Menuet III G (S.843); Praeludium D (S.925); Praeludium F (S.928); Praeludium und Fuga A (S.896); Praeludium und Fughetta e (S.900); Praeludium und Fughetta F (S.901); Scherzo d (S.844); French Suite VI E (S.817). Clean edition.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II:")]), _vm._v(" Duetto F (S.803); 2 Fughettas (S.679, 681); Partita a (S.827); Praeambulum d (S.875a); Sonata D (S.963); Suites a, E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (S.818, 819); Toccata e (S.914). M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bach: Keyboard Masterpieces")]), _vm._v(" (M. Gresh—GS 1976).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I:")]), _vm._v(" English and French Suites.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II:")]), _vm._v(" Partitas and Toccatas.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bach: The Fugue")]), _vm._v(" (C. Rosen—OUP). In Oxford Keyboard Classics series. Prelude and Fugue E (S.878); Prelude and Fugue F"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(" (S.858); Contrapunctus 1, 3, 9, 10, from the Art of Fugue (S.1080); Fantasie and Fugue a (S.904); Ricercars av Ricercars a"), _c('sup', [_vm._v("3")]), _vm._v(" and a"), _c('sup', [_vm._v("6")]), _vm._v(" (S.1079). M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatas and Partitas")]), _vm._v(" (PWM). Well edited. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Einzelne Suiten und Suitensaetze")]), _vm._v(" (Complete Suites and Movements from Suites) (CFP 9007). Most of the movements are based on dance forms, and much of the music is relatively unknown. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonaten und Sonatensatze")]), _vm._v(" (CFP 9066). Includes four complete sonatas, (S.963, 964, 965, 966) and two separate sonata movements, Adagio G (S.968), Allegro e (S.1019). Some of this material was used by Bach in other works. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Klavierwerke (Supplement)")]), _vm._v(" (H. Keller—CFP 12287 1965) 80pp. Capriccio B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (S.992); Capriccio E (S.993); Aria variata (S.989); Fantasia a (S.922); Fantasia c (S.919); Fugues in e (S.945), a (S.947), on a Theme by Reinken (S.954), on Themes by Albinoni A (S.950) and b (S.951); Vorstudien zum WTC II, Preludes and Fugues C (S.872a), F (S.901), G (S.902a), G (S.902); Minuettes from the Notebook for W. Fr. Bach G (S.841), g (S.842), G (S.843); Applicatio (S.994). Preface and Endnotes in German. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Harpsichord Music: Selections")]), _vm._v(" (Busoni—Br&H 4314 1982 reprint) 81pp. Chromatic Fantasy and Fugue (S.903): Capriccio on the Departure of a Beloved Brother (S.992): Fantasie, Adagio and Fugue c (S.968): Prelude, Fugue and Allegro (S.998). Preface in German. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Masterworks Piano Library")]), _vm._v(" (W. Phemister—Fred Bock Music 1994) 72pp. One of a series developed to help the church pianist locate appropriate music for preludes, offertories, interludes, solos, and postludes. Includes repertoire originally written for organ without a pedal part. Also includes variations, chorale preludes from "), _c('i', [_vm._v("Clavier-Übung")]), _vm._v(", Part III, and miscellaneous chorale preludes. Excellent front matter and choice of material. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Chorales from the C.P.E. Bach Collection")]), _vm._v(" (F. Rempp—Br 5237 2002) 218pp. According to the printed edition of 1784–1787. Urtext from the "), _c('i', [_vm._v("Neue Ausgabe sämtliche Werke")]), _vm._v(". Contains 370 four-voice chorale harmonizations. Excellent preface by the editor, Prefatory Note by C.P.E. Bach (both in German and English), and Indices (4) of chorales. Beautiful edition. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Le Clavier à deux voix")]), _vm._v(" (M. Bitsch, C. Manen—Combre 6127–28 2000). An anthology of works for two voices of twenty-four pieces for piano, organ, or harpsichord extracted from Suites, Inventions, the Well-Tempered Clavier, etc., in two vols. Preface in French. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. A")]), _vm._v(" (C06127) 26pp. French Suites: Menuet 1 (2nd Suite, S.813), Bourrée (5th Suite, S.816), Gigue (6th Suite, S.817). Inventions: Nos.1 (S.772), 6 (S.777), 8 (S.779), 13 (S.784). Well-Tempered Clavier I: Fugue No.10 (S.855). Well-Tempered Clavier II: Prelude No.2 (S.871), Prelude No.8 (S.877), Prelude No.15 (S.884). Goldberg Variations: Canon No.27 (S.988).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. B")]), _vm._v(" (C06128) 25pp. French Suites: Menuet 1 (3rd Suite, S.814), Polonaise (6th Suite, S.817). English Suite: Gavotte 2 (6th Suite, S.811). Inventions: Nos.2 (S.773), 4 (S.775), 11 (S.782), 15 (S.786). Well-Tempered Clavier II: Preludes Nos.6 (S.875), 10 (S.879), 20 (S.889). Musical Offering: Canon in retrograde (S.1079). "), _c('i', [_vm._v("Klavierübung")]), _vm._v(" (3rd Part): Duet No.2 Fugue (S.803).")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("COLLECTIONS FOR THE EARLY GRADES OF PIANO STUDY")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Kleine Präludien und Fughetten / Little Preludes and Fugues")]), _vm._v(". Several editions with this title are available with slightly different contents.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Bärenreiter (M. Töpel, A. Erényi—Br 5238 2002) 47pp. Contains: 6 Little Preludes (S.933–38); Little Preludes from the "), _c('i', [_vm._v("Notebook for Wilhelm Friedemann Bach")]), _vm._v(" (S.846a, 847, 851, 924a, 926–28, 930); Preludes and Fughettas from different traditions (S. 815a, 855a, 896, 899, 902/1a, 902/2, 961, 999). Urtext edition from "), _c('i', [_vm._v("Neue Bach-Ausgabe.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Henle (Steglich, Theopold—Henle 106). Contains: Little Preludes from the "), _c('i', [_vm._v("Notebook for Wilhelm Friedemann Bach")]), _vm._v(" (S.924–28, 930, 931); 6 Little Preludes (S.933–38, 999); Little Fugues and Prelude with Fugue (S. 895, 899, 900, 902, 902a, 952, 953, 961). Urtext edition.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("VU (Denhard—VU 1973). S.895, 899, 900, 902, 924–28, 930, 933–43, 952, 953, 961, 999. Edited from autograph and manuscript copies. Fingering added. Preface and critical notes in German and English.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Kleine Präludien / Little Preludes")]), _vm._v(" (H. Walter—Br&H 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I")]), _vm._v(" (13pp.): S.902a; 926–27; 934–35; 937. Provides a link between the easy dancelike movements of the notebook for Anna Magdalena Bach and the "), _c('i', [_vm._v("Two-Part Inventions")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II")]), _vm._v(" (13pp.): S.925; 928–29; 933; 936; 940–41.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. III")]), _vm._v(" (13 pp.): provides practice in hand independence. Excellent preparation for the "), _c('i', [_vm._v("Three-Part Inventions")]), _vm._v(" and the more difficult movements of the "), _c('i', [_vm._v("French Suites")]), _vm._v(". Ornaments are realized in footnotes. Fingered. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Dance Forms from the Suites")]), _vm._v(" (Anson—Willis). Thirteen dances from the Suites and Partitas. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Dances of J. S. Bach")]), _vm._v(" (M. Hinson—Alfred 600). These pieces are to be played before the "), _c('i', [_vm._v("Two-Part Inventions")]), _vm._v(". Includes allemandes, courantes, sarabandes, eighteen optional dances, and gigues. The foreword includes a discussion of the Bach suites, standard dance movements, optional dance movements, interpretation, table of ornaments, a suggested order for studying the keyboard works of Bach, and editorial policy. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Natalie Jenne and Meredith Little, “Bach's Dance Music,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 34/9 (November 1995): 21–23.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("———, "), _c('i', [_vm._v("Dance and the Music of J. S. Bach")]), _vm._v(" (Bloomington: Indiana University Press, 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bach Collection")]), _vm._v(" (Berlinger, Jonas—SB). Fifteen pieces, mainly from the suites, and one gigue by Telemann. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Various Short Preludes and Fugues")]), _vm._v(" (Bischoff—K 3104) 52pp. Contains eighteen Preludes, seven Fugues, and four Preludes and Fugues or Fughettas. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Young Bach")]), _vm._v(" (E. H. Davies—OUP). Twenty pieces from the two notebooks and five preparatory canonic studies. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The First Bach Book")]), _vm._v(" (Lipsky—K). Easier pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("An Introduction to the Performance of Bach")]), _vm._v(" (R. Tureck—OUP 1960). A graded series of three volumes on Bach performance. Contains both text and music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I")]), _vm._v(" discusses fingering, phrasing, dynamics, touch, pedaling, ornamentation, instruments (harpsichord, clavichord, piano), and a section on playing Bach on the piano. Eight pieces from the notebooks plus Tureck's realization of the Applicatio from the W. F. Bach notebook. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II")]), _vm._v(" has further notes on ornamentation, fingering, phrasing, practical uses of the sustaining pedal, and suggestions for the study of contrapuntal music, especially two-, three-, and four-part counterpoint. Music includes: Invention C (S.722) with its inversion; Fantasia g (S.917); Prelude and Fugue a (S.895). Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. III")]), _vm._v(" discusses manuscripts, editions, repeats, the Baroque dot, Bach's table of ornaments, and further questions of ornamentation. Music includes: Suite f (S.823); Suite A (S.824); Aria and Ten Variations in the Italian Style (S.989). A first-rate series by one of our foremost Bach interpreters. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bach verklärt")]), _vm._v(" (P. Cox—E. C. Schirmer). Includes numerous little-known pieces. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bach: Die kleinen Klavierstücke")]), _vm._v(" (Döflein—Br). Thirty-three pieces, mainly Little Preludes. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Leichte Klavierstücke")]), _vm._v(" (H.-J. Schulze—CFP 9412 1974) 59pp. Preface and critical notes in German and English. Forty-five pieces compiled from various keyboard works. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Young Pianist's Guide to J. S. Bach")]), _vm._v(" (Y. Novik—Studio PR 1976) 24pp. with recording. Eleven pieces, mostly from the "), _c('i', [_vm._v("Anna Magdelena Bach Notebook")]), _vm._v(". Well edited. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Young Pianist's Bach")]), _vm._v(" (H. Davies—OUP). Formerly titled “The Children's Bach.”")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Il Mio Primo Bach")]), _vm._v(" (Ric).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I")]), _vm._v(" (E. Pozzoli—Ric 1951) 13pp. Minuets G, g, c, d, G, a; Musette G (from the Gavotte, English Suite g); Musette D; Polonaise g; Marches D, G; Prelude g. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II")]), _vm._v(" (Riboli—Ric 1973). Contains eight of the eighteen Short Preludes, three Two-Part Inventions. Fingering provided is used to indicate phrasing, mainly by thumb repetition. A few suggestions are given in footnotes but no dynamics or phrasing are indicated. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Introduction to the Study of Bach")]), _vm._v(" (Mirovitch—GS 1955) 35pp. Contains a foreword, notes on interpretation, a Bach course of study (discussion of dance forms, the prelude, compositions in polyphonic form, the fugue, three-part inventions, English Suites and Partitas, Toccatas, "), _c('i', [_vm._v("The Well-Tempered Clavier")]), _vm._v("). Preparatory pieces by Hook, Zipoli, Chilcot, Kirnberger. Bach pieces include four Preludes and four movements from the French Suites. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bach Easy Piano")]), _vm._v(" (Alfred). Seventeen easier selections of Bach's most familiar music from the suites and the "), _c('i', [_vm._v("Anna Magdalena Bach Notebook")]), _vm._v(". Brief biography; notes concerning the style or origin of each piece; ornaments realized. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bach: Favorite Pieces")]), _vm._v(" (Alfred). Twenty-eight pieces with a few duplicates from the "), _c('i', [_vm._v("Bach Easy Pieces")]), _vm._v(" collection. Also includes more difficult works, such as three pieces from the "), _c('i', [_vm._v("Wilhelm Friedemann Bach Notebook")]), _vm._v(", four Two-Part Inventions, two Preludes and Fugues from WTC I, dances from the suites, and transcriptions. A short biography and notes about each piece add interest. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("J. S. Bach: An Introduction to His Keyboard Music")]), _vm._v(" (W. Palmer—Alfred 638 and 24456 2006). A varied selection of works with the usual fine introductory material providing a good understanding of the composer and his music. The second edition includes a CD recording. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Easier Piano Pieces")]), _vm._v(" (H. J. Schulze—CFP 9412). A selection of 45 easy to M-D pieces and movements, either original or transcribed by Bach. With details of sources and comments by the editor in English and German.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Das Bach: Klavierbuch")]), _vm._v(" (Wiehmayer—Heinrichshofen 20). Fifty easy pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("J. S. Bach")]), _vm._v(" (H. Duke—Freeman). In Keyboard Master Series. Prelude c (from 12 Short Preludes); Courante G; Two-Part Inventions F, a, d; Three-Part Invention E; G from Partita I; Air on the G String; Prelude C from WTC I. Fingering, pedaling, and phrasing are added. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("First Lessons in Bach")]), _vm._v(" (Carroll, Aldrich—Alfred 1977) 31pp. Many of the easier pieces. Aldrich has revised Carroll's original instructive comments from the earlier edition (GS). Phrasing, tempo indications, and dynamics are by Carroll. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("J. S. Bach: Easiest Piano Pieces")]), _vm._v(" (Steurer—CFP 5012 1980) 23pp. Eighteen short pieces plus a table of ornaments. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Very First Bach Studies")]), _vm._v(" (Teöke—EMB Z8865) 43pp. Thirty-six of the easiest pieces by Bach, some from the notebooks for Anna Magdelena Bach and Wilhelm Friedemann Bach. Well edited. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("18 Little Preludes")]), _vm._v(" (ABRSM) 36pp. Six Little Preludes from the "), _c('i', [_vm._v("Notebook for Wilhelm Friedemann Bach")]), _vm._v(" (S.924–928, 930); Six Little Preludes for Beginners (S.933–938); Six Little Preludes from Johann Kellner's Collection (S.939–943, 999). Highly edited. Int.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_c('i', [_vm._v("SHORT PRELUDES AND FUGUES")])]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("UNEDITED")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Little Preludes and Fugues")]), _vm._v(" (R. Steglich—Henle 106). Includes works from the "), _c('i', [_vm._v("Notebook for Wilhelm Friedemann Bach")]), _vm._v(". Contains: Preludes (S.895, 899, 900, 902a, 924–928, 930, 931, 933–943, 999) and Fugues/Fughettas (S.895, 899, 900, 902, 952, 953, 961).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Little Preludes and Fughettas")]), _vm._v(" (M. Töpel, A. Erényi—Br 5238 2002) 47pp. From "), _c('i', [_vm._v("Neue Ausgabe sämtliche Werke")]), _vm._v(". Includes: 6 Little Preludes (S.933–938); Little Preludes from the Notebook for W. Fr. Bach (S.846a, 847, 851, 924a, 926–928, 930); Preludes and Fughettas from Different Traditions (S.815a, 855a, 896, 902/1a, 2, 961, 999).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("["), _c('i', [_vm._v("24")]), _vm._v("] "), _c('i', [_vm._v("Little Preludes and Fugues")]), _vm._v(" (Keller—CFP 1958).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Little Preludes")]), _vm._v(" (E. Fischer—WH).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Little Preludes")]), _vm._v(" (Kreutz—Schott). S.924–930; 939–942; 999.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Little Preludes")]), _vm._v(" (Kreutz—Schott). S.933–938.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Little Preludes")]), _vm._v(" (Bischoff—K).")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDITED")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Little Preludes, Fughetta")]), _vm._v(" c, "), _c('i', [_vm._v("Four Duets")]), _vm._v(" (Busoni—Br&H).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("24 Little Preludes and Fugues")]), _vm._v(" (Czerny—CFP).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("24 Little Preludes and Fugues")]), _vm._v(" (Röntgen—UE).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Little Preludes")]), _vm._v(" (Anson—Willis).")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("ADDITIONAL BIBLIOGRAPHY")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Philip Adamson, "), _c('i', [_vm._v("Problems for the Pianist in the Performance of J. S. Bach")]), _vm._v(" (diss., Indiana University, 1976), 66pp. See especially the chapter on the differences between harpsichord and piano technique.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Putnam Aldrich, “Bach's Technique of Transposition and Improvised Ornamentation,” MQ 35 (January 1949): 26–35. One may not agree with all of Aldrich's findings but his scholarship is beyond question.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Eric Altschuler and Ira Braus, “Selecting Bach Tempos,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 47/4 (April 2008): 24–28.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sol Babitz, “On Using J. S. Bach's Keyboard Fingerings,” ML 43 (April 1962): 123–28. Includes a discussion of “notes inégales,” fingerings, ornamentation.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Paul Badura-Skoda, "), _c('i', [_vm._v("Interpreting Bach at the Keyboard")]), _vm._v(" (London: Oxford University Press, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("L. S. Barnard, “Philip Dore's Bach Clavier Lectures,” MO 76 (May 1953): 491–93, 557–59; continued in subsequent monthly issues through February 1954. Reports on a series of twenty lecture-recitals entitled “The Clavier Works of J. S. Bach.”")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("John Boe, “Fully Notated Articulation in Bach's Mature Keyboard Music,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 7/1 (January 1976): 12–19 and 7/2 (April 1976): 14–22. See response in George A. Kochevitsky, “From Our Readers: More on Articulation in J. S. Bach's Keyboard Music,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 8/1 (January 1977): 25–29.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("James Ching, “On the Playing of Bach's Clavier Music,” MT 91 (August 1950): 299–301.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Thurston Dart, “Bach's Early Keyboard Music: A Neglected Source,” AM 42/3–4 (1970): 236–38.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Edwin Fischer, "), _c('i', [_vm._v("Reflections on Music")]), _vm._v(" (London: Williams and Norgate, 1951). See chapter on Bach.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Maurice Hinson, "), _c('i', [_vm._v("The Pianist's Guide to Transcriptions, Arrangements, and Paraphrases")]), _vm._v(" (Bloomington: Indiana University Press, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Paul Johnson, “Tempo Relation in a Class of Keyboard Compositions from Sweelinck to Bach,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 18/4 (October 1987): 4–28.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Herbert Anton Kellner, “A Mathematical Approach Reconstituting J. S. Bach's Keyboard Temperament,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 30/1 (Spring–Summer 1999): 1–9.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("George A. Kochevitsky, “The Performance of J. S. Bach's Keyboard Music,” PQ 54 (Winter 1965–66).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("———, “Performing Bach's Keyboard Music,” a series of articles, each beginning with this title, in "), _c('i', [_vm._v("Bach:")]), _vm._v(" “The Choice of an Instrument,” 3/2 (April 1972); “Phrasing,” 3/4 (October 1972): 28–32; “Articulation,” 4/1 (January 1973): 21–25; “Tempo,” 4/2 (April 1973): 22–24; “Notes Inégales: A Brief History and A Summary,” 4/4 (October 1973): 27–36; “Embellishments, Part[s] I[-]IX,” 5/3 (July 1974): 37–40; 5/4 (October 1974): 25–30; 6/1 (January 1975): 24–35; 6/2 (April 1975): 27–40; 6/3 (July 1975): 20–35; 6/4 (October 1975): 23–29; “Dynamics, A Postscript,” 7/1 (January 1976): 3–11.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Wanda Landowska, "), _c('i', [_vm._v("Landowska on Music")]), _vm._v(", edited by Denise Restout (New York: Stein & Day, 1964).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Ray McIntyre, “On the Interpretation of Bach's Gigues,” MQ 51 (July 1965): 478–92.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("David Schulenberg, “Expression and Authenticity in the Harpsichord Music of J. S. Bach,” "), _c('i', [_vm._v("The Journal of Musicology")]), _vm._v(" 8/4 (Fall 1990): 449–76.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("———, "), _c('i', [_vm._v("The Keyboard Music of J. S. Bach")]), _vm._v(" (New York: Schirmer Books, 1992).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Liselotte Selbiger, “Bach on the Piano,” MR 11 (May 1950): 98–108.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Russell Stinson, “Clara Schumann's Bach Book: A Neglected Document of the Bach Revival,” "), _c('i', [_vm._v("Bach")]), _vm._v(" 39/1 (2008): 1–67.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Rosalyn Tureck, “Bach in the Twentieth Century,” MT 103 (February 1962): 92–94.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("———, “Bach: Piano, Harpsichord or Clavichord,” AMT 11 (January-February 1962): 8–9, 30.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("———, “Bach on the Piano? Why Not? After All, He Was a Piano Salesman,” HF 27 (October 1977): 91–93.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("———, “Learning to Learn Bach,” "), _c('i', [_vm._v("Etude")]), _vm._v(" (May–June 1956): 13–14, 48.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("———, “A Revaluation of Concepts in Relation to the Interpretation and Performance of Bach,” "), _c('i', [_vm._v("Bulletin of the British Institute of Recorded Sound")]), _vm._v(" 1957 (Autumn): 2–17.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Konrad Wolff, “Bach,” in "), _c('i', [_vm._v("Masters of the Keyboard, Enlarged Ed")]), _vm._v(". (Bloomington: Indiana University Press, 1990), pp.1–62.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("P. D. Q. Bach")]), _vm._v(" (1807–1742)?")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Teeny Preludes")]), _vm._v(" S.001 (TP) 6pp. 2 min. Three parodies after J. S. Bach's Short Preludes and Fugues. The first one keeps the treble part in one hand position and is most expressively played during muscle spasms or earthquakes. The other two draw from Barber Shop, Baroque, and Nashville. Twentieth-century Baroque style. Composed in Baden Baden during P. D. Q.'s “Contrition Period.” Clever, fun. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Notebook for Betty Sue Bach")]), _vm._v(", S. 13 going on 14 (TP 1973) 23pp. Allemande Left; Corrate; Oh! Courante!; Two-Part Contraption; Three-Part Contraption; Andre Gigue; Traumarie; Capriccio Espagnole for Charles III, “The Reign in Spain.” Written in P. D. Q. Bach's most gingerly style—great fun! Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("‘Goldbrick’ Variations")]), _vm._v(" S.14 1996 (TP) 11pp. ca.6 min. Var. I: Allegro boffo. Var. II: Lento pathetico. Var. III: Presto changio. Theme: Lento not so pathetico. Vintage P. D. Q. Bach. Great fun for all. Int. to MD.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Wilhelm Friedemann Bach")]), _vm._v(" (1710–1784) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The oldest son of J. S. Bach combined both contrapuntal and homophonic styles in his keyboard writing. His musical language is very expressive and represents the German “Empfindsamkeit” style so popular during this age of stylistic overlapping. His keyboard works consist of sonatas, fantasias, fugues, concerti, polonaises and short pieces. F. numbers refer to the thematic index by Martin Falck, "), _c('i', [_vm._v("W. F. Bach")]), _vm._v(" (Leipzig: Kahnt, 1913), the accepted catalog of this composer's works.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Wilhelm Friedemann Bach Gesammelte Werke")]), _vm._v(" (Collected Works) in 11 vols. (P. Wollny—Carus 2009–, distributed by the Packard Humanities Institute). This complete edition is being published by the Bach-Archiv, Leipzig, with the support of the Packard Humanities Institute. The first two vols. are devoted to solo keyboard works. Volumes are clothbound and contain a foreword, facsimile pages, and critical notes.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Vol. 1: Music for Keyboard I")]), _vm._v(" (Carus 32.001 2009) 179pp. Sonatas and Concerto for Harpsichord Solo, Concerto for Two Harpsichords (concertos are without orchestral accompaniment). Sonatas: C F.unsicher; C (2 versions, F.1A–B), C (F.2), D (F.3), D (F.4), E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (F.5), E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (F.unsicher), e (F.unsicher), F (F.unsicher), F (4 versions, F.6A-C, deest), G (F.7), A (F.8), B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (F.9). Concerto G (2 versions, F.40). Concerto for 2 Pianos F (F.10).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Vol. 2: Music for Keyboard II")]), _vm._v(" (Carus 32.002, in progress). Polonaises, Fugues and Fantasies for Harpsichord Solo; Shorter Works for One Keyboard Instrument; Works for Mechanical Instruments; Canons.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Nine Sonatas")]), _vm._v(" 1744–1754 (F. Blume—Nag; K). All in three movements, FSF. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I:")]), _vm._v(" Sonatas G (F.7), A (F.8), B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (F.9). Sonata G (F.7) is also in the collection "), _c('i', [_vm._v("The Bach Family")]), _vm._v(", edited by Geiringer (see Collections: German: Bach Family).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II:")]), _vm._v(" Sonatas D (F.3), D (F.4), E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (F.5). Sonata E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (F.5) is also in the Newman collection "), _c('i', [_vm._v("Sons of Bach")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. III:")]), _vm._v(" Sonatas C (F.1), C (F.2), F (F.6). The second and third movements of F.1 and F.2 were revised and appear in a Fantasia c of 1784.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Stuttgarter Bach-Ausgaben")]), _vm._v(" (P. Horn—Hänssler HE 32.201 1982, 32.202 1980) 2 vols.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("I")]), _vm._v(". 47pp.: Fantasia c, Sonatas C, G, B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("II")]), _vm._v(". 34pp.: 3 Sonatas.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Twelve Polonaises")]), _vm._v(" F.12 1765 (Bohnert, Schilde—Henle 485; CFP; Epstein—UE, Wührer—OBV; PWM; K, highly edited). C, c, D, d, E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", e"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", E, e, F, f, G, g. Arranged according to key; excellent examples of idealized dances, coupled with elements of sensitive “Empfindsamkeit” style. Varied moods. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Eight Fugues")]), _vm._v(" F.31 1778 (CFP).C, c, D, d, E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", e, B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", f. No.2 is in the collection "), _c('i', [_vm._v("Alte Meister")]), _vm._v(", No.4 in Vol.II of "), _c('i', [_vm._v("Harvard Anthology of Music")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Six Little Fugues")]), _vm._v(" (F. Koschinsky—NV).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Ten Fantasias")]), _vm._v(" 1778. Not all are available in performing editions. Fantasia C is No.31 in "), _c('i', [_vm._v("Organum")]), _vm._v(", Series V (K&S). Fantasia e is in the collection "), _c('i', [_vm._v("Alte Meister")]), _vm._v(", and a Fantasie e is in Georgii, "), _c('i', [_vm._v("400 Years of European Keyboard Music")]), _vm._v(" (see Collections).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Klavierfantasien")]), _vm._v(" (Schott 6122 1972). Nine fantasias that require much finger dexterity. Edited with preface in French, German, and English; playing instructions and critical notes (only in German) by Peter Schleuning. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Solo Concerto")]), _vm._v(" G (K&S, No.31 Series V, "), _c('i', [_vm._v("Organum")]), _vm._v("). In the same category as the "), _c('i', [_vm._v("Italian Concerto")]), _vm._v(" by J. S. Bach. Three movements, FSF. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Four Fantasias")]), _vm._v(" and a "), _c('i', [_vm._v("Suite")]), _vm._v(" are contained in Vol.X of "), _c('i', [_vm._v("Le Trésor des Pianistes. Ausgewählte Klavierwerke / Selected Keyboard Works")]), _vm._v(" (A. Böhnert, Schilde— Henle 452 1993) 69pp. Contains Suite g (F. 24); Sonata D (F. 3); Sonata E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (F. 5); Sonata D (F. 4); Fantasia a (F. 23); Fantasia c (F. 15). A mixed bag of thick polyphony with contrasting moods. Informative commentary in German, English, and French. Fingered. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Leichte Spielstücke")]), _vm._v(" (Hug 1971). Menuetto and Trio a; Allegretto B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v("; Bourrée b; Menuetto and Trio d; Larghetto F; Largo d; Polonaise d. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Peter Wollny, "), _c('i', [_vm._v("Studies in the Music of Wilhelm Friedemann Bach: Sources and Style")]), _vm._v(" (PhD diss., Harvard University, 1993), 637pp.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Sven-Erik Bäck")]), _vm._v(" (1919–1994) Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bäck studied with Hilding Rosenberg and Goffredo Petrassi. His music developed from a post-Nielsen style to a vital modern idiom. Bäck was fundamentally an intellectual with a strong feeling for mysticism.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata alla ricercare")]), _vm._v(" (WH 1950). Exuberant and humorous first movement.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Expansive Preludes")]), _vm._v(" (WH 1949). Three atonal pieces. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Agathe Bäcker-Grondahl")]), _vm._v(" (1847–1907) Norway")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Music")]), _vm._v(" (Da Capo 1982) 144pp. Introduction by Charles Slater. Includes many of the composer's favorite salon pieces as well as her more ambitious works: Ballade Op.36/5; Prelude Op.61/1; and Etudes de Concert Op.11/2, 6, Op.32/3, Op. 47/2. In the style of Schumann and Mendelssohn. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Song of Youth")]), _vm._v(" Op.45/1 (in "), _c('i', [_vm._v("At the Piano with Women Composers")]), _vm._v(", Alfred 428). Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Summer Song")]), _vm._v(" Op.45/3 (in "), _c('i', [_vm._v("At the Piano with Women Composers")]), _vm._v(", Alfred 428). M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Jane M. L. Iverson, "), _c('i', [_vm._v("Piano Music of Agathe Grandahl")]), _vm._v(" (diss., Greeley: University of Northern Colorado, 1993), 142pp.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Fridtjof Bäcker-Grondahl")]), _vm._v(" (1885–1959) Norway")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Tre Klaverstykker")]), _vm._v(" Op.20 (NMO 1943) 10pp. Fragrance; Petite Chanson Hereuse; Laengsel. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Dreaming")]), _vm._v(" Op.21 (NMO 1945). Thick harmonies, fast harmonic rhythm. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Scherzo")]), _vm._v(" Op.22 (NMO 1944) 11pp. “Printer's Error.” M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("All these pieces are written in a style similar to Grieg's.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Ernst Bacon")]), _vm._v(" (1898–1990) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Flight")]), _vm._v(" (Bo&H 1948). Rhumba rhythm, perpetual motion, virtuoso writing. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sombrero")]), _vm._v(" (in "), _c('i', [_vm._v("USA 1946")]), _vm._v(", MCA). Short, light, humorous, 5/8 meter. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Byways")]), _vm._v(" (GS). Twenty-four pieces based on folk tunes from various countries. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("My World")]), _vm._v(" (SB). Fourteen pieces, good introduction to contemporary sounds. Easy.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Maple Sugaring")]), _vm._v(" (GS). Arrangements of New England folk tunes. Easy.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Pig-Town Fling")]), _vm._v(". See Anthologies and Collections, USA, "), _c('i', [_vm._v("New Music for the Piano")]), _vm._v(" (LG). Fun for all. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Nicolas Bacri")]), _vm._v(" (1961– ) France")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bacri studied at the Paris Conservatory and was a recipient of the Prix de Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Cahier pour Éloi")]), _vm._v(" (Billaudot G7470B 2004) 8pp. 6½ min. Four youthful pieces: Pastorale; Romance; Sicilienne triste; Rondes enfantines. Uncomplicated structures, except occasional large span requirements. Cute childlike pieces. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata Corta")]), _vm._v(" Op.68 1978, rev.2003 (Billaudot 7700B 2005) 8pp. 6½ min. Opens with a Toccata in 5/8 meter at Allegro ruvido and becomes more defined as it passes through numerous meter changes and textures. A Choral of 1p. follows in 4/4 meter marked Lento raccogliato with quiet dynamics and sudden chordal shifts. The concluding March moves forward in distinctive rhythm to capture its title's implication. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("l'Enfance de l'art")]), _vm._v(" Op.69 (Billaudot G7627B 2004) 12pp. 10½ min. Seven youthful pieces composed in the late 1970s with some revision in 2001–03. Nocturne No.1; Valse; Nocturne No.2; Nocturne No.3; Improvisation No.1; Improvisation No.2; Nocturne No.4. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Prélude et Fugue")]), _vm._v(" Op.91 2004 (Leduc 2005) 6pp. 4½ min. Prelude commences Adagio declamato (Quasi andante) at "), _c('i', [_vm._v("ff")]), _vm._v(" for a strongly expressive and passionate movement in slow rhythmic values. Fugue continues in the same tempo, though with a quieter spirit at doubled note values in four voices. Canonic technique and strongly declamatory writing follows in this largely chromatic work for an intrepid finish at "), _c('i', [_vm._v("fff")]), _vm._v(" on the four lowest C's. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.nicolasbacri.net",
      "target": "_blank"
    }
  }, [_vm._v("www.nicolasbacri.net")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Tekla Badarzewska")]), _vm._v(" (1834–1860) Poland")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Composer of salon music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Maiden's Prayer")]), _vm._v(" 1851 (Schott Ed 7033 1982), published with her "), _c('i', [_vm._v("Das erhärte Gebet")]), _vm._v(", 25pp. Reprint. Composed when the composer was seventeen years old, this piece “unaccountably seized the imagination not only of inhibited virgins, but of sentimental amateur pianists all over the world” (BBD, 7th ed., 1984, p. 124). The composer wrote thirty-four more piano pieces in salon style, but none matched “A Maiden's Prayer.” Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Henk Badings")]), _vm._v(" (1907–1987) The Netherlands, born Java")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Badings studied mine geology and engineering at Delft Technical University and was essentially self-taught as a composer. He began a series of professorships in music in 1934 and held positions in several universities, composing over 600 works and winning numerous prizes.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata I")]), _vm._v(" (Schott 1934) 15½ min. Allegro: full of dissonant counterpoint. Largo: more lyrical. Scherzo presto; Finale—Vivace: highly motoric. Oriented toward the Brahms-Reger-Hindemith tradition. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatine")]), _vm._v(" 1936 (Schott 2576 1937) 8pp. Allegro: cheerful, accentuated melody. Andante: motivic phrasing with ascending motion. Allegro vivace: playful without complication though occasional odd fingering required. Must be able to reach ninth. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Arcadia VII")]), _vm._v(" (Schott 1945) 3 vols. Ten short mildly twentieth-century pieces in each volume. Attractive. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Paul Badura-Skoda")]), _vm._v(" (1927– ) Austria")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Élégie")]), _vm._v(" (Leduc 1982) 5pp. 6 min. Expressive, dramatic opening, filmy midsection with a theme floating ethereally over a silent forearm cluster. Tranquillo denouement settles on a C"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v("-major chord. Dissonant, freely tonal style with strong French influences, many expressionistic clichés. Half-pedals, harmonics, surging octave runs, large chords. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Raymond Baervoets")]), _vm._v(" (1930–1989) Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Hommage à Serge Prokofieff")]), _vm._v(" 1958 (Metropolis) 7pp. Secco style, strongly rhythmic, “tongue-in-cheek” melodic treatment, mildly dissonant. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Invensioni")]), _vm._v(" 1964 (CeBeDeM) 26pp. 12 min. Six pieces. Pointillistic writing, wide dynamic range. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatine")]), _vm._v(" 1958 (Metropolis) 6pp. 5 min. Three movements with the finale, a toccata, the most successful. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Junsang Bahk")]), _vm._v(" (1937– ) Korea")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Mark")]), _vm._v(" (Litolff 1971) 10pp. Extensive explanation. Palm and forearm glissandi, clusters, trills, rolled chords, Stockhausen-inspired, rhythmically dull. Avant-garde. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("William Baines")]), _vm._v(" (1899–1922) England")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In his short life, this little-known Yorkshire composer wrote some unusual and evocative music, skillfully set for the piano.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Coloured Leaves")]), _vm._v(" (Augener). Prelude; Valse; Still Days; Purple Heights. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Four Poems")]), _vm._v(" (Augener). Poem-fragment; Elves; Poem-nocturne; Appassionata. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Pictures of Light")]), _vm._v(" (Elkin). Drift-Light: right-hand ostinato, moving tune in left hand. Bursting Flames: octaves moving over keyboard. Pool-Lights: chromatic. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Seven Preludes")]), _vm._v(" (Elkin). Varied moods, charming. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Silverpoints")]), _vm._v(" (Elkin). Labyrinth: right hand has accompaniment against sweeping left-hand figuration. Water Pearles. The Burning Joss Stick. Floralia. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Twilight Pieces")]), _vm._v(" (Elkin). Twilight Woods; Quietude; A Pause for Thought. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Peter J. Pirie, “William Baines,” M&M 21 (November 1972): 36–40.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Tadeusz Baird")]), _vm._v(" (1928–1981) Poland")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina")]), _vm._v(" 1949 (M. Miśków—PWM 1997) 14pp. Vivo e scherzando; Andantino; Con molto con moto (quasi presto). A lively work accessible in spirit and character to all. The publisher notes that “the Sonatina can be played only by the people in a very good humour.”")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Little Suite for Children")]), _vm._v(" (PWM 1952) 8pp. 5½ min. Four short mildly twentieth-century movements. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina No.2")]), _vm._v(" (PWM 1952) 18pp. 12 min. In three movements. Vivo e giocoso: changing tempi and mood; restless; moves into an improvisatory andante. Andante molto e calmato: peaceful, tranquil, overtones used. Finale: full of drive and vitality; final chords played with massive force. Strong folksong influences. Style is reminiscent of early Lutoslawski. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Alistair Wightman, “Tadeusz Baird at 50,” MT 1627 (October 1978): 847–50.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("David A. Baker")]), _vm._v(" (1949– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Five Pieces: Igor Stravinsky—In Memoriam")]), _vm._v(" (CAP 1972) 15pp. No titles, only tempo indications. Neoclassic style, each piece has well-developed ideas. Closest in style to Stravinsky "), _c('i', [_vm._v("Sonata")]), _vm._v(". M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("David N. Baker")]), _vm._v(" (1931– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Baker's style is distinctive for its blending of Afro-American elements with traditional European techniques and forms. It draws on jazz, serialism, electronic techniques, gospel, and folk materials. Baker teaches at Indiana University.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.1")]), _vm._v(" 1969 (MMB) 37pp. Black Art; A Song—after Paul Lawrence Dunbar; Coltrane. Freely tonal, flexible meters, jazz influence, energetic octotonic writing, syncopation. “Coltrane” is toccata-like. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Jazz Dance Suite")]), _vm._v(" 1989 (Norruth Music) 32pp. 21 min. Facsimile of manuscript. 1. Some sort of waltz; 2. Solo Dance; 3. The Jitterbug Boogie; 4. Double Dance. Jazz idioms handled artistically throughout. Effective performance requires jazz experience. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Michael Baker")]), _vm._v(" (1941– ) Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Four Piano Pieces")]), _vm._v(" Op.22 (F. Harris). Four untitled atonal and contrasting mildly twentieth-century works that show a fine craft. Dissonant, demanding, some three-stave writing. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" Op.31 (Harris 1977) 20pp. 15 min. In one movement. Vigorous cadenza opening (returns later), freely tonal figuration, cluster-like sonorities, Larghetto chorale-like section, enormous coda. Thoroughly contemporary. Requires dextrous fingers. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.michaelconwaybaker.com",
      "target": "_blank"
    }
  }, [_vm._v("www.michaelconwaybaker.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Robert Baksa")]), _vm._v(" (1938– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A prolific composer of over 500 works, Baksa is of Hungarian heritage and has composed for many instrumental and vocal combinations.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Six New Bagatelles")]), _vm._v(" 1985–89 (Composer Library Editions/TP 1997) 35pp. Live; Smoothly, not too fast; With puckish good humor; Langorous; Quite fast; Very fast. Challenging, exuberant character pieces bound to be attractive for performer and audience alike. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Sonata")]), _vm._v(" 1997 (Composers Library Editions CLE-90 1998) 23pp. 12 min. Smoothly; Andante espressivo; Lively and crisply. Lyrical and tonal writing more commonly found at the beginning rather than the end of the twentieth century. “Modest in scope…it relies heavily on Classical and Baroque models in each of its three movements. The outer movements both present a sequence of motivic ideas which are varied in the repeats. The central movement is songlike with a contrasting central portion which remains a part of the texture when the opening idea returns” (from preface). Influenced by Hindemith, a composer Baksa admires. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Eight More Bagatelles")]), _vm._v(" 1988–2000 (Composer Library Editions CLE-121 2002) 38pp. 20 min. Presto; Smoothly, flexible; Tipsy march; Impetuous waltz; Leisurely; Brightly; Freely, misty; Lively, raucous. Attractive and tonally centered with few expression indications, allowing the performer room for musical imagination. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.robertbaksa.com",
      "target": "_blank"
    }
  }, [_vm._v("www.robertbaksa.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Leonardo Balada")]), _vm._v(" (1933– ) Spain")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A native of Catalonia, Balada teaches at Carnegie-Mellon University in Pittsburgh.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Música en Cuatro Tiempos")]), _vm._v(" 1959 (Gen 1967) 8 min. Lento: one page, quiet mood builds to climax. Energico: changing meters, vigorous, fist and forearm clusters. Scherzando: eighth notes in continuous motion, changing meters. Tiempos variados: expressive; cross-rhythms; accents; ends fast; climactic closing. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Transparency of Chopin's First Ballade")]), _vm._v(" 1976–77 (GS 3366 1982) 12pp. 10 min. A free fantasy based on the Chopin work using clusters, unbarred passages, and harmonics. A few fragments of the Chopin, tucked in here and there, are usually well concealed. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Persistencies")]), _vm._v(" 1979 (GS 1978) 20pp. 8½ min. An energetic exposition launches this strikingly effective movement. Strong syncopated lines gradually expand to clusters through persistent rhythmic patterns. Highly percussive. Some relief is provided through a Poco più mosso section; palm clusters end work; opening motive repeated. D")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Preludis Obstinants")]), _vm._v(" 1979 (GS 48508 1983) 12pp. 9 min. Five contrasting sections. Many tremolo chords between the hands, parallel chromatic scales in minor seconds between the hands, evolving patterns, chorale-like passages, arpeggiated chords (slower at every repetition), many contrasting sonorities. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Mily Balakirev")]), _vm._v(" (1837–1910) Russia")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Balakirev was the guiding spirit behind the Russian group known as “The Five.” He was a competent pianist but could never perform his own "), _c('i', [_vm._v("Islamey")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Complete Piano Works")]), _vm._v(" (Sorokin—USSR) 3 vols. Vols. I and III contain two books each. Vol. III, Book 2, contains the two-piano works. See entry below for contents.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Ausgewählte Klavierstücke / Selected Piano Works")]), _vm._v(" (C. Ruger—CFP P 9576a 1977).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I")]), _vm._v(" (CFP P 9576a) 97pp. Selected piano works including Polka; Nocturne II; Mazurkas 1–3; Waltzes 4, 6; Scherzo II; Lullaby; Toccata. Epilogue in German and English. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II")]), _vm._v(" (CFP P 9576b). A representative survey of Balakirev's piano music from his early Chopinesque genres to his program music. Includes remarks on the composer and the works. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Lark")]), _vm._v(" (Musica Obscura; GS). Arrangement of a Glinka song. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Islamey")]), _vm._v(" 1869 (N. Gertsch—Henle 793 2004; C. Rüger—CFP; Simrock; CF; Montes—Ric). The main theme is a tune Balakirev picked up on his travels in the Caucasus. He combined it with a Tartar melody and wove these materials into a rich pianistic fabric. It is his most famous work for piano and is based on Lisztian technique. A forbidding peak in the repertoire; accessible only to the most intrepid. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Nocturne No.3")]), _vm._v(" d (Zimmermann). Outer sections are pastoral and lyrical while the midsection is dramatic. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" b"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (Zimmermann; Musica Obscura) 34pp. In four movements: Andante, Allegro assai feroce, Maestoso; Mazurka; Intermezzo; Finale. Reached final form after two revisions in 1905. Suite-like; unified. In Liszt tradition. Exploits percussive possibilities of the piano. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Gerald Abraham, “A Remarkable Piano Sonata,” "), _c('i', [_vm._v("Sackbut")]), _vm._v(" 11 (1931): 330–34.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("SSB, pp.728–29.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Waltz")]), _vm._v(" f"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(" (Zimmermann). Elegant writing, pianistic, more a fantasy than a piece for dancing. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Scherzo No.1")]), _vm._v(" b 1856 (Zimmermann). A rather weak imitation of Chopin's Scherzo b; chromatic, octaves, meandering themes. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Scherzo No.2")]), _vm._v(" b"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" 1900 (Zimmermann; Music Obscura). One of Balakirev's finest works; pianistically superb. Much easier than Islamey. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Scherzo No.3")]), _vm._v(" F"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(" 1901 (Zimmerman). Not as powerful as No.2 but charming, captivating and effective. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Balakirev Album")]), _vm._v(" (EMB Z.13 774 1990) 40pp. Polka: based on one melody, innocent charm, attractive coda. Mazurka I A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" includes some slight changes in a later version. Mazurka II c"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(": second verson. Lullaby D"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" beautiful and effective, prefaced by story, bell-like butterfly (from the story), coda. Sixth Waltz f"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(" : light, uneven in quality. Sonatina G: three movements, weak. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Complete Piano Works")]), _vm._v(" contains, in addition to the works listed above, Esquisses (Sonatina); Fantasiestück D"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Humoresque b; 7 Mazurkas A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" c"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", b, G"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" D, A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", e"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v("; 3 Nocturnes b"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" b, d; Novelette; Polka; Reverie; Scherzi b, b"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" F"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v("; Tarantella B; Toccata C"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v("; Tyrolienne; Waltzes, G, F, b, B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", D"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" f"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(", g"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(". The Tarantella is a perpetual-motion study and makes high virtuosic demands on the performer. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Selected Piano Works")]), _vm._v(" (Roshchinoi—GS 8064).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Vera Breheda, "), _c('i', [_vm._v("The Original Solo Piano Works of Mili Balakirev")]), _vm._v(" (thesis, University of Washington, 1983).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Edward Garden, "), _c('i', [_vm._v("Balakirev: A Critical Study of His Life and Music")]), _vm._v(" (New York: St. Martin's Press, 1968). An unannotated catalog of works (pp.330–39) and a large bibliography (pp.321–25) are of special interest.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Claude Balbastre")]), _vm._v(" (1729–1799) France")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Pièces de clavecin, d'orgue et de fortepiano")]), _vm._v(" (A. Curtis—Heugel) 93pp. Eighteen pieces including sonatas, sonatinas, overtures, and studies. Demonstrates a vigorous and brilliant style; Italian influence shows transition from harpsichord to pianoforte composition. The “Marche des Marseillois et l'air ‘Ça ira’” is an exciting battle piece. Excellent descriptive notes. Questionable editorial policy. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Livre de Noëls")]), _vm._v(" (Schola Cantorum et Procure Generale) restitution J. Bonfils. 3 vols. Preface in French, two facsimiles. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Noël with Variations")]), _vm._v(" (J. Ohl—SB). Serves as excellent preparation for the Haydn or Mozart easier sets of variations. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Gerald Bales")]), _vm._v(" (1919–2002) Canada")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Toccata")]), _vm._v(" (BMI Canada 1947). Tempo and texture changes, contemporary recital piece. Solid technical equipment necessary. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Louis W. Ballard")]), _vm._v(" (1931–2007) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ballard, who was of Cherokee and Quapaw extraction, used Indian folk music and traditions for inspiration in a number of his compositions.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("American Indian Piano Preludes")]), _vm._v(" (New Southwest Music Publications, P. O. Box 4552, Santa Fe, NM 87502). Six pieces with Indian influence that gently permeates each piece, though not obvious. Well written. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("A City of Fire")]), _vm._v(" (New Southwest Music Publications). Dedicated to the people of Los Alamos, New Mexico, “where the fire of nuclear energy was released and exists in our society as a sort of ‘sacred fire.’” Begins with a plaintive and maestoso introduction after which a rhythmical, somewhat whimsical, section suggests the innocence of spirit prior to “the discovery.” Tonal sections segue into tonal episodes, which by their disjunctive natures are intended to suggest the impending torment associated with those people who felt the impact of atomic fire. Moves onward relentlessly, with persistent rhythmic impulse. Double octaves and disjunctive leaps suggest spiritual upheaval. Ends with a musical question mark—where do we go from here? D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Claude Ballif")]), _vm._v(" (1924–2004) France")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Cinquième Sonate")]), _vm._v(" Op.32 (Choudens 1975) 32pp. One extended dramatic movement in contrasting sections. Serial, linear, arpeggi figuration, dynamic extremes, pointillistic, harmonics, proportional rhythmic relationships, low-register "), _c('i', [_vm._v("ppp")]), _vm._v(" tremolo, varied tempi and moods, many ritards, expressionistic and intense. The color, character, and structure of this work are apparent. Contains characteristics similar to those of the Boulez sonatas. Requires mature pianism and large span. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Esther Williamson Ballou")]), _vm._v(" (1915–1973) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" (ACA 1955) 11 min. In three movements. Allegro quasi fantasia: effective use of trill, melodic sevenths, complete range of keyboard, harmonics. Andante sostenuto: bitonal. Chorale Variations: chorale in unison five octaves apart; four variations. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Variations, Scherzo and Fugue on a Theme by Lou Harrison")]), _vm._v(" (ACA 1959) 12 min. Four variations on a two-part theme; each variation well defined. Scherzo: exploits percussive effects; plaintive trio using ostinato-like effect before Scherzo idea returns; good octave technique required. Fugue: excitingly worked out; leads to frenetic climax. Ballou's second sonata; a large work. Ballou knew the capabilities of the piano thoroughly. Requires mature pianism. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Ernö Balogh")]), _vm._v(" (1897–1989) USA, born Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Balogh studied with Bartók and Kodály at the Budapest Conservatory. He moved to the U.S. in 1924 and lived both in New York City and Baltimore, teaching in the latter at Peabody Institute.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Conversation")]), _vm._v(" (Bo&H 1966) 2pp. In treble clef only, imitation. Easy.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Debate")]), _vm._v(" (Bo&H 1968) 3pp. Right hand on black keys, left hand mainly on white keys. Thin textures. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Reel")]), _vm._v(" (Bo&H 1966) 2pp. All in treble clef, clever rhythmic combinations of 6/8 meter. Easy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Oyo Bankole")]), _vm._v(" (1935–1976) Nigeria")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Of Yoruba heritage, Bankole had his early musical training in Lagos, followed by study in London and at UCLA.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Nigerian Suite")]), _vm._v(" (Chappell 1961) 11pp. Forest Rains; Ó Yá K'á Konga!; Orin Fún Òsùmàrè (Music for the Rainbow); October Winds; Warriors March. Contrasting, colorful, appealing. Unusual sonorities. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Don Banks")]), _vm._v(" (1923–1980) Australia")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Pezzo Drammatico")]), _vm._v(" 1956 (in "), _c('i', [_vm._v("Contemporary British Piano Music")]), _vm._v(", Schott) 5 min. Three-part form, twelve-tone. Mood is established by ranges in dynamics, modes of attack, coloristic devices, and strong rhythmic vitality. Last two bars give retrograde of opening statement. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Harald Banter")]), _vm._v(" (1930– ) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Banter's interests span jazz and contemporary composition, having begun his career as a sound engineer in radio broadcasting.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Naître et Disparaître / Werden und Vergehen")]), _vm._v(" (Hofmeister FH 3353 2010) 22pp. Homage to Scriabin. In one movement, beginning and ending slowly with interior sections designed to suggest “the progress of a creation process” (from preface). Philosophically twisting and turning as if a cosmic event. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Francisco Xavier Baptista")]), _vm._v(" (?-1797) Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("12 Sonatas para Cravo")]), _vm._v(" ca.1770 (Gulbenkian 1981) 75pp. Contrasting works of one, two, or three movements. Similar in style to Soler. Interesting music that deserves investigation. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("George Barati")]), _vm._v(" (1913–1996) USA, born Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("2 Piano Pieces")]), _vm._v(" (ACA 1948). Andantino: tonal, ABA, accompanied melody, succulent sonorities. Andante: harmonic preference for seconds, sevenths, and ninths; piquant sonorities; builds to climax, then ends mezzo forte. Small tone-poems. Rather diffuse in style but effective. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Samuel Barber")]), _vm._v(" (1910–1981) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Barber's accessible idiom was based on a lyrical, Neoclassical style. He used a broad spectrum of color in writing for both solo instruments and orchestra.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Complete Piano Music")]), _vm._v(" (GS 3453 1984) 116pp. Includes the works discussed below (except Love Song), as well as “A Personal Note” about Barber by Paul Wittke. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Early Piano Works")]), _vm._v(" (GS 4430 2010) 88pp. Compositions dating between 1917–1932, from the ages of seven to twenty-two. Includes Themes; Petite Berceuse; Three Sketches; Fantasie for Two Pianos; Prelude to a Tragic Drama; Fresh from West Chester (Some Jazzings); To Aunt Maime on Her Birthday; Essay I, II, III; Interlude I, II; and manuscript facsimiles of childhood compositions (Sadness, Melody in F, Largo, War Song, At Twilight, Lullaby). Only Three Sketches and Interlude I have previously been published. Int. to MD.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Love Song")]), _vm._v(" 1924 (Alfred 4628; also in "), _c('i', [_vm._v("Masters of American Piano Music")]), _vm._v(") 1p. Flows gracefully, strong melody, an American “Song Without Words.” Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Excursions")]), _vm._v(" (GS 1944) 22pp. Un poco allegro: boogie-woogie style. In slow blues tempo. Allegretto: western song with variations over ostinato harmonies. Allegro molto: square dance. Barber writes, “These are ‘Excursions’ in small classical forms into regional American idioms. Their rhythmic characteristics, as well as their source in folk material and their scoring, reminiscent of local instruments, are easily recognized.” M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonate")]), _vm._v(" e"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.26 (GS 1949) 20 min. In four movements. Allegro energico: energetic, rhythmic vitality. Allegro vivace e leggiero: quick waltz vacillating between double and triple meter (hemiola). Adagio mesto: impressive ostinato treatment involving use of all twelve tones in a unique way; Allegro con spirito: demanding four-voice fugue; dissonant; chromatic; complex counterpoint but all set within a clearly articulated tonal framework. One of the most important piano sonatas of the twentieth century. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Hans Tischler, “Barber's Piano Sonata, Opus 26,” ML 33 (1952): 352–54.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Souvenirs")]), _vm._v(" 1952 (GS) 17½ min. Originally for piano duet; solo version by the composer. Light, evokes ballroom music around the time of World War I. Elements of the tango and the waltz sometimes collide with Prokofieff-like harmonic twists. An exploration of dance forms that is thoroughly delightful and charming; subtle humor. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Nocturne")]), _vm._v(" A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.33 1959 (GS). 5 min. Inscribed “Homage to John Field.” Some reference to the Field Nocturne e, No.10. A flexible rhythmic pattern is combined with a nineteenth-century melody and twentieth-century harmonies. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Ballade")]), _vm._v(" Op.46 1977 (GS) 6pp. Written for the fifth Cliburn competition. Large ABA design, rich chordal sonorities, cadenza-like passages. Builds to enormous climax with octaves in alternating hands; colorful and effective; "), _c('i', [_vm._v("pp")]), _vm._v(" closing. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Susan Blinderman Carter, "), _c('i', [_vm._v("The Piano Music of Samuel Barber")]), _vm._v(" (PhD diss., Texas Tech University, 1980), 193pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Philip Clark and Leon McCawley, “The Reluctant American,” "), _c('i', [_vm._v("International Piano/4")]), _vm._v(" (November/December 2010): 56–59. A tribute to the Barber centenary and his piano music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("James P. Fairleigh, “Serialism in Barber's Solo Piano Music,” PQ 72 (Summer 1970): 13–17.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Russell E. Friedewald, "), _c('i', [_vm._v("A Formal and Stylistic Analysis of the Published Music of Samuel Barber")]), _vm._v(" (diss., University of Iowa, 1957).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Ramón Barce")]), _vm._v(" (1928–2008) Spain")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Estudio de Densidades")]), _vm._v(" (Editorial de Música Española Contemporánea 1974) 10pp. A study in densities. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Woldemar Bargiel")]), _vm._v(" (1828–1897) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bargiel was Clara Schumann's stepbrother. Stylistically, his works are related to those of the circle around Schumann, Brahms, and Joseph Joachim.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Drei Charakterstücke")]), _vm._v(" Op.8 1853 (Br&H EB8159 ca.1995). Dedicated to his sister, Clara Schumann. Allegro appassionato: agitated and exciting. Lento: contrasting moods. Allegro con fuoco: rambunctious but satisifying. Robert Schumann thought highly of these pieces. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Jan Bark")]), _vm._v(" (1934– ) Sweden")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bark began his musical career as a jazz trombonist. His attitude toward composing is colored by his experiences in jazz, especially with regard to the improvisatory character of the music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" (NMS 1957). In four short movements. Atonal writing with strong tonal final cadence. Economic use of material, clear style. A misprint at opening of second movement: bass clef should obviously be a treble clef. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Elaine Barkin")]), _vm._v(" (1932– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Six Piano Pieces")]), _vm._v(" (ACA 1969) 11pp. Short, flexible meters, pointillistic, extreme ranges exploited, expressionistic, rhythmic proportional relationships, percussive treatment, atonal, serial. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("David Barlow")]), _vm._v(" (1927–1975) England")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Genesis")]), _vm._v(" (Nov 1953) 4 min. A short fantasy in four contrasting sections built on a basic motif of four ascending notes. Somber contrapuntal writing, neo-Romantic style. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Elsa Barraine")]), _vm._v(" (1910–1999) France")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Barraine remained a Romantic throughout her career.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fantaisie pour clavecin ou piano")]), _vm._v(" (EMT 1961) 11pp. Neoclassic writing in one movement with contrasting sections. A piano addendum is included for certain passages. Effective on the piano; lean textures. Romantic characteristics. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Hommage à Paul Dukas")]), _vm._v(" 1936 (in "), _c('i', [_vm._v("Le Tombeau de Paul Dukas, La Revue Musicale")]), _vm._v(" 166 [May–June 1936]), 2pp. Simple right-hand tune over left-hand accompaniment. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Jean Barraqué")]), _vm._v(" (1928–1973) France")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A student of Langlais and Messiaen, Barraqué developed a unique modification of twelve-tone technique. Certain elements of tonal and atonal writing are highly synthesized in his writing.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonate")]), _vm._v(" 1950–52 (Margun/Gunmar). A forty-minute work of enormous dimensions. In two large parts to be played without interruption. The composer warns in his preface that too fast a tempo will mar the clarity of the polyphony. Extreme organization of material: rhythm, melody, and dynamics. Silence is an integral part of the form. Goléa (see below) has described this work as “one of the most important works for piano in recent French music alongside the sonatas of Boulez.” Few pianists will be able to handle this work successfully. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Antoine Goléa, “French Music Since 1945,” MQ 51 (January 1965): 22–37.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Andre Hodeir, "), _c('i', [_vm._v("Since Debussy: A View of Contemporary Music")]), _vm._v(" (New York: Grove, 1961). See pp.193–96 for a fine discussion of this work.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("G. W. Hopkins, “Jean Barraqué,” MT 107 (November 1966): 952–54.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Carol Barratt")]), _vm._v(" (1945– ) United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("At the Piano: Homage to Bartók")]), _vm._v(" (Bo&H 2007) 27pp. Twenty-one short pieces for children and adults, each based on specific pieces for piano by Bartók. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Henri Barraud")]), _vm._v(" (1900–1997) France")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Technically, Barraud was an eclectic. His originality lies in the expressive content of his music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Impromptus")]), _vm._v(" (Amphion). Souple et Calme: short, chordal. Rapide: long melodic line with flowing eighths as substructure. Lent et Grave: quiet opening, contrasting sections, large climax, quiet close. Modéré: short, melody in tenor. Sans trainer: bass ostinato rhythms, dirge-like. Cursif: two voices. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Histoires pour les Enfants")]), _vm._v(" (Durand 1930). Four simple pieces. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Premiers Pas")]), _vm._v(" (ESC). Five pieces for young people. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Richard Barrett")]), _vm._v(" (1959– ) Wales")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Invention 6")]), _vm._v(" 1982 (UMP 1985) 8pp. Tremendously complicated writing, much use of proportional rhythmic relationships, difficult to make much sense of the musicality of the piece. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Joaquim Antônio Barroso Neto")]), _vm._v(" (1881–1941) Brazil")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A native of Rio de Janeiro, Barroso Neto taught piano at the Instituto Nacional de Música, where he had been a student under Braga and Nepomuceno. He composed numerous piano works for both educational and concert purposes. His style represents a blend of nineteenth-century principles and national interests.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Cantilena")]), _vm._v(" (Carlos Wehrs) 2pp. Simple but charming melody cast over oompahs in ternary form as if it is a gentle waltz. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Canto do Marujo")]), _vm._v(" (Napoleão 1957) 2pp. Marked Vagarosamente, this quiet dancelike work is propelled by an ostinato and sings in a longingly in minor mode. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fuga")]), _vm._v(" d (Vitale 1965) 3pp. Three-voice fugue at Vivo. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Melodia")]), _vm._v(" d (Bevilacqua/Mangione 1910) 2pp. A simple melody supported by broken chords at Lento. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Minha Terra")]), _vm._v(" (Ric BR 1929) 4pp. Lively and rhythmic with colorful harmony. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Improviso")]), _vm._v(" (Vitale 1940) 4pp. Influenced by mid-nineteenth-century compositional practices with ternary form at Muito vivo in 6/8 meter. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Primeira Gavota")]), _vm._v(" (Vitale 1940) 3pp. Playful Romanticism with Brazilian flavor. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Pequena Valsa")]), _vm._v(" (Napoleão 1960) 4pp. Valse Mignonne. Lighthearted and free with expressive possibilities. Dedicated to Isidor Philipp. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("2.A Valsa Capricho")]), _vm._v(" (Bevilacqua/Mangione 1910) 7pp. Marked Tempo de valsa brilhante, the capricious character permeates with a serious tone and sinister effect. Contrasting sections relieve the intensity of the waltz proper. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Gerald Barry")]), _vm._v(" (1952– ) Ireland")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Triorchic Blues")]), _vm._v(" 1991 (OUP) 8pp. “This piece should be played with great rhythmic drive and a generally detached and punchy articulation. Use of the pedal should always be absolutely clean and should never blur the harmonies. The title refers to the castrato Ferdinando Tenducci, who was reputedly triorchic” (from the score). Thin textures, changing meters, persistent throughout. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sur les Pointes")]), _vm._v(" (OUP 1988) 18pp. 13 min. Up to page four may be performed on any keyboard instrument with the correct range. Contrasting sonorities; full chords, many octaves; last section is entitled “Like a mad pianola.” The title is a ballet term describing the raising of the body on the tips of the toes. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Cecilia Maria Barthélemon")]), _vm._v(" (1767–1859) England")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Barthélemon was considered one of London's outstanding musicians.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Sonatas")]), _vm._v(" (Harbach—Vivace) 56pp. Multimovement works, late classical style. Rich harmonies and good sense of form. Op.1/1 C; Op.1/3 E; Op. 3 G. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.3")]), _vm._v(" E Op.1/3 (F. Zimmermann—Tonger 2851 2000) 16pp. Allegro con spirito; Larghetto; Rondo. Preface by I. H. Helmke in German. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" G Op.3 (F. Zimmermann—Tonger 3131 2003) 12pp. Allegro vivace; Adagio; Rondo alla Hornpipe. Preface by editor in German. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Béla Bartók")]), _vm._v(" (1881–1945) Hungary")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bartók was one of the half-dozen major composers of the twentieth century. He was a marvelous pianist, and his piano works mirror this great talent. His early works are derivative of both Debussy and Richard Strauss. In late 1904, Bartók began to explore Hungarian folk music and eventually published nearly 2,000 folk tunes collected in his research. He developed a compositional style using rhythmic, melodic, and harmonic patterns from these native tunes. His piano works can be roughly divided into three periods: early (1907–1917), in which the music is clearly tied to folk materials; middle (1918–1935), which shows Bartók at his most dissonant and rhythmically explosive style; and late (1936–1945), in which he is more mellow, the music more spiritual and sublime. When studying Bartók's piano music, three aspects must be taken into account: his belonging to the Hungarian people, his authentically revolutionary spirit, and his own piano technique. The first two aspects are largely responsible for his highly original approach to the instrument, which, in turn, allowed him to give concrete shape to the ideas germinating in his mind. Bartók recorded about a dozen long-playing records of his own works, which are of inestimable value when studying his music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("In addition to the publishers listed below, Bo&H has published all of Bartók's piano music, though the early works were initially published by smaller Hungarian publishers and the mid-career works by UE. The designations “Dover I” and “Dover II” refer to respective parts of a two-volume set. Peter Bartók, along with the assistance of others, began preparing corrected editions of his father's works in the late 1980s through Bartók Records ("), _c('i', [_vm._v("see")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.bartokrecords.com",
      "target": "_blank"
    }
  }, [_vm._v("www.bartokrecords.com")]), _vm._v(") with corrections based upon information in family archives, manuscripts, and corrected copies elsewhere. These editions are highly recommended.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("4 Pieces")]), _vm._v(" 1905 (Bo&H; K; Dover I; EMB). Study for the Left Hand: sonata-rondo. First Phantasy: wistful. Second Phantasy. Scherzo: zestful. All show harmonic experimentation. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Rhapsody")]), _vm._v(" Op.1 1904 (Bo&H; Dover I; MMP). Later arranged for piano and orchestra. In the style of Liszt. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Colin Mason, “Bartók's Rhapsodies,” ML 30 (1949): 26–36.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("3 Popular Hungarian Songs")]), _vm._v(" 1907 (Bo&H; K). Simple treatment of the tunes. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("14 Bagatelles")]), _vm._v(" Op.6 1908 (EMB Z934, corrected ed.; Bo&H; K; Dover I). Short, original treatment of sonorous materials; require quick changes in tempo, articulation, dynamics, and dramatic gestures. Only the last two have titles: “Elle est Morte” and “Valse. Ma mie qui dance.” Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Elliott Antokoletz, “The Musical Language of Bartók's "), _c('i', [_vm._v("14 Bagatelles")]), _vm._v(" for Piano,” "), _c('i', [_vm._v("Tempo")]), _vm._v(" 137 (June 1981): 8–16.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Anne Victoria Fischer, "), _c('i', [_vm._v("Béla Bartók's ‘Fourteen Bagatelles,’ Op. 6: Determining Performance Authenticity")]), _vm._v(" (DMA diss., University of Texas, Austin, 1989), 176pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Young People at the Piano")]), _vm._v(". 2 vols. Twelve pieces in Vol.I, ten pieces in Vol.II. Short, interesting and varied pieces for the second and third years of instruction. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Ten Easy Piano Pieces")]), _vm._v(" 1908 (Bo&H; MCA; Schott; Alfred; K; Maestro; Dover I) 17 min. Bartók intended this set to be a complement to the "), _c('i', [_vm._v("Bagatelles")]), _vm._v(" Op.6, but with pedagogical intentions, “to supply piano students with easy contemporary pieces.” Like the character cycles of Schumann, they display a variety of musical styles. None are “easy,” and No.10 is the most difficult. Bartók recorded Nos.5 and 10. 1. Paraszti nota (Peasant song): Dorian mode. 2. Lassú vergödés (Painful wrestling): tritone emphasis. 3. Tót legényak tánca (Slovak dance): tempo gradations. 4. Sostenuto: much melodic interplay. 5. Este a székelyeknél (Evening in the country): pentatonic melodies; form is ABABA. 6. ‘Gödölle! piactérre leesett a-hó’ (Hungarian folk song): rhythm is most interesting point. 7. Hajnal (Dawn): Debussy influence; subtle tonal and pedal effects. 8. ‘Azt mondják, nem adnak’ (Folksong): requires careful gauging of dynamics. 9. Ujjgyakorlat (Finger exercise): inspired by Clementi and Czerny etudes. 10. Medvetánc (Bear dance): repeated-note ostinato with chords in parallel motion. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Robert Dumm, “Teaching Bartok's Aurora” (Dawn, No.7), "), _c('i', [_vm._v("Clavier")]), _vm._v(" 33/9 (November 1994): 25–26, 28, music on p.29.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("For Children")]), _vm._v(" 1908–09 (EMB Z.5454–55 1998, corrected ed.; Bo&H; GS, 2 vols.; Dover II; Banowetz—GWM, Vol.I in an authoritative edition; MMP). Eighty-five short pieces, seventy-nine without octaves. Delightful pieces showing ingenious treatment of traditional Hungarian (Vol.I) and Slovakian (Vol. II) children's songs and folk songs. Superb examples of the genre. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Denes Agay, “Bartók's ‘For Children’ Which Edition? Original?…Revised?” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 10 (March 1971): 18–23.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Dale Topp, “Bartók's ‘For Children,’” PQ 143 (Fall 1988): 35–40.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("David Walker, “Folk Tunes for Adult Beginners in Bartók's Music "), _c('i', [_vm._v("For Children,” Clavier")]), _vm._v(" 40/5 (May 2001): 26–30. Includes music for No.10.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("2 Rumanian Dances")]), _vm._v(" Op.8a 1909–10 (Bo&H; K; EMB). Thick textures, skips, rhapsodic, long and brilliant. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("2 Elegies")]), _vm._v(" Op.8b 1908–09 (Bo&H; Schott; K). Related stylistically to Op.1. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("3 Burlesques")]), _vm._v(" Op.8c 1908–10 (Bo&H; K; Dover II; EMB). Lively scherzos in varied moods; Impressionistic; no folk influence. Brilliant. 1. Quarrel: a dispute, two opposing characters grimacing and teasing. The unison first subject and the waltz of the quasi-trio are character-variations of the same motif; an unprogrammatic scherzo. 2. Slightly Tipsy: programmatic, tipsy staggering with bits of a sentimental melody in thirds in the trio. Musically the staggering is brought about by parallel white key triads bouncing up and down in melodic fourths supported by minor second grace-note chords. 3. Molto vivo, capriccioso: a grotesque scherzo that points toward the grotesque puppet dance in the late opera "), _c('i', [_vm._v("The Wooden Prince")]), _vm._v(". M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("7 Sketches")]), _vm._v(" Op.9B 1908–10 (Bo&H; EBM; K) 11 min. Andante (Portrait d'une jeune fille). Commodo (Balançoire). Lento. Non troppo lento: most difficult of the set. Andante (Mélodie populaire Roumaine). Allegretto (À la manière valaque). Poco lento. Short pieces, thin textures. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("4 Nénies")]), _vm._v(" (Dirges) Op.9A 1910 (Bo&H; K; Dover II; EMB) 9 min. Short, stark, deceptively simple, Impressionistic. Refined pedaling required. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Deux Images")]), _vm._v(" Op.10 1910–11 (EMB). En pleine fleur; Danse campagnarde. Arr. by the composer from the original for orchestra.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Allegro Barbaro")]), _vm._v(" 1911 (Bartók Records 703 2002; Bo&H; Alfred; UE 5904 1992; MMP) 3½ min. Dancelike, barbaric, dogged stress in unexpected places; bravura and strength demanded. Phrygian and lydian modes mixed. Uses the piano as a drum. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("First Term at the Piano")]), _vm._v(" 1913 (Bo&H; K; Dover II; Schott). Eighteen pieces from the Bartók-Reschofsky "), _c('i', [_vm._v("Piano Method")]), _vm._v(" published in a separate volume under this title in 1929. All by Bartók. Contains folk-song adaptations and original compositions. Not intended for concert performance; some are stylistically reminiscent of easy folk-song adaptations in "), _c('i', [_vm._v("For Children")]), _vm._v(" (1908–09). Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina")]), _vm._v(" 1915 (Bo&H; Alfred; IMC; Dover II; GS separately and in "), _c('i', [_vm._v("Selected Works for the Piano")]), _vm._v(") 4 min. Bagpipe; Bear Dance; Finale. Based on Romanian folk tunes, picturesque miniatures. One of the finest sonatinas ever written. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Guy Wuellner, “Béla Bartók's Sonatine: A Survey of Editions and Transcriptions,” AMT 25 (April–May 1976): 28–31.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Romanian Folk Dances")]), _vm._v(" 1915 (P. Bartók—UE 5804 1993, corrected ed.; Bo&H; Alfred; MMP) 6 min. six short pieces: Bot-tánc (The Stick Dance); Brâul (Braul); Topogó (In One Spot); Bucsumi tánc (Dance from Bucsum); Roman (Romanian polka); Aprozó (Lively dance). One of Bartók's most popular sets. Charming, graceful, and poignant. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Sylvia Parker, “Bartók at the Crossroads: A Classical Sonatina from Five Rumanian Folk Dances,” "), _c('i', [_vm._v("College Music Symposium")]), _vm._v(" 43 (2003): 126–49.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Romanian Christmas Songs")]), _vm._v(" 1915 (UE 5890 1995, corrected ed.; Bo&H; MMP) 2 series, 10 in each, to be played as connected cycles. Modal, asymmetrical phrasing.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Ingrid Arauco, “Bartók's "), _c('i', [_vm._v("Rumanian Christmas Carols:")]), _vm._v(" Changes from the Folk Sources and Their Significance,” "), _c('i', [_vm._v("The Journal of Musicology")]), _vm._v(" V/2 (Spring 1987): 191–225.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Angeline Schmid, “Bartók's "), _c('i', [_vm._v("Rumanian Christmas Carols,” Clavier")]), _vm._v(" 20 (October 1981): 30–31.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite")]), _vm._v(" Op.14 1916 (P. Bartók—Bo&H; UE 5891 1992, corrected ed.) 8 min. Allegretto: jesting. Scherzo: sturdy. Allegro molto: driving. Sostenuto: short, Impressionistic. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Diana K. Oki, "), _c('i', [_vm._v("Performance Problems in Béla Bartók's")]), _vm._v(" Suite "), _c('i', [_vm._v("Opus 14 and Out of Doors")]), _vm._v(" (thesis, Long Beach: California State University, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Béla Siki, "), _c('i', [_vm._v("Piano Repertoire: A Guide to Interpretation and Performance")]), _vm._v(" (New York City: Schirmer, 1981), pp. 317–28.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Andante")]), _vm._v(" 1916 (P. Bartók—UE 31442 1999) 2pp. The original second movement of the five initially planned for "), _c('i', [_vm._v("Suite")]), _vm._v(" Op.14.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("15 Hungarian Peasant Songs and Dances")]), _vm._v(" 1914–17 (Bartók Records 702 2002; Bo&H; UE; MMP) 12 min. A connected cycle of short folk tunes, simply harmonized. Boisterous “Bagpipe” concludes set. Bartók Records includes an index of the melodies with their words and places where each was found. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Robert Dumm, “A Bartók Ballad,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 15 (March 1976): 33–37. Discusses “Ballad” from this set.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Three Hungarian Folk Tunes")]), _vm._v(" 1914–17 “Homage to Paderewski” (UE 9508 1995; Bo&H 1942). This set was probably intended for inclusion in "), _c('i', [_vm._v("Fifteen Hungarian Peasant Songs")]), _vm._v(", which was written about the same time. It is an effective recital opener or companion set to one of the folk-dance cycles. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("3 Etudes")]), _vm._v(" Op.18 1918 (Bo&H; MMP) 7½ min. Allegro molto: expansion and contraction of the hand, ninths and tenths. Andante sostenuto: Impressionistic sonorities, double notes in cadenza. Tempo giusto: left-hand figuration against staccato chords, irregular meters, motoric drive. Virtuoso works, much dissonance, hard-driving, colorful, highly original. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Improvisations on Hungarian Peasant Songs")]), _vm._v(" Op.20 1920 (Bo&H 2002, corrected ed.) 12 min. Eight tunes in a connected cycle, anything but improvised, carefully unified and developed construction, very dissonant, highly individual. The end point of Bartók's folk-song settings. No.7 is in memory of Debussy; quiet clusters. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Stuart Thyne, “Bartók's Improvisations,” ML 31/1 (1950): 30–45.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Dance Suite")]), _vm._v(" 1923 (P. Bartók—Bo&H, UE) 18 min. Originally written for orchestra, transcribed for piano by Bartók. Moderato; Allegro molto; Allegro vivace; Molto tranquillo; Commodo; Finale (Allegro). Contains some of Bartók's most arresting and invigorating writing. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" 1926 (UE 8772 1992, corrected ed.; EMB has a three-color facsimile of the autograph) 13 min. In three movements: Allegro moderato; Sostenuto e pesante; Allegro molto. Classical forms plus tight motivic unity. Repeated notes throughout, intricate embellishments. Bartók's longest work for solo piano, a twentieth-century classic. Requires brittle tone, power, rhythmic drive, virtuosity. Composed as a virtuoso piece for Bartók's own concerts. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" David Burge, “Contemporary Piano: Bartók's Piano Sonata,” CK 4 (September 1978): 56. A discussion of the first movement.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Andrew James Kizas, "), _c('i', [_vm._v("Pitch Organization and Form in Bartók's Sonata for Piano (1926) (MM thesis, University of Western Ontario, 1999), 157pp")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Michael Brandon Konoval, An Analytical Study of Béla Bartók's Sonata for Piano (1926)")]), _vm._v(" (DMA diss., University of British Columbia, 1996), 221pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Out of Doors")]), _vm._v(" 1926 (P. Bartók—Bartók Records 704 2003; Bo&H; UE) 13 min. With Drums and Pipes: percussive, rhythmic, short. Barcarolla: plastic, chromatic, linear, swaying barcarolle figure, melancholy. Musettes: major–minor sonorities mixed; drone decorated with trills. Night's Music: hypnotic; an eerie nocturnal picture that includes crickets, croaking frogs, twittering, chirping, fluttering of bat wings; cluster chords. The Chase: wild ostinato, wide skips, octaves, parallel ninths, dissonant, burst of frightening power. More concerned with color than structure. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Oki entry under Suite Op.14.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("9 Little Pieces")]), _vm._v(" 1926 (UE 10 000 1995, corrected ed.; Bo&H) 3 books. No.1. Four short dialogues in two- and three-part counterpoint. Bach-like. No.2. Menuetto, Air, Marcia delle Bestie, Tambour de Basque. No.3. Preludio— All'Ungherese: a genuine Magyar rhapsody, slow introduction leads to a lively dance section. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("3 Rondos on Folk Tunes")]), _vm._v(" 1916–27 (Bo&H; UE) 7 min. No.1 is the easiest. Light, clever, playful. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Little [Petite] Suite")]), _vm._v(" 1936 (P. Bartók—Bartók Records 706 2005; Bo&H; UE) 6 min. Six adaptations from "), _c('i', [_vm._v("44 Duos for 2 Violins")]), _vm._v(". Slow Melody; Walachian Dance; Whirling Dance; Quasi Pizzicato; Ukrainian Song; Bagpipe. Excellent on the piano, picturesque. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Mikrokosmos")]), _vm._v(" 1926–37 (P. Bartók—Bo&H 1987) 6 vols. 153 progressive piano pieces. Bartók began writing these pieces for his son Peter. When completed, they constituted one of the most comprehensive collections of contemporary techniques and idioms for the piano ever assembled. They are full of exquisite miniature masterpieces. The title means “the universe is small.” "), _c('i', [_vm._v("Vols.5")]), _vm._v(" and "), _c('i', [_vm._v("6")]), _vm._v(" are suitable for concert use.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. 1:")]), _vm._v(" Hands in unison. Independence developed by simple two-part counterpoint, including canon. Modal melodies. 1–6. Unison melodies; 7. Dotted notes; 8. Repetition; 9. Syncopation; 10. With alternate hands; 11. Parallel motion; 12. Reflection; 13. Change of position; 14. Question and answer; 15. Village song; 16. Parallel motion and change of position; 17. Contrary motion; 18–21. Unison melodies; 22. Imitation and counterpoint; 23. Imitation and inversion; 24. Pastorale; 25. Imitation and inversion; 26. Repetition; 27. Syncopation; 28. Canon at the octave; 29. Imitation reflected; 30. Canon at the lower fifth; 31. Little dance in canon form; 32. In Dorian mode; 33. Slow dance; 34. In Phrygian mode; 35. Chorale; 36. Free canon.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. 2:")]), _vm._v(" Two-part writing, varied homophonic accompaniments, legato and staccato dynamics, pieces for two pianos, some chromaticism, more difficult key signatures. Technical exercises. 37. In Lydian mode; 38. Staccato and legato; 39. Staccato and legato; 40. In Yugoslav mode; 41. Melody with accompaniment; 42. Accompaniment in broken triads; 43. In Hungarian style (duet two pianos); 44. Contrary motion (duet two pianos); 45. Méditation; 46. Increasing—diminishing; 47. Big fair; 48. In Mixolydian mode; 49. Crescendo—diminuendo; 50. Minuetto; 51. Waves; 52. Unison divided; 53. In Transylvanian style; 54. Chromatic; 55. Triplets in Lydian mode (duet two pianos); 56. Melody in tenths; 57. Accents; 58. In oriental style; 59. Major and minor; 60. Canon with sustained notes; 61. Pentatonic melody; 62. Minor sixths in parallel motion; 63. Buzzing; 64. Line and point; 65. Dialogue: song; 66. Melody divided.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. 3:")]), _vm._v(" Double notes, chord studies, irregular rhythmic groupings, inventions, changing meters, technical exercises. 67. Thirds against a single voice; 68. Hungarian dance (2 pianos, four hands); 69. Chord study; 70. Melody against double notes; 71. Thirds; 72. Dragon's dance; 73. Sixths and triads; 74. Hungarian song; 75. Triplets; 76. In three parts; 77. Little study; 78. Five-tone scale; 79. Hommage à J. S. B.; 80. Hommage à R. Sch.; 81. Wandering; 82. Scherzo; 83. Melody with interruptions; 84. Merriment; 85. Broken chords; 86. Two major pentachords; 87. Variations; 88. Duet for pipes; 89. In four parts; 90. In Russian style; 91. Chromatic invention; 92. Chromatic invention; 93. In four parts; 94. Tale; 95. Song of the fox; 96. Stumblings.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. 4:")]), _vm._v(" More-complicated problems, studies in clashing dissonances, Bulgarian rhythms. 97. Notturno; 98. Thumb under; 99. Crossed hands; 100. In the style of a folksong; 101. Diminished fifths; 102. Harmonies; 103. Minor and major; 104. Through the keys; 105. Playsong; 106. Children's song; 107. Melody in the mist; 108. Wrestling; 109. From the island of Bali; 110. Clashing sounds; 111. Intermezzo; 112. Variations on a folk tune; 113. Bulgarian rhythm; 114. Theme and inversion; 115. Bulgarian rhythm; 116. Melody; 117. Bourrée; 118. Triplets in 9/8 time; 119. Dance in 3/4 time; 120. Fifth chords; 121. Two-part study.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. 5:")]), _vm._v(" Double notes, chord studies, thirds, fourths, major and minor seconds, whole-tone scales, syncopations, changing meters. 122. Chords together and opposed; 123. Staccato and legato; 124. Staccato; 125. Boating; 126. Change of time; 127. New Hungarian folksong; 128. Peasant dance; 129. Alternating thirds; 130. Village joke; 131. Fourths; 132. Major seconds broken and together; 133. Syncopation; 134. Studies in double notes; 135. Perpetuum mobile; 136. Whole-tone scale; 137. Unison; 138. Bagpipe; 139. Merry Andrew.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. 6:")]), _vm._v(" More extended treatment of the foregoing problems, culminating in six dances in Bulgarian rhythms. 140. Free variations; 141. Subject and reflection; 142. From the diary of a fly; 143. Divided arpeggios; 144. Minor seconds, major sevenths; 145. Chromatic invention; 146. Ostinato; 147. March; 148–153. Six dances in Bulgarian rhythm. In the popular Nos.148–153, Bartók combines Bulgarian rhythms in two-, three-, and four-note units and shapes them into enchanting and haunting pieces. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Adele Franklin, “Bartók: Mikrokosmos, Book II,” "), _c('i', [_vm._v("Music Teacher")]), _vm._v(" 55 (November 1976): 7–8.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("———, “Bartók: Mikrokosmos, Book III,” "), _c('i', [_vm._v("Music Teacher")]), _vm._v(" 55 (December 1976): 12–13")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("———, “Bartók: Mikrokosmos, Book IV,” "), _c('i', [_vm._v("Music Teacher")]), _vm._v(" 56 (January 1977): 17–18, and 56 (February 1977): 15–16.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Muriel Levin, “The Role of Mikrokosmos in Piano Study,” "), _c('i', [_vm._v("Piano Journal")]), _vm._v(" 15/45 (October 1994): 21–23.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Mary E. Parker, "), _c('i', [_vm._v("Bartók's ‘Mikrokosmos’: A Survey of Pedagogical and Compositional Techniques")]), _vm._v(" (diss., University of Texas, Austin, 1987).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("James Alfred Skoog, "), _c('i', [_vm._v("Set Syntax in Béla Bartók's ‘Mikrokosmos”")]), _vm._v(" (PhD diss., Indiana University, 1985), 225pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Lawrence Starr, “Melody-Accompaniment Textures in the Music of Bartók as Seen in His "), _c('i', [_vm._v("Mikrokosmos,” The Journal of Musicology")]), _vm._v(" 4/1 (Winter 1985–86): 91–104.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Benjamin Suchoff, "), _c('i', [_vm._v("Guide to the Mikrokosmos")]), _vm._v(" (New York: Boosey & Hawkes, 1971; reprint, New York: Da Capo Press, 1982, with a new introduction by György Sandor).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("———, “Bartók's Musical Microcosm,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 16 (May–June 1977): 18–20 (pp.22–25 contain Nos.57 [Accente] and 140 [Free Variation] from the "), _c('i', [_vm._v("Mikrokosmos")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Stuart Thyne, “Bartók's Mikrokosmos: A Reexamination,” PQ 107 (Fall 1979): 43–46. Discusses errors between printed text and Bartók's recordings.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Margit Varro, “Bartók's Mikrokosmos in Retrospect,” in "), _c('i', [_vm._v("Selections from the Piano Teacher")]), _vm._v(" 1958–1963 (Evanston, IL: Summy-Birchard, 1964).")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("COLLECTIONS")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Music of Béla Bartók")]), _vm._v(" (B. Suchoff—Dover 1981). Based on corrections from Bartók's memorabilia and original editions in the New York Bartók Archive. Excellent Introduction. Int. to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Series I")]), _vm._v(" (192pp.): Funeral March; Four Piano Pieces; Rhapsody Op.1; Three Folk Songs; 14 Bagatelles Op.6; Ten Easy Pieces; Two Elegies Op.8B; Seven Sketches Op.9B; Two Rumanian Dances Op.8A.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Series II")]), _vm._v(" (150pp.): For Children; Three Burlesques Op.8C; Four Dirges, Op.9A; Two Pictures Op.10; The First Term at the Piano; Sonatina.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Allegro Barbaro and Other Short Works")]), _vm._v(" (Dover 1998) 102pp. Includes: Allegro Barbaro; Romanian Folk Dances; Romanian Christmas Carols; 15 Hungarian Peasant Songs; Improvisations on Hungarian Peasant Songs; Op.20; Suite Op.14; Etudes Op.18. A fine survey. Int. to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bartók Album")]), _vm._v(" (Bo&H).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. 1:")]), _vm._v(" Bagatelles Nos.2, 3, 5, 10, and 14; Burlesque Nos.1 and 2; Danse roumaine; Esquisses Nos.1, 2, 5, and 6; Soir à la campagne; Danse de l'ours.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. 2:")]), _vm._v(" Aurora; Bagatelles Nos.1, 6, 8, and 11; Dirge No.3; Folksong; Rumanian Dance No.2; Sketch No.7; Slovak Peasant's Dance; Sostenuto; Three Folksongs from the Country of Csik; Village Dance.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Selected Works")]), _vm._v(" (GS). Funeral march from the symphonic poem “Kossuth”; Rhapsody Op.1; 14 Bagatelles Op.6; 2 Elegies Op.8b; Sketches Op.9; 4 Dirges; 2 Rumanian Dances Op.8a; 3 Burlesques Op.8c; Sonatina.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bartók Album")]), _vm._v(" (K). 3 Hungarian Folksongs; Fantasy (1903); 2 Rumanian Dances; Scherzo (1903); Sonatina; Sketches Op.9; 14 Bagatelles Op.6; Bear Dance.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bartók Easy Piano")]), _vm._v(" (Alfred). Twenty-four pieces selected from various educational collections. Contains a brief biography and introductory notes for the pieces. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bartók: Favorite Piano")]), _vm._v(" (Alfred). Twenty-four pieces including the Sonatina and pieces from other collections by Bartók. Contains a short biography and notes on each piece. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Easy Piano Music of Béla Bartók")]), _vm._v(" (D. Goldberger—Schroeder & Gunther). Twenty-four pieces that provide a fine introduction to a fundamental twentieth-century style.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Young Pianist's Guide to Bartók")]), _vm._v(" (Y. Novik—WB) 24pp. with recording of sixteen of the easier pieces. Well edited. Easy to Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Story of Béla Bartók")]), _vm._v(" (in "), _c('i', [_vm._v("Contemporary Piano Repertoire, Level 5")]), _vm._v(", Hinson, Glover—Belwin-Mills 1971). Contains biography of Bartók, discussion of his piano works, and four short, easy pieces: Let's Dance; Peasant Dance; The Fox; Scaredy Cat!")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bartók: His Greatest")]), _vm._v(" (Ashley) 192pp. Contains both volumes of For Children, Ten Easy Pieces, Bagatelles Op.6, and other selected works. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Bartók: An Introduction to His Piano Works")]), _vm._v(" (Palmer—Alfred) 64pp. A most informative foreword includes information about Bartók, about the selections, on wrist and finger action, and on touch; and studies in finger staccato, wrist staccato, staccatissimo, portato, tenuto, legato, accents, syncopation, and legato-staccato. Contains pieces from The First Term at the Piano, For Children, 10 Easy Pieces, and 7 Sketches. Editorial additions in light gray print. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Compositions for Piano")]), _vm._v(" (GS). Suite Op.14; Rumanian Folk Dances; Rumanian Christmas Carols. M-D.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BRIEF BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Damjana Bratuž, “The Folk Element in the Piano Music of Béla Bartók” (DM, Document I, Indiana University, 1967). Discusses the history, “character and style of Hungarian folk music and their application in the performance of Bartók's piano works” (abstract).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Christine Brown, “Bartók the Teacher,” "), _c('i', [_vm._v("Music Teacher")]), _vm._v(" 60/3 (March 1981): 16–17.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Elizabeth Buday, “Focus on Bartók,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 20 (October 1981): 21–22.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Anthony Cross, “Debussy and Bartók,” MT 108 (February 1967): 125–31.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Andor Foldes, “Bartók as Pianist,” JR 2 (1955): 18–22.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("David Hamilton, “Bartók at the Piano,” HF (March 1981): 39–41. A survey of the recordings made by Bartók.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Eun Hae Kim, "), _c('i', [_vm._v("Bartók and Nature: An Imaginative Reading of Representation in Selected Piano Pieces")]), _vm._v(" (DMA document, University of Kentucky, 2009), 122pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sun Kyung Lee, "), _c('i', [_vm._v("Bartók's Unfolding Performance History: A Comparative and Critical Review")]), _vm._v(" (DMA document, Boston University, 1994), 114pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Joan Pursewell, “Bartók's Early Music: Forecasting the Future,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 20 (October 1981): 23–27. A discussion of the Bagatelles Op.6 (including No.5 printed), Three Burlesques Op.8, and Sketches Op.9B.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("György Sandor, “Béla Bartók: Extending the Piano's Vocabulary,” CK 1 (September–October 1975): 16–18, 34.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Tamas Vasary, “Vasary Teaches Bartók,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 17 (May–June 1978): 17–20. A lesson on Suite Op.14.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Shu-Yuan Yang, "), _c('i', [_vm._v("An Interpretive Analysis of Béla Bartók's Performance of His Own Music")]), _vm._v(" (DMA thesis, City University of new York, 1997), 162pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("David Yeomans, "), _c('i', [_vm._v("Bartók for Piano: A Survey of His Solo Literature")]), _vm._v(" (Bloomington: Indiana University Press, 1998).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Jan Z. Bartoš")]), _vm._v(" (1908–1981) Czech Republic")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bartoš was a prolific and gifted composer. Contemporary events in his country inspired some of his latest compositions.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" Op.70 (Artia 1953). In three movements: Allegro—Piu animato; Adagio; Tarantella (Presto).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" Op.82 (Artia 1959). In three movements: Allegro molto; Largo; Allegro molto. Both sonatas display a fine compositional technique and could only have been written by a pianist. Both are tonal, yet liberally sprinkled with dissonance. Highly effective. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Nevett Bartow")]), _vm._v(" (1934–1973) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Toccata")]), _vm._v(" (SP 1972) 6pp. Tricky rhythms, dissonant. Meter and mood change in midsection; off-beat accentuations give jazzy rhythmic effect; concludes with cluster chords. Showy and effective. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Character Pieces")]), _vm._v(" Op.13 posth. (SP 41) 8pp. Toccata: bitonal. March: pompous. American Dance: jazzy. The Cuckoo: flowing lines interrupted by bird call. Chaconne maestoso: syncopated melody, octotonic, cheerful. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Leonid Bashmakov")]), _vm._v(" (1927– ) Finland, born Russia")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Six Preludes")]), _vm._v(" 1974 (Fazer) 13pp. 10 min. Short, contrasting, mildly twentieth-century except for No.6, which is filled with dissonance. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Leslie Bassett")]), _vm._v(" (1923– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bassett's style is based on textural sounds and colors that help to convey a specific mood. The composer uses various kinds of tones and groupings of instruments to achieve his methods of counterpoint. He retired from a lengthy tenure teaching at the University of Michigan and has been the recipient of a Pulitzer Prize and Guggenheim and Fulbright Fellowships.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Six Piano Pieces")]), _vm._v(" (ACA 1951). Allegro moderato: mainly two voices, imitative, tonal. Allegro: thin textures, melodic, chromatic coloring. Andante cantabile: long melodic idea well developed, unusual sonorities. Allegro brilliante: bitonal, perpetual motion, breathless. Adagio, ma non troppo: ethereal, melodic. Allegro assai: Toccata-like, moving freely into closely related tonalities. A refreshing set, effective as a group. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Hommage à Arthur Honegger")]), _vm._v(" (ACA 1951). Andantino: a two-voice Nocturne employing linear writing with a quote from Honegger's "), _c('i', [_vm._v("King David")]), _vm._v(". Piquant. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Elaborations")]), _vm._v(" (CFP 1966) 11pp. Fast: scalar passages punctuated by chordal gestures, thin textures, ornamented by trills, "), _c('i', [_vm._v("pp")]), _vm._v(" close. Slow: great freedom, long crescendo leads to a dynamic climax. Quiet: more harmonically treated, incisive rhythmic punctuation relaxes to a calm close. Brilliant: broad chromatic line, martellato effects, trill produces stunning sonorities; dramatic close. Wide range of keyboard and dynamics exploited throughout in these facile works. Basic patterns unfold inconspicuously. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Mobile")]), _vm._v(" (in "), _c('i', [_vm._v("Twelve by Eleven")]), _vm._v(", M. Hinson—Alfred 1978). Lyrical yet intense, constantly unfolding, rich in color and range. The chromatic language is enhanced by several varied repetitions that, as it were, assume new perspectives as they turn in the wind. Expressionistic, effective. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Configurations")]), _vm._v(" (CFP 1988). 1. Whirling Triplets: no bar lines, nonfunctional harmonic texture, triplets divided between hands. 2. Lines: no bar lines, two-part counterpoint, chromatic. 3. In Balance: no bar lines, chromatic, eighth notes grouped into fours and further grouped by the Fibonacci number series. 4. Climbing: changing meters, chromatic melody, pedal study. 5. Spirals: minimalist style, repeated eight times, arpeggio groupings, fast, loud. A fine set to introduce contemporary techniques. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.lesliebassett.com",
      "target": "_blank"
    }
  }, [_vm._v("www.lesliebassett.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("James Bastien")]), _vm._v(" (1934–2005) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Toccata")]), _vm._v(" (GWM 1975). A sophisticated, contemporary, dashing recital piece that would make a good substitute for the overworked Khachaturian "), _c('i', [_vm._v("Toccata.")]), _vm._v(" Pianist needs good octaves and plenty of stamina. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Stanley Bate")]), _vm._v(" (1911–1959) England")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bate's works reveal the direct influence of his teacher Hindemith and also Vaughan Williams.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("7 Pieces")]), _vm._v(" 1940 (Schott 10012). Prelude; Romance; Chanson Populaire; Moment Musical; Polka; Valse. Short works of moderate difficulty, influenced by Shostakovitch. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Pieces for an Infant Prodigy")]), _vm._v(" Op.13 (Mer). Short, unpretentious. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina No.6")]), _vm._v(" E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (AMP 1943). In three movements: Moderato; Andante; Allegro. Quartal and quintal harmonies; clear, facile writing. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina No.7")]), _vm._v(" C 1949 (Schott). Bright, smaller in dimensions than No.6. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina No.8")]), _vm._v(" C (AMP 1945). In three movements: Prelude; Valentine; Toccata. Alternating hands, tremolos, repeated notes and scales. Short movements. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Yves Baudrier")]), _vm._v(" (1906–1988) France")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Baudrier was a founding member of “La Jeune France,” formed in 1936. The group also included Messiaen, Jolivet, and D. Lesur.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("La Dame à la Licorne")]), _vm._v(" (Amphion 1935). The title refers to the tapestries “The Lady and the Unicorn” in the Musée de Cluny in Paris. Mildly twentieth-century with Impressionistic overtones. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Marion Bauer")]), _vm._v(" (1887–1955) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Turbulence")]), _vm._v(" Op.17/2 (EBM). Octaves, vigorous, brief motives, sonorous. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("A Fancy")]), _vm._v(" (Axelrod). Short, Impressionistic. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Eight Diversions")]), _vm._v(" (Chappell). Varied moods and styles. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Four Piano Pieces")]), _vm._v(" Op.21 (Arrow Music Press). Chromaticon; Ostinato; Toccata; Syncope. Short; varied compositional techniques. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Ellie Michiko Hisama, "), _c('i', [_vm._v("Gender, Politics, and Modernist Music: Analyses of Five Compositions by Ruth Crawford (1901–1953) and Marion Bauer (1887–1955)")]), _vm._v(" (PhD diss., City University of New York, 1996), 237pp. Discussess the Four Piano Pieces.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Dance Sonata")]), _vm._v(" Op.24 (ACA). In three movements. Allegro appassionata: very chromatic. Sarabande: five variations. Allegretto giocoso. Graceful writing. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Patterns")]), _vm._v(" Op.41 (ACA). Five twelve-tone pieces: Allegretto in two voices; quick Waltz; Scherzo; eloquent slow movement; Toccata. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Nancy L. Stewart, "), _c('i', [_vm._v("The Solo Piano Music of Marion Bauer")]), _vm._v(" (diss., University of Cincinnati, 1990).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Jürg Baur")]), _vm._v(" (1918–2010) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Baur studied under Philipp Jarnach at the University of Cologne. He taught at the Robert Schumann Conservatory in Düsseldorf between 1946 and 1971, serving as director for the last six years, and then at the Cologne Musikhochschule until 1990. He has been fond of mirror structures in his serial music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Spuk")]), _vm._v(" 1939 (Tonger 2299 P.J.T. 1994) 7pp. Originally the Finale to "), _c('i', [_vm._v("Ostpreussen-Suite")]), _vm._v(". Commences Fugato, presto vivace, and maintains the imitative texture to the end, recalling the fugato theme shortly before the close. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Capriccio")]), _vm._v(" (Br&H 1953) 5 min. One of Baur's earliest serial works. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Drei frühe Klavierstücke")]), _vm._v(" (O. Drechsel—Dohr 98507 1998) 18pp. Rondo (1956): marked Allegro risoluto (Sehr rasch), mostly in two voices. Improvisation (1960): marked Con moto (Rubato), is impulsive and dramatic. Burleske (1943/44): marked Vivace giocoso, in 6/8 meter with octaves and P5 as structural elements.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Aphorismen")]), _vm._v(" (Br&H 1957) 17 min. Twelve pieces. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Heptameron")]), _vm._v(" (Br&H 1964–65). Dedicated to Anton von Webern. Seven pieces in serial technique with well-contrasted, attractive sonorities. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fabula Rasa")]), _vm._v(" 2006 (Dohr 26343 2006) 9pp. A mosaic for piano inspired by R. Schumann's "), _c('i', [_vm._v("Fantasiestücke")]), _vm._v(", Op.12. In three movements: Ostinato—Allegro; Andante espressivo, sehr frei im Tempo; Allegro con fuoco. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Arnold Bax")]), _vm._v(" (1883–1953) England")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bax wrote prolifically for the piano. His style always shows great facility and a Romantic temperament. A love of the great Irish poets and Celtic folklore plus an early visit to Russia proved to be major influences.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("2 Russian Tone Poems")]), _vm._v(" 1912 (J. Williams). Nocturne (May night in the Ukraine): imaginative writing requiring keyboard facility. Gopak (National Dance): strong rhythmic drive, masterful piano writing. Both M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Country Tune")]), _vm._v(" (Murdoch). Needs careful balance of tone. Easy.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Lullaby")]), _vm._v(" 1920 (Murdoch). Melody treated with varied harmonies, two contrasting cantabile sections. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Toccata")]), _vm._v(" D"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" 1913 (Murdoch 1920). Double-note technique in right hand, brilliant. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Nereid")]), _vm._v(" (JWC; MMP). Poetic, flowing, recurring rhythmic figure. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Winter Waters")]), _vm._v(" (JWC). “Tragic Landscape” achieved by a four-note ground bass. Effective. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Whirligig")]), _vm._v(" (JWC; MMP 1919). Ostinato passed between the hands. Clever, needs digital facility. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.1")]), _vm._v(" f"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(" 1910, rev.1917–21 (Murdoch 1922). One movement, varied moods and tempi. Advanced pianism required. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.2")]), _vm._v(" G 1919 (Murdoch 1921). One movement; overall mood is grim and menacing; rhapsodic in character. Five themes, folk-song influence, thick textures. Large span required. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.3")]), _vm._v(" g"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(" 1926 (Murdoch). Three movements, not easy for performer or audience. Advanced pianism required. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.4")]), _vm._v(" G 1932 (Chappell). Perhaps the most attractive of the sonatas. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("7 Selected Piano Solos")]), _vm._v(" (Chappell 1915–43). Available separately. A fine varied album including Lullaby; Mediterranean; Country-Tune; A Hill Tune; Serpent Dance; In a Vodka Shop. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Selected Works for Piano")]), _vm._v(" (Thames). An interesting collection of short pieces written between 1897 and 1945. Includes the exquisite "), _c('i', [_vm._v("Nereid")]), _vm._v(". M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Irwin Bazelon")]), _vm._v(" (1922–1995) USA")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatina")]), _vm._v(" (Weintraub 1952). 11pp. Outside movements are quick, without clearly defined tonal centers. Shifting tonality in middle movement. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Five Pieces for Piano")]), _vm._v(" (Weintraub 1956). Miniatures with disjunct melody, much dissonance and complex rhythmic ideas. Polyphonic texture. Difficult for performer and listener. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Suite for Young People")]), _vm._v(" (PIC 1954). Part 1: Little Serenade; Christmas Carol; Dance for a Tomboy; Lullaby; Cowboy Tune; Prayer. Int. Part 2: Prelude; The Clown and the Puppet; Circus Parade; The Haunted Chateau; Dance of an Elf; Goblins and Ghosts. “The purpose in writing these pieces was to acquaint young pianists with style and character of contemporary music as early as possible in their musical training” (from the score). Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Imprints…On Ivory and Strings")]), _vm._v(" (Nov 10023107 1982) 24pp. 12 min. Preface. Dissonant chords, tone clusters, strings plucked and strummed, large paper pad inserted in strings, flexible tempi, careful pedal instructions, harmonics, spatial rhythmic notation. Exploits the resonant resources of the instrument; music from beyond the fringe! M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sunday Silence")]), _vm._v(" 1989 (TP 1993) 16pp. 15 min. Inspired by a race horse named “Sunday Silence,” this recital piece is full of rhythmic vitality. Serial, wide dynamic range, expressionistic, dazzling, performance notes: S.H. = Short Hold; V.S.H. = Very Short Hold, etc., changing tempos, harmonics, plucked strings, proportional rhythmic relationships. D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Amy Marcy Beach")]), _vm._v(" (Mrs. H. H. A. Beach) (1867–1944) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The forward-moving drive throughout Beach's writing seems to be the essence of early twentieth-century optimism. Amy Beach is finally being recognized as one of the greatest women composers in the United States, perhaps our greatest!")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Valse-Caprice")]), _vm._v(" Op.4 (Schmidt 1889; MMP). Laced with difficulties, graceful figuration, diminished chords, subtle modulations. Lighthearted, Saint-Säens colored. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Ballad")]), _vm._v(" Op.6 (Schmidt 1894; MMP). Fauré-like introduction leads to a larger Liszt-like section. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Four Sketches")]), _vm._v(" Op.15 (Schmidt 1892; MMP). In Autumn; Phantoms; Dreaming; Fireflies. Intriguing writing. In Autumn is in collection "), _c('i', [_vm._v("Masters of American Piano Music")]), _vm._v(" (Alfred 4603). 5pp. Melancholy, numerous tempo changes. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Young People's Carnival")]), _vm._v(" Op.25 (Alfred 3576) 19pp. Six programmatic movements that depict the characters of early European pantomine popular in America in the late nineteenth century. Promenade; Columbine; Pantalon; Pierrot and Pierrette; Secrets; Harlequin. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Morceaux Caractéristiques")]), _vm._v(" Op.28 (Schmidt 1894). Barcarolle; Menuet Italian; Danse de Fleurs. Reprint from original publication. Traditional forms, Romantic harmonies. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Young People's Album")]), _vm._v(" Op.36 (Alfred 3573; S. Glickman—Hildegard). Entitled "), _c('i', [_vm._v("Children's Album No.1")]), _vm._v(" in Hildegard publication. Minuet; Gavotte; Waltz; March; Polka. Five dance pieces, all notated in the treble clef; thin textures. Some of the better pedogogical pieces written around this time (1897). Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Scottish Legend")]), _vm._v(" Op.54/1 (in "), _c('i', [_vm._v("American Keyboard Music")]), _vm._v(", E. Gold—McAfee; in "), _c('i', [_vm._v("At the Piano With Women Composers")]), _vm._v(", Alfred 428). Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Variations on a Balkan Theme")]), _vm._v(" Op.60 1904 (MMP). Longest and most difficult of all Beach's solo piano works. Eight variations, long cadenza, superb writing. Includes composer's preface. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Prelude and Fugue")]), _vm._v(" Op.81 (GS 1918). Academic. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Hermit Thrush at Eve")]), _vm._v(" Op.92/1 (Schmidt 1922). Tuneful, based on birdcalls. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Hermit Thrush at Morn")]), _vm._v(" Op.92/2 (Schmidt). M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Farewell, Summer. Dancing Leaves")]), _vm._v(" Op.102 (Ditson 1924). Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Nocturne")]), _vm._v(" Op.107 (J. Church 1924). Lovely Romantic writing. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Five Improvisations")]), _vm._v(" Op.148 (Seesaw 1938). Introspective, reflective. More modern idiom than the other listed works. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Music")]), _vm._v(" (Da Capo 1982) 150pp. Introduction by Sylvia Glickman. Includes Valse Caprice Op.4; Ballade Op.6; Sketches Op.15: In Autumn, Phantoms, Dreaming, Fireflies; three pieces from Op.28: Barcarolle, Menuet Italien, Danse des Fleurs; Variations on a Balkan Theme Op.60: powerful and refreshingly original; Prelude and Fugue Op.81; Fantasia Fugata Op.87; Nocturne Op.107; A Cradle Song of the Lonely Mother Op.108; Tyrolean Valse Fantaisie Op.116; three Pianoforte Pieces Op.128: Scherzino, Young Birches, A Humming Bird. Also includes a complete list of Beach's solo piano works and chamber music including piano. Her piano music falls into three categories: elementary teaching pieces, intermediate works, and virtuoso compositions. This anthology “deals only with the last category and presents a superb survey of her pianistic style. The renaissance of interest in her music today coincides with the revival of Romantic-style composition that attracts many contemporary composers” (from preface).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Music for Piano")]), _vm._v(" (S. Glickman—Hildegard) 2 vols. Extensive preface. Int. to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I")]), _vm._v(" (1994) 85pp. Ballade Op.6; Fireflies Op.15; Barcarolle Op.28; Scottish Legend and Gavotte Fantastique Op.54; Les Réves de Columbine Op.65; From Grandmother's Garden Op.97.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II")]), _vm._v(" (1997) 71pp. Valse Caprice Op.4; In Autumn Op.15/1; Phantoms Op.15/2; Dreaming Op.15/3; Variations on Balkan Themes Op.60; A Hermit Thrush at Eve Op.92/1; A Hermit Thrush at Morn Op.92/2; Improvisations Op.148/1–5.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Life and Music of Amy Beach: The First Woman Composer of America")]), _vm._v(" (G. Smith—Creative Keyboard Publications 1992) 103pp. 15 pp. of biography with some early unusual pictures of Beach; 83 pp. of music, including "), _c('i', [_vm._v("Summer Dreams")]), _vm._v(" Op.47 for piano duet (28pp.). Solo music includes Mamma's Waltz; Menuetto; Romanzo; Petit Valse; Pierrot and Pierrette, Harlequin, Secrets Op.25/4, 6, 5; Waltz, Minuet F, Gavotte Op.36/3, 1, 2; Canoeing, Sliding on the Ice Op.54/1, 2; Menuet Italian Op.28/2; Fireflies Op.15/4. Wide variety of Beach's piano music. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Stephen Paul Burnaman, "), _c('i', [_vm._v("The Solo Piano Music of Edward MacDowell and Mrs. H. H. A. Beach: A Historical Analysis")]), _vm._v(" (DMA diss., University of Texas, Austin, 1997), 182pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Donna Elizabeth Congleton Clark, "), _c('i', [_vm._v("Pedagogical Analysis and Sequencing of Selected Intermediate-Level Solo Piano Compositions of Amy Beach")]), _vm._v(" (DMA document, University of South Carolina, 1996), 119pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Dean Elder, “Where Was Amy Beach All These Years?” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 15 (December 1976): 14–17. Includes “Out of the Depths” Op.130 for piano and “Twilight” Op.47/3 for piano duet.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Marmaduke S. Miles, "), _c('i', [_vm._v("The Solo Piano Works of Mrs. H. H. A. Beach")]), _vm._v(" (diss., Peabody Conservatory of Music, 1985), 175 pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Burnet C. Tuthill, “Mrs. H. H. A. Beach,” MQ 26 (1941): 197–310.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Marcelle Vernazza, “Amy Beach and Her Music for Children,” AMT 30/6 (June–July 1981): 20–21. Discusses the piano collections "), _c('i', [_vm._v("Young People's Album")]), _vm._v(" Op.36 and "), _c('i', [_vm._v("Young People's Carnival")]), _vm._v(" Op.25.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("James Beale")]), _vm._v(" (1924–2010) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beale taught for many years at the University of Washington, Seattle. All the sonatas are well written for the piano by a composer who obviously knew the possibilities and limitations of the instrument.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.1")]), _vm._v(" Op.6 1949 (ACA) 21 min. In three movements: Allegro; Adagio molto; Grazioso.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.2")]), _vm._v(" Op.8 (University of Washington Press 1953). Five movements that exploit a wide range of sonorities and techniques. Lyrical aspects and fluid handling of the instrument emphasized. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.3")]), _vm._v(" Op.9 1950 (ACA 1952) 15 min. In three movements: Allegretto espressivo; Allegro pesante; Allegro misterioso. Exploits extreme ranges, prestissimo coda. Some use of harmonics, Neoclassic style. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.4")]), _vm._v(" Op.11 1951 (ACA) 24 min. In five movements: Allegretto grazioso; Allegro scherzando; Andante cantabile e con rubato; Adagio; Allegro giocoso.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.6")]), _vm._v(" Op.13 1952 (ACA 1956) 15 min. In four movements: Adagietto; Presto; Andante; Presto con impeto. Least involved of the four piano sonatas. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.7")]), _vm._v(" Op.20 1956 (ACA 1956) 20pp. 23 min. In four movements: Slow–Moderate–Slow; Fast; Moderate–Slow; Slow–Fast–Slow. These tempos are suggested for program printing. Few tempo indications appear in the work, usually only metronome marks. Many “start and stopping” effects. Tremolandos and long pedal effects are effectively used. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.8")]), _vm._v(" Op.31 (ACA) 16 min. In four movements: Violento; Presto; Adagio; Allegro con rubato.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata No.9")]), _vm._v(" Op.45 1985 (ACA) 12 min. In two movements: Allegro assai/Adagio/ Tempo primo; Allegro.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Sally Beamish")]), _vm._v(" (1956– ) England")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beamish was born in London and has lived in Scotland since 1989, where she devotes herself primarily to composition.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Voices in Silence")]), _vm._v(" 2004 (Scottish Music Centre 2004) 23pp. Dawn; Night Song; Singing on a Wire; Chorale. “"), _c('i', [_vm._v("Voices in Silence")]), _vm._v(" reflects on a post-war world after the last gun has fallen silent, the sun rising on a creation oblivious to the self-destruction of mankind. Each movement builds a soliloquy on a single image; dawn on a devastated battle-field, frogs calling in a bomb crater, a bird whistling on a barbed wire fence, and finally a simple chorale” (note by composer). M-D")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Robert Beaser")]), _vm._v(" (1954– ) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beaser has taught at Juilliard since 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Landscape with Bells")]), _vm._v(" 1986 (in "), _c('i', [_vm._v("Changing Faces")]), _vm._v(", EAMC 1987). 4pp. Pedal used to produce colorful bell-like sonorities, changing meters. Follow accents closely at indicated levels so the bell-like ringing tone will be produced. “Fast, light, and ringing tempo I.” M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Dan Beaty")]), _vm._v(" (1937–2002) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beaty taught piano and composition at Stephen F. Austin State University in Nacogdoches, Texas, for thirty-five years.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Seven Bagatelles")]), _vm._v(" (GWM 320 1980) 23pp. Seconds; Thirds; Fourths; Fifths; Sixths; Sevenths; Octaves. Each piece exploits the interval of its title. Mildly twentieth-century. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Woodsprite and Waterbug Collection")]), _vm._v(" (Kjos 1977). 1. Woodsprite: pentatonic, polytonal, wide leaps. 2. Red Dog: whole-tone, ostinato. 3. Doodling: touch and dynamic contrasts, meter changes, polytonal. 4. Mists: pedal study, choice of octave placement of melody. 5. Hobby Horse: polytonal, whole-tone, two-note slurs. 6. Pagoda: glissando, pedal, pentatonic plus chromatics. 7. Thunderheads: forearm clusters, tritones, glissando. 8. Jump: alternating hands, staccato, pentatonic. 9. All Twelve: twelve-tone, legato balance, pedal. 10. Morning Song: 5/8 meter, modal, melody tossed between hands. 11. Bells: pedal, chords, tritone. 12. Water Bug: polytonal, whole-tone, hands widely spaced. Excellent set (all are short) for introducing later twentieth-century techniques. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Conrad Beck")]), _vm._v(" (1901–1989) Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beck lived in Paris from 1925 to 1933 and was acquainted with Roussel, Ibert, and Honegger. Many of his works show their influence.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Klavierstücke")]), _vm._v(" (Schott 1920–30). Books I and II contain eleven pieces. Atonal. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Dance")]), _vm._v(" (ESC 1929). Strong rhythms, not as dissonant as other works. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonatine No.2")]), _vm._v(" (Schott 1947). Large three-movement atonal work, serial. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fox-trot")]), _vm._v(" (in "), _c('i', [_vm._v("Hommage à Albert Roussel, La Revue Musicale")]), _vm._v(" 94 [April 1929]) 4pp. Written in honor of Roussel's sixtieth birthday. Beck studied with Roussel in 1924–33. Delightful dance piece. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Prélude")]), _vm._v(" (Heugel 1948). This piece and the "), _c('i', [_vm._v("Sonatine No.2")]), _vm._v(" show more emphasis on a unified French-German style. Contrapuntal texture underlies both works. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("John Becker")]), _vm._v(" (1886–1961) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Becker developed a personal harmonic style and was quite adventurous as a composer. He wrote articles for numerous music journals and was associate editor of the quarterly "), _c('i', [_vm._v("New Music")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("2 Architectural Impressions")]), _vm._v(" (ACA 1924) 4 min. Romantic-Impressionistic idiom. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("2 Chinese Miniatures")]), _vm._v(" (GS 1926) 4 min. Attractive, even if a little “dated”-sounding. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Soundpiece No.5")]), _vm._v(" (J. Gillespie—CFP 1996) 10pp. 8 min. “Short Sonata for Piano” in one-movement with four contrasting sections utilizing arpeggio figuration, chorale and toccata treatment, plus a fugue, mildly twentieth-century. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("4 Modern Dances")]), _vm._v(" (CFE) 5 min. More complex dissonant idiom, percussive. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("John Beckwith")]), _vm._v(" (1927– ) Canada")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beckwith studied piano with Alberto Guerrero at the Royal Conservatory of Music in Toronto, and composition with Nadia Boulanger in Paris. He has been the music critic for the "), _c('i', [_vm._v("Toronto Daily Star")]), _vm._v(", associate editor of the "), _c('i', [_vm._v("Canadian Music Journal")]), _vm._v(", and a member of the music faculty at the University of Toronto.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("4 Conceits")]), _vm._v(" (CMC 1945–48). Contrasting short pieces in Impressionistic style. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Novelette")]), _vm._v(" (BMI Canada 1954). Pungent sonorities. Requires broad span and good sense of driving rhythmic syncopation. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("New Mobiles")]), _vm._v(" (Waterloo 1973) 6pp. Wind-harp: hands play independently and freely. Machine: perpetual motion. Tough Beans Charlie: repeated chords, skips, arpeggi. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("White Black")]), _vm._v(" (Waterloo 1973). One hand plays white keys while the other plays black keys. Glissandi. Int.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("David Bedford")]), _vm._v(" (1937–2011) England")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bedford studied with Berkeley and Nono. His music was influenced by Schönberg. He also wrote in popular styles.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Piece I")]), _vm._v(" 1965 (UE) 4 min. Bars lasting five seconds are marked off. Values are only approximate, and much is left to the performer to decide. Staccato and legato elements are cleverly used, dramatic. Based on a single chord, may be a reaction to the abstruseness of serial technique. John Cage and Morton Feldman influence. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Piano Piece II")]), _vm._v(" 1968 (UE) 6pp. 7½ min. Larger in scope than "), _c('i', [_vm._v("Piano Piece")]), _vm._v(" I; form is repetitive rather than developmental. Much emphasis on dynamics and silences. Among other preparations, six notes must be fitted with rubber wedges, and four milk bottles are to be placed on strings. Avant-garde. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata in One Movement")]), _vm._v(" 1981 (UE) 18 min. Sections are bound together tightly; well unified. Opens with the presentation of a group of seven pitches, with only one pitch in each two-bar segment, varied meters. Second group of seven pitches is a permutation of the first set of metric changes; five groups of seven notes are presented altogether. Fast-moving, dramatic cumulative effect, very quiet and haunting ending. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" David Burge, “Contemporary Piano,” "), _c('i', [_vm._v("Keyboard")]), _vm._v(" 8 (April 1982): 58, 74, for a discussion of this work.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Toccata")]), _vm._v(" d 1981 (UE) 12 min. Driving, serial influence, contains some highly effective moments. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Jack Beeson")]), _vm._v(" (1921–2010) USA")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beeson was a graduate of the Eastman School of Music and Columbia University. He studied privately with Bartók in New York in 1944 and went on to compose in a variety of styles and techniques.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fourth Piano Sonata")]), _vm._v(" 1945, rev.1951 (TP 1984) 16pp. 11 min. In two movements. Slowly, with freedom: freely tonal with much chromatic coloring, corky rhythmic figure contrasted with more cantabile sections, quiet closing. Squarely: fughetta-like, thin textures, quiet and “warmly” section, logically built climax, exciting ending. Pedal indications are suggestive and incomplete. M-D to D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Fifth Piano Sonata")]), _vm._v(" 1946, rev.1951 (J. Kirkpatrick—TP 1973) 11pp. In three movements. Allegro moderato: shifting meters and emotions, restless, unstable tonality. Adagio: free, ornate, irregular rhythmic flow. Marziale: audacious, daring, strong rhythmic drive, dissonant percussive harmonies. Short, tightly knit. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Janet E. Seitzer, "), _c('i', [_vm._v("The Solo Piano Works of Jack Beeson")]), _vm._v(" (diss., Baltimore: Peabody Institute of The Johns Hopkins University, 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('b', [_vm._v("Ludwig van Beethoven")]), _vm._v(" (1770–1827) Germany")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Beethoven's piano works occupy a unique place in keyboard literature and demand the detailed attention of both the teacher and the serious student. Works without opus number (WoO) are numbered in accordance with Georg Kinsky, "), _c('i', [_vm._v("Das Werk Beethovens, thematisch-bibliographisches Verzeichnis seiner sämtlichen vollendeten Kompositionen")]), _vm._v(", completed by Hans Halm (Munich: G. Henle, 1955).")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("SONATAS")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("From work to work within this genre, the music takes many—and frequently abrupt—turns of character. More often than not, almost schizophrenic changes occur from movement to movement. What an enormous difference there is between Op.106 and Op.110, or even between Op.10/2 and Op.10/3. The impact of the sonatas upon Romanticism was almost immediate, and they quickly took their place in standard repertoire. Hans von Bülow was so impressed by Beethoven's 32 Sonatas that he called them the New Testament of piano literature (alongside Bach's "), _c('i', [_vm._v("Well-Tempered Clavier")]), _vm._v(" as the Old Testament).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("An order of progressive difficulty in the sonatas might be: Op.49/2, Op.49/1, Op.79, Op.14/1, Op.2/1 (last movement more difficult), Op.14/2, Op.10/2, Op.10/1, Op.10/3, Op.13, Op.26, Op.27/1, Op.28, Op.22, Op.2/2, Op.2/3, Op.78, Op.90, Op.7, Op.31/3, Op.54, Op.31/2, Op.27/2, Op.31/1, Op.109, Op.110, Op.81a, Op.53, Op.57, Op.101, Op.111, Op.106.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("There have been more editions of the sonatas than of any other body of works in the keyboard literature. Among the most noteworthy are:")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Henle")]), _vm._v(" (B. Wellner, C. Hansen, Henle 32, 34), 2 vols. Urtext edition. "), _c('i', [_vm._v("Vol. I:")]), _vm._v(" Opp.2–28; "), _c('i', [_vm._v("Vol. II:")]), _vm._v(" Opp.31–111. Commentary in German, English, and French.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Henle")]), _vm._v(", in "), _c('i', [_vm._v("Neue Ausgabe sämtlicher Werke")]), _vm._v(" (H. Schmidt), 3 vols. "), _c('i', [_vm._v("Vol. I:")]), _vm._v(" Opp.2–26; "), _c('i', [_vm._v("Vol. II:")]), _vm._v(" Opp.27–57; "), _c('i', [_vm._v("Vol. III:")]), _vm._v(" Opp.79–111; critical commentary.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("VU")]), _vm._v(" (P. Hauschild), 3 vols. "), _c('i', [_vm._v("Vol. I:")]), _vm._v(" Opp.2–22. "), _c('i', [_vm._v("Vol. II:")]), _vm._v(" Opp.26–57. "), _c('i', [_vm._v("Vol. III:")]), _vm._v(" Opp.78–111.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("UE")]), _vm._v(" (H. Schenker, rev. E. Ratz), 2 vols. Based on solid research and scholarship. Very reliable.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Alfred")]), _vm._v(" (S. Gordon), 4 vols. "), _c('i', [_vm._v("Vol. I:")]), _vm._v(" Opp.2–13; "), _c('i', [_vm._v("Vol. II:")]), _vm._v(" Opp.14–28; "), _c('i', [_vm._v("Vol. III:")]), _vm._v(" Opp.31–78; "), _c('i', [_vm._v("Vol. IV:")]), _vm._v(" Opp.79–111.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("CFP")]), _vm._v(" (C. Arrau, L. Hoffmann-Erbrecht). Combines research, based on authentic sources of revision, with the experience of international concert practice and established academic principles. Contains fingering and metronome marks by Czerny as well as by Arrau, whose fingering is unusually interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("ABRSM, The 35 Piano Sonatas")]), _vm._v(" (B. Cooper, 2007), 3 vols. In addition to the standard 32 Sonatas, includes WoO47/1 E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", WoO47/2 f, WoO47/3 D. Editorial suggestions in brackets. Articulations do not always agree with urtext editions. Extensive introduction and commentary on the individual sonatas, plus introductory CDs. Fingering by D. Ward.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Belwin-Mills")]), _vm._v(" (A. Schnabel). A very personal conception available in two volumes or as separate sonatas; compare with Schnabel's recordings! The fingering is one of the finest attributes of this edition.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Dover")]), _vm._v(" (H. Schenker), 2 vols. Reprint of older UE edition which is excellent although it has a few minor flaws; Schenker's fingering is very illuminating. "), _c('i', [_vm._v("Vol. I:")]), _vm._v(" Opp.2–28; "), _c('i', [_vm._v("Vol. II:")]), _vm._v(" Opp.31–111.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Other editions with merit are: F. C. A. Martienssen—CFP, 2 vols.; Koehler, Ruthardt—CFP, 2 vols.; Lamond—Br&H, 2 vols.; GS and K, reprints the older Br&H edition (also available in five vols. in Lea Pocket Scores, LPS 11–15 and Kalmus miniature scores); Liszt—Zen-On (Liszt expressed not only the "), _c('i', [_vm._v("urtext")]), _vm._v(" of the music, but the "), _c('i', [_vm._v("urgeist")]), _vm._v(" [spirit] of the music as well); d'Albert—CF; Casella—Ric; Dukas—Durand; L. Weiner—EMB; D. Geoffroy—Lemoine; Germer—Litolff; Peter Solymos—EMB; Craxton, Tovey— ABRSM, 3 vols.; K. Taylor (Allans Music Australia 1985), 4 vols., complete with notes on performance and interpretation; I. Mariássy, T. Zaszkalicsky—KMB, 3 vols.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Available separately: Every sonata from Op.2/1 through Op.111 (Craxton, Tovey—ABRSM; Bülow, Lebert—GS, use with care, some notes are changed). Many are also available in other editions as noted below.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Facsimiles available: Op.27/2 (H. Schenker—UE); Op.53 (Beethovenhaus, Bonn); Op.57 (CFP; GS; K. Sakka—Ongaku-No-Tomo-Sha); Op.109 (Robert O. Lehman Foundation); Op.111 (CFP; Dover).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("3 Sonatas")]), _vm._v(" E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", f, D WoO 47 1783? (“Kurfürsten Sonatas”) (Irmer, Lampe—Henle 255).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" C (A. Orga—Roberton Publications 1978) 16pp. 12 min. This little-known sonata, consisting in manuscript of a complete first movement and twenty-five bars of a second, prompted Tovey to the conclusion that “it cannot have been written long before the sonatas in Op.2 (1795) and the first movement, for all its slenderness in dimensions and sound, is as masterly as anything in that opus” (from the score). It is published here in a scholarly and practical edition, with a completion of the second movement and a projected third movement based on contemporary sketchbooks of the composer. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" f Op.2/1 1795 (H. Fischer—CFP 4001a; Hoehn—Schott; B.A. Wallner, C. Hansen—Henle 183; M. Hinson—Alfred 8052; Ching—Prowse; d'Albert— CF; P. P. Hauschild—VU 50121; K; Heugel; Scionti—Ric; ABRSM; GS). Allegro; Adagio; Minuetto—Allegretto; Prestissimo. A dramatic work of moderate technical demands. Retains the classic minuet. Triplet basses of the finale require a flexible left hand.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Garrick Ohlsson, “Beethoven's Sonata No.1 (Op.2/1): A Performer's Analysis,” "), _c('i', [_vm._v("Keyboard")]), _vm._v(" 8/10 (October 1982): 22–27.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" A Op.2/2 1795 (Hoehn—Schott; ABRSM; GS). Allegro vivace; Largo appassionato; Scherzo—Allegretto; Rondo—Grazioso. The most interesting of the three sonatas in this opus. Brilliant outer movements. The beautiful slow movement presents tonal problems, while the third is a lively scherzo full of staccato humor.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" C Op.2/3 1796 (Hoehn—Schott; Wallner, C. Hansen—Henle 622; d'Albert—CF; ABRSM; GS). Allegro con brio: broken-chord and broken-octave required. Adagio: deeply moving. Scherzo—Allegro: strong rhythmic control necessary for the groups of three eighth-notes. Allegro assai: many staccato chords and octaves, scintillating. A large-scale work, the most difficult of this opus.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.7 1796 (N. Gertsch, M. Perahia—Henle 773; VU 50123; ABRSM; GS). Allegro molto e con brio: difficult legato octaves in the second half of the exposition, fast broken octaves later. Largo, con gran espressione: requires a fine rhythmic sense. Allegro: folksy; naive; flowing legato required. Rondo—Poco Allegretto e grazioso: graceful theme, leaping left hand shares melody.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Roger Kamien, “Chromatic Details in Beethoven's Piano Sonata in E Flat Major, Op.7,” MR 35 (August 1974): 149–56.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" c Op.10/1 1796? (Hoehn—Schott; B.A. Wallner, C. Hansen—Henle 47; Ching—Prowse; d'Albert—CF; ABRSM; GS; K). Allegro molto e con brio: first-rate musical and technical material. Adagio molto: varied ornamental version of the second subject but in tempo when it returns. Finale—Prestissimo: needs firm fingers, accurate staccato, a stunning SA design.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" F Op.10/2 1797? (VU 50129; Hoehn—Schott; d'Albert—CF; ABRSM; S. Gordon—Alfred; GS; K). Allegro: gracious. Allegretto: cantabile, chorale in D"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Presto: fugue-like opening; needs fluent fingers, accurate staccato, and firm rhythmic control.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Béla Siki, "), _c('i', [_vm._v("Piano Repertoire: A Guide to Interpretation and Performance")]), _vm._v(" (New York City: Schirmer, 1981), pp. 91–99.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" D Op.10/3 1798 (VU 50132; Hoehn—Schott; B.A. Wallner, C. Hansen— Henle 641; ABRSM; GS). Presto: requires good rotation technique and strong fingers; needs to race along. Largo e mesto: one of the most eloquent of all the slow movements; has emotional depth. Menuetto—Allegro: match triplet tempo in the Trio with the Menuetto. Rondo—Allegro: elaborate working-out of the opening three-note motif, humorous throughout with many starts and stops.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" c “Pathétique” Op.13 1789? (B.A. Wallner, C. Hansen—Henle 48; M. Hinson—Alfred 6352; S. Gordon—Alfred 27902; P. Hauschild—VU 50188; Banowetz—GWM, available with cassette; Hoehn—Schott; Schenker, Ratz—UE; Ching—Prowse; d'Albert—CF; K; Fischer—CFP; ABRSM; GS; Lympany—Hansen House; Fuzeau 2008). Grave—Allegro di molto e con brio—Tempo I—Allegro molto e con brio: young players who attempt this movement are not equipped for its difficulties, such as the left-hand tremolo passages. Adagio cantabile: one basic tempo throughout, although careful rubato will point out melodic nuances. Rondo—Allegro: not as demanding as the opening movement but should not sound anti-climactic. Fuzeau is a facsimile of Joseph Eder's 1799 edition. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Kenneth Drake, “Beethoven's Sonata Pathétique,” PQ 107 (Fall 1979): 51–54.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Miriam Hyde, “Beethoven Sonata No.13 (Pathétique),” "), _c('i', [_vm._v("MTA of New South Wales Quarterly Magazine")]), _vm._v(" (August 1993): 13–17.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("William S. Newman, “K.457 and Op.13—Two Related Masterpieces in C Minor,” PQ 57 (Fall 1966): 11–15; revised and enlarged version, MR 28 (1967): 46–52.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Béla Siki, "), _c('i', [_vm._v("Piano Repertoire: A Guide to Interpretation and Performance")]), _vm._v(" (New York City: Schirmer, 1981), pp.100–12.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("TM, “Analysis of Beethoven: Piano Sonata in c minor, Op.13 (‘Pathétique’), Second Movement,” pp.92–107.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" E Op.14/1 1799 (N. Gertsch, M. Perahia—Henle 810; M. Hinson—Alfred 8051; J. Fischer—CFP 4009/10; Hoehn—Schott; K; ABRSM; GS). Op.14/1, two published together (Henle 810; Köhler/Kann—Schott). Allegro: tricky broken thirds. Allegretto: scherzo-like substitute for the usual central slow movement. Rondo—Allegro commodo: joyous.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Forbes Watson, “Beethoven's Op.14, No.1,” MT 86 (1945): 108–11. A discussion of Beethoven's arrangement of this sonata for string quartet.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" G Op.14/2 1799 (N. Gertsch, M. Perahia—Henle 810; Hoehn—Schott; K; ABRSM; GS; Ching—Prowse). Allegro: be careful of the repeated D in measures 9 and 11; left-hand staccatos in the development are problems. Andante: variations on a chorale; be careful of tonal balance in the first variation. Scherzo—Allegro assai: in rondo form; opening bars must be clearly accented.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.22 1800 (ABRSM; GS). Allegro con brio: rotation passages require a free forearm. Adagio con molta espressione: must have a warm singing tone. Menuetto: rhythmic swing; requires clean finger articulation in the alternative G minor section. Rondo—Allegretto: beautiful Schubertian tune requires smooth legato. Beethoven showed a special fondness for this work.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.26 1801 (P. Hauschild—VU; N. Gertsch, M. Perahia—Henle 892 2010; B.A. Wallner, C. Hansen—Henle 696 1980; Hoehn—Schott; Heugel; Schenker—UE; ABRSM; GS). Andante con variazioni: needs a consistent tempo to unite all five variations. Scherzo—Allegro molto: difficult legato thirds. Marcia funebre sulla morte d'un Eroe—Maestoso andante: distinguish carefully between tenuto and staccato and be careful of pedaling. Allegro: this busy rondo requires a fine rotation technique. None of the movements are written in SA design.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.27/1 1801 (B.A. Wallner, C. Hansen—Henle 724; Fischer—CFP with Op.27/2; Hoehn—Schott; K; ABRSM; GS). Andante—Allegro—Tempo I: firm rhythmic and tonal control essential. Allegro molto e vivace: dance form, has bright Trio. Adagio con espressione: not a separate movement but an introduction to the final movement. Allegro vivace: rondo with a development; interrupted near the end to reintroduce the melody of the slow introduction. The subtitle of this work, "), _c('i', [_vm._v("Sonata quasi una Fantasia")]), _vm._v(", is amply justified, for Beethoven seems not to be overly concerned with the sonata's traditional structure. His capacity for wit is stunningly revealed in this subtle yet stalwart work.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" c"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(" (“Moonlight”) Op.27/2 1801 (Palmer—Alfred 2502; S. Gordon—Alfred 27903; J. Fischer—CFP, separately [4014] and with Op.27/1; B.A. Wallner, C. Hansen—Henle 49; H. Schenker, Ratz—UE, facsimile included; P. Hauschild—VU 50114; M. Lympany—Hansen House; Ching—Prowse; K; ABRSM; GS). Adagio sostenuto: an expressive, lyric cantabile line, pianissimo, is necessary for this magnificent movement. Allegretto: Liszt called this movement “a flower between abysses,” but it is actually a spontaneous scherzo and trio that requires a fine rhythmic swing. Presto agitato: dramatic, animated, tumultuous, SA design with two themes, fiery broken chords, tremolos and staccato chord passages. Like its companion Sonata Op.27/1, this work is also subtitled "), _c('i', [_vm._v("Sonata quasi una Fantasia")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Irwin Fischer, “A Note in Opus 27, No.2,” ML 32 (January 1951): 45–46.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Béla Siki, "), _c('i', [_vm._v("Piano Repertoire: A Guide to Interpretation and Performance")]), _vm._v(" (New York City: Schirmer, 1981), pp.113–21.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" D (“Pastorale”) Op.28 1801 (N. Gertsch, M. Perahia—Henle 725; Schenker, Ratz—UE; Hoehn—Schott; K; ABRSM; GS). Allegro: various sections closely unified. Andante: one of Beethoven's favorites. Scherzo—Allegro vivace: use the left-hand part of the Trio to establish the tempo for the Scherzo. Rondo—Allegro, ma non troppo: the opening has the most “pastoral” sound in the entire sonata. The subtitle “Pastorale” was not original with Beethoven.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" James Callahan, “Arrau vs. Schnabel in Beethoven's Op.28,” PQ 93 (Spring 1976): 46–52.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Hwakyu Lee, "), _c('i', [_vm._v("Fractals in Beethoven's Piano Sonata Opus 28")]), _vm._v(" (DMA document, University of Wisconsin, Madison, 2004).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Béla Siki, "), _c('i', [_vm._v("Piano Repertoire: A Guide to Interpretation and Performance")]), _vm._v(" (New York City: Schirmer, 1981), pp. 122–31.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" G Op.31/1 1802 (N. Gertsch, M. Perahia—Henle 754; ABRSM; GS). Allegro vivace: requires a good finger technique. Adagio grazioso: elegant graces. Rondo—Allegretto: difficult left-hand passages for a small hand.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" d (“Tempest”) Op.31/2 1802 (N. Gertsch, M. Perahia—Henle 784; J. Fischer—CFP 4017; Hoehn—Schott; L. Weiner—EMB; S. Gordon—Alfred 27904; Heugel; ABRSM; GS). Largo—Allegro: storm and stress; tricky two-note slurs; the two ghostly recitatives require careful pedaling. Adagio: rhythmic continuity is the greatest problem. Allegretto: melancholy; wistful; agitated interruptions; persistent use of opening four-note motive must never sound mechanical. One of the greatest sonatas in all Romanticism.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Barry Cooper, “The Origins of Beethoven's D Minor Sonata Op.31 No.2,” M&L 62/3–4 (July-October 1981): 261–80.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Tedd Joselson, “Master Class: Beethoven's ‘Tempest’ Sonata,” CK 5 (August 1979): 65.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Ludwig Misch, "), _c('i', [_vm._v("Beethoven Studies")]), _vm._v(" (Norman: University of Oklahoma Press, 1953). "), _c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" discusses “The ‘Problem’ of the D Minor Sonata.” Suggests a new interpretation of the form.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.31/3 1802 (N. Gertsch, M. Perahia—Henle 755; Heugel; ABRSM; GS). Allegro: Liszt wrote over the opening motive the words “Liebst du mich?” and Tobias Matthay used the word “lov-ing-ly” to underscore the gentle rhythm and touch; requires a good trill and careful definition of the slurs in the second theme. Scherzo—Allegretto vivace: an excellent hand-staccato study. Menuetto—Moderato e grazioso: keep the same tempo for the Menuetto and Trio. Presto con fuoco: fast tempo presents problems of coordination between the hands; requires fine left-hand staccato; contagious gaiety abounds.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" g Op.49/1 1795–96 (M. Hinson—Alfred, with Op.49/2; B.A. Wallner, C. Hansen—Henle 56, with Op.49/2; K; Hoehn—Schott; P. Hauschild— Schott, with Op.49/2; Ratz—UE; Ching—Prowse; Lemoine; ABRSM; GS). Andante: requires smooth thirds in the left hand at opening. Rondo—Allegro: main theme must be a good staccato. Beethoven probably did not intend to publish the Op.49 sonatas, as he used a "), _c('i', [_vm._v("menuetto")]), _vm._v(" section from Op.49/2 in his "), _c('i', [_vm._v("Septet")]), _vm._v(" Op.20. It is believed that his brother Karl found the works and sent them to a publisher. They were published in 1805. Both works have clear forms and charming moments and are excellent for introducing Beethoven to young pianists.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Stefan Bardas, “Sonata Op.49/1: A Beethoven Master Class,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 22/8 (October 1983): 26–33. Includes music.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" G Op.49/2 1795–96 (same editions as for Op.49/1). Allegro ma non troppo; Tempo di Menuetto. Easier than Op.49/1. Both sonatas seem out of place, situated between the highly progressive sonatas of Op.31 and the virtuoso “Waldstein” Op.53.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Peter Collins, “Beethoven's Two Sonatas, Op.49: A New Perspective,” AMT 57/6 (June/July 2008): 20–25.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" C (“Waldstein”) Op.53 1804 (N. Gertsch, M. Perahia—Henle 946; Schenker, Ratz—UE; L. Weiner—EMB; K; Hoehn—Schott; Beethovenhaus, Bonn, facsimile; S. Gordon—Alfred 27905; M. Lympany—Hansen House; Heugel; Lemoine; ABRSM; GS). Allegro con brio: virtuosic; needs careful attention to its larger shape with very little tempo change at the E-major second subject. Introduzione—Adagio molto: exact time values required in this short, slow, and sonorous introduction. Rondo—Allegretto moderato: contains transformed statements of the basic theme, long trills, and glissando octaves; point up the moderato, especially in the lyric main theme; requires utmost control. One of the greatest sonatas.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Barry Cooper, “The Evolution of the First Movement of Beethoven's ‘Waldstein’ Sonata,” M&L 58 (April 1977): 170–91.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Anthony J. Crain, “Problems in the Beethoven Literature,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 9 (January 1970): 30–36. Mainly a discussion of trouble spots with special reference to Sonata C, Op.53.")]), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Paul Lewis, “Thinking Music: Beethoven's ‘Waldstein’ Piano Sonata Op.53,” "), _c('i', [_vm._v("International Piano")]), _vm._v("/1 (May/June 2010): 52–53.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Elizabeth N. McKay, “Abbe Vogler, Beethoven and the Waldstein Sonata,” "), _c('i', [_vm._v("The Beethoven Newsletter")]), _vm._v(" (Spring 1993): 7.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" F Op.54 1804 (ABRSM; GS). In Tempo d'un menuetto: two alternating subjects; second one requires endurance in vigorous staccato octaves and sixths. Allegretto: toccata based on one theme; requires a smooth delivery. This work has much to recommend it and is frequently overlooked.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" James C. Kidd, “Wit and Humor in Tonal Syntax,” "), _c('i', [_vm._v("Current Musicology")]), _vm._v(" 21 (1976):70–82. Discusses the first movement of Op.54 from the viewpoint of a subtle and comprehensive use of wit and humor by Beethoven.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" f (“Appassionata”) Op.57 1804–5 (J. Fischer—CFP contains epilogue in German and English, facsimile, critical notes in German, and bars 340–66 of the first version of the last movement; B. A. Wallner, C. Hansen—Henle 58; Schenker, Ratz—UE; S. Gordon—Alfred 27906; M. Lympany—Hansen House; d'Albert—CF; Hoehn—Schott; K; Heugel; WH; ABRSM; GS, includes facsimile; K. Sakka—Ongaku-No-Tomo-Sha, facsimile). Allegro assai: emotional and dramatic qualities; difficult articulation problems, especially in the second part of the second subject, which requires great speed and large tone. Andante con moto: short set of variations using one of Beethoven's most beautiful melodies. Allegro ma non troppo: must have an intense emotional drive in the tremendous sweep of the movement. Beethoven thought this his best sonata.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Martha Frohlich, "), _c('i', [_vm._v("Beethoven's ‘Appassionata’ Sonata")]), _vm._v(" (Oxford: Clarendon Press, 1991). In the series “Studies in Musical Genesis and Structure.”")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Claude H. Herndon, “A Notational Error in the Appassionata (Op.57),” "), _c('i', [_vm._v("PQ")]), _vm._v(" 138 (Summer 1987): 54")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Sviatoslav Richter, “Thoughts on Beethoven's Appassionata,” trans. by Beatrice L. Frank, "), _c('i', [_vm._v("Clavier")]), _vm._v(" 30/2 (Feb. 1991): 36.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" F"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/hash.jpg"
    }
  }), _vm._v(" Op.78 1809 (Höpfel—Schott, with preface and critical notes in German and English; M. Hinson—Alfred 6327; ABRSM; GS). Adagio cantabile—Allegro ma non troppo: leisurely; lyric; tempo should not be too fast. Allegro vivace: clear articulation of the two-note slurs should restrain the tempo of this scherzo-like vivace; graceful caprice.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" G Op.79 1809 (B.A. Wallner, C. Hansen—Henle 59; WH; Hoehn—Schott; ABRSM; M. Hinson—Alfred; GS; K). Presto alla tedesca: hand crossings help the lilt of this German dance. Andante: simple and beautiful Neapolitan barcarolle. Vivace: a fun movement; briefly worked out; has no difficulties.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Ludwig Misch, "), _c('i', [_vm._v("Beethoven Studies")]), _vm._v(" (Norman: Oklahoma University Press, 1953). "), _c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(", “Alla danza tedesca,” throws light on the original sketches of this movement.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (“Sonate caractéristique: Les Adieux; l'absence et le retour”) Op.81a 1809 (B.A. Wallner, C. Hansen—Henle 723; S. Gordon—Alfred; K; Heugel; ABRSM; GS). Adagio—Allegro: treacherous legato double notes and fast staccato chords. Andante espressivo: do not play too slowly, especially in comparison with the Adagio of the first movement, but bend the tempo slightly when the melodic turns appear. Vivacissimamente: triumphant; slurs in bars 9 and 10 should restrain the fast tempo. This sonata was inspired by Archduke Rudolph, friend and student of Beethoven, who left Vienna shortly before the French occupation of 1809.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" e Op.90 1814 (B.A. Wallner, C. Hansen—Henle 283; K; Heugel; ABRSM; GS). Mit Lebhaftigkeit und durchaus mit Empfindung und Ausdruch: requires smooth left-hand sixteenth-note accompaniment of the second subject (difficult for a small hand). Nicht zu geschwind und sehr singbar vorgetragen: a leisurely rondo with Schubertian overtones; must have a beautiful legato. More difficult than it looks, this sonata balances intellect and cool emotion. It is mercurial, almost capricious. Modulations and expressive counterpoint in the first movement contrast with gentle lyricism in the Rondo. This sonata stands on the threshold of Beethoven's last “metaphysical” works.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" A Op.101 1816 (N. Gertsch, M. Perahia—Henle 792; ABRSM; GS). Etwas Lebhaft, und mit der innigsten Empfindung (Allegretto, ma non troppo): difficult to decide on the correct tempo for this quiet reverie (lively, but with innermost feeling). Lebhaft. Marschmässig (Vivace alla marcia): usually played too fast; heroic mood needs dignity and extreme rhythmic accuracy. Langsam und sehnsuchtsvoll (Adagio, ma non troppo, con affetto): opening reverie heard again; take the fast turns at a very sustained pace; serves as introduction to the finale. Geschwinde, doch nicht zu sehr, und mit Entschlossenheit (Allegro): expansive, too fast a tempo turns this movement into trivia.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Marta Schermerhorn, "), _c('i', [_vm._v("An Historical and Analytical Study of Beethoven's Fortepiano Sonata in A Major, Opus 101")]), _vm._v(" (thesis, San Jose State University, 1991).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" (“Hammerklavier”) Op.106 1817–18 (J. Fischer—CFP: epilogue in German and English, critical notes in German, fingered; Hoehn—Schott; ABRSM; GS). Allegro: Beethoven's metronome indications are impractical; a flexible tempo with the "), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music2.jpg"
    }
  }), _vm._v(" = ca.92 is suggested; formidable technical problems; grandiose; SA with two contrasting themes; much contrapuntal use in the development. Scherzo—Assai vivace: brusque contrasts; rhythmic figures must be accurate but delicate in their accentuation. Adagio sostenuto: the longest Adagio Beethoven wrote for a sonata; meditative and melancholy; amazingly expressive ornamentation. Largo: an improvisatory introduction to the finale fugue. Allegro risoluto: extended fugue subject; many deviations in the fugue; develops a fugue within a fugue ("), _c('i', [_vm._v("sempre dolce cantabile")]), _vm._v("); requires great finger control. A colossal work, the longest and most difficult of the sonatas, an apocalyptic masterpiece.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Alan Tyson, “The Hammerklavier and Its English Editions,” MT 103 (April 1962): 235–37.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" E Op.109 1820 (Schenker—UE; B.A. Wallner, C. Hansen—Henle 362; K; ABRSM; GS; Robert O. Lehman Foundation, facsimile). Vivace, ma non troppo: short; like a prelude; introspective; amiable; SA design with two contrasted key centers of E and B presented in two contrasted tempos. Prestissimo: condensed SA design; restless; like an interlude connecting the outer movements; similar in texture to the first movement of Op.101. Gesangvoll, mit innigster Empfindung (Andante molto cantabile ed espressivo): theme and six variations, including a fugato, that reveal changes in character while progressing to a climatic point and then subsiding into a quiet return of the theme. In many ways this work seems like a "), _c('i', [_vm._v("Sonata quasi una Fantasia")]), _vm._v(" in all but name.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Russell Bliss, “Late Beethoven: Playing Piano Sonata Op.109,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 15 (January 1976): 19–22.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Allen Forte, "), _c('i', [_vm._v("The Compositional Matrix")]), _vm._v(" (Cincinnati: Music Teachers National Association, 1961; reprint, New York: Da Capo Press, 1973). On the sketches for Beethoven's Op.109.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Nicholas Marston, "), _c('i', [_vm._v("Beethoven's Piano Sonata in E, Op.109")]), _vm._v(" (New York: Clarendon Press, 1995), 230 pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" A"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.110 1821 (B.A. Wallner, C. Hansen—Henle 363; J. Fischer—CFP 4031a; Höpfel—Schott 09715; K; ABRSM; GS). Moderato cantabile molto espressivo: SA design treated freely; keep a generally uniform tempo for all of the pieces of material; songlike; amiable. Allegro molto: scherzo-like; the right-hand figuration in the central section must not be hurried. Adagio ma non troppo: short lyric introduction leads to Fuga—Allegro, ma non troppo: smooth counterpoint, a friendly fugue that gradually arrives at a full conclusion. Much more difficult than it looks, especially in the voice leadings.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Russell Bliss, “Otherworldly Sounds Captured by Beethoven's Sonata, Op. 110,” "), _c('i', [_vm._v("Clavier")]), _vm._v(" 41/10 (December 2002): 28–31.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Sonata")]), _vm._v(" c Op.111 1822 (B.A. Wallner, C. Hansen—Henle 364; K; Hoehn—Schott; Schenker—UE; ABRSM; GS; Dover, facsimile; CFP, facsimile). Maestoso— Allegro con brio ed appassionato: stormy, powerful, and potent. Arietta— Adagio molto semplice e cantabile: deeply moving; maintain the basic tempo throughout the variations; Var. 4 is frequently taken too fast; Beethoven seems to have found the peace of God in this movement.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Philip Barford, “Beethoven's Last Sonata,” ML 35 (October 1954): 320–31.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("William Drabkin, “Some Relationships between the Autographs of Beethoven's Sonata in C minor, Op.111,” "), _c('i', [_vm._v("Current Musicology")]), _vm._v(" 13 (1972): 38–47.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Tim Gilligan, “Beethoven's C Minor Sonata, Op. 111,” "), _c('i', [_vm._v("International Piano")]), _vm._v(" 7/26 (March/April 2003): 60–67. Surveys historical recordings.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Soo-Yun Lee, "), _c('i', [_vm._v("A Personal Interpretation of Ludwig van Beethoven's Last Piano Sonata, Op. 111, from a Spiritual Viewpoint")]), _vm._v(" (DMA document, University of Texas, Austin, 2003), 99pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Johanna Goldstein, "), _c('i', [_vm._v("A Beethoven Enigma: Performance Practice and the Piano Sonata, Opus 111")]), _vm._v(" (New York: Peter Lang, 1988).")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Willis H. Hackman, “Rhythmic Analysis as a Clue to Articulation in the Arietta of Beethoven's Op.111,” PQ 93 (Spring 1976): 26–37.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Charles Timbrell, “Notes on the Sources of Beethoven's Op. 111,” M&L 58 (April 1977): 204–15.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("The Titled Sonatas")]), _vm._v(" (I. Kolodin—GS). Includes eight dramatic and programmatic sonatas: Pathétique, Moonlight, Pastorale, Tempest, Waldstein, Appassionata, Les Adieux, Hammerklavier. A most interesting and illuminating preface defends the use of these names. Urtext edition (the old Br&H) reprinted.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Selected Easiest Sonata Movements for Piano")]), _vm._v(" (Alfred 4841–42) 2 vols.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" David Breitman, "), _c('i', [_vm._v("The Damper Pedal and the Beethoven Piano Sonatas: A Historical Perspective")]), _vm._v(" (diss., Cornell University, 1993).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Cassandra Irene Carr, "), _c('i', [_vm._v("Wit and Humor as a Dramatic Force in the Beethoven Piano Sonatas")]), _vm._v(" (diss., University of Washington, 1985).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Hsia-Jung Chang, "), _c('i', [_vm._v("Beethoven Piano Sonatas: Are They String Quartets in Disguise?")]), _vm._v(" (DMA document, Manhattan School of Music, 1997), 94pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("William Drabkin, “The Beethoven Sonatas,” MT (April 1985): 216–20. Discusses six editions available at that time.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Kenneth Drake, "), _c('i', [_vm._v("The Sonatas of Beethoven as He Played and Taught Them")]), _vm._v(" (Cincinnati: MTNA, 1972; reprinted, Indiana University Press, 1981), 209pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("———. "), _c('i', [_vm._v("The Beethoven Sonatas and the Creative Experience")]), _vm._v(" (Bloomington: Indiana University Press, 1994), 320 pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Leonne Lewis, with Paul Badura-Skoda, Martin Hughes, and Elisabeth Leonskaja, “Revisiting Beethoven's Piano Sonatas,” "), _c('i', [_vm._v("Clavier Companion")]), _vm._v(" 2/6 (November/December 2010): 18–23.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Suzanne Macahilig, "), _c('i', [_vm._v("A Method for the Interpretation of Beethoven's Middle Period Piano Sonatas")]), _vm._v(" (PhD diss., New York University, 1992), 465pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Melissa Elliott Mann, "), _c('i', [_vm._v("The Creation of a Canon: Patterns in Reception of Beethoven's Piano Sonatas")]), _vm._v(" (PhD diss., University of Connecticut, 2003), 235pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Charles Rosen, "), _c('i', [_vm._v("Beethoven's Piano Sonatas")]), _vm._v(" (New Haven, CT: Yale University Press, 2002), 272pp. plus CD.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("John Shedlock, "), _c('i', [_vm._v("Beethoven's Pianoforte Sonatas: The Origin and Respective Value of Various Readings")]), _vm._v(" (London: Augener, 1918).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Shiow-Lih L. Shieh, "), _c('i', [_vm._v("A Pianist's Reference Guide to Beethoven's Piano Sonatas")]), _vm._v(" (diss., University of North Carolina at Greensboro, 1992).")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Scott McBride Smith and Stewart Gordon, “What Do Beethoven's Piano Sonatas Reveal About His Pianism?,” "), _c('i', [_vm._v("Keyboard Companion")]), _vm._v(" 19/3 (Autumn 2008): 22–25.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Moo Kyoung Song, "), _c('i', [_vm._v("The Evolution of Sonata-Form Design in Ludwig van Beethoven's Early Piano Sonatas, WoO 47 to Opus 22")]), _vm._v(" (PhD diss., University of Texas, Austin, 2002), 358pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Kathryn Stuart, "), _c('i', [_vm._v("Marks of Emphasis in Beethoven Piano Sonatas")]), _vm._v(" (DMA diss., Cornell University, 1996), 142pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Shwu-Miin Tang, "), _c('i', [_vm._v("The Technical Demands of the First Fifteen Piano Sonatas with Opus Numbers by Ludwig van Beethoven")]), _vm._v(" (DMA treatise, University of Texas, Austin, 1997), 132pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Robert Taub, "), _c('i', [_vm._v("Playing the Beethoven Piano Sonatas")]), _vm._v(" (Portland, OR: Amadeus Press, 2002), 258pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("You-Whai Tsao, "), _c('i', [_vm._v("Beethoven's Tempo in His Thirty-Two Piano Sonatas")]), _vm._v(" (DMA treatise, Claremont Graduate University, 1996), 110pp.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Ernest Walker, “The Associated Board's Edition of Beethoven's Pianoforte Sonatas,” ML 13/1 (1932): 11–18.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("———. “The (Beethoven) Pianoforte Sonatas: Some Textural Problems,” ML 8/2 (1927): 211–17.")]), _vm._v(" "), _c('h3', {
    staticClass: "subhead1"
  }, [_vm._v("VARIATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Twenty-two sets of variations make up another large group of Beethoven's keyboard writing. They date from 1782 to 1823 and cover a slightly larger span of years than the sonatas (1782–1822). Opus numbers were used with only a few sets. Interpretative problems vary from easy to the most formidable. Among the most noteworthy collections of complete or nearly complete variations are:")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Henle")]), _vm._v(" (J. Schmidt-Görg, Georgii) 2 vols. Urtext, preface in German, English, and French.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I")]), _vm._v(" (142): 9 Variations on a March of E. Chr. Dressler WoO 63; 6 Variations on a Swiss Air WoO 64; 24 Variations on “Vieni Amore” by V. Righini WoO 65; 13 Variations on “Es war einmal” by K. Ditters von Dittersdorf WoO 66; 12 Variations on the Minuet à la Vigano by J. Haibel WoO 68; 9 Variations on “Quant’ è più bello” by G. Paisiello WoO 69; 6 Variations on “Nel cor più non mi sento” by Paisiello WoO 70; 12 Variations on a Russian Dance by P. Wranitzky WoO 71; 8 Variations on “Une fièvre brûlante” by A. E. M. Gretry WoO 72; 10 Variations on “La stessa la stessissima” by A. Salieri WoO 73; 7 Variations on “Kind, willst du ruhig schlafen” by P. Winter WoO 75.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II")]), _vm._v(" (144): 8 Variations on “Tändeln und Scherzen” by F. X. Sussmayr WoO 76; 6 Easy Variations G WoO 77; 6 Variations F Op.34; 15 Variations and Fugue E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(" Op.35; 7 Variations on “God Save the King” WoO 78; 5 Variations on “Rule Britannia” WoO 79; 32 Variations c WoO 80; 6 Variations D Op.76; 33 Variations on a Waltz by A. Diabelli Op.120; 9 Variations on a March of E. Chr. Dressler (2d version) WoO 63: 8 Variations on “Ich hab’ ein kleines Hüttchen nur” Anhang 10.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("VU")]), _vm._v(" (M. Holl, B. Seidlhofer 1973). Urtext, performing format edition, fingered.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I:")]), _vm._v(" WoO 64, 65, 70, 71, 77, 80; Opp.34, 35, 76, 120.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II:")]), _vm._v(" WoO 63, 66, 68, 69, 72, 73, 75, 76, 78, 79.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("CFP")]), _vm._v(" (P. Hauschild 1970). Urtext, preface in German and English, fingered by Gerhard Erber.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. I:")]), _vm._v(" Opp.34, 35, 76, 120; WoO 65, 80.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("Vol. II:")]), _vm._v(" remaining variations.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("Dover")]), _vm._v(" (1986) 228pp. Reprint from the Br&H complete edition, 1862–65. Contains twenty-one sets of variations. Missing are "), _c('i', [_vm._v("9 Variations on a March of E. Chr. Dressler")]), _vm._v(" (second version) WoO 63.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Steven M. Whiting, “To the ‘New Manner’ Born: A Study of Beethoven's Early Variations,” University of Illinois, 1991. Covers the Dressler Variations of 1782 to the Süssmayer Variations of 1799.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Variations")]), _vm._v(" F Op.34 1802 (Schott). Only the theme and last variation are in F, the others each move down a third (D, B"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", G, E"), _c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/music.jpg"
    }
  }), _vm._v(", c). Each variation has its own personality: Var.1: graceful roulades. Var.2: a scherzo. Var.3: pastoral. Var.4: a minuet. Var.5: a funeral march. Var.6: in rondo style. An interesting experiment that Beethoven never repeated. M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("15 Variations and Fugue on a Theme from ‘Prometheus’")]), _vm._v(" Op.35 1802. The theme is from the "), _c('i', [_vm._v("Prometheus")]), _vm._v(" ballet and was used later for the "), _c('i', [_vm._v("Eroica")]), _vm._v(" symphony finale. Demands are similar to those of the sonatas from this time, such as the Opp.53 and 57; more difficult than "), _c('i', [_vm._v("Variations")]), _vm._v(" Op.34. A unique work in that it combines elements of fugue, sonata, and suite in one movement. The main part of the work encompasses fifteen variations handled with a kaleidoscopic display of keyboard figuration. The final variation is a long, highly ornamented Largo. The lighthearted fugue has an unsuccessful conclusion. D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Ellwood Derr, “Beethoven's Long-Term Memory of C. P. E. Bach's Rondo in E Flat, W.61/1 (1787), Manifest in the Variations in E Flat for Piano, Op.35 (1802),” MQ 70/1 (Winter 1984): 45–76.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("6 Variations")]), _vm._v(" D Op.76 1809 (in "), _c('i', [_vm._v("Masters of the Classical Period")]), _vm._v(", Alfred 1199). The theme is from the familiar Turkish March of the "), _c('i', [_vm._v("Ruins of Athens")]), _vm._v(". The six variations display all of Beethoven's later style characteristics infused with humorous touches. Easier than any of the other discussed sets. Int. to M-D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_c('i', [_vm._v("33 Variations on a Waltz by Diabelli")]), _vm._v(" Op.120 1823 (Kross, Georgii—Henle 636; Kuhlmann—CFP 4476; Schnabel—CF). This set is a masterpiece because of the novelty of its ideas, care in working them out, and beauty in the most artful of their transitions. It is a sort of cosmos unto itself in its spectrum of moods and its endless inventiveness. Diabelli's fun theme sets Beethoven free to build recognizable variations in every conceivable way, and it is in that instant recognition that this giant set of variations becomes possible. Alfred Brendel considers this set the greatest work in all piano literature. It invites comparison with Bach's "), _c('i', [_vm._v("Goldberg Variations")]), _vm._v(". D.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_c('i', [_vm._v("See:")]), _vm._v(" Stephen A. Bergquist, “Beethoven's Diabelli Variations: Early Performance History,” "), _c('i', [_vm._v("The Beethoven Newsletter")]), _vm._v(" 7/2 (Summer 1992): 38–41.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Eric Blom, “Beethoven's Diabelli Variations,” in "), _c('i', [_vm._v("Classics Major and Minor")]), _vm._v(" (London: J. M. Dent, 1958), pp.48–78.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Karl Geiringer, “The Structure of Beethoven's Diabelli Variations,” MQ 50 (October 1964): 496–503.")]), _vm._v(" "), _c('p', {
    staticClass: "hang1"
  }, [_vm._v("Lia M. Jensen, "), _c('i', [_vm._v("From Waltz to Minuet: A Narrative Journey of Memory in Beethoven's “Diabelli Variations,” Op. 120")]), _vm._v(" (DMA diss., University of Nebraska, Lincoln, 2006), 426pp.")])])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9780253010230',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(196)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(198);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 198 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.ba17a9527e55b9348bf7.js